import { useQuery, useMutation, UseQueryOptions, UseMutationOptions } from '@tanstack/react-query';
import { fetchGenerated } from '../client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date string, such as 2007-12-03, compliant with the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: any;
  GatsbyImageData: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
};

export type AvifOptions = {
  lossless?: InputMaybe<Scalars['Boolean']>;
  quality?: InputMaybe<Scalars['Int']>;
  speed?: InputMaybe<Scalars['Int']>;
};

export type ActiveActivity = {
  activeAdult: Scalars['Float'];
  activeChild: Scalars['Float'];
  adults: Scalars['Float'];
  children: Scalars['Float'];
  fairlyAdult: Scalars['Float'];
  fairlyChild: Scalars['Float'];
  inactiveAdult: Scalars['Float'];
  lessActiveChild: Scalars['Float'];
  lsoaCode: Scalars['String'];
  total: Scalars['Float'];
};

export type ActivityFilterInputAdult = {
  activeAdult: Scalars['Boolean'];
  fairlyAdult: Scalars['Boolean'];
  inactiveAdult: Scalars['Boolean'];
};

export type ActivityFilterInputChild = {
  activeChild: Scalars['Boolean'];
  fairlyChild: Scalars['Boolean'];
  lessActiveChild: Scalars['Boolean'];
};

export type AdminValidateSurvey = {
  gameId: Scalars['String'];
  surveyID: Scalars['String'];
};

export type AfterGameSurvey = {
  isAutoSend: Scalars['Boolean'];
  link: Scalars['String'];
  sendDate: Scalars['String'];
  surveyID: Scalars['String'];
};

export type AfterGameSurveyInput = {
  isAutoSend: Scalars['Boolean'];
  link: Scalars['String'];
  sendDate: Scalars['String'];
  surveyID: Scalars['String'];
};

export type AgeFilterInput = {
  ageGap1: Scalars['Boolean'];
  ageGap2: Scalars['Boolean'];
  ageGap3: Scalars['Boolean'];
  ageGap4: Scalars['Boolean'];
};

/** Types of answers */
export enum AnswerType {
  Pnts = 'PNTS',
  No = 'no',
  Yes = 'yes'
}

export type AssignSubranges = {
  gameId: Scalars['String'];
};

export type BlurredOptions = {
  /** Force the output format for the low-res preview. Default is to use the same format as the input. You should rarely need to change this */
  toFormat?: InputMaybe<ImageFormat>;
  /** Width of the generated low-res preview. Default is 20px */
  width?: InputMaybe<Scalars['Int']>;
};

export type BoardItem = {
  avatar?: Maybe<Scalars['String']>;
  entity: LeaderboardEntity;
  id: Scalars['String'];
  name: Scalars['String'];
  points: Scalars['Int'];
};

export type BooleanQueryOperatorInput = {
  eq?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type BulkChangeSubranges = {
  gameId: Scalars['String'];
  isApproved?: InputMaybe<Scalars['Boolean']>;
  isLocked?: InputMaybe<Scalars['Boolean']>;
};

export type CampaignRecord = {
  /** Pinpoint message specific */
  applicationId?: Maybe<Scalars['String']>;
  campaignId: Scalars['String'];
  createdAt: Scalars['String'];
  /** Related game, global message if its empty */
  gameId?: Maybe<Scalars['String']>;
  /** Pinpoint message specific */
  pinpointId?: Maybe<Scalars['String']>;
  /** Pinpoint message specific */
  scheduledTime?: Maybe<Scalars['String']>;
};

/** Card order status */
export enum CardOrderStatus {
  Delivered = 'delivered',
  Draft = 'draft',
  Ordered = 'ordered',
  Shipped = 'shipped'
}

export type ChangePasswordInput = {
  password: Scalars['String'];
  playerId: Scalars['String'];
};

export type ClosingSurvey = {
  isAutoSend: Scalars['Boolean'];
  link: Scalars['String'];
  sendDaysBeforeEnd?: Maybe<Array<Scalars['Int']>>;
  shownFromDate: Scalars['String'];
  surveyID: Scalars['String'];
};

export type ClosingSurveyInput = {
  isAutoSend: Scalars['Boolean'];
  link: Scalars['String'];
  sendDaysBeforeEnd?: InputMaybe<Array<Scalars['Int']>>;
  shownFromDate: Scalars['String'];
  surveyID: Scalars['String'];
};

export type CodesInput = {
  admin_county?: InputMaybe<Scalars['String']>;
  admin_district?: InputMaybe<Scalars['String']>;
  admin_ward?: InputMaybe<Scalars['String']>;
  ccg?: InputMaybe<Scalars['String']>;
  ccg_id?: InputMaybe<Scalars['String']>;
  ced?: InputMaybe<Scalars['String']>;
  lau2?: InputMaybe<Scalars['String']>;
  lsoa?: InputMaybe<Scalars['String']>;
  msoa?: InputMaybe<Scalars['String']>;
  nuts?: InputMaybe<Scalars['String']>;
  parish?: InputMaybe<Scalars['String']>;
  parliamentary_constituency?: InputMaybe<Scalars['String']>;
  pfa?: InputMaybe<Scalars['String']>;
};

export type CollectInput = {
  deviceID?: InputMaybe<Scalars['String']>;
  gameId: Scalars['String'];
  locationId: Scalars['String'];
  playerId?: InputMaybe<Scalars['String']>;
  tagNumber?: InputMaybe<Scalars['Float']>;
  timestamp: Scalars['String'];
  type: CollectType;
};

export enum CollectType {
  Gem = 'gem',
  Swipe = 'swipe'
}

/** Update Player Profile */
export type ConfirmEmailInput = {
  code: Scalars['Float'];
  id?: InputMaybe<Scalars['String']>;
};

export type ContactInput = {
  description: Scalars['String'];
  playerId: Scalars['String'];
  subject: Scalars['String'];
  tags?: InputMaybe<Array<Scalars['String']>>;
};

/** Create child Player */
export type CreateChildPlayerInput = {
  ageGroup?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  info?: InputMaybe<PlayerInfoInput>;
  profile?: InputMaybe<PlayerProfileInput>;
};

/** Create Game Info */
export type CreateGameInfoInput = {
  anticipation?: InputMaybe<Scalars['String']>;
  anticipationStartsAt: Scalars['String'];
  boundingBox?: InputMaybe<Scalars['String']>;
  endCountdownDays?: InputMaybe<Scalars['Float']>;
  endsAt: Scalars['String'];
  helpWidget: HelpWidget;
  hideOnLanding?: InputMaybe<Scalars['Boolean']>;
  isMobileGame?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  region?: InputMaybe<GameRegion>;
  restrictAtDays?: InputMaybe<Scalars['Float']>;
  sanityID?: InputMaybe<Scalars['String']>;
  settings?: InputMaybe<SettingsInput>;
  slug?: InputMaybe<Scalars['String']>;
  startsAt: Scalars['String'];
  status: GameStatus;
  surveys?: InputMaybe<SurveyOptionsInput>;
  sustainEndsAt: Scalars['String'];
  teamsStartsAt: Scalars['String'];
  type: GameType;
};

/** Create Game */
export type CreateGameInput = {
  id?: InputMaybe<Scalars['String']>;
  info: CreateGameInfoInput;
};

/** Create Group */
export type CreateGroupInput = {
  color?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  gameId: Scalars['String'];
  name: Scalars['String'];
};

/** Create Game Info */
export type CreateMovingStatsInput = {
  gameId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  playerId: Scalars['String'];
  timestamp: Scalars['String'];
  type: Scalars['String'];
};

/** Admin create Player Input */
export type CreatePlayerInput = {
  email: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  info?: InputMaybe<PlayerInfoInput>;
  password: Scalars['String'];
  role?: InputMaybe<PlayerRoleInput>;
};

export type DateQueryOperatorInput = {
  eq?: InputMaybe<Scalars['Date']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type DeleteEvent = {
  gameId: Scalars['String'];
  id: Scalars['String'];
};

export type DeleteEventPoint = {
  gameId: Scalars['String'];
  id: Scalars['String'];
};

/** Delete Game */
export type DeleteGameInput = {
  id: Scalars['String'];
};

export type DeleteGroup = {
  gameId: Scalars['String'];
  id: Scalars['String'];
};

export type DeleteLeaderboard = {
  gameId: Scalars['String'];
  id: Scalars['String'];
};

export type DeleteLocation = {
  gameId: Scalars['String'];
  id: Scalars['String'];
};

export type Demographics = {
  deciles: Array<DemographicsDecile>;
  lsoaCodes: Array<LsoaCodes>;
  totalPlayers: Scalars['Float'];
  totalPopulation: Scalars['Float'];
};

export type DemographicsDecile = {
  decile: Scalars['Float'];
  indexOfPenetration: Scalars['Float'];
  totalPlayers: Scalars['Float'];
  totalPlayersPercent: Scalars['Float'];
  totalPopulation: Scalars['Float'];
  totalPopulationPercent: Scalars['Float'];
};

export type Directory = Node & {
  absolutePath: Scalars['String'];
  accessTime: Scalars['Date'];
  atime: Scalars['Date'];
  atimeMs: Scalars['Float'];
  base: Scalars['String'];
  birthTime: Scalars['Date'];
  /** @deprecated Use `birthTime` instead */
  birthtime?: Maybe<Scalars['Date']>;
  /** @deprecated Use `birthTime` instead */
  birthtimeMs?: Maybe<Scalars['Float']>;
  changeTime: Scalars['Date'];
  children: Array<Node>;
  ctime: Scalars['Date'];
  ctimeMs: Scalars['Float'];
  dev: Scalars['Int'];
  dir: Scalars['String'];
  ext: Scalars['String'];
  extension: Scalars['String'];
  gid: Scalars['Int'];
  id: Scalars['ID'];
  ino: Scalars['Float'];
  internal: Internal;
  mode: Scalars['Int'];
  modifiedTime: Scalars['Date'];
  mtime: Scalars['Date'];
  mtimeMs: Scalars['Float'];
  name: Scalars['String'];
  nlink: Scalars['Int'];
  parent?: Maybe<Node>;
  prettySize: Scalars['String'];
  rdev: Scalars['Int'];
  relativeDirectory: Scalars['String'];
  relativePath: Scalars['String'];
  root: Scalars['String'];
  size: Scalars['Int'];
  sourceInstanceName: Scalars['String'];
  uid: Scalars['Int'];
};


export type DirectoryAccessTimeArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type DirectoryAtimeArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type DirectoryBirthTimeArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type DirectoryChangeTimeArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type DirectoryCtimeArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type DirectoryModifiedTimeArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type DirectoryMtimeArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type DirectoryConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<DirectoryEdge>;
  group: Array<DirectoryGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<Directory>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type DirectoryConnectionDistinctArgs = {
  field: DirectoryFieldSelector;
};


export type DirectoryConnectionGroupArgs = {
  field: DirectoryFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type DirectoryConnectionMaxArgs = {
  field: DirectoryFieldSelector;
};


export type DirectoryConnectionMinArgs = {
  field: DirectoryFieldSelector;
};


export type DirectoryConnectionSumArgs = {
  field: DirectoryFieldSelector;
};

export type DirectoryEdge = {
  next?: Maybe<Directory>;
  node: Directory;
  previous?: Maybe<Directory>;
};

export type DirectoryFieldSelector = {
  absolutePath?: InputMaybe<FieldSelectorEnum>;
  accessTime?: InputMaybe<FieldSelectorEnum>;
  atime?: InputMaybe<FieldSelectorEnum>;
  atimeMs?: InputMaybe<FieldSelectorEnum>;
  base?: InputMaybe<FieldSelectorEnum>;
  birthTime?: InputMaybe<FieldSelectorEnum>;
  birthtime?: InputMaybe<FieldSelectorEnum>;
  birthtimeMs?: InputMaybe<FieldSelectorEnum>;
  changeTime?: InputMaybe<FieldSelectorEnum>;
  children?: InputMaybe<NodeFieldSelector>;
  ctime?: InputMaybe<FieldSelectorEnum>;
  ctimeMs?: InputMaybe<FieldSelectorEnum>;
  dev?: InputMaybe<FieldSelectorEnum>;
  dir?: InputMaybe<FieldSelectorEnum>;
  ext?: InputMaybe<FieldSelectorEnum>;
  extension?: InputMaybe<FieldSelectorEnum>;
  gid?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  ino?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  mode?: InputMaybe<FieldSelectorEnum>;
  modifiedTime?: InputMaybe<FieldSelectorEnum>;
  mtime?: InputMaybe<FieldSelectorEnum>;
  mtimeMs?: InputMaybe<FieldSelectorEnum>;
  name?: InputMaybe<FieldSelectorEnum>;
  nlink?: InputMaybe<FieldSelectorEnum>;
  parent?: InputMaybe<NodeFieldSelector>;
  prettySize?: InputMaybe<FieldSelectorEnum>;
  rdev?: InputMaybe<FieldSelectorEnum>;
  relativeDirectory?: InputMaybe<FieldSelectorEnum>;
  relativePath?: InputMaybe<FieldSelectorEnum>;
  root?: InputMaybe<FieldSelectorEnum>;
  size?: InputMaybe<FieldSelectorEnum>;
  sourceInstanceName?: InputMaybe<FieldSelectorEnum>;
  uid?: InputMaybe<FieldSelectorEnum>;
};

export type DirectoryFilterInput = {
  absolutePath?: InputMaybe<StringQueryOperatorInput>;
  accessTime?: InputMaybe<DateQueryOperatorInput>;
  atime?: InputMaybe<DateQueryOperatorInput>;
  atimeMs?: InputMaybe<FloatQueryOperatorInput>;
  base?: InputMaybe<StringQueryOperatorInput>;
  birthTime?: InputMaybe<DateQueryOperatorInput>;
  birthtime?: InputMaybe<DateQueryOperatorInput>;
  birthtimeMs?: InputMaybe<FloatQueryOperatorInput>;
  changeTime?: InputMaybe<DateQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  ctime?: InputMaybe<DateQueryOperatorInput>;
  ctimeMs?: InputMaybe<FloatQueryOperatorInput>;
  dev?: InputMaybe<IntQueryOperatorInput>;
  dir?: InputMaybe<StringQueryOperatorInput>;
  ext?: InputMaybe<StringQueryOperatorInput>;
  extension?: InputMaybe<StringQueryOperatorInput>;
  gid?: InputMaybe<IntQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  ino?: InputMaybe<FloatQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  mode?: InputMaybe<IntQueryOperatorInput>;
  modifiedTime?: InputMaybe<DateQueryOperatorInput>;
  mtime?: InputMaybe<DateQueryOperatorInput>;
  mtimeMs?: InputMaybe<FloatQueryOperatorInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  nlink?: InputMaybe<IntQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  prettySize?: InputMaybe<StringQueryOperatorInput>;
  rdev?: InputMaybe<IntQueryOperatorInput>;
  relativeDirectory?: InputMaybe<StringQueryOperatorInput>;
  relativePath?: InputMaybe<StringQueryOperatorInput>;
  root?: InputMaybe<StringQueryOperatorInput>;
  size?: InputMaybe<IntQueryOperatorInput>;
  sourceInstanceName?: InputMaybe<StringQueryOperatorInput>;
  uid?: InputMaybe<IntQueryOperatorInput>;
};

export type DirectoryGroupConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<DirectoryEdge>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
  group: Array<DirectoryGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<Directory>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type DirectoryGroupConnectionDistinctArgs = {
  field: DirectoryFieldSelector;
};


export type DirectoryGroupConnectionGroupArgs = {
  field: DirectoryFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type DirectoryGroupConnectionMaxArgs = {
  field: DirectoryFieldSelector;
};


export type DirectoryGroupConnectionMinArgs = {
  field: DirectoryFieldSelector;
};


export type DirectoryGroupConnectionSumArgs = {
  field: DirectoryFieldSelector;
};

export type DirectorySortInput = {
  absolutePath?: InputMaybe<SortOrderEnum>;
  accessTime?: InputMaybe<SortOrderEnum>;
  atime?: InputMaybe<SortOrderEnum>;
  atimeMs?: InputMaybe<SortOrderEnum>;
  base?: InputMaybe<SortOrderEnum>;
  birthTime?: InputMaybe<SortOrderEnum>;
  birthtime?: InputMaybe<SortOrderEnum>;
  birthtimeMs?: InputMaybe<SortOrderEnum>;
  changeTime?: InputMaybe<SortOrderEnum>;
  children?: InputMaybe<NodeSortInput>;
  ctime?: InputMaybe<SortOrderEnum>;
  ctimeMs?: InputMaybe<SortOrderEnum>;
  dev?: InputMaybe<SortOrderEnum>;
  dir?: InputMaybe<SortOrderEnum>;
  ext?: InputMaybe<SortOrderEnum>;
  extension?: InputMaybe<SortOrderEnum>;
  gid?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  ino?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  mode?: InputMaybe<SortOrderEnum>;
  modifiedTime?: InputMaybe<SortOrderEnum>;
  mtime?: InputMaybe<SortOrderEnum>;
  mtimeMs?: InputMaybe<SortOrderEnum>;
  name?: InputMaybe<SortOrderEnum>;
  nlink?: InputMaybe<SortOrderEnum>;
  parent?: InputMaybe<NodeSortInput>;
  prettySize?: InputMaybe<SortOrderEnum>;
  rdev?: InputMaybe<SortOrderEnum>;
  relativeDirectory?: InputMaybe<SortOrderEnum>;
  relativePath?: InputMaybe<SortOrderEnum>;
  root?: InputMaybe<SortOrderEnum>;
  size?: InputMaybe<SortOrderEnum>;
  sourceInstanceName?: InputMaybe<SortOrderEnum>;
  uid?: InputMaybe<SortOrderEnum>;
};

export type DuotoneGradient = {
  highlight: Scalars['String'];
  opacity?: InputMaybe<Scalars['Int']>;
  shadow: Scalars['String'];
};

export type Event = {
  /** Override customLocations and locationCategory */
  allBeatBoxes?: Maybe<Scalars['Boolean']>;
  /** Override timing array */
  allDay?: Maybe<Scalars['Boolean']>;
  customLocationIds?: Maybe<Array<Scalars['String']>>;
  description: Scalars['String'];
  endDate: Scalars['String'];
  gameId: Scalars['String'];
  groupIds?: Maybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  /** Set's Sanity integration. */
  isVisible?: Maybe<Scalars['Boolean']>;
  points?: Maybe<Scalars['Int']>;
  sanityID?: Maybe<Scalars['String']>;
  startDate: Scalars['String'];
  timing?: Maybe<Array<Timing>>;
  weekDay: Array<Scalars['Int']>;
};

/** Create Game Event */
export type EventCreateInput = {
  /** Override customLocations and locationCategory */
  allBeatBoxes?: InputMaybe<Scalars['Boolean']>;
  /** Override timing array */
  allDay?: InputMaybe<Scalars['Boolean']>;
  customLocationIds?: InputMaybe<Array<Scalars['String']>>;
  description: Scalars['String'];
  endDate: Scalars['String'];
  gameId: Scalars['String'];
  groupIds?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  /** Set's Sanity integration. */
  isVisible?: InputMaybe<Scalars['Boolean']>;
  points?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['String'];
  timing?: InputMaybe<Array<TimingInput>>;
  weekDay: Array<Scalars['Int']>;
};

export type EventPoint = {
  endDate: Scalars['String'];
  eventId: Scalars['String'];
  gameId: Scalars['String'];
  id: Scalars['String'];
  locationId: Scalars['String'];
  points: Scalars['Int'];
  startDate: Scalars['String'];
};

/** Update Game Event */
export type EventUpdateInput = {
  /** Override customLocations and locationCategory */
  allBeatBoxes?: InputMaybe<Scalars['Boolean']>;
  /** Override timing array */
  allDay?: InputMaybe<Scalars['Boolean']>;
  customLocationIds?: InputMaybe<Array<Scalars['String']>>;
  description?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  gameId: Scalars['String'];
  groupIds?: InputMaybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  /** Set's Sanity integration. */
  isVisible?: InputMaybe<Scalars['Boolean']>;
  points?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['String']>;
  timing?: InputMaybe<Array<TimingInput>>;
  weekDay?: InputMaybe<Array<Scalars['Int']>>;
};

export enum FieldSelectorEnum {
  Select = 'SELECT'
}

export type File = Node & {
  absolutePath: Scalars['String'];
  accessTime: Scalars['Date'];
  atime: Scalars['Date'];
  atimeMs: Scalars['Float'];
  base: Scalars['String'];
  birthTime: Scalars['Date'];
  /** @deprecated Use `birthTime` instead */
  birthtime?: Maybe<Scalars['Date']>;
  /** @deprecated Use `birthTime` instead */
  birthtimeMs?: Maybe<Scalars['Float']>;
  blksize?: Maybe<Scalars['Int']>;
  blocks?: Maybe<Scalars['Int']>;
  changeTime: Scalars['Date'];
  /** Returns the first child node of type ImageSharp or null if there are no children of given type on this node */
  childImageSharp?: Maybe<ImageSharp>;
  /** Returns the first child node of type Locale or null if there are no children of given type on this node */
  childLocale?: Maybe<Locale>;
  children: Array<Node>;
  /** Returns all children nodes filtered by type ImageSharp */
  childrenImageSharp?: Maybe<Array<Maybe<ImageSharp>>>;
  /** Returns all children nodes filtered by type Locale */
  childrenLocale?: Maybe<Array<Maybe<Locale>>>;
  ctime: Scalars['Date'];
  ctimeMs: Scalars['Float'];
  dev: Scalars['Int'];
  dir: Scalars['String'];
  ext: Scalars['String'];
  extension: Scalars['String'];
  gid: Scalars['Int'];
  id: Scalars['ID'];
  ino: Scalars['Float'];
  internal: Internal;
  mode: Scalars['Int'];
  modifiedTime: Scalars['Date'];
  mtime: Scalars['Date'];
  mtimeMs: Scalars['Float'];
  name: Scalars['String'];
  nlink: Scalars['Int'];
  parent?: Maybe<Node>;
  prettySize: Scalars['String'];
  /** Copy file to static directory and return public url to it */
  publicURL?: Maybe<Scalars['String']>;
  rdev: Scalars['Int'];
  relativeDirectory: Scalars['String'];
  relativePath: Scalars['String'];
  root: Scalars['String'];
  size: Scalars['Int'];
  sourceInstanceName: Scalars['String'];
  uid: Scalars['Int'];
};


export type FileAccessTimeArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type FileAtimeArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type FileBirthTimeArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type FileChangeTimeArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type FileCtimeArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type FileModifiedTimeArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type FileMtimeArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type FileConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<FileEdge>;
  group: Array<FileGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<File>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type FileConnectionDistinctArgs = {
  field: FileFieldSelector;
};


export type FileConnectionGroupArgs = {
  field: FileFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type FileConnectionMaxArgs = {
  field: FileFieldSelector;
};


export type FileConnectionMinArgs = {
  field: FileFieldSelector;
};


export type FileConnectionSumArgs = {
  field: FileFieldSelector;
};

export type FileEdge = {
  next?: Maybe<File>;
  node: File;
  previous?: Maybe<File>;
};

export type FileFieldSelector = {
  absolutePath?: InputMaybe<FieldSelectorEnum>;
  accessTime?: InputMaybe<FieldSelectorEnum>;
  atime?: InputMaybe<FieldSelectorEnum>;
  atimeMs?: InputMaybe<FieldSelectorEnum>;
  base?: InputMaybe<FieldSelectorEnum>;
  birthTime?: InputMaybe<FieldSelectorEnum>;
  birthtime?: InputMaybe<FieldSelectorEnum>;
  birthtimeMs?: InputMaybe<FieldSelectorEnum>;
  blksize?: InputMaybe<FieldSelectorEnum>;
  blocks?: InputMaybe<FieldSelectorEnum>;
  changeTime?: InputMaybe<FieldSelectorEnum>;
  childImageSharp?: InputMaybe<ImageSharpFieldSelector>;
  childLocale?: InputMaybe<LocaleFieldSelector>;
  children?: InputMaybe<NodeFieldSelector>;
  childrenImageSharp?: InputMaybe<ImageSharpFieldSelector>;
  childrenLocale?: InputMaybe<LocaleFieldSelector>;
  ctime?: InputMaybe<FieldSelectorEnum>;
  ctimeMs?: InputMaybe<FieldSelectorEnum>;
  dev?: InputMaybe<FieldSelectorEnum>;
  dir?: InputMaybe<FieldSelectorEnum>;
  ext?: InputMaybe<FieldSelectorEnum>;
  extension?: InputMaybe<FieldSelectorEnum>;
  gid?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  ino?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  mode?: InputMaybe<FieldSelectorEnum>;
  modifiedTime?: InputMaybe<FieldSelectorEnum>;
  mtime?: InputMaybe<FieldSelectorEnum>;
  mtimeMs?: InputMaybe<FieldSelectorEnum>;
  name?: InputMaybe<FieldSelectorEnum>;
  nlink?: InputMaybe<FieldSelectorEnum>;
  parent?: InputMaybe<NodeFieldSelector>;
  prettySize?: InputMaybe<FieldSelectorEnum>;
  publicURL?: InputMaybe<FieldSelectorEnum>;
  rdev?: InputMaybe<FieldSelectorEnum>;
  relativeDirectory?: InputMaybe<FieldSelectorEnum>;
  relativePath?: InputMaybe<FieldSelectorEnum>;
  root?: InputMaybe<FieldSelectorEnum>;
  size?: InputMaybe<FieldSelectorEnum>;
  sourceInstanceName?: InputMaybe<FieldSelectorEnum>;
  uid?: InputMaybe<FieldSelectorEnum>;
};

export type FileFilterInput = {
  absolutePath?: InputMaybe<StringQueryOperatorInput>;
  accessTime?: InputMaybe<DateQueryOperatorInput>;
  atime?: InputMaybe<DateQueryOperatorInput>;
  atimeMs?: InputMaybe<FloatQueryOperatorInput>;
  base?: InputMaybe<StringQueryOperatorInput>;
  birthTime?: InputMaybe<DateQueryOperatorInput>;
  birthtime?: InputMaybe<DateQueryOperatorInput>;
  birthtimeMs?: InputMaybe<FloatQueryOperatorInput>;
  blksize?: InputMaybe<IntQueryOperatorInput>;
  blocks?: InputMaybe<IntQueryOperatorInput>;
  changeTime?: InputMaybe<DateQueryOperatorInput>;
  childImageSharp?: InputMaybe<ImageSharpFilterInput>;
  childLocale?: InputMaybe<LocaleFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  childrenImageSharp?: InputMaybe<ImageSharpFilterListInput>;
  childrenLocale?: InputMaybe<LocaleFilterListInput>;
  ctime?: InputMaybe<DateQueryOperatorInput>;
  ctimeMs?: InputMaybe<FloatQueryOperatorInput>;
  dev?: InputMaybe<IntQueryOperatorInput>;
  dir?: InputMaybe<StringQueryOperatorInput>;
  ext?: InputMaybe<StringQueryOperatorInput>;
  extension?: InputMaybe<StringQueryOperatorInput>;
  gid?: InputMaybe<IntQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  ino?: InputMaybe<FloatQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  mode?: InputMaybe<IntQueryOperatorInput>;
  modifiedTime?: InputMaybe<DateQueryOperatorInput>;
  mtime?: InputMaybe<DateQueryOperatorInput>;
  mtimeMs?: InputMaybe<FloatQueryOperatorInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  nlink?: InputMaybe<IntQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  prettySize?: InputMaybe<StringQueryOperatorInput>;
  publicURL?: InputMaybe<StringQueryOperatorInput>;
  rdev?: InputMaybe<IntQueryOperatorInput>;
  relativeDirectory?: InputMaybe<StringQueryOperatorInput>;
  relativePath?: InputMaybe<StringQueryOperatorInput>;
  root?: InputMaybe<StringQueryOperatorInput>;
  size?: InputMaybe<IntQueryOperatorInput>;
  sourceInstanceName?: InputMaybe<StringQueryOperatorInput>;
  uid?: InputMaybe<IntQueryOperatorInput>;
};

export type FileGroupConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<FileEdge>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
  group: Array<FileGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<File>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type FileGroupConnectionDistinctArgs = {
  field: FileFieldSelector;
};


export type FileGroupConnectionGroupArgs = {
  field: FileFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type FileGroupConnectionMaxArgs = {
  field: FileFieldSelector;
};


export type FileGroupConnectionMinArgs = {
  field: FileFieldSelector;
};


export type FileGroupConnectionSumArgs = {
  field: FileFieldSelector;
};

export type FileSortInput = {
  absolutePath?: InputMaybe<SortOrderEnum>;
  accessTime?: InputMaybe<SortOrderEnum>;
  atime?: InputMaybe<SortOrderEnum>;
  atimeMs?: InputMaybe<SortOrderEnum>;
  base?: InputMaybe<SortOrderEnum>;
  birthTime?: InputMaybe<SortOrderEnum>;
  birthtime?: InputMaybe<SortOrderEnum>;
  birthtimeMs?: InputMaybe<SortOrderEnum>;
  blksize?: InputMaybe<SortOrderEnum>;
  blocks?: InputMaybe<SortOrderEnum>;
  changeTime?: InputMaybe<SortOrderEnum>;
  childImageSharp?: InputMaybe<ImageSharpSortInput>;
  childLocale?: InputMaybe<LocaleSortInput>;
  children?: InputMaybe<NodeSortInput>;
  childrenImageSharp?: InputMaybe<ImageSharpSortInput>;
  childrenLocale?: InputMaybe<LocaleSortInput>;
  ctime?: InputMaybe<SortOrderEnum>;
  ctimeMs?: InputMaybe<SortOrderEnum>;
  dev?: InputMaybe<SortOrderEnum>;
  dir?: InputMaybe<SortOrderEnum>;
  ext?: InputMaybe<SortOrderEnum>;
  extension?: InputMaybe<SortOrderEnum>;
  gid?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  ino?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  mode?: InputMaybe<SortOrderEnum>;
  modifiedTime?: InputMaybe<SortOrderEnum>;
  mtime?: InputMaybe<SortOrderEnum>;
  mtimeMs?: InputMaybe<SortOrderEnum>;
  name?: InputMaybe<SortOrderEnum>;
  nlink?: InputMaybe<SortOrderEnum>;
  parent?: InputMaybe<NodeSortInput>;
  prettySize?: InputMaybe<SortOrderEnum>;
  publicURL?: InputMaybe<SortOrderEnum>;
  rdev?: InputMaybe<SortOrderEnum>;
  relativeDirectory?: InputMaybe<SortOrderEnum>;
  relativePath?: InputMaybe<SortOrderEnum>;
  root?: InputMaybe<SortOrderEnum>;
  size?: InputMaybe<SortOrderEnum>;
  sourceInstanceName?: InputMaybe<SortOrderEnum>;
  uid?: InputMaybe<SortOrderEnum>;
};

export type FindByTag = {
  gameId?: InputMaybe<Scalars['String']>;
  tagNumber: Scalars['Int'];
};

export type FindEventPoints = {
  eventId: Scalars['String'];
  gameId: Scalars['String'];
};

export type FindFamilyPlayersInput = {
  isChild?: InputMaybe<Scalars['Boolean']>;
  parentId: Scalars['String'];
};

export type FindGroupElements = {
  gameId: Scalars['String'];
  groupId: Scalars['String'];
};

export type FindInactiveTagInput = {
  playerId: Scalars['String'];
};

/** Find Player follow */
export type FindPlayerFollowInput = {
  gameId: Scalars['String'];
  playerId: Scalars['String'];
};

export type FindSwipeByDateRange = {
  gameId: Scalars['String'];
};

export type FindTagSubranges = {
  filter?: InputMaybe<SubrangeFilter>;
  gameId: Scalars['String'];
};

export type FindTeamsInput = {
  gameId: Scalars['String'];
};

export type FloatQueryOperatorInput = {
  eq?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

/** Admin Update player */
export type FullUpdatePlayerInput = {
  ageGroup?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  info?: InputMaybe<PlayerInfoInput>;
  profile?: InputMaybe<PlayerProfileInput>;
  role?: InputMaybe<PlayerRoleInput>;
};

export type Game = {
  counter: GameCounter;
  id: Scalars['String'];
  info: GameInfo;
  leaderboards: Array<GameLeaderboard>;
  locations: Array<Location>;
  tagRanges: Array<GameTagRange>;
  tagSubranges: Array<GameTagSubrange>;
  teams: Array<Team>;
};

export type GameCounter = {
  registeredPlayers: Scalars['Int'];
  totalMiles: Scalars['Float'];
  totalPlayers: Scalars['Int'];
};

export type GameInfo = {
  anticipation?: Maybe<Scalars['String']>;
  anticipationStartsAt: Scalars['String'];
  boundingBox?: Maybe<Scalars['String']>;
  /** Show end countdown X days before game ends. */
  endCountdownDays?: Maybe<Scalars['Float']>;
  endsAt: Scalars['String'];
  helpWidget: HelpWidget;
  hideOnLanding?: Maybe<Scalars['Boolean']>;
  isMobileGame?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  /** Set when game is finished (not longer supported) */
  originalSlug?: Maybe<Scalars['String']>;
  region?: Maybe<GameRegion>;
  /** Close joining and creating new teams ant X day before game ends. */
  restrictAtDays?: Maybe<Scalars['Float']>;
  settings: Settings;
  slug: Scalars['String'];
  startsAt: Scalars['String'];
  status: GameStatus;
  surveys?: Maybe<SurveyOptions>;
  sustainEndsAt: Scalars['String'];
  targetedEmails?: Maybe<TargetedEmailsSetting>;
  teamsStartsAt: Scalars['String'];
  type: GameType;
};

export type GameLeaderboard = {
  id: Scalars['String'];
  name: Scalars['String'];
  teamIds?: Maybe<Array<Scalars['String']>>;
  teamTypes?: Maybe<Array<TeamTypes>>;
};

/** Create Game Leaderboard */
export type GameLeaderboardCreateInput = {
  gameId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  teamIds?: InputMaybe<Array<Scalars['String']>>;
  teamTypes?: InputMaybe<Array<TeamTypes>>;
};

/** Update Game Leaderboard */
export type GameLeaderboardUpdateInput = {
  gameId: Scalars['String'];
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  teamIds?: InputMaybe<Array<Scalars['String']>>;
  teamTypes?: InputMaybe<Array<TeamTypes>>;
};

export enum GameRegion {
  England = 'England',
  Ireland = 'Ireland',
  Scotland = 'Scotland'
}

/** Game lifecycle status */
export enum GameStatus {
  Anticipation = 'anticipation',
  Draft = 'draft',
  Finished = 'finished',
  Live = 'live',
  Sustain = 'sustain'
}

export type GameTagRange = {
  from: Scalars['Int'];
  gameId: Scalars['String'];
  id: Scalars['String'];
  to: Scalars['Int'];
};

/** Create Game Tag Range */
export type GameTagRangeCreateInput = {
  from: Scalars['Int'];
  gameId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  to: Scalars['Int'];
};

/** Delete Game Tag Range */
export type GameTagRangeDeleteInput = {
  gameId: Scalars['String'];
  id: Scalars['String'];
};

/** Update Game Tag Range */
export type GameTagRangeUpdateInput = {
  from: Scalars['Int'];
  gameId: Scalars['String'];
  id: Scalars['String'];
  to: Scalars['Int'];
};

export type GameTagSubrange = {
  amount: Scalars['Int'];
  connectionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  distributionPointId?: Maybe<Scalars['String']>;
  from: Scalars['Int'];
  gameId: Scalars['String'];
  id: Scalars['String'];
  isApproved: Scalars['Boolean'];
  isLocked: Scalars['Boolean'];
  tagType: TagsTypes;
  team?: Maybe<Team>;
  to: Scalars['Int'];
  type: SubrangesTypes;
};

/** Create game tag sub-range */
export type GameTagSubrangeCreateInput = {
  amount?: InputMaybe<Scalars['Int']>;
  connectionId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  distributionPointId?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['Int']>;
  gameId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  isApproved?: InputMaybe<Scalars['Boolean']>;
  isLocked?: InputMaybe<Scalars['Boolean']>;
  to?: InputMaybe<Scalars['Int']>;
  type: SubrangesTypes;
};

/** Delete Game Tag Subrange */
export type GameTagSubrangeDeleteInput = {
  gameId: Scalars['String'];
  id: Scalars['String'];
};

/** Update game tag sub-range */
export type GameTagSubrangeUpdateInput = {
  amount?: InputMaybe<Scalars['Int']>;
  connectionId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  distributionPointId?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['Int']>;
  gameId: Scalars['String'];
  id: Scalars['String'];
  isApproved?: InputMaybe<Scalars['Boolean']>;
  isLocked?: InputMaybe<Scalars['Boolean']>;
  to?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<SubrangesTypes>;
};

/** Game type depending on the game size */
export enum GameType {
  Classic = 'classic',
  Compact = 'compact'
}

export type GatsbyImageDataQueryOperatorInput = {
  eq?: InputMaybe<Scalars['GatsbyImageData']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['GatsbyImageData']>>>;
  ne?: InputMaybe<Scalars['GatsbyImageData']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['GatsbyImageData']>>>;
};

export enum GatsbyImageFormat {
  Auto = 'AUTO',
  Avif = 'AVIF',
  Jpg = 'JPG',
  NoChange = 'NO_CHANGE',
  Png = 'PNG',
  Webp = 'WEBP'
}

export enum GatsbyImageLayout {
  Constrained = 'CONSTRAINED',
  Fixed = 'FIXED',
  FullWidth = 'FULL_WIDTH'
}

export enum GatsbyImagePlaceholder {
  Blurred = 'BLURRED',
  DominantColor = 'DOMINANT_COLOR',
  None = 'NONE',
  TracedSvg = 'TRACED_SVG'
}

export type GemRoute = {
  gameId: Scalars['String'];
  gemType: GemType;
  id: Scalars['String'];
  locationId: Scalars['String'];
  locationSlug?: Maybe<Scalars['String']>;
  playerId: Scalars['String'];
  points: Scalars['Int'];
  sqlId: Scalars['String'];
  tagNumber: Scalars['Int'];
  timestamp: Scalars['String'];
};

/** Types for gems. Valid only form LocationTypes === 'gem' */
export enum GemType {
  Amber = 'amber',
  Cyan = 'cyan',
  Emerald = 'emerald',
  Hidden = 'hidden',
  Purple = 'purple',
  Ruby = 'ruby',
  Unset = 'unset'
}

export type GemsCount = {
  AmberGift: Scalars['Float'];
  CyanDrift: Scalars['Float'];
  EmeraldShift: Scalars['Float'];
  Hidden: Scalars['Float'];
  PurpleSwift: Scalars['Float'];
  RubyLift: Scalars['Float'];
};

export type GenderFilterInput = {
  female: Scalars['Boolean'];
  male: Scalars['Boolean'];
  other: Scalars['Boolean'];
};

export type GetBeatBoxSwipes = {
  total: Scalars['Float'];
};

export type GetBeatBoxSwipesInput = {
  gameId: Scalars['String'];
};

export type GetBeatBoxesVisited = {
  total: Scalars['Float'];
  visited: Scalars['Float'];
};

export type GetBeatBoxesVisitedInput = {
  gameId: Scalars['String'];
};

export type GetCardsCount = {
  distributed: Scalars['Float'];
  total: Scalars['Float'];
};

export type GetCardsCountInput = {
  gameId: Scalars['String'];
};

export type GetDemographicsData = {
  activityAdult?: InputMaybe<ActivityFilterInputAdult>;
  activityChild?: InputMaybe<ActivityFilterInputChild>;
  age?: InputMaybe<AgeFilterInput>;
  gameId: Scalars['String'];
  gender?: InputMaybe<GenderFilterInput>;
  imd?: InputMaybe<ImdFilterInput>;
  teamType?: InputMaybe<TeamFilterInput>;
};

export type GetEvent = {
  gameId: Scalars['String'];
  id: Scalars['String'];
};

export type GetFollowLeaderboardsInput = {
  gameId: Scalars['String'];
  playerId?: InputMaybe<Scalars['String']>;
  type: LeaderboardPointType;
};

export type GetForPaginatedListInput = {
  gameId: Scalars['String'];
  ids: Array<Scalars['String']>;
};

export type GetGameMileage = {
  mileage: Scalars['Float'];
};

export type GetGameMileageInput = {
  gameId: Scalars['String'];
};

export type GetGroup = {
  gameId: Scalars['String'];
  id: Scalars['String'];
};

export type GetHeadlineDemographicData = {
  allRegisteredAdultPlayers: Scalars['Float'];
  allRegisteredPlayers: Scalars['Float'];
  allSurveyResponses: Scalars['Float'];
  bame: Scalars['Float'];
  children: Scalars['Float'];
  condition: Scalars['Float'];
  disability: Scalars['Float'];
  female: Scalars['Float'];
  inactiveAdult: Scalars['Float'];
  lessActiveChild: Scalars['Float'];
  surveyResponsesAdult: Scalars['Float'];
  surveyResponsesChild: Scalars['Float'];
};

export type GetHeadlineDemographicDataInput = {
  gameId: Scalars['String'];
};

export type GetLocationFrequency = {
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  visits: Scalars['Float'];
};

export type GetLocationFrequencyInput = {
  gameId: Scalars['String'];
};

export type GetLocationInput = {
  gameId: Scalars['String'];
  id: Scalars['String'];
};

export type GetNewsletterConsents = {
  newsletter: Scalars['Float'];
  partner: Scalars['Float'];
  totalAdults: Scalars['Float'];
};

export type GetNewsletterConsentsInput = {
  gameId: Scalars['String'];
};

export type GetPlayerCount = {
  adults: Scalars['Float'];
  anonymised: Scalars['Float'];
  children: Scalars['Float'];
  registered: Scalars['Float'];
  total: Scalars['Float'];
  unregistered: Scalars['Float'];
};

export type GetPlayerCountInput = {
  gameId: Scalars['String'];
};

export type GetPlayerLeaderboardsInput = {
  gameId: Scalars['String'];
  playerId: Scalars['String'];
  teamId?: InputMaybe<Scalars['String']>;
  type: LeaderboardPointType;
};

export type GetPlayersDemographicData = {
  allRegisteredPlayers: Scalars['Float'];
  allSurveyResponses: Scalars['Float'];
  allWithSurveys: Scalars['Float'];
  bame: Scalars['Float'];
  condition: Scalars['Float'];
  disability: Scalars['Float'];
  registered: Scalars['Float'];
};

export type GetPlayersDemographicDataInput = {
  activityAdult?: InputMaybe<ActivityFilterInputAdult>;
  activityChild?: InputMaybe<ActivityFilterInputChild>;
  age?: InputMaybe<AgeFilterInput>;
  gameId: Scalars['String'];
  gender?: InputMaybe<GenderFilterInput>;
  imd?: InputMaybe<ImdFilterInput>;
  teamType?: InputMaybe<TeamFilterInput>;
};

export type GetSchoolData = {
  id: Scalars['String'];
  members: Scalars['String'];
  name: Scalars['String'];
  points: Scalars['String'];
  rollNumber: Scalars['String'];
};

export type GetSurveysCompleted = {
  total: Scalars['Float'];
  uniquePlayers: Scalars['Float'];
};

export type GetSurveysCompletedInput = {
  gameId: Scalars['String'];
};

export type GetSwipesFrequenciesDailyInput = {
  gameId: Scalars['String'];
};

export type GetSwipesFrequenciesHourlyChartInput = {
  gameId: Scalars['String'];
};

export type GetSwipesFrequenciesHourlyInput = {
  gameId: Scalars['String'];
};

export type GetTeamInput = {
  gameId: Scalars['String'];
  id: Scalars['String'];
};

export type GetTeamLeaderboardsInput = {
  gameId: Scalars['String'];
  leaderboardId?: InputMaybe<Scalars['String']>;
  pointType?: InputMaybe<LeaderboardTeamPointType>;
  type: LeaderboardPointType;
};

export type GetTeamsData = {
  SENSchool: Scalars['Float'];
  all: Scalars['Float'];
  allSchoolsPlayers: Scalars['Float'];
  allTeamsPlayers: Scalars['Float'];
  charity: Scalars['Float'];
  community: Scalars['Float'];
  cycling: Scalars['Float'];
  running: Scalars['Float'];
  school: Scalars['Float'];
  workplace: Scalars['Float'];
};

export type GetTime = {
  gameId: Scalars['String'];
  playerId: Scalars['String'];
};

export type GetTimeRes = {
  locationId?: Maybe<Scalars['String']>;
  time: Scalars['Float'];
};

export type Group = {
  color: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  gameId: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type GroupElement = {
  gameId: Scalars['String'];
  groupId: Scalars['String'];
  locationId: Scalars['String'];
};

/** Create / Delete Group element */
export type GroupElementInput = {
  gameId: Scalars['String'];
  groupId: Scalars['String'];
  locationId: Scalars['String'];
};

/** Game Freshdesk widget */
export enum HelpWidget {
  Standard = 'standard',
  StandardAndMobile = 'standardAndMobile',
  StandardAndWelsh = 'standardAndWelsh'
}

export type ImdFilterInput = {
  IMD1: Scalars['Boolean'];
  IMD2: Scalars['Boolean'];
  IMD3: Scalars['Boolean'];
  IMD4: Scalars['Boolean'];
  IMD5: Scalars['Boolean'];
  IMD6: Scalars['Boolean'];
  IMD7: Scalars['Boolean'];
  IMD8: Scalars['Boolean'];
  IMD9: Scalars['Boolean'];
  IMD10: Scalars['Boolean'];
};

export enum ImageCropFocus {
  Attention = 'ATTENTION',
  Center = 'CENTER',
  East = 'EAST',
  Entropy = 'ENTROPY',
  North = 'NORTH',
  Northeast = 'NORTHEAST',
  Northwest = 'NORTHWEST',
  South = 'SOUTH',
  Southeast = 'SOUTHEAST',
  Southwest = 'SOUTHWEST',
  West = 'WEST'
}

export enum ImageFit {
  Contain = 'CONTAIN',
  Cover = 'COVER',
  Fill = 'FILL',
  Inside = 'INSIDE',
  Outside = 'OUTSIDE'
}

export enum ImageFormat {
  Auto = 'AUTO',
  Avif = 'AVIF',
  Jpg = 'JPG',
  NoChange = 'NO_CHANGE',
  Png = 'PNG',
  Webp = 'WEBP'
}

export enum ImageLayout {
  Constrained = 'CONSTRAINED',
  Fixed = 'FIXED',
  FullWidth = 'FULL_WIDTH'
}

export enum ImagePlaceholder {
  Blurred = 'BLURRED',
  DominantColor = 'DOMINANT_COLOR',
  None = 'NONE',
  TracedSvg = 'TRACED_SVG'
}

export type ImageSharp = Node & {
  children: Array<Node>;
  fixed?: Maybe<ImageSharpFixed>;
  fluid?: Maybe<ImageSharpFluid>;
  gatsbyImageData: Scalars['GatsbyImageData'];
  id: Scalars['ID'];
  internal: Internal;
  original?: Maybe<ImageSharpOriginal>;
  parent?: Maybe<Node>;
  resize?: Maybe<ImageSharpResize>;
};


export type ImageSharpFixedArgs = {
  background?: InputMaybe<Scalars['String']>;
  base64Width?: InputMaybe<Scalars['Int']>;
  cropFocus?: InputMaybe<ImageCropFocus>;
  duotone?: InputMaybe<DuotoneGradient>;
  fit?: InputMaybe<ImageFit>;
  grayscale?: InputMaybe<Scalars['Boolean']>;
  height?: InputMaybe<Scalars['Int']>;
  jpegProgressive?: InputMaybe<Scalars['Boolean']>;
  jpegQuality?: InputMaybe<Scalars['Int']>;
  pngCompressionSpeed?: InputMaybe<Scalars['Int']>;
  pngQuality?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  rotate?: InputMaybe<Scalars['Int']>;
  toFormat?: InputMaybe<ImageFormat>;
  toFormatBase64?: InputMaybe<ImageFormat>;
  traceSVG?: InputMaybe<Potrace>;
  trim?: InputMaybe<Scalars['Float']>;
  webpQuality?: InputMaybe<Scalars['Int']>;
  width?: InputMaybe<Scalars['Int']>;
};


export type ImageSharpFluidArgs = {
  background?: InputMaybe<Scalars['String']>;
  base64Width?: InputMaybe<Scalars['Int']>;
  cropFocus?: InputMaybe<ImageCropFocus>;
  duotone?: InputMaybe<DuotoneGradient>;
  fit?: InputMaybe<ImageFit>;
  grayscale?: InputMaybe<Scalars['Boolean']>;
  jpegProgressive?: InputMaybe<Scalars['Boolean']>;
  jpegQuality?: InputMaybe<Scalars['Int']>;
  maxHeight?: InputMaybe<Scalars['Int']>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  pngCompressionSpeed?: InputMaybe<Scalars['Int']>;
  pngQuality?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  rotate?: InputMaybe<Scalars['Int']>;
  sizes?: InputMaybe<Scalars['String']>;
  srcSetBreakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  toFormat?: InputMaybe<ImageFormat>;
  toFormatBase64?: InputMaybe<ImageFormat>;
  traceSVG?: InputMaybe<Potrace>;
  trim?: InputMaybe<Scalars['Float']>;
  webpQuality?: InputMaybe<Scalars['Int']>;
};


export type ImageSharpGatsbyImageDataArgs = {
  aspectRatio?: InputMaybe<Scalars['Float']>;
  avifOptions?: InputMaybe<AvifOptions>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  blurredOptions?: InputMaybe<BlurredOptions>;
  breakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  formats?: InputMaybe<Array<InputMaybe<ImageFormat>>>;
  height?: InputMaybe<Scalars['Int']>;
  jpgOptions?: InputMaybe<JpgOptions>;
  layout?: InputMaybe<ImageLayout>;
  outputPixelDensities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  placeholder?: InputMaybe<ImagePlaceholder>;
  pngOptions?: InputMaybe<PngOptions>;
  quality?: InputMaybe<Scalars['Int']>;
  sizes?: InputMaybe<Scalars['String']>;
  tracedSVGOptions?: InputMaybe<Potrace>;
  transformOptions?: InputMaybe<TransformOptions>;
  webpOptions?: InputMaybe<WebPOptions>;
  width?: InputMaybe<Scalars['Int']>;
};


export type ImageSharpResizeArgs = {
  background?: InputMaybe<Scalars['String']>;
  base64?: InputMaybe<Scalars['Boolean']>;
  cropFocus?: InputMaybe<ImageCropFocus>;
  duotone?: InputMaybe<DuotoneGradient>;
  fit?: InputMaybe<ImageFit>;
  grayscale?: InputMaybe<Scalars['Boolean']>;
  height?: InputMaybe<Scalars['Int']>;
  jpegProgressive?: InputMaybe<Scalars['Boolean']>;
  jpegQuality?: InputMaybe<Scalars['Int']>;
  pngCompressionLevel?: InputMaybe<Scalars['Int']>;
  pngCompressionSpeed?: InputMaybe<Scalars['Int']>;
  pngQuality?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  rotate?: InputMaybe<Scalars['Int']>;
  toFormat?: InputMaybe<ImageFormat>;
  traceSVG?: InputMaybe<Potrace>;
  trim?: InputMaybe<Scalars['Float']>;
  webpQuality?: InputMaybe<Scalars['Int']>;
  width?: InputMaybe<Scalars['Int']>;
};

export type ImageSharpConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<ImageSharpEdge>;
  group: Array<ImageSharpGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<ImageSharp>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type ImageSharpConnectionDistinctArgs = {
  field: ImageSharpFieldSelector;
};


export type ImageSharpConnectionGroupArgs = {
  field: ImageSharpFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type ImageSharpConnectionMaxArgs = {
  field: ImageSharpFieldSelector;
};


export type ImageSharpConnectionMinArgs = {
  field: ImageSharpFieldSelector;
};


export type ImageSharpConnectionSumArgs = {
  field: ImageSharpFieldSelector;
};

export type ImageSharpEdge = {
  next?: Maybe<ImageSharp>;
  node: ImageSharp;
  previous?: Maybe<ImageSharp>;
};

export type ImageSharpFieldSelector = {
  children?: InputMaybe<NodeFieldSelector>;
  fixed?: InputMaybe<ImageSharpFixedFieldSelector>;
  fluid?: InputMaybe<ImageSharpFluidFieldSelector>;
  gatsbyImageData?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  original?: InputMaybe<ImageSharpOriginalFieldSelector>;
  parent?: InputMaybe<NodeFieldSelector>;
  resize?: InputMaybe<ImageSharpResizeFieldSelector>;
};

export type ImageSharpFilterInput = {
  children?: InputMaybe<NodeFilterListInput>;
  fixed?: InputMaybe<ImageSharpFixedFilterInput>;
  fluid?: InputMaybe<ImageSharpFluidFilterInput>;
  gatsbyImageData?: InputMaybe<GatsbyImageDataQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  original?: InputMaybe<ImageSharpOriginalFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
  resize?: InputMaybe<ImageSharpResizeFilterInput>;
};

export type ImageSharpFilterListInput = {
  elemMatch?: InputMaybe<ImageSharpFilterInput>;
};

export type ImageSharpFixed = {
  aspectRatio?: Maybe<Scalars['Float']>;
  base64?: Maybe<Scalars['String']>;
  height: Scalars['Float'];
  originalName?: Maybe<Scalars['String']>;
  src: Scalars['String'];
  srcSet: Scalars['String'];
  srcSetWebp?: Maybe<Scalars['String']>;
  srcWebp?: Maybe<Scalars['String']>;
  tracedSVG?: Maybe<Scalars['String']>;
  width: Scalars['Float'];
};

export type ImageSharpFixedFieldSelector = {
  aspectRatio?: InputMaybe<FieldSelectorEnum>;
  base64?: InputMaybe<FieldSelectorEnum>;
  height?: InputMaybe<FieldSelectorEnum>;
  originalName?: InputMaybe<FieldSelectorEnum>;
  src?: InputMaybe<FieldSelectorEnum>;
  srcSet?: InputMaybe<FieldSelectorEnum>;
  srcSetWebp?: InputMaybe<FieldSelectorEnum>;
  srcWebp?: InputMaybe<FieldSelectorEnum>;
  tracedSVG?: InputMaybe<FieldSelectorEnum>;
  width?: InputMaybe<FieldSelectorEnum>;
};

export type ImageSharpFixedFilterInput = {
  aspectRatio?: InputMaybe<FloatQueryOperatorInput>;
  base64?: InputMaybe<StringQueryOperatorInput>;
  height?: InputMaybe<FloatQueryOperatorInput>;
  originalName?: InputMaybe<StringQueryOperatorInput>;
  src?: InputMaybe<StringQueryOperatorInput>;
  srcSet?: InputMaybe<StringQueryOperatorInput>;
  srcSetWebp?: InputMaybe<StringQueryOperatorInput>;
  srcWebp?: InputMaybe<StringQueryOperatorInput>;
  tracedSVG?: InputMaybe<StringQueryOperatorInput>;
  width?: InputMaybe<FloatQueryOperatorInput>;
};

export type ImageSharpFixedSortInput = {
  aspectRatio?: InputMaybe<SortOrderEnum>;
  base64?: InputMaybe<SortOrderEnum>;
  height?: InputMaybe<SortOrderEnum>;
  originalName?: InputMaybe<SortOrderEnum>;
  src?: InputMaybe<SortOrderEnum>;
  srcSet?: InputMaybe<SortOrderEnum>;
  srcSetWebp?: InputMaybe<SortOrderEnum>;
  srcWebp?: InputMaybe<SortOrderEnum>;
  tracedSVG?: InputMaybe<SortOrderEnum>;
  width?: InputMaybe<SortOrderEnum>;
};

export type ImageSharpFluid = {
  aspectRatio: Scalars['Float'];
  base64?: Maybe<Scalars['String']>;
  originalImg?: Maybe<Scalars['String']>;
  originalName?: Maybe<Scalars['String']>;
  presentationHeight: Scalars['Int'];
  presentationWidth: Scalars['Int'];
  sizes: Scalars['String'];
  src: Scalars['String'];
  srcSet: Scalars['String'];
  srcSetWebp?: Maybe<Scalars['String']>;
  srcWebp?: Maybe<Scalars['String']>;
  tracedSVG?: Maybe<Scalars['String']>;
};

export type ImageSharpFluidFieldSelector = {
  aspectRatio?: InputMaybe<FieldSelectorEnum>;
  base64?: InputMaybe<FieldSelectorEnum>;
  originalImg?: InputMaybe<FieldSelectorEnum>;
  originalName?: InputMaybe<FieldSelectorEnum>;
  presentationHeight?: InputMaybe<FieldSelectorEnum>;
  presentationWidth?: InputMaybe<FieldSelectorEnum>;
  sizes?: InputMaybe<FieldSelectorEnum>;
  src?: InputMaybe<FieldSelectorEnum>;
  srcSet?: InputMaybe<FieldSelectorEnum>;
  srcSetWebp?: InputMaybe<FieldSelectorEnum>;
  srcWebp?: InputMaybe<FieldSelectorEnum>;
  tracedSVG?: InputMaybe<FieldSelectorEnum>;
};

export type ImageSharpFluidFilterInput = {
  aspectRatio?: InputMaybe<FloatQueryOperatorInput>;
  base64?: InputMaybe<StringQueryOperatorInput>;
  originalImg?: InputMaybe<StringQueryOperatorInput>;
  originalName?: InputMaybe<StringQueryOperatorInput>;
  presentationHeight?: InputMaybe<IntQueryOperatorInput>;
  presentationWidth?: InputMaybe<IntQueryOperatorInput>;
  sizes?: InputMaybe<StringQueryOperatorInput>;
  src?: InputMaybe<StringQueryOperatorInput>;
  srcSet?: InputMaybe<StringQueryOperatorInput>;
  srcSetWebp?: InputMaybe<StringQueryOperatorInput>;
  srcWebp?: InputMaybe<StringQueryOperatorInput>;
  tracedSVG?: InputMaybe<StringQueryOperatorInput>;
};

export type ImageSharpFluidSortInput = {
  aspectRatio?: InputMaybe<SortOrderEnum>;
  base64?: InputMaybe<SortOrderEnum>;
  originalImg?: InputMaybe<SortOrderEnum>;
  originalName?: InputMaybe<SortOrderEnum>;
  presentationHeight?: InputMaybe<SortOrderEnum>;
  presentationWidth?: InputMaybe<SortOrderEnum>;
  sizes?: InputMaybe<SortOrderEnum>;
  src?: InputMaybe<SortOrderEnum>;
  srcSet?: InputMaybe<SortOrderEnum>;
  srcSetWebp?: InputMaybe<SortOrderEnum>;
  srcWebp?: InputMaybe<SortOrderEnum>;
  tracedSVG?: InputMaybe<SortOrderEnum>;
};

export type ImageSharpGroupConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<ImageSharpEdge>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
  group: Array<ImageSharpGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<ImageSharp>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type ImageSharpGroupConnectionDistinctArgs = {
  field: ImageSharpFieldSelector;
};


export type ImageSharpGroupConnectionGroupArgs = {
  field: ImageSharpFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type ImageSharpGroupConnectionMaxArgs = {
  field: ImageSharpFieldSelector;
};


export type ImageSharpGroupConnectionMinArgs = {
  field: ImageSharpFieldSelector;
};


export type ImageSharpGroupConnectionSumArgs = {
  field: ImageSharpFieldSelector;
};

export type ImageSharpOriginal = {
  height?: Maybe<Scalars['Float']>;
  src?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Float']>;
};

export type ImageSharpOriginalFieldSelector = {
  height?: InputMaybe<FieldSelectorEnum>;
  src?: InputMaybe<FieldSelectorEnum>;
  width?: InputMaybe<FieldSelectorEnum>;
};

export type ImageSharpOriginalFilterInput = {
  height?: InputMaybe<FloatQueryOperatorInput>;
  src?: InputMaybe<StringQueryOperatorInput>;
  width?: InputMaybe<FloatQueryOperatorInput>;
};

export type ImageSharpOriginalSortInput = {
  height?: InputMaybe<SortOrderEnum>;
  src?: InputMaybe<SortOrderEnum>;
  width?: InputMaybe<SortOrderEnum>;
};

export type ImageSharpResize = {
  aspectRatio?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Int']>;
  originalName?: Maybe<Scalars['String']>;
  src?: Maybe<Scalars['String']>;
  tracedSVG?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
};

export type ImageSharpResizeFieldSelector = {
  aspectRatio?: InputMaybe<FieldSelectorEnum>;
  height?: InputMaybe<FieldSelectorEnum>;
  originalName?: InputMaybe<FieldSelectorEnum>;
  src?: InputMaybe<FieldSelectorEnum>;
  tracedSVG?: InputMaybe<FieldSelectorEnum>;
  width?: InputMaybe<FieldSelectorEnum>;
};

export type ImageSharpResizeFilterInput = {
  aspectRatio?: InputMaybe<FloatQueryOperatorInput>;
  height?: InputMaybe<IntQueryOperatorInput>;
  originalName?: InputMaybe<StringQueryOperatorInput>;
  src?: InputMaybe<StringQueryOperatorInput>;
  tracedSVG?: InputMaybe<StringQueryOperatorInput>;
  width?: InputMaybe<IntQueryOperatorInput>;
};

export type ImageSharpResizeSortInput = {
  aspectRatio?: InputMaybe<SortOrderEnum>;
  height?: InputMaybe<SortOrderEnum>;
  originalName?: InputMaybe<SortOrderEnum>;
  src?: InputMaybe<SortOrderEnum>;
  tracedSVG?: InputMaybe<SortOrderEnum>;
  width?: InputMaybe<SortOrderEnum>;
};

export type ImageSharpSortInput = {
  children?: InputMaybe<NodeSortInput>;
  fixed?: InputMaybe<ImageSharpFixedSortInput>;
  fluid?: InputMaybe<ImageSharpFluidSortInput>;
  gatsbyImageData?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  original?: InputMaybe<ImageSharpOriginalSortInput>;
  parent?: InputMaybe<NodeSortInput>;
  resize?: InputMaybe<ImageSharpResizeSortInput>;
};

export type InactiveTag = {
  endDate?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  playerId: Scalars['String'];
  startDate: Scalars['String'];
  tagNumber: Scalars['Int'];
};

/** Create Inactive Tag */
export type InactiveTagCreateInput = {
  endDate?: InputMaybe<Scalars['String']>;
  playerId: Scalars['String'];
  startDate: Scalars['String'];
  tagNumber: Scalars['Int'];
};

/** Delete Inactive Tag */
export type InactiveTagDeleteInput = {
  id: Scalars['String'];
  playerId: Scalars['String'];
};

export type IncrementPlayerPoint = {
  extra: Scalars['Float'];
  id: Scalars['String'];
};

/** Installer Update Location */
export type InstallerLocationUpdateInput = {
  gameId: Scalars['String'];
  id: Scalars['String'];
  lat?: InputMaybe<Scalars['Float']>;
  lng?: InputMaybe<Scalars['Float']>;
};

export type IntQueryOperatorInput = {
  eq?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  ne?: InputMaybe<Scalars['Int']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type Internal = {
  content?: Maybe<Scalars['String']>;
  contentDigest: Scalars['String'];
  contentFilePath?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  fieldOwners?: Maybe<Array<Maybe<Scalars['String']>>>;
  ignoreType?: Maybe<Scalars['Boolean']>;
  mediaType?: Maybe<Scalars['String']>;
  owner: Scalars['String'];
  type: Scalars['String'];
};

export type InternalFieldSelector = {
  content?: InputMaybe<FieldSelectorEnum>;
  contentDigest?: InputMaybe<FieldSelectorEnum>;
  contentFilePath?: InputMaybe<FieldSelectorEnum>;
  description?: InputMaybe<FieldSelectorEnum>;
  fieldOwners?: InputMaybe<FieldSelectorEnum>;
  ignoreType?: InputMaybe<FieldSelectorEnum>;
  mediaType?: InputMaybe<FieldSelectorEnum>;
  owner?: InputMaybe<FieldSelectorEnum>;
  type?: InputMaybe<FieldSelectorEnum>;
};

export type InternalFilterInput = {
  content?: InputMaybe<StringQueryOperatorInput>;
  contentDigest?: InputMaybe<StringQueryOperatorInput>;
  contentFilePath?: InputMaybe<StringQueryOperatorInput>;
  description?: InputMaybe<StringQueryOperatorInput>;
  fieldOwners?: InputMaybe<StringQueryOperatorInput>;
  ignoreType?: InputMaybe<BooleanQueryOperatorInput>;
  mediaType?: InputMaybe<StringQueryOperatorInput>;
  owner?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
};

export type InternalSortInput = {
  content?: InputMaybe<SortOrderEnum>;
  contentDigest?: InputMaybe<SortOrderEnum>;
  contentFilePath?: InputMaybe<SortOrderEnum>;
  description?: InputMaybe<SortOrderEnum>;
  fieldOwners?: InputMaybe<SortOrderEnum>;
  ignoreType?: InputMaybe<SortOrderEnum>;
  mediaType?: InputMaybe<SortOrderEnum>;
  owner?: InputMaybe<SortOrderEnum>;
  type?: InputMaybe<SortOrderEnum>;
};

export type IsTagSubrangesAvailable = {
  from: Scalars['Int'];
  to: Scalars['Int'];
};

export type JpgOptions = {
  progressive?: InputMaybe<Scalars['Boolean']>;
  quality?: InputMaybe<Scalars['Int']>;
};

export type JsonQueryOperatorInput = {
  eq?: InputMaybe<Scalars['JSON']>;
  glob?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  ne?: InputMaybe<Scalars['JSON']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  regex?: InputMaybe<Scalars['JSON']>;
};

export type JoinFamilyInput = {
  parentId: Scalars['String'];
};

export type JoinGameInput = {
  consentText?: InputMaybe<Scalars['String']>;
  gameId: Scalars['String'];
};

export type JoinTeamInput = {
  playerId: Scalars['String'];
  teamId: Scalars['String'];
};

export type Leaderboard = {
  board: Array<BoardItem>;
};

export enum LeaderboardEntity {
  Player = 'Player',
  Team = 'Team'
}

export enum LeaderboardPointType {
  Gem = 'gem',
  Swipe = 'swipe'
}

export enum LeaderboardTeamPointType {
  All = 'all',
  Average = 'average'
}

export type LeaderboardWAverage = {
  averageBoard: Array<BoardItem>;
  board: Array<BoardItem>;
};

export type LeaderboardsResponse = {
  data: Array<LeaderboardsResults>;
  rank: Scalars['String'];
};

export type LeaderboardsResults = {
  amount: Scalars['Float'];
  avatar?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  marked: Scalars['Boolean'];
  name: Scalars['String'];
  position: Scalars['Float'];
};

export type LeaderboardsTeamResponse = {
  data: Array<LeaderboardsTeamResults>;
  rank: Scalars['String'];
};

export type LeaderboardsTeamResults = {
  amount: Scalars['Float'];
  avatar?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  marked: Scalars['Boolean'];
  name: Scalars['String'];
  position: Scalars['Float'];
  totalMembers: Scalars['Int'];
};

export type Locale = Node & {
  children: Array<Node>;
  data?: Maybe<Scalars['String']>;
  fileAbsolutePath?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  internal: Internal;
  language?: Maybe<Scalars['String']>;
  ns?: Maybe<Scalars['String']>;
  parent?: Maybe<Node>;
};

export type LocaleConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<LocaleEdge>;
  group: Array<LocaleGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<Locale>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type LocaleConnectionDistinctArgs = {
  field: LocaleFieldSelector;
};


export type LocaleConnectionGroupArgs = {
  field: LocaleFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type LocaleConnectionMaxArgs = {
  field: LocaleFieldSelector;
};


export type LocaleConnectionMinArgs = {
  field: LocaleFieldSelector;
};


export type LocaleConnectionSumArgs = {
  field: LocaleFieldSelector;
};

export type LocaleEdge = {
  next?: Maybe<Locale>;
  node: Locale;
  previous?: Maybe<Locale>;
};

export type LocaleFieldSelector = {
  children?: InputMaybe<NodeFieldSelector>;
  data?: InputMaybe<FieldSelectorEnum>;
  fileAbsolutePath?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  language?: InputMaybe<FieldSelectorEnum>;
  ns?: InputMaybe<FieldSelectorEnum>;
  parent?: InputMaybe<NodeFieldSelector>;
};

export type LocaleFilterInput = {
  children?: InputMaybe<NodeFilterListInput>;
  data?: InputMaybe<StringQueryOperatorInput>;
  fileAbsolutePath?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  language?: InputMaybe<StringQueryOperatorInput>;
  ns?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
};

export type LocaleFilterListInput = {
  elemMatch?: InputMaybe<LocaleFilterInput>;
};

export type LocaleGroupConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<LocaleEdge>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
  group: Array<LocaleGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<Locale>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type LocaleGroupConnectionDistinctArgs = {
  field: LocaleFieldSelector;
};


export type LocaleGroupConnectionGroupArgs = {
  field: LocaleFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type LocaleGroupConnectionMaxArgs = {
  field: LocaleFieldSelector;
};


export type LocaleGroupConnectionMinArgs = {
  field: LocaleFieldSelector;
};


export type LocaleGroupConnectionSumArgs = {
  field: LocaleFieldSelector;
};

export type LocaleSortInput = {
  children?: InputMaybe<NodeSortInput>;
  data?: InputMaybe<SortOrderEnum>;
  fileAbsolutePath?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  language?: InputMaybe<SortOrderEnum>;
  ns?: InputMaybe<SortOrderEnum>;
  parent?: InputMaybe<NodeSortInput>;
};

export type Location = {
  beatBoxNumber?: Maybe<Scalars['Int']>;
  /** Maximum points set in event on request time */
  currentPoints: Scalars['Int'];
  details: LocationDetails;
  gameId: Scalars['String'];
  gemType?: Maybe<GemType>;
  id: Scalars['String'];
  isVisible: Scalars['Boolean'];
  lat: Scalars['Float'];
  lng: Scalars['Float'];
  /** Default points to be gain in location */
  points: Scalars['Int'];
  slug: Scalars['String'];
  status: LocationStatus;
  type: LocationTypes;
};

/** Create Location */
export type LocationCreateInput = {
  beatBoxNumber?: InputMaybe<Scalars['Int']>;
  details?: InputMaybe<LocationDetailsCreateInput>;
  gameId: Scalars['String'];
  gemType?: InputMaybe<GemType>;
  id?: InputMaybe<Scalars['String']>;
  lat: Scalars['Float'];
  lng: Scalars['Float'];
  points?: InputMaybe<Scalars['Int']>;
  slug: Scalars['String'];
  type: LocationTypes;
};

export type LocationDetails = {
  accessible?: Maybe<Scalars['Boolean']>;
  batteryLevel?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  deviceID?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isMobile?: Maybe<Scalars['Boolean']>;
  /** Friendly/display name */
  name?: Maybe<Scalars['String']>;
  ownerName?: Maybe<Scalars['String']>;
  reported?: Maybe<Scalars['String']>;
  /** @deprecated use location.status instead */
  status?: Maybe<Scalars['String']>;
  what3words?: Maybe<Array<Scalars['String']>>;
};

/** Create Location Details */
export type LocationDetailsCreateInput = {
  accessible?: InputMaybe<Scalars['Boolean']>;
  batteryLevel?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  deviceID?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isMobile?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  ownerName?: InputMaybe<Scalars['String']>;
  reported?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  what3words?: InputMaybe<Array<Scalars['String']>>;
};

/** Update Location Details */
export type LocationDetailsUpdateInput = {
  accessible?: InputMaybe<Scalars['Boolean']>;
  batteryLevel?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  deviceID?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  isMobile?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  ownerName?: InputMaybe<Scalars['String']>;
  reported?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  what3words?: InputMaybe<Array<Scalars['String']>>;
};

/** Status of each location. Handle soft deletes */
export enum LocationStatus {
  Active = 'active',
  Removed = 'removed'
}

/** Types of map locations */
export enum LocationTypes {
  Poi = 'POI',
  BeatBox = 'beatBox',
  DistributionPoint = 'distributionPoint',
  Gem = 'gem',
  School = 'school'
}

/** Update Location */
export type LocationUpdateInput = {
  beatBoxNumber?: InputMaybe<Scalars['Int']>;
  details?: InputMaybe<LocationDetailsUpdateInput>;
  gameId: Scalars['String'];
  gemType?: InputMaybe<GemType>;
  id: Scalars['String'];
  lat?: InputMaybe<Scalars['Float']>;
  lng?: InputMaybe<Scalars['Float']>;
  points?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<LocationTypes>;
};

export type LsoaCodes = {
  indexOfPenetration: Scalars['Float'];
  lsoaCode: Scalars['String'];
  lsoaName: Scalars['String'];
  totalPlayers: Scalars['Float'];
  totalPopulation: Scalars['Float'];
};

export type Message = {
  /** Team message specific */
  authorId?: Maybe<Scalars['String']>;
  campaignId: Scalars['String'];
  category: Scalars['String'];
  /** Team: { title: string, body: string }. Other: SANITY_CONTENT_ID */
  content: Scalars['String'];
  createdAt: Scalars['String'];
  /** Pinpoint message specific */
  endpointId?: Maybe<Scalars['String']>;
  /** Team message specific */
  gameId?: Maybe<Scalars['String']>;
  isLiked: Scalars['Boolean'];
  likesCount: Scalars['Int'];
  messageId: Scalars['String'];
  playerId: Scalars['String'];
  readAt?: Maybe<Scalars['String']>;
  /** Team message specific */
  teamId?: Maybe<Scalars['String']>;
  /** Team message specific */
  teamName?: Maybe<Scalars['String']>;
};

export type Metrics = {
  ConnectedAdultAccounts: Scalars['Float'];
  ConnectedChildAccounts: Scalars['Float'];
  GemsCount: GemsCount;
  LastSwipeDate: Scalars['String'];
  PercentBoxesVisited: Scalars['Float'];
  TotalGemPoints: Scalars['Float'];
  TotalGems: Scalars['Float'];
  TotalMiles: Scalars['Float'];
  TotalPoints: Scalars['Float'];
  TotalSwipes: Scalars['Float'];
  TotalTeamPoints: Scalars['Float'];
};

export type MovePlayerInput = {
  playerId: Scalars['String'];
  tagNumber: Scalars['Int'];
};

export type MoveSmallTeamsInput = {
  gameId: Scalars['String'];
  size: Scalars['Float'];
};

export type MovingStats = {
  gameId: Scalars['String'];
  id: Scalars['String'];
  playerId: Scalars['String'];
  timestamp: Scalars['String'];
  type: Scalars['String'];
};

export type Mutation = {
  adminAssignTagSubrange: Scalars['Boolean'];
  adminBulkChangeTagSubrange: Scalars['Boolean'];
  adminChangePassword: Scalars['Boolean'];
  adminCreateEmailList: Scalars['String'];
  adminCreateEvent: Event;
  adminCreateGame: Game;
  adminCreateGroup: Group;
  adminCreateGroupElement: GroupElement;
  adminCreateInactiveTag: InactiveTag;
  adminCreateLeaderboard: GameLeaderboard;
  adminCreateLocation: Location;
  adminCreatePlayer: Player;
  adminCreateTagGlobal: TagGlobalRange;
  adminCreateTagRange: GameTagRange;
  adminCreateTagSubrange: GameTagSubrange;
  adminCreateTeam: Team;
  adminDeleteEvent: Event;
  adminDeleteEventPoint: Scalars['Boolean'];
  adminDeleteGame: Scalars['Boolean'];
  adminDeleteGroup: Scalars['Boolean'];
  adminDeleteGroupElement: Scalars['Boolean'];
  adminDeleteLeaderboard: Scalars['Boolean'];
  adminDeleteLocation: Scalars['Boolean'];
  adminDeletePlayer: Scalars['Boolean'];
  adminDeleteTagGlobal: Scalars['Boolean'];
  adminDeleteTagRange: Scalars['Boolean'];
  adminDeleteTagSubrange: Scalars['Boolean'];
  adminDeleteTeam: Scalars['Boolean'];
  adminDuplicateEvent: Event;
  adminFillEmailList: Scalars['Int'];
  adminIsSubrangeAvailable: Scalars['Boolean'];
  adminMoveSmallTeams: Scalars['Boolean'];
  adminMoveTag: Scalars['Boolean'];
  adminRemoveFromGame: Scalars['Boolean'];
  adminRemoveInactiveTag: Scalars['Boolean'];
  adminUpdateEvent: Event;
  adminUpdateGame: Game;
  adminUpdateGroup: Group;
  adminUpdateLeaderboard: GameLeaderboard;
  adminUpdateLocation: Location;
  adminUpdatePlayer: Player;
  adminUpdatePlayerPoints: Scalars['Boolean'];
  adminUpdateTagGlobal: TagGlobalRange;
  adminUpdateTagRange: GameTagRange;
  adminUpdateTagSubrange: GameTagSubrange;
  adminUpdateTeam: Team;
  adminValidateSurvey: ValidateSurveyResponse;
  assignTag: PlayerTag;
  checkPostCode: PostCode;
  collect: Scalars['Boolean'];
  confirmEmail: Scalars['Boolean'];
  contactRequest: Scalars['Boolean'];
  createChild: Player;
  createFollow: Scalars['Boolean'];
  createMovingStats: MovingStats;
  createSurvey: Survey;
  createTeam: Team;
  createTeamV2: Scalars['String'];
  deleteChild: Scalars['Boolean'];
  deleteFollow: Scalars['Boolean'];
  deletePlayer: Scalars['Boolean'];
  deleteTeamV2: Scalars['Boolean'];
  demoteLeaderV2: Scalars['Boolean'];
  installerUpdateLocation: Location;
  joinFamily: Scalars['Boolean'];
  joinGame: Scalars['Boolean'];
  joinTeam: Scalars['Boolean'];
  joinTeamV2: Scalars['Boolean'];
  leaveGame: Scalars['Boolean'];
  leaveTeam: Scalars['Boolean'];
  leaveTeamV2: Scalars['Boolean'];
  likeMessage: Scalars['Boolean'];
  newsletterSignUp: Scalars['Boolean'];
  postTeamMessage: Scalars['Boolean'];
  promoteLeaderV2: Scalars['Boolean'];
  readMessage: Scalars['Boolean'];
  removeFromFamily: Scalars['Boolean'];
  reportUser: Scalars['Boolean'];
  signup: Player;
  unlikeMessage: Scalars['Boolean'];
  updatePlayer: Player;
};


export type MutationAdminAssignTagSubrangeArgs = {
  input: AssignSubranges;
};


export type MutationAdminBulkChangeTagSubrangeArgs = {
  input: BulkChangeSubranges;
};


export type MutationAdminChangePasswordArgs = {
  input: ChangePasswordInput;
};


export type MutationAdminCreateEmailListArgs = {
  gameId: Scalars['String'];
};


export type MutationAdminCreateEventArgs = {
  input: EventCreateInput;
};


export type MutationAdminCreateGameArgs = {
  input: CreateGameInput;
};


export type MutationAdminCreateGroupArgs = {
  input: CreateGroupInput;
};


export type MutationAdminCreateGroupElementArgs = {
  input: GroupElementInput;
};


export type MutationAdminCreateInactiveTagArgs = {
  input: InactiveTagCreateInput;
};


export type MutationAdminCreateLeaderboardArgs = {
  input: GameLeaderboardCreateInput;
};


export type MutationAdminCreateLocationArgs = {
  input: LocationCreateInput;
};


export type MutationAdminCreatePlayerArgs = {
  input: CreatePlayerInput;
};


export type MutationAdminCreateTagGlobalArgs = {
  input: TagGlobalRangeCreateInput;
};


export type MutationAdminCreateTagRangeArgs = {
  input: GameTagRangeCreateInput;
};


export type MutationAdminCreateTagSubrangeArgs = {
  input: GameTagSubrangeCreateInput;
};


export type MutationAdminCreateTeamArgs = {
  input: TeamCreateInput;
};


export type MutationAdminDeleteEventArgs = {
  input: DeleteEvent;
};


export type MutationAdminDeleteEventPointArgs = {
  input: DeleteEventPoint;
};


export type MutationAdminDeleteGameArgs = {
  input: DeleteGameInput;
};


export type MutationAdminDeleteGroupArgs = {
  input: DeleteGroup;
};


export type MutationAdminDeleteGroupElementArgs = {
  input: GroupElementInput;
};


export type MutationAdminDeleteLeaderboardArgs = {
  input: DeleteLeaderboard;
};


export type MutationAdminDeleteLocationArgs = {
  input: DeleteLocation;
};


export type MutationAdminDeletePlayerArgs = {
  id: Scalars['String'];
};


export type MutationAdminDeleteTagGlobalArgs = {
  id: Scalars['String'];
};


export type MutationAdminDeleteTagRangeArgs = {
  input: GameTagRangeDeleteInput;
};


export type MutationAdminDeleteTagSubrangeArgs = {
  input: GameTagSubrangeDeleteInput;
};


export type MutationAdminDeleteTeamArgs = {
  input: TeamDeleteInput;
};


export type MutationAdminDuplicateEventArgs = {
  input: GetEvent;
};


export type MutationAdminFillEmailListArgs = {
  gameId: Scalars['String'];
};


export type MutationAdminIsSubrangeAvailableArgs = {
  input: IsTagSubrangesAvailable;
};


export type MutationAdminMoveSmallTeamsArgs = {
  input: MoveSmallTeamsInput;
};


export type MutationAdminMoveTagArgs = {
  input: MovePlayerInput;
};


export type MutationAdminRemoveFromGameArgs = {
  id: Scalars['String'];
};


export type MutationAdminRemoveInactiveTagArgs = {
  input: InactiveTagDeleteInput;
};


export type MutationAdminUpdateEventArgs = {
  input: EventUpdateInput;
};


export type MutationAdminUpdateGameArgs = {
  input: UpdateGameInput;
};


export type MutationAdminUpdateGroupArgs = {
  input: UpdateGroupInput;
};


export type MutationAdminUpdateLeaderboardArgs = {
  input: GameLeaderboardUpdateInput;
};


export type MutationAdminUpdateLocationArgs = {
  input: LocationUpdateInput;
};


export type MutationAdminUpdatePlayerArgs = {
  input: FullUpdatePlayerInput;
};


export type MutationAdminUpdatePlayerPointsArgs = {
  input: IncrementPlayerPoint;
};


export type MutationAdminUpdateTagGlobalArgs = {
  input: TagGlobalRangeUpdateInput;
};


export type MutationAdminUpdateTagRangeArgs = {
  input: GameTagRangeUpdateInput;
};


export type MutationAdminUpdateTagSubrangeArgs = {
  input: GameTagSubrangeUpdateInput;
};


export type MutationAdminUpdateTeamArgs = {
  input: TeamUpdateInput;
};


export type MutationAdminValidateSurveyArgs = {
  input: AdminValidateSurvey;
};


export type MutationAssignTagArgs = {
  input: PlayerTagCreateInput;
};


export type MutationCheckPostCodeArgs = {
  input: PostCodeInput;
};


export type MutationCollectArgs = {
  input: CollectInput;
};


export type MutationConfirmEmailArgs = {
  input: ConfirmEmailInput;
};


export type MutationContactRequestArgs = {
  input: ContactInput;
};


export type MutationCreateChildArgs = {
  input: CreateChildPlayerInput;
};


export type MutationCreateFollowArgs = {
  input: PlayerFollowInput;
};


export type MutationCreateMovingStatsArgs = {
  input: CreateMovingStatsInput;
};


export type MutationCreateSurveyArgs = {
  input: SurveySharedInput;
};


export type MutationCreateTeamArgs = {
  input: TeamCreateInput;
};


export type MutationCreateTeamV2Args = {
  gameId: Scalars['String'];
  name: Scalars['String'];
  parentTeamId?: InputMaybe<Scalars['String']>;
};


export type MutationDeleteChildArgs = {
  childId: Scalars['String'];
};


export type MutationDeleteFollowArgs = {
  input: PlayerFollowInput;
};


export type MutationDeleteTeamV2Args = {
  gameId: Scalars['String'];
  teamId: Scalars['String'];
};


export type MutationDemoteLeaderV2Args = {
  gameId: Scalars['String'];
  playerId: Scalars['String'];
  teamId: Scalars['String'];
};


export type MutationInstallerUpdateLocationArgs = {
  input: InstallerLocationUpdateInput;
};


export type MutationJoinFamilyArgs = {
  input: JoinFamilyInput;
};


export type MutationJoinGameArgs = {
  input: JoinGameInput;
};


export type MutationJoinTeamArgs = {
  input: JoinTeamInput;
};


export type MutationJoinTeamV2Args = {
  gameId: Scalars['String'];
  teamId: Scalars['String'];
};


export type MutationLeaveTeamArgs = {
  playerId: Scalars['String'];
};


export type MutationLeaveTeamV2Args = {
  gameId: Scalars['String'];
  teamId: Scalars['String'];
};


export type MutationLikeMessageArgs = {
  campaignId: Scalars['String'];
};


export type MutationNewsletterSignUpArgs = {
  input: NewsletterSignUpInput;
};


export type MutationPostTeamMessageArgs = {
  content: TeamMessageContent;
};


export type MutationPromoteLeaderV2Args = {
  gameId: Scalars['String'];
  playerId: Scalars['String'];
  teamId: Scalars['String'];
};


export type MutationReadMessageArgs = {
  messageId: Scalars['String'];
};


export type MutationRemoveFromFamilyArgs = {
  input: RemoveFromFamilyInput;
};


export type MutationReportUserArgs = {
  input: ReportUserInput;
};


export type MutationSignupArgs = {
  input: SignupPlayerInput;
};


export type MutationUnlikeMessageArgs = {
  campaignId: Scalars['String'];
};


export type MutationUpdatePlayerArgs = {
  input: UpdatePlayerInput;
};

export type NewsletterSignUpInput = {
  email: Scalars['String'];
  gameId: Scalars['String'];
};

/** Node Interface */
export type Node = {
  children: Array<Node>;
  id: Scalars['ID'];
  internal: Internal;
  parent?: Maybe<Node>;
};

export type NodeFieldSelector = {
  children?: InputMaybe<NodeFieldSelector>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  parent?: InputMaybe<NodeFieldSelector>;
};

export type NodeFilterInput = {
  children?: InputMaybe<NodeFilterListInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
};

export type NodeFilterListInput = {
  elemMatch?: InputMaybe<NodeFilterInput>;
};

export type NodeSortInput = {
  children?: InputMaybe<NodeSortInput>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  parent?: InputMaybe<NodeSortInput>;
};

/** Orders tag types (only card used) */
export enum OrderTagTypes {
  Card = 'CARD'
}

export type PngOptions = {
  compressionSpeed?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
};

export type PageInfo = {
  currentPage: Scalars['Int'];
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  itemCount: Scalars['Int'];
  pageCount: Scalars['Int'];
  perPage?: Maybe<Scalars['Int']>;
  totalCount: Scalars['Int'];
};

export type Player = {
  /** Only for local sign up purpose */
  authID?: Maybe<Scalars['String']>;
  game?: Maybe<PlayerGame>;
  gemRoutes?: Maybe<Array<GemRoute>>;
  id: Scalars['String'];
  info: PlayerInfo;
  points?: Maybe<PlayerPoint>;
  profile: PlayerProfile;
  role: PlayerRole;
  routes?: Maybe<Array<Route>>;
  tags: Array<PlayerTag>;
  team?: Maybe<Team>;
};

export type PlayerAnalytics = {
  metrics: Metrics;
  userAttributes: UserAttributes;
};

/** Create Player follow */
export type PlayerFollowInput = {
  followId: Scalars['String'];
  gameId: Scalars['String'];
  playerId: Scalars['String'];
};

export type PlayerGame = {
  consentAt?: Maybe<Scalars['String']>;
  consentText?: Maybe<Scalars['String']>;
  gameId: Scalars['String'];
  id: Scalars['String'];
  joinedAt?: Maybe<Scalars['String']>;
  leaveAt?: Maybe<Scalars['String']>;
  playerId: Scalars['String'];
};

export type PlayerInfo = {
  /** Reference to mobile avatar. ex.: character13 */
  avatar?: Maybe<Scalars['String']>;
  gameId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  publicName?: Maybe<Scalars['String']>;
  teamId?: Maybe<Scalars['String']>;
};

/** Update Player Info */
export type PlayerInfoInput = {
  avatar?: InputMaybe<Scalars['String']>;
  publicName?: InputMaybe<Scalars['String']>;
};

export type PlayerPoint = {
  /** Sum of routes and extra */
  all: Scalars['Float'];
  extra: Scalars['Float'];
  gems: Scalars['Float'];
  id: Scalars['String'];
  /** Points for beatbox */
  routes: Scalars['Float'];
};

export type PlayerProfile = {
  /** Only for children */
  ageGroup?: Maybe<Scalars['String']>;
  /** Player subscript to marketing email */
  allowMarketingEmails?: Maybe<Scalars['Boolean']>;
  birthDate?: Maybe<Scalars['String']>;
  birthYear?: Maybe<Scalars['Float']>;
  /** PLayer sign consent text. */
  consentText?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  /** The timestamp that the user was deleted as part of data-retention process */
  deletedAt?: Maybe<Scalars['Float']>;
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  imdFormattedPostCode?: Maybe<Scalars['String']>;
  /** Indicates if player completed all info */
  isRegistered?: Maybe<Scalars['Boolean']>;
  /** Player verifies email address */
  isVerified?: Maybe<Scalars['Boolean']>;
  /** @deprecated No longer needed. TO REMOVE */
  lastName?: Maybe<Scalars['String']>;
  lsoaCode?: Maybe<Scalars['String']>;
  /** Marketing email consent text */
  marketingEmailsText?: Maybe<Scalars['String']>;
  /** @deprecated No longer needed. TO REMOVE */
  mobileNumber?: Maybe<Scalars['String']>;
  postCode?: Maybe<Scalars['String']>;
};

/** Update Player Profile */
export type PlayerProfileInput = {
  allowMarketingEmails?: InputMaybe<Scalars['Boolean']>;
  birthDate?: InputMaybe<Scalars['String']>;
  birthYear?: InputMaybe<Scalars['Float']>;
  consentText?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  imdFormattedPostCode?: InputMaybe<Scalars['String']>;
  isRegistered?: InputMaybe<Scalars['Boolean']>;
  isVerified?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  lsoaCode?: InputMaybe<Scalars['String']>;
  marketingEmailsText?: InputMaybe<Scalars['String']>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  postCode?: InputMaybe<Scalars['String']>;
};

export type PlayerRole = {
  authID?: Maybe<Scalars['String']>;
  claims?: Maybe<Array<Scalars['String']>>;
  /** Full access to admin panel */
  isAdmin?: Maybe<Scalars['Boolean']>;
  /** True for unregistered players */
  isAnonymous?: Maybe<Scalars['Boolean']>;
  isChild?: Maybe<Scalars['Boolean']>;
  isInstaller?: Maybe<Scalars['Boolean']>;
  /** Able to log in admin panel */
  isManager?: Maybe<Scalars['Boolean']>;
  parentId?: Maybe<Scalars['String']>;
  policies?: Maybe<Array<PolicyType>>;
  removedAt?: Maybe<Scalars['String']>;
};

/** Player Role Input */
export type PlayerRoleInput = {
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  isInstaller?: InputMaybe<Scalars['Boolean']>;
  isManager?: InputMaybe<Scalars['Boolean']>;
  policies?: InputMaybe<Array<PolicyTypeInput>>;
};

export type PlayerTag = {
  code?: Maybe<Scalars['String']>;
  deviceID?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  playerId: Scalars['String'];
  tagNumber: Scalars['Int'];
  tagType: TagTypes;
};

/** Create Player Tag */
export type PlayerTagCreateInput = {
  code?: InputMaybe<Scalars['String']>;
  deviceID?: InputMaybe<Scalars['String']>;
  playerId: Scalars['String'];
  tagNumber?: InputMaybe<Scalars['Int']>;
  tagType: TagTypes;
};

export type PlayersList = {
  all: Scalars['Float'];
  id: Scalars['String'];
  isAnonymous?: Maybe<Scalars['Boolean']>;
};

export type PlayersListInput = {
  gameId: Scalars['String'];
  teamId?: InputMaybe<Scalars['String']>;
};

export type PolicyType = {
  name: Scalars['String'];
  options?: Maybe<Scalars['JSON']>;
};

export type PolicyTypeInput = {
  name: Scalars['String'];
  options?: InputMaybe<Scalars['JSON']>;
};

export type PostCode = {
  id: Scalars['String'];
};

export type PostCodeInput = {
  codes: CodesInput;
  country: Scalars['String'];
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  postcode: Scalars['String'];
};

export type Potrace = {
  alphaMax?: InputMaybe<Scalars['Float']>;
  background?: InputMaybe<Scalars['String']>;
  blackOnWhite?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Scalars['String']>;
  optCurve?: InputMaybe<Scalars['Boolean']>;
  optTolerance?: InputMaybe<Scalars['Float']>;
  threshold?: InputMaybe<Scalars['Int']>;
  turdSize?: InputMaybe<Scalars['Float']>;
  turnPolicy?: InputMaybe<PotraceTurnPolicy>;
};

export enum PotraceTurnPolicy {
  TurnpolicyBlack = 'TURNPOLICY_BLACK',
  TurnpolicyLeft = 'TURNPOLICY_LEFT',
  TurnpolicyMajority = 'TURNPOLICY_MAJORITY',
  TurnpolicyMinority = 'TURNPOLICY_MINORITY',
  TurnpolicyRight = 'TURNPOLICY_RIGHT',
  TurnpolicyWhite = 'TURNPOLICY_WHITE'
}

export type Query = {
  activityByLocation: Array<ActiveActivity>;
  adminFindAllGroupsElements: Array<GroupElement>;
  adminFindEventPoints: Array<EventPoint>;
  adminFindEvents: Array<Event>;
  adminFindGroupElements: Array<GroupElement>;
  adminFindGroups: Array<Group>;
  adminFindInactiveTags: Array<InactiveTag>;
  adminFindManagers: Array<Player>;
  adminFindSwipeByDateRange: Array<Swipe>;
  adminFindSwipeByTag: Array<Swipe>;
  adminFindTagByType: Array<PlayerTag>;
  adminFindTagGlobal: Array<TagGlobalRange>;
  adminFindTagRanges: Array<GameTagRange>;
  adminFindTagSubranges: Array<GameTagSubrange>;
  adminGetBeatBoxSwipes: GetBeatBoxSwipes;
  adminGetBeatBoxesVisited: GetBeatBoxesVisited;
  adminGetCardsCount: GetCardsCount;
  adminGetEvent: Event;
  adminGetGameMileage: GetGameMileage;
  adminGetGroup: Group;
  adminGetHeadlineDemographicData: GetHeadlineDemographicData;
  adminGetLocationFrequency: Array<GetLocationFrequency>;
  adminGetNewsletterConsents: GetNewsletterConsents;
  adminGetPlayerCount: GetPlayerCount;
  adminGetPlayersDemographicData: GetPlayersDemographicData;
  adminGetSchoolData: Array<GetSchoolData>;
  adminGetSurveysCompleted: GetSurveysCompleted;
  adminGetSwipesFrequenciesDaily: SwipesFrequenciesDaily;
  adminGetSwipesFrequenciesHourly: SwipesFrequenciesHourly;
  adminGetSwipesFrequenciesHourlyChart: SwipesFrequenciesHourlyChart;
  adminGetTagGlobal: TagGlobalRange;
  adminGetTagRange: GameTagRange;
  adminGetTagSubrange: GameTagSubrange;
  adminGetTeamsData: GetTeamsData;
  allDirectory: DirectoryConnection;
  allFile: FileConnection;
  allImageSharp: ImageSharpConnection;
  allLocale: LocaleConnection;
  allSanityActivity: SanityActivityConnection;
  allSanityAwards: SanityAwardsConnection;
  allSanityContent: SanityContentConnection;
  allSanityCta: SanityCtaConnection;
  allSanityEvent: SanityEventConnection;
  allSanityFaqs: SanityFaqsConnection;
  allSanityFileAsset: SanityFileAssetConnection;
  allSanityGame: SanityGameConnection;
  allSanityGameIcon: SanityGameIconConnection;
  allSanityGlobalSettings: SanityGlobalSettingsConnection;
  allSanityHomepage: SanityHomepageConnection;
  allSanityHowToPlay: SanityHowToPlayConnection;
  allSanityImageAsset: SanityImageAssetConnection;
  allSanityLeaderboardSettings: SanityLeaderboardSettingsConnection;
  allSanityLocality: SanityLocalityConnection;
  allSanityMessage: SanityMessageConnection;
  allSanityMessageCategory: SanityMessageCategoryConnection;
  allSanityMessageCta: SanityMessageCtaConnection;
  allSanityPartner: SanityPartnerConnection;
  allSanityPartnersPage: SanityPartnersPageConnection;
  allSanityProducts: SanityProductsConnection;
  allSanityRegistrationSettings: SanityRegistrationSettingsConnection;
  allSanityTheme: SanityThemeConnection;
  allSanityVideoCta: SanityVideoCtaConnection;
  allSite: SiteConnection;
  allSiteBuildMetadata: SiteBuildMetadataConnection;
  allSiteFunction: SiteFunctionConnection;
  allSitePage: SitePageConnection;
  allSitePlugin: SitePluginConnection;
  checkPublicName: Scalars['Boolean'];
  directory?: Maybe<Directory>;
  file?: Maybe<File>;
  findFamilyPlayers: Array<Player>;
  findFollowed: Array<Scalars['String']>;
  findGames: Array<Game>;
  findLeaderboards: Array<GameLeaderboard>;
  findLocations: Array<Location>;
  findLocationsByType: Array<Location>;
  findPlayerList: Array<PlayersList>;
  findPlayerSurveys: Array<Survey>;
  findPlayers: Array<Player>;
  findTeamNames: TeamNames;
  findTeams: Array<Team>;
  getCampaigns: Array<CampaignRecord>;
  getFollowLeaderboards: LeaderboardsResponse;
  getGame: Game;
  getGameBySlug: Game;
  getLeaderboard: GameLeaderboard;
  getLocation: Location;
  getLocationBySlug: Location;
  getMessage: Message;
  getMessages: Array<Message>;
  getPlayer: Player;
  getPlayerAnalytics: PlayerAnalytics;
  getPlayerBy: Player;
  getPlayerByAuth: Player;
  getPlayerByEmail: Player;
  getPlayerLeaderboardV2: Leaderboard;
  getPlayerLeaderboards: LeaderboardsResponse;
  getPlayerTeamsV2: Array<TeamV2>;
  getPlayersForPaginatedList: Array<Player>;
  getRouteTime: GetTimeRes;
  getTagByTagNumber?: Maybe<PlayerTag>;
  getTeam: Team;
  getTeamLeaderboardV2: LeaderboardWAverage;
  getTeamLeaderboards: LeaderboardsTeamResponse;
  getTeamLeadersV2: Array<TeamV2Membership>;
  getTeamMembersV2: Array<TeamV2Membership>;
  getTeamMembershipV2: TeamV2Membership;
  getTeamV2: TeamV2;
  getTeamsV2: Array<TeamV2>;
  hasUnreadMessage: Scalars['Boolean'];
  imageSharp?: Maybe<ImageSharp>;
  imdData: Demographics;
  installerFindLocations: Array<Location>;
  installerFindSwipeByTag: Array<Swipe>;
  isTeamLeaderV2: Scalars['Boolean'];
  locale?: Maybe<Locale>;
  sanityActivity?: Maybe<SanityActivity>;
  sanityAwards?: Maybe<SanityAwards>;
  sanityContent?: Maybe<SanityContent>;
  sanityCta?: Maybe<SanityCta>;
  sanityEvent?: Maybe<SanityEvent>;
  sanityFaqs?: Maybe<SanityFaqs>;
  sanityFileAsset?: Maybe<SanityFileAsset>;
  sanityGame?: Maybe<SanityGame>;
  sanityGameIcon?: Maybe<SanityGameIcon>;
  sanityGlobalSettings?: Maybe<SanityGlobalSettings>;
  sanityHomepage?: Maybe<SanityHomepage>;
  sanityHowToPlay?: Maybe<SanityHowToPlay>;
  sanityImageAsset?: Maybe<SanityImageAsset>;
  sanityLeaderboardSettings?: Maybe<SanityLeaderboardSettings>;
  sanityLocality?: Maybe<SanityLocality>;
  sanityMessage?: Maybe<SanityMessage>;
  sanityMessageCategory?: Maybe<SanityMessageCategory>;
  sanityMessageCta?: Maybe<SanityMessageCta>;
  sanityPartner?: Maybe<SanityPartner>;
  sanityPartnersPage?: Maybe<SanityPartnersPage>;
  sanityProducts?: Maybe<SanityProducts>;
  sanityRegistrationSettings?: Maybe<SanityRegistrationSettings>;
  sanityTheme?: Maybe<SanityTheme>;
  sanityVideoCta?: Maybe<SanityVideoCta>;
  site?: Maybe<Site>;
  siteBuildMetadata?: Maybe<SiteBuildMetadata>;
  siteFunction?: Maybe<SiteFunction>;
  sitePage?: Maybe<SitePage>;
  sitePlugin?: Maybe<SitePlugin>;
  swipesActivityByLocation: Array<SwipesActivity>;
};


export type QueryActivityByLocationArgs = {
  input: GetDemographicsData;
};


export type QueryAdminFindAllGroupsElementsArgs = {
  gameId: Scalars['String'];
};


export type QueryAdminFindEventPointsArgs = {
  input: FindEventPoints;
};


export type QueryAdminFindEventsArgs = {
  gameId: Scalars['String'];
};


export type QueryAdminFindGroupElementsArgs = {
  input: FindGroupElements;
};


export type QueryAdminFindGroupsArgs = {
  gameId: Scalars['String'];
};


export type QueryAdminFindInactiveTagsArgs = {
  input: FindInactiveTagInput;
};


export type QueryAdminFindSwipeByDateRangeArgs = {
  input: FindSwipeByDateRange;
};


export type QueryAdminFindSwipeByTagArgs = {
  input: FindByTag;
};


export type QueryAdminFindTagByTypeArgs = {
  tagNumber?: InputMaybe<SortKeyNumber>;
  type: TagTypes;
};


export type QueryAdminFindTagRangesArgs = {
  gameId: Scalars['String'];
};


export type QueryAdminFindTagSubrangesArgs = {
  input: FindTagSubranges;
};


export type QueryAdminGetBeatBoxSwipesArgs = {
  input: GetBeatBoxSwipesInput;
};


export type QueryAdminGetBeatBoxesVisitedArgs = {
  input: GetBeatBoxesVisitedInput;
};


export type QueryAdminGetCardsCountArgs = {
  input: GetCardsCountInput;
};


export type QueryAdminGetEventArgs = {
  input: GetEvent;
};


export type QueryAdminGetGameMileageArgs = {
  input: GetGameMileageInput;
};


export type QueryAdminGetGroupArgs = {
  input: GetGroup;
};


export type QueryAdminGetHeadlineDemographicDataArgs = {
  input: GetHeadlineDemographicDataInput;
};


export type QueryAdminGetLocationFrequencyArgs = {
  input: GetLocationFrequencyInput;
};


export type QueryAdminGetNewsletterConsentsArgs = {
  input: GetNewsletterConsentsInput;
};


export type QueryAdminGetPlayerCountArgs = {
  input: GetPlayerCountInput;
};


export type QueryAdminGetPlayersDemographicDataArgs = {
  input: GetPlayersDemographicDataInput;
};


export type QueryAdminGetSchoolDataArgs = {
  gameId: Scalars['String'];
};


export type QueryAdminGetSurveysCompletedArgs = {
  input: GetSurveysCompletedInput;
};


export type QueryAdminGetSwipesFrequenciesDailyArgs = {
  input: GetSwipesFrequenciesDailyInput;
};


export type QueryAdminGetSwipesFrequenciesHourlyArgs = {
  input: GetSwipesFrequenciesHourlyInput;
};


export type QueryAdminGetSwipesFrequenciesHourlyChartArgs = {
  input: GetSwipesFrequenciesHourlyChartInput;
};


export type QueryAdminGetTagGlobalArgs = {
  id: Scalars['String'];
};


export type QueryAdminGetTagRangeArgs = {
  gameId: Scalars['String'];
  id: Scalars['String'];
};


export type QueryAdminGetTagSubrangeArgs = {
  gameId: Scalars['String'];
  id: Scalars['String'];
};


export type QueryAdminGetTeamsDataArgs = {
  gameId: Scalars['String'];
};


export type QueryAllDirectoryArgs = {
  filter?: InputMaybe<DirectoryFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<DirectorySortInput>>>;
};


export type QueryAllFileArgs = {
  filter?: InputMaybe<FileFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<FileSortInput>>>;
};


export type QueryAllImageSharpArgs = {
  filter?: InputMaybe<ImageSharpFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<ImageSharpSortInput>>>;
};


export type QueryAllLocaleArgs = {
  filter?: InputMaybe<LocaleFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<LocaleSortInput>>>;
};


export type QueryAllSanityActivityArgs = {
  filter?: InputMaybe<SanityActivityFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<SanityActivitySortInput>>>;
};


export type QueryAllSanityAwardsArgs = {
  filter?: InputMaybe<SanityAwardsFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<SanityAwardsSortInput>>>;
};


export type QueryAllSanityContentArgs = {
  filter?: InputMaybe<SanityContentFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<SanityContentSortInput>>>;
};


export type QueryAllSanityCtaArgs = {
  filter?: InputMaybe<SanityCtaFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<SanityCtaSortInput>>>;
};


export type QueryAllSanityEventArgs = {
  filter?: InputMaybe<SanityEventFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<SanityEventSortInput>>>;
};


export type QueryAllSanityFaqsArgs = {
  filter?: InputMaybe<SanityFaqsFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<SanityFaqsSortInput>>>;
};


export type QueryAllSanityFileAssetArgs = {
  filter?: InputMaybe<SanityFileAssetFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<SanityFileAssetSortInput>>>;
};


export type QueryAllSanityGameArgs = {
  filter?: InputMaybe<SanityGameFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<SanityGameSortInput>>>;
};


export type QueryAllSanityGameIconArgs = {
  filter?: InputMaybe<SanityGameIconFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<SanityGameIconSortInput>>>;
};


export type QueryAllSanityGlobalSettingsArgs = {
  filter?: InputMaybe<SanityGlobalSettingsFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<SanityGlobalSettingsSortInput>>>;
};


export type QueryAllSanityHomepageArgs = {
  filter?: InputMaybe<SanityHomepageFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<SanityHomepageSortInput>>>;
};


export type QueryAllSanityHowToPlayArgs = {
  filter?: InputMaybe<SanityHowToPlayFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<SanityHowToPlaySortInput>>>;
};


export type QueryAllSanityImageAssetArgs = {
  filter?: InputMaybe<SanityImageAssetFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<SanityImageAssetSortInput>>>;
};


export type QueryAllSanityLeaderboardSettingsArgs = {
  filter?: InputMaybe<SanityLeaderboardSettingsFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<SanityLeaderboardSettingsSortInput>>>;
};


export type QueryAllSanityLocalityArgs = {
  filter?: InputMaybe<SanityLocalityFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<SanityLocalitySortInput>>>;
};


export type QueryAllSanityMessageArgs = {
  filter?: InputMaybe<SanityMessageFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<SanityMessageSortInput>>>;
};


export type QueryAllSanityMessageCategoryArgs = {
  filter?: InputMaybe<SanityMessageCategoryFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<SanityMessageCategorySortInput>>>;
};


export type QueryAllSanityMessageCtaArgs = {
  filter?: InputMaybe<SanityMessageCtaFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<SanityMessageCtaSortInput>>>;
};


export type QueryAllSanityPartnerArgs = {
  filter?: InputMaybe<SanityPartnerFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<SanityPartnerSortInput>>>;
};


export type QueryAllSanityPartnersPageArgs = {
  filter?: InputMaybe<SanityPartnersPageFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<SanityPartnersPageSortInput>>>;
};


export type QueryAllSanityProductsArgs = {
  filter?: InputMaybe<SanityProductsFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<SanityProductsSortInput>>>;
};


export type QueryAllSanityRegistrationSettingsArgs = {
  filter?: InputMaybe<SanityRegistrationSettingsFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<SanityRegistrationSettingsSortInput>>>;
};


export type QueryAllSanityThemeArgs = {
  filter?: InputMaybe<SanityThemeFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<SanityThemeSortInput>>>;
};


export type QueryAllSanityVideoCtaArgs = {
  filter?: InputMaybe<SanityVideoCtaFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<SanityVideoCtaSortInput>>>;
};


export type QueryAllSiteArgs = {
  filter?: InputMaybe<SiteFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<SiteSortInput>>>;
};


export type QueryAllSiteBuildMetadataArgs = {
  filter?: InputMaybe<SiteBuildMetadataFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<SiteBuildMetadataSortInput>>>;
};


export type QueryAllSiteFunctionArgs = {
  filter?: InputMaybe<SiteFunctionFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<SiteFunctionSortInput>>>;
};


export type QueryAllSitePageArgs = {
  filter?: InputMaybe<SitePageFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<SitePageSortInput>>>;
};


export type QueryAllSitePluginArgs = {
  filter?: InputMaybe<SitePluginFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<SitePluginSortInput>>>;
};


export type QueryCheckPublicNameArgs = {
  name: Scalars['String'];
};


export type QueryDirectoryArgs = {
  absolutePath?: InputMaybe<StringQueryOperatorInput>;
  accessTime?: InputMaybe<DateQueryOperatorInput>;
  atime?: InputMaybe<DateQueryOperatorInput>;
  atimeMs?: InputMaybe<FloatQueryOperatorInput>;
  base?: InputMaybe<StringQueryOperatorInput>;
  birthTime?: InputMaybe<DateQueryOperatorInput>;
  birthtime?: InputMaybe<DateQueryOperatorInput>;
  birthtimeMs?: InputMaybe<FloatQueryOperatorInput>;
  changeTime?: InputMaybe<DateQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  ctime?: InputMaybe<DateQueryOperatorInput>;
  ctimeMs?: InputMaybe<FloatQueryOperatorInput>;
  dev?: InputMaybe<IntQueryOperatorInput>;
  dir?: InputMaybe<StringQueryOperatorInput>;
  ext?: InputMaybe<StringQueryOperatorInput>;
  extension?: InputMaybe<StringQueryOperatorInput>;
  gid?: InputMaybe<IntQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  ino?: InputMaybe<FloatQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  mode?: InputMaybe<IntQueryOperatorInput>;
  modifiedTime?: InputMaybe<DateQueryOperatorInput>;
  mtime?: InputMaybe<DateQueryOperatorInput>;
  mtimeMs?: InputMaybe<FloatQueryOperatorInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  nlink?: InputMaybe<IntQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  prettySize?: InputMaybe<StringQueryOperatorInput>;
  rdev?: InputMaybe<IntQueryOperatorInput>;
  relativeDirectory?: InputMaybe<StringQueryOperatorInput>;
  relativePath?: InputMaybe<StringQueryOperatorInput>;
  root?: InputMaybe<StringQueryOperatorInput>;
  size?: InputMaybe<IntQueryOperatorInput>;
  sourceInstanceName?: InputMaybe<StringQueryOperatorInput>;
  uid?: InputMaybe<IntQueryOperatorInput>;
};


export type QueryFileArgs = {
  absolutePath?: InputMaybe<StringQueryOperatorInput>;
  accessTime?: InputMaybe<DateQueryOperatorInput>;
  atime?: InputMaybe<DateQueryOperatorInput>;
  atimeMs?: InputMaybe<FloatQueryOperatorInput>;
  base?: InputMaybe<StringQueryOperatorInput>;
  birthTime?: InputMaybe<DateQueryOperatorInput>;
  birthtime?: InputMaybe<DateQueryOperatorInput>;
  birthtimeMs?: InputMaybe<FloatQueryOperatorInput>;
  blksize?: InputMaybe<IntQueryOperatorInput>;
  blocks?: InputMaybe<IntQueryOperatorInput>;
  changeTime?: InputMaybe<DateQueryOperatorInput>;
  childImageSharp?: InputMaybe<ImageSharpFilterInput>;
  childLocale?: InputMaybe<LocaleFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  childrenImageSharp?: InputMaybe<ImageSharpFilterListInput>;
  childrenLocale?: InputMaybe<LocaleFilterListInput>;
  ctime?: InputMaybe<DateQueryOperatorInput>;
  ctimeMs?: InputMaybe<FloatQueryOperatorInput>;
  dev?: InputMaybe<IntQueryOperatorInput>;
  dir?: InputMaybe<StringQueryOperatorInput>;
  ext?: InputMaybe<StringQueryOperatorInput>;
  extension?: InputMaybe<StringQueryOperatorInput>;
  gid?: InputMaybe<IntQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  ino?: InputMaybe<FloatQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  mode?: InputMaybe<IntQueryOperatorInput>;
  modifiedTime?: InputMaybe<DateQueryOperatorInput>;
  mtime?: InputMaybe<DateQueryOperatorInput>;
  mtimeMs?: InputMaybe<FloatQueryOperatorInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  nlink?: InputMaybe<IntQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  prettySize?: InputMaybe<StringQueryOperatorInput>;
  publicURL?: InputMaybe<StringQueryOperatorInput>;
  rdev?: InputMaybe<IntQueryOperatorInput>;
  relativeDirectory?: InputMaybe<StringQueryOperatorInput>;
  relativePath?: InputMaybe<StringQueryOperatorInput>;
  root?: InputMaybe<StringQueryOperatorInput>;
  size?: InputMaybe<IntQueryOperatorInput>;
  sourceInstanceName?: InputMaybe<StringQueryOperatorInput>;
  uid?: InputMaybe<IntQueryOperatorInput>;
};


export type QueryFindFamilyPlayersArgs = {
  input: FindFamilyPlayersInput;
};


export type QueryFindFollowedArgs = {
  input: FindPlayerFollowInput;
};


export type QueryFindLeaderboardsArgs = {
  gameId: Scalars['String'];
};


export type QueryFindLocationsArgs = {
  gameId: Scalars['String'];
};


export type QueryFindLocationsByTypeArgs = {
  gameId: Scalars['String'];
  type: LocationTypes;
};


export type QueryFindPlayerListArgs = {
  input: PlayersListInput;
};


export type QueryFindPlayerSurveysArgs = {
  gameId: Scalars['String'];
  playerId: Scalars['String'];
};


export type QueryFindPlayersArgs = {
  gameId: Scalars['String'];
  teamId?: InputMaybe<Scalars['String']>;
};


export type QueryFindTeamNamesArgs = {
  input: FindTeamsInput;
};


export type QueryFindTeamsArgs = {
  input: FindTeamsInput;
};


export type QueryGetCampaignsArgs = {
  category?: InputMaybe<Scalars['String']>;
  gameId?: InputMaybe<Scalars['String']>;
};


export type QueryGetFollowLeaderboardsArgs = {
  input: GetFollowLeaderboardsInput;
};


export type QueryGetGameArgs = {
  id: Scalars['String'];
};


export type QueryGetGameBySlugArgs = {
  slug: Scalars['String'];
};


export type QueryGetLeaderboardArgs = {
  gameId: Scalars['String'];
  id: Scalars['String'];
};


export type QueryGetLocationArgs = {
  input: GetLocationInput;
};


export type QueryGetLocationBySlugArgs = {
  gameId: Scalars['String'];
  slug: Scalars['String'];
};


export type QueryGetMessageArgs = {
  messageId: Scalars['String'];
};


export type QueryGetMessagesArgs = {
  category?: InputMaybe<Scalars['String']>;
};


export type QueryGetPlayerArgs = {
  id: Scalars['String'];
};


export type QueryGetPlayerByArgs = {
  input: SearchPlayerByInput;
};


export type QueryGetPlayerByAuthArgs = {
  authID: Scalars['String'];
};


export type QueryGetPlayerByEmailArgs = {
  email: Scalars['String'];
};


export type QueryGetPlayerLeaderboardV2Args = {
  gems?: InputMaybe<Scalars['Boolean']>;
  teamId: Scalars['String'];
};


export type QueryGetPlayerLeaderboardsArgs = {
  input: GetPlayerLeaderboardsInput;
};


export type QueryGetPlayerTeamsV2Args = {
  gameId: Scalars['String'];
  playerId: Scalars['String'];
};


export type QueryGetPlayersForPaginatedListArgs = {
  input: GetForPaginatedListInput;
};


export type QueryGetRouteTimeArgs = {
  input: GetTime;
};


export type QueryGetTagByTagNumberArgs = {
  tagNumber: Scalars['Int'];
};


export type QueryGetTeamArgs = {
  input: GetTeamInput;
};


export type QueryGetTeamLeaderboardV2Args = {
  gameId: Scalars['String'];
  teamId: Scalars['String'];
};


export type QueryGetTeamLeaderboardsArgs = {
  input: GetTeamLeaderboardsInput;
};


export type QueryGetTeamLeadersV2Args = {
  teamId: Scalars['String'];
};


export type QueryGetTeamMembersV2Args = {
  teamId: Scalars['String'];
};


export type QueryGetTeamMembershipV2Args = {
  gameId: Scalars['String'];
  playerId: Scalars['String'];
  teamId: Scalars['String'];
};


export type QueryGetTeamV2Args = {
  gameId: Scalars['String'];
  teamId: Scalars['String'];
};


export type QueryGetTeamsV2Args = {
  gameId: Scalars['String'];
  parentTeamId?: InputMaybe<Scalars['String']>;
};


export type QueryImageSharpArgs = {
  children?: InputMaybe<NodeFilterListInput>;
  fixed?: InputMaybe<ImageSharpFixedFilterInput>;
  fluid?: InputMaybe<ImageSharpFluidFilterInput>;
  gatsbyImageData?: InputMaybe<GatsbyImageDataQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  original?: InputMaybe<ImageSharpOriginalFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
  resize?: InputMaybe<ImageSharpResizeFilterInput>;
};


export type QueryImdDataArgs = {
  input: GetDemographicsData;
};


export type QueryInstallerFindLocationsArgs = {
  gameId: Scalars['String'];
};


export type QueryInstallerFindSwipeByTagArgs = {
  input: FindByTag;
};


export type QueryIsTeamLeaderV2Args = {
  gameId: Scalars['String'];
  playerId: Scalars['String'];
  teamId: Scalars['String'];
};


export type QueryLocaleArgs = {
  children?: InputMaybe<NodeFilterListInput>;
  data?: InputMaybe<StringQueryOperatorInput>;
  fileAbsolutePath?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  language?: InputMaybe<StringQueryOperatorInput>;
  ns?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
};


export type QuerySanityActivityArgs = {
  _createdAt?: InputMaybe<DateQueryOperatorInput>;
  _id?: InputMaybe<StringQueryOperatorInput>;
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawDescription?: InputMaybe<JsonQueryOperatorInput>;
  _rawFile?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NBase?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NRefs?: InputMaybe<JsonQueryOperatorInput>;
  _rawImage?: InputMaybe<JsonQueryOperatorInput>;
  _rev?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  _updatedAt?: InputMaybe<DateQueryOperatorInput>;
  alt?: InputMaybe<StringQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  description?: InputMaybe<SanityBlockFilterListInput>;
  file?: InputMaybe<SanityFileFilterInput>;
  i18n_base?: InputMaybe<SanityActivityFilterInput>;
  i18n_lang?: InputMaybe<StringQueryOperatorInput>;
  i18n_refs?: InputMaybe<SanityActivityFilterListInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  image?: InputMaybe<SanityImageFilterInput>;
  internal?: InputMaybe<InternalFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
  title?: InputMaybe<StringQueryOperatorInput>;
};


export type QuerySanityAwardsArgs = {
  _createdAt?: InputMaybe<DateQueryOperatorInput>;
  _id?: InputMaybe<StringQueryOperatorInput>;
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawI18NBase?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NRefs?: InputMaybe<JsonQueryOperatorInput>;
  _rawIcon?: InputMaybe<JsonQueryOperatorInput>;
  _rawIconBackground?: InputMaybe<JsonQueryOperatorInput>;
  _rev?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  _updatedAt?: InputMaybe<DateQueryOperatorInput>;
  alt?: InputMaybe<StringQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  description?: InputMaybe<StringQueryOperatorInput>;
  i18n_base?: InputMaybe<SanityAwardsFilterInput>;
  i18n_lang?: InputMaybe<StringQueryOperatorInput>;
  i18n_refs?: InputMaybe<SanityAwardsFilterListInput>;
  icon?: InputMaybe<SanityImageFilterInput>;
  iconBackground?: InputMaybe<SanityColorFilterInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  motivator?: InputMaybe<StringQueryOperatorInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  range?: InputMaybe<FloatQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
};


export type QuerySanityContentArgs = {
  _createdAt?: InputMaybe<DateQueryOperatorInput>;
  _id?: InputMaybe<StringQueryOperatorInput>;
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawBody?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NBase?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NRefs?: InputMaybe<JsonQueryOperatorInput>;
  _rev?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  _updatedAt?: InputMaybe<DateQueryOperatorInput>;
  body?: InputMaybe<SanityBlockFilterListInput>;
  children?: InputMaybe<NodeFilterListInput>;
  i18n_base?: InputMaybe<SanityContentFilterInput>;
  i18n_lang?: InputMaybe<StringQueryOperatorInput>;
  i18n_refs?: InputMaybe<SanityContentFilterListInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  internalTitle?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  title?: InputMaybe<StringQueryOperatorInput>;
};


export type QuerySanityCtaArgs = {
  _createdAt?: InputMaybe<DateQueryOperatorInput>;
  _id?: InputMaybe<StringQueryOperatorInput>;
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawI18NBase?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NRefs?: InputMaybe<JsonQueryOperatorInput>;
  _rawLink?: InputMaybe<JsonQueryOperatorInput>;
  _rev?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  _updatedAt?: InputMaybe<DateQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  i18n_base?: InputMaybe<SanityCtaFilterInput>;
  i18n_lang?: InputMaybe<StringQueryOperatorInput>;
  i18n_refs?: InputMaybe<SanityCtaFilterListInput>;
  icon?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  internalTitle?: InputMaybe<StringQueryOperatorInput>;
  link?: InputMaybe<SanityLinkWithTextFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
  size?: InputMaybe<StringQueryOperatorInput>;
  style?: InputMaybe<StringQueryOperatorInput>;
  text?: InputMaybe<StringQueryOperatorInput>;
  title?: InputMaybe<StringQueryOperatorInput>;
};


export type QuerySanityEventArgs = {
  _createdAt?: InputMaybe<DateQueryOperatorInput>;
  _id?: InputMaybe<StringQueryOperatorInput>;
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawDescription?: InputMaybe<JsonQueryOperatorInput>;
  _rawGame?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NBase?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NRefs?: InputMaybe<JsonQueryOperatorInput>;
  _rawImage?: InputMaybe<JsonQueryOperatorInput>;
  _rev?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  _updatedAt?: InputMaybe<DateQueryOperatorInput>;
  alt?: InputMaybe<StringQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  description?: InputMaybe<SanityBlockFilterListInput>;
  endDate?: InputMaybe<DateQueryOperatorInput>;
  endTime?: InputMaybe<StringQueryOperatorInput>;
  eventSlug?: InputMaybe<StringQueryOperatorInput>;
  externalUrl?: InputMaybe<StringQueryOperatorInput>;
  game?: InputMaybe<SanityGameFilterInput>;
  i18n_base?: InputMaybe<SanityEventFilterInput>;
  i18n_lang?: InputMaybe<StringQueryOperatorInput>;
  i18n_refs?: InputMaybe<SanityEventFilterListInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  image?: InputMaybe<SanityImageFilterInput>;
  internal?: InputMaybe<InternalFilterInput>;
  internalTitle?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  startDate?: InputMaybe<DateQueryOperatorInput>;
  startTime?: InputMaybe<StringQueryOperatorInput>;
  title?: InputMaybe<StringQueryOperatorInput>;
};


export type QuerySanityFaqsArgs = {
  _createdAt?: InputMaybe<DateQueryOperatorInput>;
  _id?: InputMaybe<StringQueryOperatorInput>;
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawI18NBase?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NRefs?: InputMaybe<JsonQueryOperatorInput>;
  _rawIntro?: InputMaybe<JsonQueryOperatorInput>;
  _rawQuestions?: InputMaybe<JsonQueryOperatorInput>;
  _rev?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  _updatedAt?: InputMaybe<DateQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  i18n_base?: InputMaybe<SanityFaqsFilterInput>;
  i18n_lang?: InputMaybe<StringQueryOperatorInput>;
  i18n_refs?: InputMaybe<SanityFaqsFilterListInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  internalTitle?: InputMaybe<StringQueryOperatorInput>;
  intro?: InputMaybe<SanityBlockFilterListInput>;
  parent?: InputMaybe<NodeFilterInput>;
  questions?: InputMaybe<SanityFaqQuestionFilterListInput>;
  title?: InputMaybe<StringQueryOperatorInput>;
};


export type QuerySanityFileAssetArgs = {
  _createdAt?: InputMaybe<DateQueryOperatorInput>;
  _id?: InputMaybe<StringQueryOperatorInput>;
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawSource?: InputMaybe<JsonQueryOperatorInput>;
  _rev?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  _updatedAt?: InputMaybe<DateQueryOperatorInput>;
  altText?: InputMaybe<StringQueryOperatorInput>;
  assetId?: InputMaybe<StringQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  description?: InputMaybe<StringQueryOperatorInput>;
  extension?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  label?: InputMaybe<StringQueryOperatorInput>;
  mimeType?: InputMaybe<StringQueryOperatorInput>;
  originalFilename?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  path?: InputMaybe<StringQueryOperatorInput>;
  sha1hash?: InputMaybe<StringQueryOperatorInput>;
  size?: InputMaybe<FloatQueryOperatorInput>;
  source?: InputMaybe<SanityAssetSourceDataFilterInput>;
  title?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
};


export type QuerySanityGameArgs = {
  _createdAt?: InputMaybe<DateQueryOperatorInput>;
  _id?: InputMaybe<StringQueryOperatorInput>;
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawActivities?: InputMaybe<JsonQueryOperatorInput>;
  _rawCtaForMap?: InputMaybe<JsonQueryOperatorInput>;
  _rawCtaListForLoggedInUsers?: InputMaybe<JsonQueryOperatorInput>;
  _rawCtaListForLoggedOutUsers?: InputMaybe<JsonQueryOperatorInput>;
  _rawEndOfGameWinnersText?: InputMaybe<JsonQueryOperatorInput>;
  _rawFaqs?: InputMaybe<JsonQueryOperatorInput>;
  _rawFooterPartners?: InputMaybe<JsonQueryOperatorInput>;
  _rawGameIcon?: InputMaybe<JsonQueryOperatorInput>;
  _rawGamePartnerConsentText?: InputMaybe<JsonQueryOperatorInput>;
  _rawHowToPlay?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NBase?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NRefs?: InputMaybe<JsonQueryOperatorInput>;
  _rawIntroductionContent?: InputMaybe<JsonQueryOperatorInput>;
  _rawIntroductionVideoCta?: InputMaybe<JsonQueryOperatorInput>;
  _rawLeaderboardSettings?: InputMaybe<JsonQueryOperatorInput>;
  _rawMaintenanceDescription?: InputMaybe<JsonQueryOperatorInput>;
  _rawPartners?: InputMaybe<JsonQueryOperatorInput>;
  _rawPartnersPage?: InputMaybe<JsonQueryOperatorInput>;
  _rawWeeklyThemes?: InputMaybe<JsonQueryOperatorInput>;
  _rev?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  _updatedAt?: InputMaybe<DateQueryOperatorInput>;
  activities?: InputMaybe<SanityActivityFilterListInput>;
  awards?: InputMaybe<BooleanQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  ctaForMap?: InputMaybe<SanityCtaFilterInput>;
  ctaListForLoggedInUsers?: InputMaybe<SanityCtaFilterListInput>;
  ctaListForLoggedOutUsers?: InputMaybe<SanityCtaFilterListInput>;
  displayAll?: InputMaybe<BooleanQueryOperatorInput>;
  dynamoId?: InputMaybe<StringQueryOperatorInput>;
  emailAddress?: InputMaybe<StringQueryOperatorInput>;
  endOfGameShowWinners?: InputMaybe<BooleanQueryOperatorInput>;
  endOfGameWinnersText?: InputMaybe<SanityBlockFilterListInput>;
  facebookUsername?: InputMaybe<StringQueryOperatorInput>;
  footerPartners?: InputMaybe<SanityPartnerFilterListInput>;
  gameIcon?: InputMaybe<SanityGameIconFilterInput>;
  gamePartnerConsentText?: InputMaybe<SanityBlockFilterListInput>;
  hideLeaderboards?: InputMaybe<BooleanQueryOperatorInput>;
  howToPlay?: InputMaybe<SanityContentFilterInput>;
  i18n_base?: InputMaybe<SanityGameFilterInput>;
  i18n_lang?: InputMaybe<StringQueryOperatorInput>;
  i18n_refs?: InputMaybe<SanityGameFilterListInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  introductionContent?: InputMaybe<SanityBlockFilterListInput>;
  introductionHeading?: InputMaybe<StringQueryOperatorInput>;
  introductionVideoCta?: InputMaybe<SanityVideoCtaFilterInput>;
  leaderboardSettings?: InputMaybe<SanityLeaderboardSettingsFilterInput>;
  maintenanceDescription?: InputMaybe<SanityBlockFilterListInput>;
  maintenanceTitle?: InputMaybe<StringQueryOperatorInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  numberOfPartnersInFooter?: InputMaybe<FloatQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  partners?: InputMaybe<SanityPartnerFilterListInput>;
  partnersPage?: InputMaybe<SanityPartnersPageFilterInput>;
  showMessage?: InputMaybe<BooleanQueryOperatorInput>;
  slug?: InputMaybe<StringQueryOperatorInput>;
  status?: InputMaybe<StringQueryOperatorInput>;
  twitterUsername?: InputMaybe<StringQueryOperatorInput>;
  weeklyThemes?: InputMaybe<SanityThemeFilterListInput>;
};


export type QuerySanityGameIconArgs = {
  _createdAt?: InputMaybe<DateQueryOperatorInput>;
  _id?: InputMaybe<StringQueryOperatorInput>;
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawIcon?: InputMaybe<JsonQueryOperatorInput>;
  _rev?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  _updatedAt?: InputMaybe<DateQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  icon?: InputMaybe<SanityImageFilterInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
  title?: InputMaybe<StringQueryOperatorInput>;
};


export type QuerySanityGlobalSettingsArgs = {
  _createdAt?: InputMaybe<DateQueryOperatorInput>;
  _id?: InputMaybe<StringQueryOperatorInput>;
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawDigitalToolKit?: InputMaybe<JsonQueryOperatorInput>;
  _rawEndOfGameIntroductionText?: InputMaybe<JsonQueryOperatorInput>;
  _rawEndOfGameLeaderboardsHiddenText?: InputMaybe<JsonQueryOperatorInput>;
  _rawEndOfGameWinnersText?: InputMaybe<JsonQueryOperatorInput>;
  _rawGenericCardorFobLocation?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NBase?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NRefs?: InputMaybe<JsonQueryOperatorInput>;
  _rev?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  _updatedAt?: InputMaybe<DateQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  digitalToolKit?: InputMaybe<SanityFileFilterInput>;
  endOfGameIntroductionText?: InputMaybe<SanityBlockFilterListInput>;
  endOfGameLeaderboardsHiddenText?: InputMaybe<SanityBlockFilterListInput>;
  endOfGameWinnersText?: InputMaybe<SanityBlockFilterListInput>;
  genericCardorFobLocation?: InputMaybe<SanityFaqQuestionFilterInput>;
  i18n_base?: InputMaybe<SanityGlobalSettingsFilterInput>;
  i18n_lang?: InputMaybe<StringQueryOperatorInput>;
  i18n_refs?: InputMaybe<SanityGlobalSettingsFilterListInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
};


export type QuerySanityHomepageArgs = {
  _createdAt?: InputMaybe<DateQueryOperatorInput>;
  _id?: InputMaybe<StringQueryOperatorInput>;
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawAboutUs?: InputMaybe<JsonQueryOperatorInput>;
  _rawAccessibility?: InputMaybe<JsonQueryOperatorInput>;
  _rawChildPrivacyPolicy?: InputMaybe<JsonQueryOperatorInput>;
  _rawCookies?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NBase?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NRefs?: InputMaybe<JsonQueryOperatorInput>;
  _rawIntroductionContent?: InputMaybe<JsonQueryOperatorInput>;
  _rawIntroductionVideoCta?: InputMaybe<JsonQueryOperatorInput>;
  _rawNewsletter?: InputMaybe<JsonQueryOperatorInput>;
  _rawPartners?: InputMaybe<JsonQueryOperatorInput>;
  _rawPrivacyPolicy?: InputMaybe<JsonQueryOperatorInput>;
  _rawResourcesForSchools?: InputMaybe<JsonQueryOperatorInput>;
  _rawTermsAndConditions?: InputMaybe<JsonQueryOperatorInput>;
  _rev?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  _updatedAt?: InputMaybe<DateQueryOperatorInput>;
  aboutUs?: InputMaybe<SanityContentFilterInput>;
  accessibility?: InputMaybe<SanityContentFilterInput>;
  childPrivacyPolicy?: InputMaybe<SanityContentFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  cookies?: InputMaybe<SanityContentFilterInput>;
  gamesSectionHeading?: InputMaybe<StringQueryOperatorInput>;
  i18n_base?: InputMaybe<SanityHomepageFilterInput>;
  i18n_lang?: InputMaybe<StringQueryOperatorInput>;
  i18n_refs?: InputMaybe<SanityHomepageFilterListInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  introductionContent?: InputMaybe<SanityBlockFilterListInput>;
  introductionHeading?: InputMaybe<StringQueryOperatorInput>;
  introductionVideoCta?: InputMaybe<SanityVideoCtaFilterInput>;
  mainHeading?: InputMaybe<StringQueryOperatorInput>;
  newsletter?: InputMaybe<SanityContentFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
  partners?: InputMaybe<SanityPartnerFilterListInput>;
  privacyPolicy?: InputMaybe<SanityContentFilterInput>;
  resourcesForSchools?: InputMaybe<SanityContentFilterInput>;
  termsAndConditions?: InputMaybe<SanityContentFilterInput>;
};


export type QuerySanityHowToPlayArgs = {
  _createdAt?: InputMaybe<DateQueryOperatorInput>;
  _id?: InputMaybe<StringQueryOperatorInput>;
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawHowToPlayContent?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NBase?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NRefs?: InputMaybe<JsonQueryOperatorInput>;
  _rev?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  _updatedAt?: InputMaybe<DateQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  howToPlayContent?: InputMaybe<SanityBlockFilterListInput>;
  i18n_base?: InputMaybe<SanityHowToPlayFilterInput>;
  i18n_lang?: InputMaybe<StringQueryOperatorInput>;
  i18n_refs?: InputMaybe<SanityHowToPlayFilterListInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
};


export type QuerySanityImageAssetArgs = {
  _createdAt?: InputMaybe<DateQueryOperatorInput>;
  _id?: InputMaybe<StringQueryOperatorInput>;
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawMetadata?: InputMaybe<JsonQueryOperatorInput>;
  _rawSource?: InputMaybe<JsonQueryOperatorInput>;
  _rev?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  _updatedAt?: InputMaybe<DateQueryOperatorInput>;
  altText?: InputMaybe<StringQueryOperatorInput>;
  assetId?: InputMaybe<StringQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  description?: InputMaybe<StringQueryOperatorInput>;
  extension?: InputMaybe<StringQueryOperatorInput>;
  filename?: InputMaybe<StringQueryOperatorInput>;
  filesize?: InputMaybe<IntQueryOperatorInput>;
  gatsbyImage?: InputMaybe<GatsbyImageDataQueryOperatorInput>;
  gatsbyImageData?: InputMaybe<GatsbyImageDataQueryOperatorInput>;
  height?: InputMaybe<IntQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  label?: InputMaybe<StringQueryOperatorInput>;
  metadata?: InputMaybe<SanityImageMetadataFilterInput>;
  mimeType?: InputMaybe<StringQueryOperatorInput>;
  originalFilename?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  path?: InputMaybe<StringQueryOperatorInput>;
  publicUrl?: InputMaybe<StringQueryOperatorInput>;
  resize?: InputMaybe<RemoteFileResizeFilterInput>;
  sha1hash?: InputMaybe<StringQueryOperatorInput>;
  size?: InputMaybe<FloatQueryOperatorInput>;
  source?: InputMaybe<SanityAssetSourceDataFilterInput>;
  title?: InputMaybe<StringQueryOperatorInput>;
  uploadId?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  width?: InputMaybe<IntQueryOperatorInput>;
};


export type QuerySanityLeaderboardSettingsArgs = {
  _createdAt?: InputMaybe<DateQueryOperatorInput>;
  _id?: InputMaybe<StringQueryOperatorInput>;
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawHowItWorksContent?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NBase?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NRefs?: InputMaybe<JsonQueryOperatorInput>;
  _rev?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  _updatedAt?: InputMaybe<DateQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  howItWorksContent?: InputMaybe<SanityHeadingWithRichTextFilterListInput>;
  i18n_base?: InputMaybe<SanityLeaderboardSettingsFilterInput>;
  i18n_lang?: InputMaybe<StringQueryOperatorInput>;
  i18n_refs?: InputMaybe<SanityLeaderboardSettingsFilterListInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  internalTitle?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  pointsHelpText?: InputMaybe<StringQueryOperatorInput>;
};


export type QuerySanityLocalityArgs = {
  _createdAt?: InputMaybe<DateQueryOperatorInput>;
  _id?: InputMaybe<StringQueryOperatorInput>;
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawActivities?: InputMaybe<JsonQueryOperatorInput>;
  _rawClosingSurveyShownFrom?: InputMaybe<JsonQueryOperatorInput>;
  _rawContactPage?: InputMaybe<JsonQueryOperatorInput>;
  _rawCtaListForLoggedInUsers?: InputMaybe<JsonQueryOperatorInput>;
  _rawCtaListForLoggedOutUsers?: InputMaybe<JsonQueryOperatorInput>;
  _rawEndOfGameWinnersText?: InputMaybe<JsonQueryOperatorInput>;
  _rawFaqs?: InputMaybe<JsonQueryOperatorInput>;
  _rawFooterPartners?: InputMaybe<JsonQueryOperatorInput>;
  _rawGameIcon?: InputMaybe<JsonQueryOperatorInput>;
  _rawGamePartnerConsentIntroduction?: InputMaybe<JsonQueryOperatorInput>;
  _rawHowToPlay?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NBase?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NRefs?: InputMaybe<JsonQueryOperatorInput>;
  _rawIntroductionContent?: InputMaybe<JsonQueryOperatorInput>;
  _rawIntroductionVideoCta?: InputMaybe<JsonQueryOperatorInput>;
  _rawLeaderboardSettings?: InputMaybe<JsonQueryOperatorInput>;
  _rawPartners?: InputMaybe<JsonQueryOperatorInput>;
  _rawPartnersPage?: InputMaybe<JsonQueryOperatorInput>;
  _rawWeeklyThemes?: InputMaybe<JsonQueryOperatorInput>;
  _rev?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  _updatedAt?: InputMaybe<DateQueryOperatorInput>;
  active?: InputMaybe<BooleanQueryOperatorInput>;
  activities?: InputMaybe<SanityActivityFilterListInput>;
  awards?: InputMaybe<BooleanQueryOperatorInput>;
  bbox?: InputMaybe<StringQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  closingSurveyCollectorUrl?: InputMaybe<StringQueryOperatorInput>;
  closingSurveyId?: InputMaybe<FloatQueryOperatorInput>;
  closingSurveyShownFrom?: InputMaybe<SanityRichDateFilterInput>;
  contactPage?: InputMaybe<SanityContentFilterInput>;
  ctaListForLoggedInUsers?: InputMaybe<SanityCtaFilterListInput>;
  ctaListForLoggedOutUsers?: InputMaybe<SanityCtaFilterListInput>;
  displayAll?: InputMaybe<BooleanQueryOperatorInput>;
  emailAddress?: InputMaybe<StringQueryOperatorInput>;
  endOfGameShowWinners?: InputMaybe<BooleanQueryOperatorInput>;
  endOfGameWinnersText?: InputMaybe<SanityBlockFilterListInput>;
  facebookUsername?: InputMaybe<StringQueryOperatorInput>;
  footerPartners?: InputMaybe<SanityPartnerFilterListInput>;
  gameIcon?: InputMaybe<SanityGameIconFilterInput>;
  gamePartnerConsentIntroduction?: InputMaybe<SanityBlockFilterListInput>;
  gamePartnerConsentText?: InputMaybe<StringQueryOperatorInput>;
  howToPlay?: InputMaybe<SanityContentFilterInput>;
  i18n_base?: InputMaybe<SanityLocalityFilterInput>;
  i18n_lang?: InputMaybe<StringQueryOperatorInput>;
  i18n_refs?: InputMaybe<SanityLocalityFilterListInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  internalName?: InputMaybe<StringQueryOperatorInput>;
  introductionContent?: InputMaybe<SanityBlockFilterListInput>;
  introductionHeading?: InputMaybe<StringQueryOperatorInput>;
  introductionVideoCta?: InputMaybe<SanityVideoCtaFilterInput>;
  leaderboardSettings?: InputMaybe<SanityLeaderboardSettingsFilterInput>;
  mapsKmlUrl?: InputMaybe<StringQueryOperatorInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  numberOfPartnersInFooter?: InputMaybe<FloatQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  partners?: InputMaybe<SanityPartnerFilterListInput>;
  partnersPage?: InputMaybe<SanityPartnersPageFilterInput>;
  tellUsAboutYouSurveyCollectorUrl?: InputMaybe<StringQueryOperatorInput>;
  tellUsAboutYouSurveyId?: InputMaybe<FloatQueryOperatorInput>;
  tellUsAboutYouSurveyMandatory?: InputMaybe<BooleanQueryOperatorInput>;
  twitterUsername?: InputMaybe<StringQueryOperatorInput>;
  urlSlug?: InputMaybe<StringQueryOperatorInput>;
  weeklyThemes?: InputMaybe<SanityThemeFilterListInput>;
};


export type QuerySanityMessageArgs = {
  _createdAt?: InputMaybe<DateQueryOperatorInput>;
  _id?: InputMaybe<StringQueryOperatorInput>;
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawBody?: InputMaybe<JsonQueryOperatorInput>;
  _rawCategory?: InputMaybe<JsonQueryOperatorInput>;
  _rawCta1?: InputMaybe<JsonQueryOperatorInput>;
  _rawCta2?: InputMaybe<JsonQueryOperatorInput>;
  _rawGame?: InputMaybe<JsonQueryOperatorInput>;
  _rawImage?: InputMaybe<JsonQueryOperatorInput>;
  _rev?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  _updatedAt?: InputMaybe<DateQueryOperatorInput>;
  body?: InputMaybe<SanityBlockFilterListInput>;
  category?: InputMaybe<SanityMessageCategoryFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  cta1?: InputMaybe<SanityMessageCtaFilterInput>;
  cta2?: InputMaybe<SanityMessageCtaFilterInput>;
  game?: InputMaybe<SanityGameFilterInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  image?: InputMaybe<SanityImageFilterInput>;
  imagePosition?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
  subtitle?: InputMaybe<StringQueryOperatorInput>;
  title?: InputMaybe<StringQueryOperatorInput>;
};


export type QuerySanityMessageCategoryArgs = {
  _createdAt?: InputMaybe<DateQueryOperatorInput>;
  _id?: InputMaybe<StringQueryOperatorInput>;
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawIcon?: InputMaybe<JsonQueryOperatorInput>;
  _rawImage?: InputMaybe<JsonQueryOperatorInput>;
  _rev?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  _updatedAt?: InputMaybe<DateQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  icon?: InputMaybe<SanityImageFilterInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  image?: InputMaybe<SanityImageFilterInput>;
  internal?: InputMaybe<InternalFilterInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  playerCategory?: InputMaybe<StringQueryOperatorInput>;
};


export type QuerySanityMessageCtaArgs = {
  _createdAt?: InputMaybe<DateQueryOperatorInput>;
  _id?: InputMaybe<StringQueryOperatorInput>;
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawEvent?: InputMaybe<JsonQueryOperatorInput>;
  _rev?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  _updatedAt?: InputMaybe<DateQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  event?: InputMaybe<SanityEventFilterInput>;
  externalLink?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  internalLink?: InputMaybe<StringQueryOperatorInput>;
  label?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
};


export type QuerySanityPartnerArgs = {
  _createdAt?: InputMaybe<DateQueryOperatorInput>;
  _id?: InputMaybe<StringQueryOperatorInput>;
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawI18NBase?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NRefs?: InputMaybe<JsonQueryOperatorInput>;
  _rawLogo?: InputMaybe<JsonQueryOperatorInput>;
  _rev?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  _updatedAt?: InputMaybe<DateQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  i18n_base?: InputMaybe<SanityPartnerFilterInput>;
  i18n_lang?: InputMaybe<StringQueryOperatorInput>;
  i18n_refs?: InputMaybe<SanityPartnerFilterListInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  logo?: InputMaybe<SanityImageFilterInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  websiteUrl?: InputMaybe<StringQueryOperatorInput>;
};


export type QuerySanityPartnersPageArgs = {
  _createdAt?: InputMaybe<DateQueryOperatorInput>;
  _id?: InputMaybe<StringQueryOperatorInput>;
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawI18NBase?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NRefs?: InputMaybe<JsonQueryOperatorInput>;
  _rawIntroduction?: InputMaybe<JsonQueryOperatorInput>;
  _rev?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  _updatedAt?: InputMaybe<DateQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  i18n_base?: InputMaybe<SanityPartnersPageFilterInput>;
  i18n_lang?: InputMaybe<StringQueryOperatorInput>;
  i18n_refs?: InputMaybe<SanityPartnersPageFilterListInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  introduction?: InputMaybe<SanityBlockFilterListInput>;
  parent?: InputMaybe<NodeFilterInput>;
  title?: InputMaybe<StringQueryOperatorInput>;
};


export type QuerySanityProductsArgs = {
  _createdAt?: InputMaybe<DateQueryOperatorInput>;
  _id?: InputMaybe<StringQueryOperatorInput>;
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawI18NBase?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NRefs?: InputMaybe<JsonQueryOperatorInput>;
  _rawImage?: InputMaybe<JsonQueryOperatorInput>;
  _rev?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  _updatedAt?: InputMaybe<DateQueryOperatorInput>;
  alt?: InputMaybe<StringQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  description?: InputMaybe<StringQueryOperatorInput>;
  i18n_base?: InputMaybe<SanityProductsFilterInput>;
  i18n_lang?: InputMaybe<StringQueryOperatorInput>;
  i18n_refs?: InputMaybe<SanityProductsFilterListInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  image?: InputMaybe<SanityImageFilterInput>;
  internal?: InputMaybe<InternalFilterInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  price?: InputMaybe<FloatQueryOperatorInput>;
  productID?: InputMaybe<StringQueryOperatorInput>;
  weight?: InputMaybe<FloatQueryOperatorInput>;
};


export type QuerySanityRegistrationSettingsArgs = {
  _createdAt?: InputMaybe<DateQueryOperatorInput>;
  _id?: InputMaybe<StringQueryOperatorInput>;
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawAppTermsOfServiceText?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NBase?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NRefs?: InputMaybe<JsonQueryOperatorInput>;
  _rawTermsAndConditionsConsentText?: InputMaybe<JsonQueryOperatorInput>;
  _rev?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  _updatedAt?: InputMaybe<DateQueryOperatorInput>;
  appTermsOfServiceText?: InputMaybe<SanityBlockFilterListInput>;
  children?: InputMaybe<NodeFilterListInput>;
  contactConsentText?: InputMaybe<StringQueryOperatorInput>;
  i18n_base?: InputMaybe<SanityRegistrationSettingsFilterInput>;
  i18n_lang?: InputMaybe<StringQueryOperatorInput>;
  i18n_refs?: InputMaybe<SanityRegistrationSettingsFilterListInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  joinGameMessage?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  termsAndConditionsConsentText?: InputMaybe<SanityBlockFilterListInput>;
};


export type QuerySanityThemeArgs = {
  _createdAt?: InputMaybe<DateQueryOperatorInput>;
  _id?: InputMaybe<StringQueryOperatorInput>;
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawDescription?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NBase?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NRefs?: InputMaybe<JsonQueryOperatorInput>;
  _rawLogo?: InputMaybe<JsonQueryOperatorInput>;
  _rev?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  _updatedAt?: InputMaybe<DateQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  description?: InputMaybe<SanityBlockFilterListInput>;
  i18n_base?: InputMaybe<SanityThemeFilterInput>;
  i18n_lang?: InputMaybe<StringQueryOperatorInput>;
  i18n_refs?: InputMaybe<SanityThemeFilterListInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  logo?: InputMaybe<SanityImageFilterInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  subtitle?: InputMaybe<StringQueryOperatorInput>;
  themeColours?: InputMaybe<StringQueryOperatorInput>;
  title?: InputMaybe<StringQueryOperatorInput>;
};


export type QuerySanityVideoCtaArgs = {
  _createdAt?: InputMaybe<DateQueryOperatorInput>;
  _id?: InputMaybe<StringQueryOperatorInput>;
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawI18NBase?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NRefs?: InputMaybe<JsonQueryOperatorInput>;
  _rawPlaceholderImage?: InputMaybe<JsonQueryOperatorInput>;
  _rev?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  _updatedAt?: InputMaybe<DateQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  i18n_base?: InputMaybe<SanityVideoCtaFilterInput>;
  i18n_lang?: InputMaybe<StringQueryOperatorInput>;
  i18n_refs?: InputMaybe<SanityVideoCtaFilterListInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  internalTitle?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  placeholderImage?: InputMaybe<SanityImageFilterInput>;
  text?: InputMaybe<StringQueryOperatorInput>;
  videoUrl?: InputMaybe<StringQueryOperatorInput>;
};


export type QuerySiteArgs = {
  buildTime?: InputMaybe<DateQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  flags?: InputMaybe<SiteFlagsFilterInput>;
  graphqlTypegen?: InputMaybe<SiteGraphqlTypegenFilterInput>;
  host?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  jsxRuntime?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  pathPrefix?: InputMaybe<StringQueryOperatorInput>;
  polyfill?: InputMaybe<BooleanQueryOperatorInput>;
  port?: InputMaybe<IntQueryOperatorInput>;
  siteMetadata?: InputMaybe<SiteSiteMetadataFilterInput>;
  trailingSlash?: InputMaybe<StringQueryOperatorInput>;
};


export type QuerySiteBuildMetadataArgs = {
  buildTime?: InputMaybe<DateQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
};


export type QuerySiteFunctionArgs = {
  absoluteCompiledFilePath?: InputMaybe<StringQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  functionRoute?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  matchPath?: InputMaybe<StringQueryOperatorInput>;
  originalAbsoluteFilePath?: InputMaybe<StringQueryOperatorInput>;
  originalRelativeFilePath?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  pluginName?: InputMaybe<StringQueryOperatorInput>;
  relativeCompiledFilePath?: InputMaybe<StringQueryOperatorInput>;
};


export type QuerySitePageArgs = {
  children?: InputMaybe<NodeFilterListInput>;
  component?: InputMaybe<StringQueryOperatorInput>;
  componentChunkName?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  internalComponentName?: InputMaybe<StringQueryOperatorInput>;
  matchPath?: InputMaybe<StringQueryOperatorInput>;
  pageContext?: InputMaybe<JsonQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  path?: InputMaybe<StringQueryOperatorInput>;
  pluginCreator?: InputMaybe<SitePluginFilterInput>;
};


export type QuerySitePluginArgs = {
  browserAPIs?: InputMaybe<StringQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  nodeAPIs?: InputMaybe<StringQueryOperatorInput>;
  packageJson?: InputMaybe<JsonQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  pluginFilepath?: InputMaybe<StringQueryOperatorInput>;
  pluginOptions?: InputMaybe<JsonQueryOperatorInput>;
  resolve?: InputMaybe<StringQueryOperatorInput>;
  ssrAPIs?: InputMaybe<StringQueryOperatorInput>;
  version?: InputMaybe<StringQueryOperatorInput>;
};


export type QuerySwipesActivityByLocationArgs = {
  input: GetDemographicsData;
};

/** Remote Interface */
export type RemoteFile = {
  filename: Scalars['String'];
  filesize?: Maybe<Scalars['Int']>;
  /** Data used in the <GatsbyImage /> component. See https://gatsby.dev/img for more info. */
  gatsbyImage?: Maybe<Scalars['GatsbyImageData']>;
  height?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  mimeType: Scalars['String'];
  publicUrl: Scalars['String'];
  resize?: Maybe<RemoteFileResize>;
  width?: Maybe<Scalars['Int']>;
};


/** Remote Interface */
export type RemoteFileGatsbyImageArgs = {
  aspectRatio?: InputMaybe<Scalars['Float']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  breakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  cropFocus?: InputMaybe<Array<InputMaybe<RemoteFileCropFocus>>>;
  fit?: InputMaybe<RemoteFileFit>;
  formats?: InputMaybe<Array<RemoteFileFormat>>;
  height?: InputMaybe<Scalars['Int']>;
  layout?: InputMaybe<RemoteFileLayout>;
  outputPixelDensities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  placeholder?: InputMaybe<RemoteFilePlaceholder>;
  quality?: InputMaybe<Scalars['Int']>;
  sizes?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};


/** Remote Interface */
export type RemoteFileResizeArgs = {
  aspectRatio?: InputMaybe<Scalars['Float']>;
  cropFocus?: InputMaybe<Array<InputMaybe<RemoteFileCropFocus>>>;
  fit?: InputMaybe<RemoteFileFit>;
  format?: InputMaybe<RemoteFileFormat>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  width?: InputMaybe<Scalars['Int']>;
};

export enum RemoteFileCropFocus {
  Bottom = 'BOTTOM',
  Center = 'CENTER',
  Edges = 'EDGES',
  Entropy = 'ENTROPY',
  Faces = 'FACES',
  Left = 'LEFT',
  Right = 'RIGHT',
  Top = 'TOP'
}

export enum RemoteFileFit {
  Contain = 'CONTAIN',
  Cover = 'COVER',
  Fill = 'FILL',
  Outside = 'OUTSIDE'
}

export enum RemoteFileFormat {
  Auto = 'AUTO',
  Avif = 'AVIF',
  Jpg = 'JPG',
  Png = 'PNG',
  Webp = 'WEBP'
}

export enum RemoteFileLayout {
  Constrained = 'CONSTRAINED',
  Fixed = 'FIXED',
  FullWidth = 'FULL_WIDTH'
}

export enum RemoteFilePlaceholder {
  Blurred = 'BLURRED',
  DominantColor = 'DOMINANT_COLOR',
  None = 'NONE',
  TracedSvg = 'TRACED_SVG'
}

export type RemoteFileResize = {
  height?: Maybe<Scalars['Int']>;
  src?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
};

export type RemoteFileResizeFieldSelector = {
  height?: InputMaybe<FieldSelectorEnum>;
  src?: InputMaybe<FieldSelectorEnum>;
  width?: InputMaybe<FieldSelectorEnum>;
};

export type RemoteFileResizeFilterInput = {
  height?: InputMaybe<IntQueryOperatorInput>;
  src?: InputMaybe<StringQueryOperatorInput>;
  width?: InputMaybe<IntQueryOperatorInput>;
};

export type RemoteFileResizeSortInput = {
  height?: InputMaybe<SortOrderEnum>;
  src?: InputMaybe<SortOrderEnum>;
  width?: InputMaybe<SortOrderEnum>;
};

export type RemoveFromFamilyInput = {
  parentId: Scalars['String'];
  playerId: Scalars['String'];
};

export type ReportUserInput = {
  description: Scalars['String'];
  playerId: Scalars['String'];
  reportedPlayerId: Scalars['String'];
  tags?: InputMaybe<Array<Scalars['String']>>;
};

export type Route = {
  gameId: Scalars['String'];
  id: Scalars['String'];
  locationId: Scalars['String'];
  locationSlug?: Maybe<Scalars['String']>;
  playerId: Scalars['String'];
  points: Scalars['Int'];
  sqlId: Scalars['String'];
  swipeId: Scalars['String'];
  swipeTimestamp: Scalars['String'];
  tagNumber: Scalars['Int'];
};

export type SanityAccordion = {
  _key?: Maybe<Scalars['String']>;
  _rawItems?: Maybe<Scalars['JSON']>;
  _type?: Maybe<Scalars['String']>;
  i18n_lang?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<SanityAccordionItem>>>;
};


export type SanityAccordion_RawItemsArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};

export type SanityAccordionItem = {
  _key?: Maybe<Scalars['String']>;
  _rawBody?: Maybe<Scalars['JSON']>;
  _type?: Maybe<Scalars['String']>;
  body?: Maybe<Array<Maybe<SanityBlock>>>;
  heading?: Maybe<Scalars['String']>;
};


export type SanityAccordionItem_RawBodyArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};

export type SanityAccordionOrBlockOrCtaOrCtaGridOrEmbedOrFigureOrProductGridOrResourcesOrVideoCta = SanityAccordion | SanityBlock | SanityCta | SanityCtaGrid | SanityEmbed | SanityFigure | SanityProductGrid | SanityResources | SanityVideoCta;

export type SanityActivity = Node & SanityDocument & {
  _createdAt?: Maybe<Scalars['Date']>;
  _id?: Maybe<Scalars['String']>;
  _key?: Maybe<Scalars['String']>;
  _rawDescription?: Maybe<Scalars['JSON']>;
  _rawFile?: Maybe<Scalars['JSON']>;
  _rawI18NBase?: Maybe<Scalars['JSON']>;
  _rawI18NRefs?: Maybe<Scalars['JSON']>;
  _rawImage?: Maybe<Scalars['JSON']>;
  _rev?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  _updatedAt?: Maybe<Scalars['Date']>;
  alt?: Maybe<Scalars['String']>;
  children: Array<Node>;
  description?: Maybe<Array<Maybe<SanityBlock>>>;
  file?: Maybe<SanityFile>;
  i18n_base?: Maybe<SanityActivity>;
  i18n_lang?: Maybe<Scalars['String']>;
  i18n_refs?: Maybe<Array<Maybe<SanityActivity>>>;
  id: Scalars['ID'];
  image?: Maybe<SanityImage>;
  internal: Internal;
  parent?: Maybe<Node>;
  title?: Maybe<Scalars['String']>;
};


export type SanityActivity_CreatedAtArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type SanityActivity_RawDescriptionArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityActivity_RawFileArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityActivity_RawI18NBaseArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityActivity_RawI18NRefsArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityActivity_RawImageArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityActivity_UpdatedAtArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type SanityActivityConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SanityActivityEdge>;
  group: Array<SanityActivityGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<SanityActivity>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SanityActivityConnectionDistinctArgs = {
  field: SanityActivityFieldSelector;
};


export type SanityActivityConnectionGroupArgs = {
  field: SanityActivityFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SanityActivityConnectionMaxArgs = {
  field: SanityActivityFieldSelector;
};


export type SanityActivityConnectionMinArgs = {
  field: SanityActivityFieldSelector;
};


export type SanityActivityConnectionSumArgs = {
  field: SanityActivityFieldSelector;
};

export type SanityActivityEdge = {
  next?: Maybe<SanityActivity>;
  node: SanityActivity;
  previous?: Maybe<SanityActivity>;
};

export type SanityActivityFieldSelector = {
  _createdAt?: InputMaybe<FieldSelectorEnum>;
  _id?: InputMaybe<FieldSelectorEnum>;
  _key?: InputMaybe<FieldSelectorEnum>;
  _rawDescription?: InputMaybe<FieldSelectorEnum>;
  _rawFile?: InputMaybe<FieldSelectorEnum>;
  _rawI18NBase?: InputMaybe<FieldSelectorEnum>;
  _rawI18NRefs?: InputMaybe<FieldSelectorEnum>;
  _rawImage?: InputMaybe<FieldSelectorEnum>;
  _rev?: InputMaybe<FieldSelectorEnum>;
  _type?: InputMaybe<FieldSelectorEnum>;
  _updatedAt?: InputMaybe<FieldSelectorEnum>;
  alt?: InputMaybe<FieldSelectorEnum>;
  children?: InputMaybe<NodeFieldSelector>;
  description?: InputMaybe<SanityBlockFieldSelector>;
  file?: InputMaybe<SanityFileFieldSelector>;
  i18n_base?: InputMaybe<SanityActivityFieldSelector>;
  i18n_lang?: InputMaybe<FieldSelectorEnum>;
  i18n_refs?: InputMaybe<SanityActivityFieldSelector>;
  id?: InputMaybe<FieldSelectorEnum>;
  image?: InputMaybe<SanityImageFieldSelector>;
  internal?: InputMaybe<InternalFieldSelector>;
  parent?: InputMaybe<NodeFieldSelector>;
  title?: InputMaybe<FieldSelectorEnum>;
};

export type SanityActivityFilterInput = {
  _createdAt?: InputMaybe<DateQueryOperatorInput>;
  _id?: InputMaybe<StringQueryOperatorInput>;
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawDescription?: InputMaybe<JsonQueryOperatorInput>;
  _rawFile?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NBase?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NRefs?: InputMaybe<JsonQueryOperatorInput>;
  _rawImage?: InputMaybe<JsonQueryOperatorInput>;
  _rev?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  _updatedAt?: InputMaybe<DateQueryOperatorInput>;
  alt?: InputMaybe<StringQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  description?: InputMaybe<SanityBlockFilterListInput>;
  file?: InputMaybe<SanityFileFilterInput>;
  i18n_base?: InputMaybe<SanityActivityFilterInput>;
  i18n_lang?: InputMaybe<StringQueryOperatorInput>;
  i18n_refs?: InputMaybe<SanityActivityFilterListInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  image?: InputMaybe<SanityImageFilterInput>;
  internal?: InputMaybe<InternalFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
  title?: InputMaybe<StringQueryOperatorInput>;
};

export type SanityActivityFilterListInput = {
  elemMatch?: InputMaybe<SanityActivityFilterInput>;
};

export type SanityActivityGroupConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SanityActivityEdge>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
  group: Array<SanityActivityGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<SanityActivity>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SanityActivityGroupConnectionDistinctArgs = {
  field: SanityActivityFieldSelector;
};


export type SanityActivityGroupConnectionGroupArgs = {
  field: SanityActivityFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SanityActivityGroupConnectionMaxArgs = {
  field: SanityActivityFieldSelector;
};


export type SanityActivityGroupConnectionMinArgs = {
  field: SanityActivityFieldSelector;
};


export type SanityActivityGroupConnectionSumArgs = {
  field: SanityActivityFieldSelector;
};

export type SanityActivitySortInput = {
  _createdAt?: InputMaybe<SortOrderEnum>;
  _id?: InputMaybe<SortOrderEnum>;
  _key?: InputMaybe<SortOrderEnum>;
  _rawDescription?: InputMaybe<SortOrderEnum>;
  _rawFile?: InputMaybe<SortOrderEnum>;
  _rawI18NBase?: InputMaybe<SortOrderEnum>;
  _rawI18NRefs?: InputMaybe<SortOrderEnum>;
  _rawImage?: InputMaybe<SortOrderEnum>;
  _rev?: InputMaybe<SortOrderEnum>;
  _type?: InputMaybe<SortOrderEnum>;
  _updatedAt?: InputMaybe<SortOrderEnum>;
  alt?: InputMaybe<SortOrderEnum>;
  children?: InputMaybe<NodeSortInput>;
  description?: InputMaybe<SanityBlockSortInput>;
  file?: InputMaybe<SanityFileSortInput>;
  i18n_base?: InputMaybe<SanityActivitySortInput>;
  i18n_lang?: InputMaybe<SortOrderEnum>;
  i18n_refs?: InputMaybe<SanityActivitySortInput>;
  id?: InputMaybe<SortOrderEnum>;
  image?: InputMaybe<SanityImageSortInput>;
  internal?: InputMaybe<InternalSortInput>;
  parent?: InputMaybe<NodeSortInput>;
  title?: InputMaybe<SortOrderEnum>;
};

export type SanityAssetSourceData = {
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type SanityAssetSourceDataFieldSelector = {
  _key?: InputMaybe<FieldSelectorEnum>;
  _type?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  name?: InputMaybe<FieldSelectorEnum>;
  url?: InputMaybe<FieldSelectorEnum>;
};

export type SanityAssetSourceDataFilterInput = {
  _key?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
};

export type SanityAssetSourceDataSortInput = {
  _key?: InputMaybe<SortOrderEnum>;
  _type?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  name?: InputMaybe<SortOrderEnum>;
  url?: InputMaybe<SortOrderEnum>;
};

export type SanityAwards = Node & SanityDocument & {
  _createdAt?: Maybe<Scalars['Date']>;
  _id?: Maybe<Scalars['String']>;
  _key?: Maybe<Scalars['String']>;
  _rawI18NBase?: Maybe<Scalars['JSON']>;
  _rawI18NRefs?: Maybe<Scalars['JSON']>;
  _rawIcon?: Maybe<Scalars['JSON']>;
  _rawIconBackground?: Maybe<Scalars['JSON']>;
  _rev?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  _updatedAt?: Maybe<Scalars['Date']>;
  alt?: Maybe<Scalars['String']>;
  children: Array<Node>;
  description?: Maybe<Scalars['String']>;
  i18n_base?: Maybe<SanityAwards>;
  i18n_lang?: Maybe<Scalars['String']>;
  i18n_refs?: Maybe<Array<Maybe<SanityAwards>>>;
  icon?: Maybe<SanityImage>;
  iconBackground?: Maybe<SanityColor>;
  id: Scalars['ID'];
  internal: Internal;
  motivator?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parent?: Maybe<Node>;
  range?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['String']>;
};


export type SanityAwards_CreatedAtArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type SanityAwards_RawI18NBaseArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityAwards_RawI18NRefsArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityAwards_RawIconArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityAwards_RawIconBackgroundArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityAwards_UpdatedAtArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type SanityAwardsConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SanityAwardsEdge>;
  group: Array<SanityAwardsGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<SanityAwards>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SanityAwardsConnectionDistinctArgs = {
  field: SanityAwardsFieldSelector;
};


export type SanityAwardsConnectionGroupArgs = {
  field: SanityAwardsFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SanityAwardsConnectionMaxArgs = {
  field: SanityAwardsFieldSelector;
};


export type SanityAwardsConnectionMinArgs = {
  field: SanityAwardsFieldSelector;
};


export type SanityAwardsConnectionSumArgs = {
  field: SanityAwardsFieldSelector;
};

export type SanityAwardsEdge = {
  next?: Maybe<SanityAwards>;
  node: SanityAwards;
  previous?: Maybe<SanityAwards>;
};

export type SanityAwardsFieldSelector = {
  _createdAt?: InputMaybe<FieldSelectorEnum>;
  _id?: InputMaybe<FieldSelectorEnum>;
  _key?: InputMaybe<FieldSelectorEnum>;
  _rawI18NBase?: InputMaybe<FieldSelectorEnum>;
  _rawI18NRefs?: InputMaybe<FieldSelectorEnum>;
  _rawIcon?: InputMaybe<FieldSelectorEnum>;
  _rawIconBackground?: InputMaybe<FieldSelectorEnum>;
  _rev?: InputMaybe<FieldSelectorEnum>;
  _type?: InputMaybe<FieldSelectorEnum>;
  _updatedAt?: InputMaybe<FieldSelectorEnum>;
  alt?: InputMaybe<FieldSelectorEnum>;
  children?: InputMaybe<NodeFieldSelector>;
  description?: InputMaybe<FieldSelectorEnum>;
  i18n_base?: InputMaybe<SanityAwardsFieldSelector>;
  i18n_lang?: InputMaybe<FieldSelectorEnum>;
  i18n_refs?: InputMaybe<SanityAwardsFieldSelector>;
  icon?: InputMaybe<SanityImageFieldSelector>;
  iconBackground?: InputMaybe<SanityColorFieldSelector>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  motivator?: InputMaybe<FieldSelectorEnum>;
  name?: InputMaybe<FieldSelectorEnum>;
  parent?: InputMaybe<NodeFieldSelector>;
  range?: InputMaybe<FieldSelectorEnum>;
  type?: InputMaybe<FieldSelectorEnum>;
};

export type SanityAwardsFilterInput = {
  _createdAt?: InputMaybe<DateQueryOperatorInput>;
  _id?: InputMaybe<StringQueryOperatorInput>;
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawI18NBase?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NRefs?: InputMaybe<JsonQueryOperatorInput>;
  _rawIcon?: InputMaybe<JsonQueryOperatorInput>;
  _rawIconBackground?: InputMaybe<JsonQueryOperatorInput>;
  _rev?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  _updatedAt?: InputMaybe<DateQueryOperatorInput>;
  alt?: InputMaybe<StringQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  description?: InputMaybe<StringQueryOperatorInput>;
  i18n_base?: InputMaybe<SanityAwardsFilterInput>;
  i18n_lang?: InputMaybe<StringQueryOperatorInput>;
  i18n_refs?: InputMaybe<SanityAwardsFilterListInput>;
  icon?: InputMaybe<SanityImageFilterInput>;
  iconBackground?: InputMaybe<SanityColorFilterInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  motivator?: InputMaybe<StringQueryOperatorInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  range?: InputMaybe<FloatQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
};

export type SanityAwardsFilterListInput = {
  elemMatch?: InputMaybe<SanityAwardsFilterInput>;
};

export type SanityAwardsGroupConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SanityAwardsEdge>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
  group: Array<SanityAwardsGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<SanityAwards>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SanityAwardsGroupConnectionDistinctArgs = {
  field: SanityAwardsFieldSelector;
};


export type SanityAwardsGroupConnectionGroupArgs = {
  field: SanityAwardsFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SanityAwardsGroupConnectionMaxArgs = {
  field: SanityAwardsFieldSelector;
};


export type SanityAwardsGroupConnectionMinArgs = {
  field: SanityAwardsFieldSelector;
};


export type SanityAwardsGroupConnectionSumArgs = {
  field: SanityAwardsFieldSelector;
};

export type SanityAwardsSortInput = {
  _createdAt?: InputMaybe<SortOrderEnum>;
  _id?: InputMaybe<SortOrderEnum>;
  _key?: InputMaybe<SortOrderEnum>;
  _rawI18NBase?: InputMaybe<SortOrderEnum>;
  _rawI18NRefs?: InputMaybe<SortOrderEnum>;
  _rawIcon?: InputMaybe<SortOrderEnum>;
  _rawIconBackground?: InputMaybe<SortOrderEnum>;
  _rev?: InputMaybe<SortOrderEnum>;
  _type?: InputMaybe<SortOrderEnum>;
  _updatedAt?: InputMaybe<SortOrderEnum>;
  alt?: InputMaybe<SortOrderEnum>;
  children?: InputMaybe<NodeSortInput>;
  description?: InputMaybe<SortOrderEnum>;
  i18n_base?: InputMaybe<SanityAwardsSortInput>;
  i18n_lang?: InputMaybe<SortOrderEnum>;
  i18n_refs?: InputMaybe<SanityAwardsSortInput>;
  icon?: InputMaybe<SanityImageSortInput>;
  iconBackground?: InputMaybe<SanityColorSortInput>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  motivator?: InputMaybe<SortOrderEnum>;
  name?: InputMaybe<SortOrderEnum>;
  parent?: InputMaybe<NodeSortInput>;
  range?: InputMaybe<SortOrderEnum>;
  type?: InputMaybe<SortOrderEnum>;
};

export type SanityBlock = {
  _key?: Maybe<Scalars['String']>;
  _rawChildren?: Maybe<Scalars['JSON']>;
  _type?: Maybe<Scalars['String']>;
  children?: Maybe<Array<Maybe<SanitySpan>>>;
  list?: Maybe<Scalars['String']>;
  style?: Maybe<Scalars['String']>;
};


export type SanityBlock_RawChildrenArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};

export type SanityBlockFieldSelector = {
  _key?: InputMaybe<FieldSelectorEnum>;
  _rawChildren?: InputMaybe<FieldSelectorEnum>;
  _type?: InputMaybe<FieldSelectorEnum>;
  children?: InputMaybe<SanitySpanFieldSelector>;
  list?: InputMaybe<FieldSelectorEnum>;
  style?: InputMaybe<FieldSelectorEnum>;
};

export type SanityBlockFilterInput = {
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawChildren?: InputMaybe<JsonQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  children?: InputMaybe<SanitySpanFilterListInput>;
  list?: InputMaybe<StringQueryOperatorInput>;
  style?: InputMaybe<StringQueryOperatorInput>;
};

export type SanityBlockFilterListInput = {
  elemMatch?: InputMaybe<SanityBlockFilterInput>;
};

export type SanityBlockOrEmbedOrFigureOrVideoCta = SanityBlock | SanityEmbed | SanityFigure | SanityVideoCta;

export type SanityBlockSortInput = {
  _key?: InputMaybe<SortOrderEnum>;
  _rawChildren?: InputMaybe<SortOrderEnum>;
  _type?: InputMaybe<SortOrderEnum>;
  children?: InputMaybe<SanitySpanSortInput>;
  list?: InputMaybe<SortOrderEnum>;
  style?: InputMaybe<SortOrderEnum>;
};

export type SanityColor = {
  _key?: Maybe<Scalars['String']>;
  _rawHsl?: Maybe<Scalars['JSON']>;
  _rawHsv?: Maybe<Scalars['JSON']>;
  _rawRgb?: Maybe<Scalars['JSON']>;
  _type?: Maybe<Scalars['String']>;
  alpha?: Maybe<Scalars['Float']>;
  hex?: Maybe<Scalars['String']>;
  hsl?: Maybe<SanityHslaColor>;
  hsv?: Maybe<SanityHsvaColor>;
  rgb?: Maybe<SanityRgbaColor>;
};


export type SanityColor_RawHslArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityColor_RawHsvArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityColor_RawRgbArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};

export type SanityColorFieldSelector = {
  _key?: InputMaybe<FieldSelectorEnum>;
  _rawHsl?: InputMaybe<FieldSelectorEnum>;
  _rawHsv?: InputMaybe<FieldSelectorEnum>;
  _rawRgb?: InputMaybe<FieldSelectorEnum>;
  _type?: InputMaybe<FieldSelectorEnum>;
  alpha?: InputMaybe<FieldSelectorEnum>;
  hex?: InputMaybe<FieldSelectorEnum>;
  hsl?: InputMaybe<SanityHslaColorFieldSelector>;
  hsv?: InputMaybe<SanityHsvaColorFieldSelector>;
  rgb?: InputMaybe<SanityRgbaColorFieldSelector>;
};

export type SanityColorFilterInput = {
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawHsl?: InputMaybe<JsonQueryOperatorInput>;
  _rawHsv?: InputMaybe<JsonQueryOperatorInput>;
  _rawRgb?: InputMaybe<JsonQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  alpha?: InputMaybe<FloatQueryOperatorInput>;
  hex?: InputMaybe<StringQueryOperatorInput>;
  hsl?: InputMaybe<SanityHslaColorFilterInput>;
  hsv?: InputMaybe<SanityHsvaColorFilterInput>;
  rgb?: InputMaybe<SanityRgbaColorFilterInput>;
};

export type SanityColorSortInput = {
  _key?: InputMaybe<SortOrderEnum>;
  _rawHsl?: InputMaybe<SortOrderEnum>;
  _rawHsv?: InputMaybe<SortOrderEnum>;
  _rawRgb?: InputMaybe<SortOrderEnum>;
  _type?: InputMaybe<SortOrderEnum>;
  alpha?: InputMaybe<SortOrderEnum>;
  hex?: InputMaybe<SortOrderEnum>;
  hsl?: InputMaybe<SanityHslaColorSortInput>;
  hsv?: InputMaybe<SanityHsvaColorSortInput>;
  rgb?: InputMaybe<SanityRgbaColorSortInput>;
};

export type SanityContent = Node & SanityDocument & {
  _createdAt?: Maybe<Scalars['Date']>;
  _id?: Maybe<Scalars['String']>;
  _key?: Maybe<Scalars['String']>;
  _rawBody?: Maybe<Scalars['JSON']>;
  _rawI18NBase?: Maybe<Scalars['JSON']>;
  _rawI18NRefs?: Maybe<Scalars['JSON']>;
  _rev?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  _updatedAt?: Maybe<Scalars['Date']>;
  body?: Maybe<Array<Maybe<SanityBlock>>>;
  children: Array<Node>;
  i18n_base?: Maybe<SanityContent>;
  i18n_lang?: Maybe<Scalars['String']>;
  i18n_refs?: Maybe<Array<Maybe<SanityContent>>>;
  id: Scalars['ID'];
  internal: Internal;
  internalTitle?: Maybe<Scalars['String']>;
  parent?: Maybe<Node>;
  title?: Maybe<Scalars['String']>;
};


export type SanityContent_CreatedAtArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type SanityContent_RawBodyArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityContent_RawI18NBaseArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityContent_RawI18NRefsArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityContent_UpdatedAtArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type SanityContentConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SanityContentEdge>;
  group: Array<SanityContentGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<SanityContent>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SanityContentConnectionDistinctArgs = {
  field: SanityContentFieldSelector;
};


export type SanityContentConnectionGroupArgs = {
  field: SanityContentFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SanityContentConnectionMaxArgs = {
  field: SanityContentFieldSelector;
};


export type SanityContentConnectionMinArgs = {
  field: SanityContentFieldSelector;
};


export type SanityContentConnectionSumArgs = {
  field: SanityContentFieldSelector;
};

export type SanityContentEdge = {
  next?: Maybe<SanityContent>;
  node: SanityContent;
  previous?: Maybe<SanityContent>;
};

export type SanityContentFieldSelector = {
  _createdAt?: InputMaybe<FieldSelectorEnum>;
  _id?: InputMaybe<FieldSelectorEnum>;
  _key?: InputMaybe<FieldSelectorEnum>;
  _rawBody?: InputMaybe<FieldSelectorEnum>;
  _rawI18NBase?: InputMaybe<FieldSelectorEnum>;
  _rawI18NRefs?: InputMaybe<FieldSelectorEnum>;
  _rev?: InputMaybe<FieldSelectorEnum>;
  _type?: InputMaybe<FieldSelectorEnum>;
  _updatedAt?: InputMaybe<FieldSelectorEnum>;
  body?: InputMaybe<SanityBlockFieldSelector>;
  children?: InputMaybe<NodeFieldSelector>;
  i18n_base?: InputMaybe<SanityContentFieldSelector>;
  i18n_lang?: InputMaybe<FieldSelectorEnum>;
  i18n_refs?: InputMaybe<SanityContentFieldSelector>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  internalTitle?: InputMaybe<FieldSelectorEnum>;
  parent?: InputMaybe<NodeFieldSelector>;
  title?: InputMaybe<FieldSelectorEnum>;
};

export type SanityContentFilterInput = {
  _createdAt?: InputMaybe<DateQueryOperatorInput>;
  _id?: InputMaybe<StringQueryOperatorInput>;
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawBody?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NBase?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NRefs?: InputMaybe<JsonQueryOperatorInput>;
  _rev?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  _updatedAt?: InputMaybe<DateQueryOperatorInput>;
  body?: InputMaybe<SanityBlockFilterListInput>;
  children?: InputMaybe<NodeFilterListInput>;
  i18n_base?: InputMaybe<SanityContentFilterInput>;
  i18n_lang?: InputMaybe<StringQueryOperatorInput>;
  i18n_refs?: InputMaybe<SanityContentFilterListInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  internalTitle?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  title?: InputMaybe<StringQueryOperatorInput>;
};

export type SanityContentFilterListInput = {
  elemMatch?: InputMaybe<SanityContentFilterInput>;
};

export type SanityContentGroupConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SanityContentEdge>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
  group: Array<SanityContentGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<SanityContent>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SanityContentGroupConnectionDistinctArgs = {
  field: SanityContentFieldSelector;
};


export type SanityContentGroupConnectionGroupArgs = {
  field: SanityContentFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SanityContentGroupConnectionMaxArgs = {
  field: SanityContentFieldSelector;
};


export type SanityContentGroupConnectionMinArgs = {
  field: SanityContentFieldSelector;
};


export type SanityContentGroupConnectionSumArgs = {
  field: SanityContentFieldSelector;
};

export type SanityContentOrFaqs = SanityContent | SanityFaqs;

export type SanityContentSortInput = {
  _createdAt?: InputMaybe<SortOrderEnum>;
  _id?: InputMaybe<SortOrderEnum>;
  _key?: InputMaybe<SortOrderEnum>;
  _rawBody?: InputMaybe<SortOrderEnum>;
  _rawI18NBase?: InputMaybe<SortOrderEnum>;
  _rawI18NRefs?: InputMaybe<SortOrderEnum>;
  _rev?: InputMaybe<SortOrderEnum>;
  _type?: InputMaybe<SortOrderEnum>;
  _updatedAt?: InputMaybe<SortOrderEnum>;
  body?: InputMaybe<SanityBlockSortInput>;
  children?: InputMaybe<NodeSortInput>;
  i18n_base?: InputMaybe<SanityContentSortInput>;
  i18n_lang?: InputMaybe<SortOrderEnum>;
  i18n_refs?: InputMaybe<SanityContentSortInput>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  internalTitle?: InputMaybe<SortOrderEnum>;
  parent?: InputMaybe<NodeSortInput>;
  title?: InputMaybe<SortOrderEnum>;
};

export type SanityCta = Node & SanityDocument & {
  _createdAt?: Maybe<Scalars['Date']>;
  _id?: Maybe<Scalars['String']>;
  _key?: Maybe<Scalars['String']>;
  _rawI18NBase?: Maybe<Scalars['JSON']>;
  _rawI18NRefs?: Maybe<Scalars['JSON']>;
  _rawLink?: Maybe<Scalars['JSON']>;
  _rev?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  _updatedAt?: Maybe<Scalars['Date']>;
  children: Array<Node>;
  i18n_base?: Maybe<SanityCta>;
  i18n_lang?: Maybe<Scalars['String']>;
  i18n_refs?: Maybe<Array<Maybe<SanityCta>>>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  internal: Internal;
  internalTitle?: Maybe<Scalars['String']>;
  link?: Maybe<SanityLinkWithText>;
  parent?: Maybe<Node>;
  size?: Maybe<Scalars['String']>;
  style?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};


export type SanityCta_CreatedAtArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type SanityCta_RawI18NBaseArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityCta_RawI18NRefsArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityCta_RawLinkArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityCta_UpdatedAtArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type SanityCtaConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SanityCtaEdge>;
  group: Array<SanityCtaGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<SanityCta>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SanityCtaConnectionDistinctArgs = {
  field: SanityCtaFieldSelector;
};


export type SanityCtaConnectionGroupArgs = {
  field: SanityCtaFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SanityCtaConnectionMaxArgs = {
  field: SanityCtaFieldSelector;
};


export type SanityCtaConnectionMinArgs = {
  field: SanityCtaFieldSelector;
};


export type SanityCtaConnectionSumArgs = {
  field: SanityCtaFieldSelector;
};

export type SanityCtaEdge = {
  next?: Maybe<SanityCta>;
  node: SanityCta;
  previous?: Maybe<SanityCta>;
};

export type SanityCtaFieldSelector = {
  _createdAt?: InputMaybe<FieldSelectorEnum>;
  _id?: InputMaybe<FieldSelectorEnum>;
  _key?: InputMaybe<FieldSelectorEnum>;
  _rawI18NBase?: InputMaybe<FieldSelectorEnum>;
  _rawI18NRefs?: InputMaybe<FieldSelectorEnum>;
  _rawLink?: InputMaybe<FieldSelectorEnum>;
  _rev?: InputMaybe<FieldSelectorEnum>;
  _type?: InputMaybe<FieldSelectorEnum>;
  _updatedAt?: InputMaybe<FieldSelectorEnum>;
  children?: InputMaybe<NodeFieldSelector>;
  i18n_base?: InputMaybe<SanityCtaFieldSelector>;
  i18n_lang?: InputMaybe<FieldSelectorEnum>;
  i18n_refs?: InputMaybe<SanityCtaFieldSelector>;
  icon?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  internalTitle?: InputMaybe<FieldSelectorEnum>;
  link?: InputMaybe<SanityLinkWithTextFieldSelector>;
  parent?: InputMaybe<NodeFieldSelector>;
  size?: InputMaybe<FieldSelectorEnum>;
  style?: InputMaybe<FieldSelectorEnum>;
  text?: InputMaybe<FieldSelectorEnum>;
  title?: InputMaybe<FieldSelectorEnum>;
};

export type SanityCtaFilterInput = {
  _createdAt?: InputMaybe<DateQueryOperatorInput>;
  _id?: InputMaybe<StringQueryOperatorInput>;
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawI18NBase?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NRefs?: InputMaybe<JsonQueryOperatorInput>;
  _rawLink?: InputMaybe<JsonQueryOperatorInput>;
  _rev?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  _updatedAt?: InputMaybe<DateQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  i18n_base?: InputMaybe<SanityCtaFilterInput>;
  i18n_lang?: InputMaybe<StringQueryOperatorInput>;
  i18n_refs?: InputMaybe<SanityCtaFilterListInput>;
  icon?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  internalTitle?: InputMaybe<StringQueryOperatorInput>;
  link?: InputMaybe<SanityLinkWithTextFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
  size?: InputMaybe<StringQueryOperatorInput>;
  style?: InputMaybe<StringQueryOperatorInput>;
  text?: InputMaybe<StringQueryOperatorInput>;
  title?: InputMaybe<StringQueryOperatorInput>;
};

export type SanityCtaFilterListInput = {
  elemMatch?: InputMaybe<SanityCtaFilterInput>;
};

export type SanityCtaGrid = {
  _key?: Maybe<Scalars['String']>;
  _rawItems?: Maybe<Scalars['JSON']>;
  _type?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<SanityCta>>>;
};


export type SanityCtaGrid_RawItemsArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};

export type SanityCtaGroupConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SanityCtaEdge>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
  group: Array<SanityCtaGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<SanityCta>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SanityCtaGroupConnectionDistinctArgs = {
  field: SanityCtaFieldSelector;
};


export type SanityCtaGroupConnectionGroupArgs = {
  field: SanityCtaFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SanityCtaGroupConnectionMaxArgs = {
  field: SanityCtaFieldSelector;
};


export type SanityCtaGroupConnectionMinArgs = {
  field: SanityCtaFieldSelector;
};


export type SanityCtaGroupConnectionSumArgs = {
  field: SanityCtaFieldSelector;
};

export type SanityCtaSortInput = {
  _createdAt?: InputMaybe<SortOrderEnum>;
  _id?: InputMaybe<SortOrderEnum>;
  _key?: InputMaybe<SortOrderEnum>;
  _rawI18NBase?: InputMaybe<SortOrderEnum>;
  _rawI18NRefs?: InputMaybe<SortOrderEnum>;
  _rawLink?: InputMaybe<SortOrderEnum>;
  _rev?: InputMaybe<SortOrderEnum>;
  _type?: InputMaybe<SortOrderEnum>;
  _updatedAt?: InputMaybe<SortOrderEnum>;
  children?: InputMaybe<NodeSortInput>;
  i18n_base?: InputMaybe<SanityCtaSortInput>;
  i18n_lang?: InputMaybe<SortOrderEnum>;
  i18n_refs?: InputMaybe<SanityCtaSortInput>;
  icon?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  internalTitle?: InputMaybe<SortOrderEnum>;
  link?: InputMaybe<SanityLinkWithTextSortInput>;
  parent?: InputMaybe<NodeSortInput>;
  size?: InputMaybe<SortOrderEnum>;
  style?: InputMaybe<SortOrderEnum>;
  text?: InputMaybe<SortOrderEnum>;
  title?: InputMaybe<SortOrderEnum>;
};

/** A Sanity document */
export type SanityDocument = {
  _createdAt?: Maybe<Scalars['Date']>;
  _id?: Maybe<Scalars['String']>;
  _rev?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  _updatedAt?: Maybe<Scalars['Date']>;
};

export type SanityEmbed = {
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type SanityEvent = Node & SanityDocument & {
  _createdAt?: Maybe<Scalars['Date']>;
  _id?: Maybe<Scalars['String']>;
  _key?: Maybe<Scalars['String']>;
  _rawDescription?: Maybe<Scalars['JSON']>;
  _rawGame?: Maybe<Scalars['JSON']>;
  _rawI18NBase?: Maybe<Scalars['JSON']>;
  _rawI18NRefs?: Maybe<Scalars['JSON']>;
  _rawImage?: Maybe<Scalars['JSON']>;
  _rev?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  _updatedAt?: Maybe<Scalars['Date']>;
  alt?: Maybe<Scalars['String']>;
  children: Array<Node>;
  description?: Maybe<Array<Maybe<SanityBlock>>>;
  endDate?: Maybe<Scalars['Date']>;
  endTime?: Maybe<Scalars['String']>;
  eventSlug?: Maybe<Scalars['String']>;
  externalUrl?: Maybe<Scalars['String']>;
  game?: Maybe<SanityGame>;
  i18n_base?: Maybe<SanityEvent>;
  i18n_lang?: Maybe<Scalars['String']>;
  i18n_refs?: Maybe<Array<Maybe<SanityEvent>>>;
  id: Scalars['ID'];
  image?: Maybe<SanityImage>;
  internal: Internal;
  internalTitle?: Maybe<Scalars['String']>;
  parent?: Maybe<Node>;
  startDate?: Maybe<Scalars['Date']>;
  startTime?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};


export type SanityEvent_CreatedAtArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type SanityEvent_RawDescriptionArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityEvent_RawGameArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityEvent_RawI18NBaseArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityEvent_RawI18NRefsArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityEvent_RawImageArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityEvent_UpdatedAtArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type SanityEventEndDateArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type SanityEventStartDateArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type SanityEventConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SanityEventEdge>;
  group: Array<SanityEventGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<SanityEvent>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SanityEventConnectionDistinctArgs = {
  field: SanityEventFieldSelector;
};


export type SanityEventConnectionGroupArgs = {
  field: SanityEventFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SanityEventConnectionMaxArgs = {
  field: SanityEventFieldSelector;
};


export type SanityEventConnectionMinArgs = {
  field: SanityEventFieldSelector;
};


export type SanityEventConnectionSumArgs = {
  field: SanityEventFieldSelector;
};

export type SanityEventEdge = {
  next?: Maybe<SanityEvent>;
  node: SanityEvent;
  previous?: Maybe<SanityEvent>;
};

export type SanityEventFieldSelector = {
  _createdAt?: InputMaybe<FieldSelectorEnum>;
  _id?: InputMaybe<FieldSelectorEnum>;
  _key?: InputMaybe<FieldSelectorEnum>;
  _rawDescription?: InputMaybe<FieldSelectorEnum>;
  _rawGame?: InputMaybe<FieldSelectorEnum>;
  _rawI18NBase?: InputMaybe<FieldSelectorEnum>;
  _rawI18NRefs?: InputMaybe<FieldSelectorEnum>;
  _rawImage?: InputMaybe<FieldSelectorEnum>;
  _rev?: InputMaybe<FieldSelectorEnum>;
  _type?: InputMaybe<FieldSelectorEnum>;
  _updatedAt?: InputMaybe<FieldSelectorEnum>;
  alt?: InputMaybe<FieldSelectorEnum>;
  children?: InputMaybe<NodeFieldSelector>;
  description?: InputMaybe<SanityBlockFieldSelector>;
  endDate?: InputMaybe<FieldSelectorEnum>;
  endTime?: InputMaybe<FieldSelectorEnum>;
  eventSlug?: InputMaybe<FieldSelectorEnum>;
  externalUrl?: InputMaybe<FieldSelectorEnum>;
  game?: InputMaybe<SanityGameFieldSelector>;
  i18n_base?: InputMaybe<SanityEventFieldSelector>;
  i18n_lang?: InputMaybe<FieldSelectorEnum>;
  i18n_refs?: InputMaybe<SanityEventFieldSelector>;
  id?: InputMaybe<FieldSelectorEnum>;
  image?: InputMaybe<SanityImageFieldSelector>;
  internal?: InputMaybe<InternalFieldSelector>;
  internalTitle?: InputMaybe<FieldSelectorEnum>;
  parent?: InputMaybe<NodeFieldSelector>;
  startDate?: InputMaybe<FieldSelectorEnum>;
  startTime?: InputMaybe<FieldSelectorEnum>;
  title?: InputMaybe<FieldSelectorEnum>;
};

export type SanityEventFilterInput = {
  _createdAt?: InputMaybe<DateQueryOperatorInput>;
  _id?: InputMaybe<StringQueryOperatorInput>;
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawDescription?: InputMaybe<JsonQueryOperatorInput>;
  _rawGame?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NBase?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NRefs?: InputMaybe<JsonQueryOperatorInput>;
  _rawImage?: InputMaybe<JsonQueryOperatorInput>;
  _rev?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  _updatedAt?: InputMaybe<DateQueryOperatorInput>;
  alt?: InputMaybe<StringQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  description?: InputMaybe<SanityBlockFilterListInput>;
  endDate?: InputMaybe<DateQueryOperatorInput>;
  endTime?: InputMaybe<StringQueryOperatorInput>;
  eventSlug?: InputMaybe<StringQueryOperatorInput>;
  externalUrl?: InputMaybe<StringQueryOperatorInput>;
  game?: InputMaybe<SanityGameFilterInput>;
  i18n_base?: InputMaybe<SanityEventFilterInput>;
  i18n_lang?: InputMaybe<StringQueryOperatorInput>;
  i18n_refs?: InputMaybe<SanityEventFilterListInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  image?: InputMaybe<SanityImageFilterInput>;
  internal?: InputMaybe<InternalFilterInput>;
  internalTitle?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  startDate?: InputMaybe<DateQueryOperatorInput>;
  startTime?: InputMaybe<StringQueryOperatorInput>;
  title?: InputMaybe<StringQueryOperatorInput>;
};

export type SanityEventFilterListInput = {
  elemMatch?: InputMaybe<SanityEventFilterInput>;
};

export type SanityEventGroupConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SanityEventEdge>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
  group: Array<SanityEventGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<SanityEvent>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SanityEventGroupConnectionDistinctArgs = {
  field: SanityEventFieldSelector;
};


export type SanityEventGroupConnectionGroupArgs = {
  field: SanityEventFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SanityEventGroupConnectionMaxArgs = {
  field: SanityEventFieldSelector;
};


export type SanityEventGroupConnectionMinArgs = {
  field: SanityEventFieldSelector;
};


export type SanityEventGroupConnectionSumArgs = {
  field: SanityEventFieldSelector;
};

export type SanityEventSortInput = {
  _createdAt?: InputMaybe<SortOrderEnum>;
  _id?: InputMaybe<SortOrderEnum>;
  _key?: InputMaybe<SortOrderEnum>;
  _rawDescription?: InputMaybe<SortOrderEnum>;
  _rawGame?: InputMaybe<SortOrderEnum>;
  _rawI18NBase?: InputMaybe<SortOrderEnum>;
  _rawI18NRefs?: InputMaybe<SortOrderEnum>;
  _rawImage?: InputMaybe<SortOrderEnum>;
  _rev?: InputMaybe<SortOrderEnum>;
  _type?: InputMaybe<SortOrderEnum>;
  _updatedAt?: InputMaybe<SortOrderEnum>;
  alt?: InputMaybe<SortOrderEnum>;
  children?: InputMaybe<NodeSortInput>;
  description?: InputMaybe<SanityBlockSortInput>;
  endDate?: InputMaybe<SortOrderEnum>;
  endTime?: InputMaybe<SortOrderEnum>;
  eventSlug?: InputMaybe<SortOrderEnum>;
  externalUrl?: InputMaybe<SortOrderEnum>;
  game?: InputMaybe<SanityGameSortInput>;
  i18n_base?: InputMaybe<SanityEventSortInput>;
  i18n_lang?: InputMaybe<SortOrderEnum>;
  i18n_refs?: InputMaybe<SanityEventSortInput>;
  id?: InputMaybe<SortOrderEnum>;
  image?: InputMaybe<SanityImageSortInput>;
  internal?: InputMaybe<InternalSortInput>;
  internalTitle?: InputMaybe<SortOrderEnum>;
  parent?: InputMaybe<NodeSortInput>;
  startDate?: InputMaybe<SortOrderEnum>;
  startTime?: InputMaybe<SortOrderEnum>;
  title?: InputMaybe<SortOrderEnum>;
};

export type SanityFaqQuestion = {
  _key?: Maybe<Scalars['String']>;
  _rawAnswer?: Maybe<Scalars['JSON']>;
  _type?: Maybe<Scalars['String']>;
  answer?: Maybe<Array<Maybe<SanityBlock>>>;
  question?: Maybe<Scalars['String']>;
};


export type SanityFaqQuestion_RawAnswerArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};

export type SanityFaqQuestionFieldSelector = {
  _key?: InputMaybe<FieldSelectorEnum>;
  _rawAnswer?: InputMaybe<FieldSelectorEnum>;
  _type?: InputMaybe<FieldSelectorEnum>;
  answer?: InputMaybe<SanityBlockFieldSelector>;
  question?: InputMaybe<FieldSelectorEnum>;
};

export type SanityFaqQuestionFilterInput = {
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawAnswer?: InputMaybe<JsonQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  answer?: InputMaybe<SanityBlockFilterListInput>;
  question?: InputMaybe<StringQueryOperatorInput>;
};

export type SanityFaqQuestionFilterListInput = {
  elemMatch?: InputMaybe<SanityFaqQuestionFilterInput>;
};

export type SanityFaqQuestionSortInput = {
  _key?: InputMaybe<SortOrderEnum>;
  _rawAnswer?: InputMaybe<SortOrderEnum>;
  _type?: InputMaybe<SortOrderEnum>;
  answer?: InputMaybe<SanityBlockSortInput>;
  question?: InputMaybe<SortOrderEnum>;
};

export type SanityFaqs = Node & SanityDocument & {
  _createdAt?: Maybe<Scalars['Date']>;
  _id?: Maybe<Scalars['String']>;
  _key?: Maybe<Scalars['String']>;
  _rawI18NBase?: Maybe<Scalars['JSON']>;
  _rawI18NRefs?: Maybe<Scalars['JSON']>;
  _rawIntro?: Maybe<Scalars['JSON']>;
  _rawQuestions?: Maybe<Scalars['JSON']>;
  _rev?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  _updatedAt?: Maybe<Scalars['Date']>;
  children: Array<Node>;
  i18n_base?: Maybe<SanityFaqs>;
  i18n_lang?: Maybe<Scalars['String']>;
  i18n_refs?: Maybe<Array<Maybe<SanityFaqs>>>;
  id: Scalars['ID'];
  internal: Internal;
  internalTitle?: Maybe<Scalars['String']>;
  intro?: Maybe<Array<Maybe<SanityBlock>>>;
  parent?: Maybe<Node>;
  questions?: Maybe<Array<Maybe<SanityFaqQuestion>>>;
  title?: Maybe<Scalars['String']>;
};


export type SanityFaqs_CreatedAtArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type SanityFaqs_RawI18NBaseArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityFaqs_RawI18NRefsArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityFaqs_RawIntroArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityFaqs_RawQuestionsArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityFaqs_UpdatedAtArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type SanityFaqsConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SanityFaqsEdge>;
  group: Array<SanityFaqsGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<SanityFaqs>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SanityFaqsConnectionDistinctArgs = {
  field: SanityFaqsFieldSelector;
};


export type SanityFaqsConnectionGroupArgs = {
  field: SanityFaqsFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SanityFaqsConnectionMaxArgs = {
  field: SanityFaqsFieldSelector;
};


export type SanityFaqsConnectionMinArgs = {
  field: SanityFaqsFieldSelector;
};


export type SanityFaqsConnectionSumArgs = {
  field: SanityFaqsFieldSelector;
};

export type SanityFaqsEdge = {
  next?: Maybe<SanityFaqs>;
  node: SanityFaqs;
  previous?: Maybe<SanityFaqs>;
};

export type SanityFaqsFieldSelector = {
  _createdAt?: InputMaybe<FieldSelectorEnum>;
  _id?: InputMaybe<FieldSelectorEnum>;
  _key?: InputMaybe<FieldSelectorEnum>;
  _rawI18NBase?: InputMaybe<FieldSelectorEnum>;
  _rawI18NRefs?: InputMaybe<FieldSelectorEnum>;
  _rawIntro?: InputMaybe<FieldSelectorEnum>;
  _rawQuestions?: InputMaybe<FieldSelectorEnum>;
  _rev?: InputMaybe<FieldSelectorEnum>;
  _type?: InputMaybe<FieldSelectorEnum>;
  _updatedAt?: InputMaybe<FieldSelectorEnum>;
  children?: InputMaybe<NodeFieldSelector>;
  i18n_base?: InputMaybe<SanityFaqsFieldSelector>;
  i18n_lang?: InputMaybe<FieldSelectorEnum>;
  i18n_refs?: InputMaybe<SanityFaqsFieldSelector>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  internalTitle?: InputMaybe<FieldSelectorEnum>;
  intro?: InputMaybe<SanityBlockFieldSelector>;
  parent?: InputMaybe<NodeFieldSelector>;
  questions?: InputMaybe<SanityFaqQuestionFieldSelector>;
  title?: InputMaybe<FieldSelectorEnum>;
};

export type SanityFaqsFilterInput = {
  _createdAt?: InputMaybe<DateQueryOperatorInput>;
  _id?: InputMaybe<StringQueryOperatorInput>;
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawI18NBase?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NRefs?: InputMaybe<JsonQueryOperatorInput>;
  _rawIntro?: InputMaybe<JsonQueryOperatorInput>;
  _rawQuestions?: InputMaybe<JsonQueryOperatorInput>;
  _rev?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  _updatedAt?: InputMaybe<DateQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  i18n_base?: InputMaybe<SanityFaqsFilterInput>;
  i18n_lang?: InputMaybe<StringQueryOperatorInput>;
  i18n_refs?: InputMaybe<SanityFaqsFilterListInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  internalTitle?: InputMaybe<StringQueryOperatorInput>;
  intro?: InputMaybe<SanityBlockFilterListInput>;
  parent?: InputMaybe<NodeFilterInput>;
  questions?: InputMaybe<SanityFaqQuestionFilterListInput>;
  title?: InputMaybe<StringQueryOperatorInput>;
};

export type SanityFaqsFilterListInput = {
  elemMatch?: InputMaybe<SanityFaqsFilterInput>;
};

export type SanityFaqsGroupConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SanityFaqsEdge>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
  group: Array<SanityFaqsGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<SanityFaqs>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SanityFaqsGroupConnectionDistinctArgs = {
  field: SanityFaqsFieldSelector;
};


export type SanityFaqsGroupConnectionGroupArgs = {
  field: SanityFaqsFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SanityFaqsGroupConnectionMaxArgs = {
  field: SanityFaqsFieldSelector;
};


export type SanityFaqsGroupConnectionMinArgs = {
  field: SanityFaqsFieldSelector;
};


export type SanityFaqsGroupConnectionSumArgs = {
  field: SanityFaqsFieldSelector;
};

export type SanityFaqsSortInput = {
  _createdAt?: InputMaybe<SortOrderEnum>;
  _id?: InputMaybe<SortOrderEnum>;
  _key?: InputMaybe<SortOrderEnum>;
  _rawI18NBase?: InputMaybe<SortOrderEnum>;
  _rawI18NRefs?: InputMaybe<SortOrderEnum>;
  _rawIntro?: InputMaybe<SortOrderEnum>;
  _rawQuestions?: InputMaybe<SortOrderEnum>;
  _rev?: InputMaybe<SortOrderEnum>;
  _type?: InputMaybe<SortOrderEnum>;
  _updatedAt?: InputMaybe<SortOrderEnum>;
  children?: InputMaybe<NodeSortInput>;
  i18n_base?: InputMaybe<SanityFaqsSortInput>;
  i18n_lang?: InputMaybe<SortOrderEnum>;
  i18n_refs?: InputMaybe<SanityFaqsSortInput>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  internalTitle?: InputMaybe<SortOrderEnum>;
  intro?: InputMaybe<SanityBlockSortInput>;
  parent?: InputMaybe<NodeSortInput>;
  questions?: InputMaybe<SanityFaqQuestionSortInput>;
  title?: InputMaybe<SortOrderEnum>;
};

export type SanityFigure = {
  _key?: Maybe<Scalars['String']>;
  _rawImage?: Maybe<Scalars['JSON']>;
  _type?: Maybe<Scalars['String']>;
  alt?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  image?: Maybe<SanityImage>;
  placement?: Maybe<Scalars['String']>;
};


export type SanityFigure_RawImageArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};

export type SanityFile = {
  _key?: Maybe<Scalars['String']>;
  _rawAsset?: Maybe<Scalars['JSON']>;
  _type?: Maybe<Scalars['String']>;
  asset?: Maybe<SanityFileAsset>;
};


export type SanityFile_RawAssetArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};

export type SanityFileAsset = Node & SanityDocument & {
  _createdAt?: Maybe<Scalars['Date']>;
  _id?: Maybe<Scalars['String']>;
  _key?: Maybe<Scalars['String']>;
  _rawSource?: Maybe<Scalars['JSON']>;
  _rev?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  _updatedAt?: Maybe<Scalars['Date']>;
  altText?: Maybe<Scalars['String']>;
  assetId?: Maybe<Scalars['String']>;
  children: Array<Node>;
  description?: Maybe<Scalars['String']>;
  extension?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  internal: Internal;
  label?: Maybe<Scalars['String']>;
  mimeType?: Maybe<Scalars['String']>;
  originalFilename?: Maybe<Scalars['String']>;
  parent?: Maybe<Node>;
  path?: Maybe<Scalars['String']>;
  sha1hash?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Float']>;
  source?: Maybe<SanityAssetSourceData>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};


export type SanityFileAsset_CreatedAtArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type SanityFileAsset_RawSourceArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityFileAsset_UpdatedAtArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type SanityFileAssetConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SanityFileAssetEdge>;
  group: Array<SanityFileAssetGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<SanityFileAsset>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SanityFileAssetConnectionDistinctArgs = {
  field: SanityFileAssetFieldSelector;
};


export type SanityFileAssetConnectionGroupArgs = {
  field: SanityFileAssetFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SanityFileAssetConnectionMaxArgs = {
  field: SanityFileAssetFieldSelector;
};


export type SanityFileAssetConnectionMinArgs = {
  field: SanityFileAssetFieldSelector;
};


export type SanityFileAssetConnectionSumArgs = {
  field: SanityFileAssetFieldSelector;
};

export type SanityFileAssetEdge = {
  next?: Maybe<SanityFileAsset>;
  node: SanityFileAsset;
  previous?: Maybe<SanityFileAsset>;
};

export type SanityFileAssetFieldSelector = {
  _createdAt?: InputMaybe<FieldSelectorEnum>;
  _id?: InputMaybe<FieldSelectorEnum>;
  _key?: InputMaybe<FieldSelectorEnum>;
  _rawSource?: InputMaybe<FieldSelectorEnum>;
  _rev?: InputMaybe<FieldSelectorEnum>;
  _type?: InputMaybe<FieldSelectorEnum>;
  _updatedAt?: InputMaybe<FieldSelectorEnum>;
  altText?: InputMaybe<FieldSelectorEnum>;
  assetId?: InputMaybe<FieldSelectorEnum>;
  children?: InputMaybe<NodeFieldSelector>;
  description?: InputMaybe<FieldSelectorEnum>;
  extension?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  label?: InputMaybe<FieldSelectorEnum>;
  mimeType?: InputMaybe<FieldSelectorEnum>;
  originalFilename?: InputMaybe<FieldSelectorEnum>;
  parent?: InputMaybe<NodeFieldSelector>;
  path?: InputMaybe<FieldSelectorEnum>;
  sha1hash?: InputMaybe<FieldSelectorEnum>;
  size?: InputMaybe<FieldSelectorEnum>;
  source?: InputMaybe<SanityAssetSourceDataFieldSelector>;
  title?: InputMaybe<FieldSelectorEnum>;
  url?: InputMaybe<FieldSelectorEnum>;
};

export type SanityFileAssetFilterInput = {
  _createdAt?: InputMaybe<DateQueryOperatorInput>;
  _id?: InputMaybe<StringQueryOperatorInput>;
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawSource?: InputMaybe<JsonQueryOperatorInput>;
  _rev?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  _updatedAt?: InputMaybe<DateQueryOperatorInput>;
  altText?: InputMaybe<StringQueryOperatorInput>;
  assetId?: InputMaybe<StringQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  description?: InputMaybe<StringQueryOperatorInput>;
  extension?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  label?: InputMaybe<StringQueryOperatorInput>;
  mimeType?: InputMaybe<StringQueryOperatorInput>;
  originalFilename?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  path?: InputMaybe<StringQueryOperatorInput>;
  sha1hash?: InputMaybe<StringQueryOperatorInput>;
  size?: InputMaybe<FloatQueryOperatorInput>;
  source?: InputMaybe<SanityAssetSourceDataFilterInput>;
  title?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
};

export type SanityFileAssetGroupConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SanityFileAssetEdge>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
  group: Array<SanityFileAssetGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<SanityFileAsset>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SanityFileAssetGroupConnectionDistinctArgs = {
  field: SanityFileAssetFieldSelector;
};


export type SanityFileAssetGroupConnectionGroupArgs = {
  field: SanityFileAssetFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SanityFileAssetGroupConnectionMaxArgs = {
  field: SanityFileAssetFieldSelector;
};


export type SanityFileAssetGroupConnectionMinArgs = {
  field: SanityFileAssetFieldSelector;
};


export type SanityFileAssetGroupConnectionSumArgs = {
  field: SanityFileAssetFieldSelector;
};

export type SanityFileAssetSortInput = {
  _createdAt?: InputMaybe<SortOrderEnum>;
  _id?: InputMaybe<SortOrderEnum>;
  _key?: InputMaybe<SortOrderEnum>;
  _rawSource?: InputMaybe<SortOrderEnum>;
  _rev?: InputMaybe<SortOrderEnum>;
  _type?: InputMaybe<SortOrderEnum>;
  _updatedAt?: InputMaybe<SortOrderEnum>;
  altText?: InputMaybe<SortOrderEnum>;
  assetId?: InputMaybe<SortOrderEnum>;
  children?: InputMaybe<NodeSortInput>;
  description?: InputMaybe<SortOrderEnum>;
  extension?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  label?: InputMaybe<SortOrderEnum>;
  mimeType?: InputMaybe<SortOrderEnum>;
  originalFilename?: InputMaybe<SortOrderEnum>;
  parent?: InputMaybe<NodeSortInput>;
  path?: InputMaybe<SortOrderEnum>;
  sha1hash?: InputMaybe<SortOrderEnum>;
  size?: InputMaybe<SortOrderEnum>;
  source?: InputMaybe<SanityAssetSourceDataSortInput>;
  title?: InputMaybe<SortOrderEnum>;
  url?: InputMaybe<SortOrderEnum>;
};

export type SanityFileFieldSelector = {
  _key?: InputMaybe<FieldSelectorEnum>;
  _rawAsset?: InputMaybe<FieldSelectorEnum>;
  _type?: InputMaybe<FieldSelectorEnum>;
  asset?: InputMaybe<SanityFileAssetFieldSelector>;
};

export type SanityFileFilterInput = {
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawAsset?: InputMaybe<JsonQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  asset?: InputMaybe<SanityFileAssetFilterInput>;
};

export type SanityFileSortInput = {
  _key?: InputMaybe<SortOrderEnum>;
  _rawAsset?: InputMaybe<SortOrderEnum>;
  _type?: InputMaybe<SortOrderEnum>;
  asset?: InputMaybe<SanityFileAssetSortInput>;
};

export type SanityGame = Node & SanityDocument & {
  _createdAt?: Maybe<Scalars['Date']>;
  _id?: Maybe<Scalars['String']>;
  _key?: Maybe<Scalars['String']>;
  _rawActivities?: Maybe<Scalars['JSON']>;
  _rawCtaForMap?: Maybe<Scalars['JSON']>;
  _rawCtaListForLoggedInUsers?: Maybe<Scalars['JSON']>;
  _rawCtaListForLoggedOutUsers?: Maybe<Scalars['JSON']>;
  _rawEndOfGameWinnersText?: Maybe<Scalars['JSON']>;
  _rawFaqs?: Maybe<Scalars['JSON']>;
  _rawFooterPartners?: Maybe<Scalars['JSON']>;
  _rawGameIcon?: Maybe<Scalars['JSON']>;
  _rawGamePartnerConsentText?: Maybe<Scalars['JSON']>;
  _rawHowToPlay?: Maybe<Scalars['JSON']>;
  _rawI18NBase?: Maybe<Scalars['JSON']>;
  _rawI18NRefs?: Maybe<Scalars['JSON']>;
  _rawIntroductionContent?: Maybe<Scalars['JSON']>;
  _rawIntroductionVideoCta?: Maybe<Scalars['JSON']>;
  _rawLeaderboardSettings?: Maybe<Scalars['JSON']>;
  _rawMaintenanceDescription?: Maybe<Scalars['JSON']>;
  _rawPartners?: Maybe<Scalars['JSON']>;
  _rawPartnersPage?: Maybe<Scalars['JSON']>;
  _rawWeeklyThemes?: Maybe<Scalars['JSON']>;
  _rev?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  _updatedAt?: Maybe<Scalars['Date']>;
  activities?: Maybe<Array<Maybe<SanityActivity>>>;
  awards?: Maybe<Scalars['Boolean']>;
  children: Array<Node>;
  ctaForMap?: Maybe<SanityCta>;
  ctaListForLoggedInUsers?: Maybe<Array<Maybe<SanityCta>>>;
  ctaListForLoggedOutUsers?: Maybe<Array<Maybe<SanityCta>>>;
  displayAll?: Maybe<Scalars['Boolean']>;
  dynamoId?: Maybe<Scalars['String']>;
  emailAddress?: Maybe<Scalars['String']>;
  endOfGameShowWinners?: Maybe<Scalars['Boolean']>;
  endOfGameWinnersText?: Maybe<Array<Maybe<SanityBlock>>>;
  facebookUsername?: Maybe<Scalars['String']>;
  faqs?: Maybe<SanityContentOrFaqs>;
  footerPartners?: Maybe<Array<Maybe<SanityPartner>>>;
  gameIcon?: Maybe<SanityGameIcon>;
  gamePartnerConsentText?: Maybe<Array<Maybe<SanityBlock>>>;
  hideLeaderboards?: Maybe<Scalars['Boolean']>;
  howToPlay?: Maybe<SanityContent>;
  i18n_base?: Maybe<SanityGame>;
  i18n_lang?: Maybe<Scalars['String']>;
  i18n_refs?: Maybe<Array<Maybe<SanityGame>>>;
  id: Scalars['ID'];
  internal: Internal;
  introductionContent?: Maybe<Array<Maybe<SanityBlock>>>;
  introductionHeading?: Maybe<Scalars['String']>;
  introductionVideoCta?: Maybe<SanityVideoCta>;
  leaderboardSettings?: Maybe<SanityLeaderboardSettings>;
  maintenanceDescription?: Maybe<Array<Maybe<SanityBlock>>>;
  maintenanceTitle?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  numberOfPartnersInFooter?: Maybe<Scalars['Float']>;
  parent?: Maybe<Node>;
  partners?: Maybe<Array<Maybe<SanityPartner>>>;
  partnersPage?: Maybe<SanityPartnersPage>;
  showMessage?: Maybe<Scalars['Boolean']>;
  slug?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  twitterUsername?: Maybe<Scalars['String']>;
  weeklyThemes?: Maybe<Array<Maybe<SanityTheme>>>;
};


export type SanityGame_CreatedAtArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type SanityGame_RawActivitiesArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityGame_RawCtaForMapArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityGame_RawCtaListForLoggedInUsersArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityGame_RawCtaListForLoggedOutUsersArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityGame_RawEndOfGameWinnersTextArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityGame_RawFaqsArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityGame_RawFooterPartnersArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityGame_RawGameIconArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityGame_RawGamePartnerConsentTextArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityGame_RawHowToPlayArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityGame_RawI18NBaseArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityGame_RawI18NRefsArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityGame_RawIntroductionContentArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityGame_RawIntroductionVideoCtaArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityGame_RawLeaderboardSettingsArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityGame_RawMaintenanceDescriptionArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityGame_RawPartnersArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityGame_RawPartnersPageArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityGame_RawWeeklyThemesArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityGame_UpdatedAtArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type SanityGameConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SanityGameEdge>;
  group: Array<SanityGameGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<SanityGame>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SanityGameConnectionDistinctArgs = {
  field: SanityGameFieldSelector;
};


export type SanityGameConnectionGroupArgs = {
  field: SanityGameFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SanityGameConnectionMaxArgs = {
  field: SanityGameFieldSelector;
};


export type SanityGameConnectionMinArgs = {
  field: SanityGameFieldSelector;
};


export type SanityGameConnectionSumArgs = {
  field: SanityGameFieldSelector;
};

export type SanityGameEdge = {
  next?: Maybe<SanityGame>;
  node: SanityGame;
  previous?: Maybe<SanityGame>;
};

export type SanityGameFieldSelector = {
  _createdAt?: InputMaybe<FieldSelectorEnum>;
  _id?: InputMaybe<FieldSelectorEnum>;
  _key?: InputMaybe<FieldSelectorEnum>;
  _rawActivities?: InputMaybe<FieldSelectorEnum>;
  _rawCtaForMap?: InputMaybe<FieldSelectorEnum>;
  _rawCtaListForLoggedInUsers?: InputMaybe<FieldSelectorEnum>;
  _rawCtaListForLoggedOutUsers?: InputMaybe<FieldSelectorEnum>;
  _rawEndOfGameWinnersText?: InputMaybe<FieldSelectorEnum>;
  _rawFaqs?: InputMaybe<FieldSelectorEnum>;
  _rawFooterPartners?: InputMaybe<FieldSelectorEnum>;
  _rawGameIcon?: InputMaybe<FieldSelectorEnum>;
  _rawGamePartnerConsentText?: InputMaybe<FieldSelectorEnum>;
  _rawHowToPlay?: InputMaybe<FieldSelectorEnum>;
  _rawI18NBase?: InputMaybe<FieldSelectorEnum>;
  _rawI18NRefs?: InputMaybe<FieldSelectorEnum>;
  _rawIntroductionContent?: InputMaybe<FieldSelectorEnum>;
  _rawIntroductionVideoCta?: InputMaybe<FieldSelectorEnum>;
  _rawLeaderboardSettings?: InputMaybe<FieldSelectorEnum>;
  _rawMaintenanceDescription?: InputMaybe<FieldSelectorEnum>;
  _rawPartners?: InputMaybe<FieldSelectorEnum>;
  _rawPartnersPage?: InputMaybe<FieldSelectorEnum>;
  _rawWeeklyThemes?: InputMaybe<FieldSelectorEnum>;
  _rev?: InputMaybe<FieldSelectorEnum>;
  _type?: InputMaybe<FieldSelectorEnum>;
  _updatedAt?: InputMaybe<FieldSelectorEnum>;
  activities?: InputMaybe<SanityActivityFieldSelector>;
  awards?: InputMaybe<FieldSelectorEnum>;
  children?: InputMaybe<NodeFieldSelector>;
  ctaForMap?: InputMaybe<SanityCtaFieldSelector>;
  ctaListForLoggedInUsers?: InputMaybe<SanityCtaFieldSelector>;
  ctaListForLoggedOutUsers?: InputMaybe<SanityCtaFieldSelector>;
  displayAll?: InputMaybe<FieldSelectorEnum>;
  dynamoId?: InputMaybe<FieldSelectorEnum>;
  emailAddress?: InputMaybe<FieldSelectorEnum>;
  endOfGameShowWinners?: InputMaybe<FieldSelectorEnum>;
  endOfGameWinnersText?: InputMaybe<SanityBlockFieldSelector>;
  facebookUsername?: InputMaybe<FieldSelectorEnum>;
  footerPartners?: InputMaybe<SanityPartnerFieldSelector>;
  gameIcon?: InputMaybe<SanityGameIconFieldSelector>;
  gamePartnerConsentText?: InputMaybe<SanityBlockFieldSelector>;
  hideLeaderboards?: InputMaybe<FieldSelectorEnum>;
  howToPlay?: InputMaybe<SanityContentFieldSelector>;
  i18n_base?: InputMaybe<SanityGameFieldSelector>;
  i18n_lang?: InputMaybe<FieldSelectorEnum>;
  i18n_refs?: InputMaybe<SanityGameFieldSelector>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  introductionContent?: InputMaybe<SanityBlockFieldSelector>;
  introductionHeading?: InputMaybe<FieldSelectorEnum>;
  introductionVideoCta?: InputMaybe<SanityVideoCtaFieldSelector>;
  leaderboardSettings?: InputMaybe<SanityLeaderboardSettingsFieldSelector>;
  maintenanceDescription?: InputMaybe<SanityBlockFieldSelector>;
  maintenanceTitle?: InputMaybe<FieldSelectorEnum>;
  name?: InputMaybe<FieldSelectorEnum>;
  numberOfPartnersInFooter?: InputMaybe<FieldSelectorEnum>;
  parent?: InputMaybe<NodeFieldSelector>;
  partners?: InputMaybe<SanityPartnerFieldSelector>;
  partnersPage?: InputMaybe<SanityPartnersPageFieldSelector>;
  showMessage?: InputMaybe<FieldSelectorEnum>;
  slug?: InputMaybe<FieldSelectorEnum>;
  status?: InputMaybe<FieldSelectorEnum>;
  twitterUsername?: InputMaybe<FieldSelectorEnum>;
  weeklyThemes?: InputMaybe<SanityThemeFieldSelector>;
};

export type SanityGameFilterInput = {
  _createdAt?: InputMaybe<DateQueryOperatorInput>;
  _id?: InputMaybe<StringQueryOperatorInput>;
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawActivities?: InputMaybe<JsonQueryOperatorInput>;
  _rawCtaForMap?: InputMaybe<JsonQueryOperatorInput>;
  _rawCtaListForLoggedInUsers?: InputMaybe<JsonQueryOperatorInput>;
  _rawCtaListForLoggedOutUsers?: InputMaybe<JsonQueryOperatorInput>;
  _rawEndOfGameWinnersText?: InputMaybe<JsonQueryOperatorInput>;
  _rawFaqs?: InputMaybe<JsonQueryOperatorInput>;
  _rawFooterPartners?: InputMaybe<JsonQueryOperatorInput>;
  _rawGameIcon?: InputMaybe<JsonQueryOperatorInput>;
  _rawGamePartnerConsentText?: InputMaybe<JsonQueryOperatorInput>;
  _rawHowToPlay?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NBase?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NRefs?: InputMaybe<JsonQueryOperatorInput>;
  _rawIntroductionContent?: InputMaybe<JsonQueryOperatorInput>;
  _rawIntroductionVideoCta?: InputMaybe<JsonQueryOperatorInput>;
  _rawLeaderboardSettings?: InputMaybe<JsonQueryOperatorInput>;
  _rawMaintenanceDescription?: InputMaybe<JsonQueryOperatorInput>;
  _rawPartners?: InputMaybe<JsonQueryOperatorInput>;
  _rawPartnersPage?: InputMaybe<JsonQueryOperatorInput>;
  _rawWeeklyThemes?: InputMaybe<JsonQueryOperatorInput>;
  _rev?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  _updatedAt?: InputMaybe<DateQueryOperatorInput>;
  activities?: InputMaybe<SanityActivityFilterListInput>;
  awards?: InputMaybe<BooleanQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  ctaForMap?: InputMaybe<SanityCtaFilterInput>;
  ctaListForLoggedInUsers?: InputMaybe<SanityCtaFilterListInput>;
  ctaListForLoggedOutUsers?: InputMaybe<SanityCtaFilterListInput>;
  displayAll?: InputMaybe<BooleanQueryOperatorInput>;
  dynamoId?: InputMaybe<StringQueryOperatorInput>;
  emailAddress?: InputMaybe<StringQueryOperatorInput>;
  endOfGameShowWinners?: InputMaybe<BooleanQueryOperatorInput>;
  endOfGameWinnersText?: InputMaybe<SanityBlockFilterListInput>;
  facebookUsername?: InputMaybe<StringQueryOperatorInput>;
  footerPartners?: InputMaybe<SanityPartnerFilterListInput>;
  gameIcon?: InputMaybe<SanityGameIconFilterInput>;
  gamePartnerConsentText?: InputMaybe<SanityBlockFilterListInput>;
  hideLeaderboards?: InputMaybe<BooleanQueryOperatorInput>;
  howToPlay?: InputMaybe<SanityContentFilterInput>;
  i18n_base?: InputMaybe<SanityGameFilterInput>;
  i18n_lang?: InputMaybe<StringQueryOperatorInput>;
  i18n_refs?: InputMaybe<SanityGameFilterListInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  introductionContent?: InputMaybe<SanityBlockFilterListInput>;
  introductionHeading?: InputMaybe<StringQueryOperatorInput>;
  introductionVideoCta?: InputMaybe<SanityVideoCtaFilterInput>;
  leaderboardSettings?: InputMaybe<SanityLeaderboardSettingsFilterInput>;
  maintenanceDescription?: InputMaybe<SanityBlockFilterListInput>;
  maintenanceTitle?: InputMaybe<StringQueryOperatorInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  numberOfPartnersInFooter?: InputMaybe<FloatQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  partners?: InputMaybe<SanityPartnerFilterListInput>;
  partnersPage?: InputMaybe<SanityPartnersPageFilterInput>;
  showMessage?: InputMaybe<BooleanQueryOperatorInput>;
  slug?: InputMaybe<StringQueryOperatorInput>;
  status?: InputMaybe<StringQueryOperatorInput>;
  twitterUsername?: InputMaybe<StringQueryOperatorInput>;
  weeklyThemes?: InputMaybe<SanityThemeFilterListInput>;
};

export type SanityGameFilterListInput = {
  elemMatch?: InputMaybe<SanityGameFilterInput>;
};

export type SanityGameGroupConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SanityGameEdge>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
  group: Array<SanityGameGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<SanityGame>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SanityGameGroupConnectionDistinctArgs = {
  field: SanityGameFieldSelector;
};


export type SanityGameGroupConnectionGroupArgs = {
  field: SanityGameFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SanityGameGroupConnectionMaxArgs = {
  field: SanityGameFieldSelector;
};


export type SanityGameGroupConnectionMinArgs = {
  field: SanityGameFieldSelector;
};


export type SanityGameGroupConnectionSumArgs = {
  field: SanityGameFieldSelector;
};

export type SanityGameIcon = Node & SanityDocument & {
  _createdAt?: Maybe<Scalars['Date']>;
  _id?: Maybe<Scalars['String']>;
  _key?: Maybe<Scalars['String']>;
  _rawIcon?: Maybe<Scalars['JSON']>;
  _rev?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  _updatedAt?: Maybe<Scalars['Date']>;
  children: Array<Node>;
  icon?: Maybe<SanityImage>;
  id: Scalars['ID'];
  internal: Internal;
  parent?: Maybe<Node>;
  title?: Maybe<Scalars['String']>;
};


export type SanityGameIcon_CreatedAtArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type SanityGameIcon_RawIconArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityGameIcon_UpdatedAtArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type SanityGameIconConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SanityGameIconEdge>;
  group: Array<SanityGameIconGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<SanityGameIcon>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SanityGameIconConnectionDistinctArgs = {
  field: SanityGameIconFieldSelector;
};


export type SanityGameIconConnectionGroupArgs = {
  field: SanityGameIconFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SanityGameIconConnectionMaxArgs = {
  field: SanityGameIconFieldSelector;
};


export type SanityGameIconConnectionMinArgs = {
  field: SanityGameIconFieldSelector;
};


export type SanityGameIconConnectionSumArgs = {
  field: SanityGameIconFieldSelector;
};

export type SanityGameIconEdge = {
  next?: Maybe<SanityGameIcon>;
  node: SanityGameIcon;
  previous?: Maybe<SanityGameIcon>;
};

export type SanityGameIconFieldSelector = {
  _createdAt?: InputMaybe<FieldSelectorEnum>;
  _id?: InputMaybe<FieldSelectorEnum>;
  _key?: InputMaybe<FieldSelectorEnum>;
  _rawIcon?: InputMaybe<FieldSelectorEnum>;
  _rev?: InputMaybe<FieldSelectorEnum>;
  _type?: InputMaybe<FieldSelectorEnum>;
  _updatedAt?: InputMaybe<FieldSelectorEnum>;
  children?: InputMaybe<NodeFieldSelector>;
  icon?: InputMaybe<SanityImageFieldSelector>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  parent?: InputMaybe<NodeFieldSelector>;
  title?: InputMaybe<FieldSelectorEnum>;
};

export type SanityGameIconFilterInput = {
  _createdAt?: InputMaybe<DateQueryOperatorInput>;
  _id?: InputMaybe<StringQueryOperatorInput>;
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawIcon?: InputMaybe<JsonQueryOperatorInput>;
  _rev?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  _updatedAt?: InputMaybe<DateQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  icon?: InputMaybe<SanityImageFilterInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
  title?: InputMaybe<StringQueryOperatorInput>;
};

export type SanityGameIconGroupConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SanityGameIconEdge>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
  group: Array<SanityGameIconGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<SanityGameIcon>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SanityGameIconGroupConnectionDistinctArgs = {
  field: SanityGameIconFieldSelector;
};


export type SanityGameIconGroupConnectionGroupArgs = {
  field: SanityGameIconFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SanityGameIconGroupConnectionMaxArgs = {
  field: SanityGameIconFieldSelector;
};


export type SanityGameIconGroupConnectionMinArgs = {
  field: SanityGameIconFieldSelector;
};


export type SanityGameIconGroupConnectionSumArgs = {
  field: SanityGameIconFieldSelector;
};

export type SanityGameIconSortInput = {
  _createdAt?: InputMaybe<SortOrderEnum>;
  _id?: InputMaybe<SortOrderEnum>;
  _key?: InputMaybe<SortOrderEnum>;
  _rawIcon?: InputMaybe<SortOrderEnum>;
  _rev?: InputMaybe<SortOrderEnum>;
  _type?: InputMaybe<SortOrderEnum>;
  _updatedAt?: InputMaybe<SortOrderEnum>;
  children?: InputMaybe<NodeSortInput>;
  icon?: InputMaybe<SanityImageSortInput>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  parent?: InputMaybe<NodeSortInput>;
  title?: InputMaybe<SortOrderEnum>;
};

export type SanityGameSortInput = {
  _createdAt?: InputMaybe<SortOrderEnum>;
  _id?: InputMaybe<SortOrderEnum>;
  _key?: InputMaybe<SortOrderEnum>;
  _rawActivities?: InputMaybe<SortOrderEnum>;
  _rawCtaForMap?: InputMaybe<SortOrderEnum>;
  _rawCtaListForLoggedInUsers?: InputMaybe<SortOrderEnum>;
  _rawCtaListForLoggedOutUsers?: InputMaybe<SortOrderEnum>;
  _rawEndOfGameWinnersText?: InputMaybe<SortOrderEnum>;
  _rawFaqs?: InputMaybe<SortOrderEnum>;
  _rawFooterPartners?: InputMaybe<SortOrderEnum>;
  _rawGameIcon?: InputMaybe<SortOrderEnum>;
  _rawGamePartnerConsentText?: InputMaybe<SortOrderEnum>;
  _rawHowToPlay?: InputMaybe<SortOrderEnum>;
  _rawI18NBase?: InputMaybe<SortOrderEnum>;
  _rawI18NRefs?: InputMaybe<SortOrderEnum>;
  _rawIntroductionContent?: InputMaybe<SortOrderEnum>;
  _rawIntroductionVideoCta?: InputMaybe<SortOrderEnum>;
  _rawLeaderboardSettings?: InputMaybe<SortOrderEnum>;
  _rawMaintenanceDescription?: InputMaybe<SortOrderEnum>;
  _rawPartners?: InputMaybe<SortOrderEnum>;
  _rawPartnersPage?: InputMaybe<SortOrderEnum>;
  _rawWeeklyThemes?: InputMaybe<SortOrderEnum>;
  _rev?: InputMaybe<SortOrderEnum>;
  _type?: InputMaybe<SortOrderEnum>;
  _updatedAt?: InputMaybe<SortOrderEnum>;
  activities?: InputMaybe<SanityActivitySortInput>;
  awards?: InputMaybe<SortOrderEnum>;
  children?: InputMaybe<NodeSortInput>;
  ctaForMap?: InputMaybe<SanityCtaSortInput>;
  ctaListForLoggedInUsers?: InputMaybe<SanityCtaSortInput>;
  ctaListForLoggedOutUsers?: InputMaybe<SanityCtaSortInput>;
  displayAll?: InputMaybe<SortOrderEnum>;
  dynamoId?: InputMaybe<SortOrderEnum>;
  emailAddress?: InputMaybe<SortOrderEnum>;
  endOfGameShowWinners?: InputMaybe<SortOrderEnum>;
  endOfGameWinnersText?: InputMaybe<SanityBlockSortInput>;
  facebookUsername?: InputMaybe<SortOrderEnum>;
  footerPartners?: InputMaybe<SanityPartnerSortInput>;
  gameIcon?: InputMaybe<SanityGameIconSortInput>;
  gamePartnerConsentText?: InputMaybe<SanityBlockSortInput>;
  hideLeaderboards?: InputMaybe<SortOrderEnum>;
  howToPlay?: InputMaybe<SanityContentSortInput>;
  i18n_base?: InputMaybe<SanityGameSortInput>;
  i18n_lang?: InputMaybe<SortOrderEnum>;
  i18n_refs?: InputMaybe<SanityGameSortInput>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  introductionContent?: InputMaybe<SanityBlockSortInput>;
  introductionHeading?: InputMaybe<SortOrderEnum>;
  introductionVideoCta?: InputMaybe<SanityVideoCtaSortInput>;
  leaderboardSettings?: InputMaybe<SanityLeaderboardSettingsSortInput>;
  maintenanceDescription?: InputMaybe<SanityBlockSortInput>;
  maintenanceTitle?: InputMaybe<SortOrderEnum>;
  name?: InputMaybe<SortOrderEnum>;
  numberOfPartnersInFooter?: InputMaybe<SortOrderEnum>;
  parent?: InputMaybe<NodeSortInput>;
  partners?: InputMaybe<SanityPartnerSortInput>;
  partnersPage?: InputMaybe<SanityPartnersPageSortInput>;
  showMessage?: InputMaybe<SortOrderEnum>;
  slug?: InputMaybe<SortOrderEnum>;
  status?: InputMaybe<SortOrderEnum>;
  twitterUsername?: InputMaybe<SortOrderEnum>;
  weeklyThemes?: InputMaybe<SanityThemeSortInput>;
};

export type SanityGameVariable = {
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['String']>;
};

export type SanityGameVariableOrSpan = SanityGameVariable | SanitySpan;

export enum SanityGatsbyImagePlaceholder {
  Blurred = 'BLURRED',
  DominantColor = 'DOMINANT_COLOR',
  None = 'NONE'
}

export type SanityGeopoint = {
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  alt?: Maybe<Scalars['Float']>;
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
};

export type SanityGeopointFieldSelector = {
  _key?: InputMaybe<FieldSelectorEnum>;
  _type?: InputMaybe<FieldSelectorEnum>;
  alt?: InputMaybe<FieldSelectorEnum>;
  lat?: InputMaybe<FieldSelectorEnum>;
  lng?: InputMaybe<FieldSelectorEnum>;
};

export type SanityGeopointFilterInput = {
  _key?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  alt?: InputMaybe<FloatQueryOperatorInput>;
  lat?: InputMaybe<FloatQueryOperatorInput>;
  lng?: InputMaybe<FloatQueryOperatorInput>;
};

export type SanityGeopointSortInput = {
  _key?: InputMaybe<SortOrderEnum>;
  _type?: InputMaybe<SortOrderEnum>;
  alt?: InputMaybe<SortOrderEnum>;
  lat?: InputMaybe<SortOrderEnum>;
  lng?: InputMaybe<SortOrderEnum>;
};

export type SanityGlobalSettings = Node & SanityDocument & {
  _createdAt?: Maybe<Scalars['Date']>;
  _id?: Maybe<Scalars['String']>;
  _key?: Maybe<Scalars['String']>;
  _rawDigitalToolKit?: Maybe<Scalars['JSON']>;
  _rawEndOfGameIntroductionText?: Maybe<Scalars['JSON']>;
  _rawEndOfGameLeaderboardsHiddenText?: Maybe<Scalars['JSON']>;
  _rawEndOfGameWinnersText?: Maybe<Scalars['JSON']>;
  _rawGenericCardorFobLocation?: Maybe<Scalars['JSON']>;
  _rawI18NBase?: Maybe<Scalars['JSON']>;
  _rawI18NRefs?: Maybe<Scalars['JSON']>;
  _rev?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  _updatedAt?: Maybe<Scalars['Date']>;
  children: Array<Node>;
  digitalToolKit?: Maybe<SanityFile>;
  endOfGameIntroductionText?: Maybe<Array<Maybe<SanityBlock>>>;
  endOfGameLeaderboardsHiddenText?: Maybe<Array<Maybe<SanityBlock>>>;
  endOfGameWinnersText?: Maybe<Array<Maybe<SanityBlock>>>;
  genericCardorFobLocation?: Maybe<SanityFaqQuestion>;
  i18n_base?: Maybe<SanityGlobalSettings>;
  i18n_lang?: Maybe<Scalars['String']>;
  i18n_refs?: Maybe<Array<Maybe<SanityGlobalSettings>>>;
  id: Scalars['ID'];
  internal: Internal;
  parent?: Maybe<Node>;
};


export type SanityGlobalSettings_CreatedAtArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type SanityGlobalSettings_RawDigitalToolKitArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityGlobalSettings_RawEndOfGameIntroductionTextArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityGlobalSettings_RawEndOfGameLeaderboardsHiddenTextArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityGlobalSettings_RawEndOfGameWinnersTextArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityGlobalSettings_RawGenericCardorFobLocationArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityGlobalSettings_RawI18NBaseArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityGlobalSettings_RawI18NRefsArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityGlobalSettings_UpdatedAtArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type SanityGlobalSettingsConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SanityGlobalSettingsEdge>;
  group: Array<SanityGlobalSettingsGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<SanityGlobalSettings>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SanityGlobalSettingsConnectionDistinctArgs = {
  field: SanityGlobalSettingsFieldSelector;
};


export type SanityGlobalSettingsConnectionGroupArgs = {
  field: SanityGlobalSettingsFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SanityGlobalSettingsConnectionMaxArgs = {
  field: SanityGlobalSettingsFieldSelector;
};


export type SanityGlobalSettingsConnectionMinArgs = {
  field: SanityGlobalSettingsFieldSelector;
};


export type SanityGlobalSettingsConnectionSumArgs = {
  field: SanityGlobalSettingsFieldSelector;
};

export type SanityGlobalSettingsEdge = {
  next?: Maybe<SanityGlobalSettings>;
  node: SanityGlobalSettings;
  previous?: Maybe<SanityGlobalSettings>;
};

export type SanityGlobalSettingsFieldSelector = {
  _createdAt?: InputMaybe<FieldSelectorEnum>;
  _id?: InputMaybe<FieldSelectorEnum>;
  _key?: InputMaybe<FieldSelectorEnum>;
  _rawDigitalToolKit?: InputMaybe<FieldSelectorEnum>;
  _rawEndOfGameIntroductionText?: InputMaybe<FieldSelectorEnum>;
  _rawEndOfGameLeaderboardsHiddenText?: InputMaybe<FieldSelectorEnum>;
  _rawEndOfGameWinnersText?: InputMaybe<FieldSelectorEnum>;
  _rawGenericCardorFobLocation?: InputMaybe<FieldSelectorEnum>;
  _rawI18NBase?: InputMaybe<FieldSelectorEnum>;
  _rawI18NRefs?: InputMaybe<FieldSelectorEnum>;
  _rev?: InputMaybe<FieldSelectorEnum>;
  _type?: InputMaybe<FieldSelectorEnum>;
  _updatedAt?: InputMaybe<FieldSelectorEnum>;
  children?: InputMaybe<NodeFieldSelector>;
  digitalToolKit?: InputMaybe<SanityFileFieldSelector>;
  endOfGameIntroductionText?: InputMaybe<SanityBlockFieldSelector>;
  endOfGameLeaderboardsHiddenText?: InputMaybe<SanityBlockFieldSelector>;
  endOfGameWinnersText?: InputMaybe<SanityBlockFieldSelector>;
  genericCardorFobLocation?: InputMaybe<SanityFaqQuestionFieldSelector>;
  i18n_base?: InputMaybe<SanityGlobalSettingsFieldSelector>;
  i18n_lang?: InputMaybe<FieldSelectorEnum>;
  i18n_refs?: InputMaybe<SanityGlobalSettingsFieldSelector>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  parent?: InputMaybe<NodeFieldSelector>;
};

export type SanityGlobalSettingsFilterInput = {
  _createdAt?: InputMaybe<DateQueryOperatorInput>;
  _id?: InputMaybe<StringQueryOperatorInput>;
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawDigitalToolKit?: InputMaybe<JsonQueryOperatorInput>;
  _rawEndOfGameIntroductionText?: InputMaybe<JsonQueryOperatorInput>;
  _rawEndOfGameLeaderboardsHiddenText?: InputMaybe<JsonQueryOperatorInput>;
  _rawEndOfGameWinnersText?: InputMaybe<JsonQueryOperatorInput>;
  _rawGenericCardorFobLocation?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NBase?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NRefs?: InputMaybe<JsonQueryOperatorInput>;
  _rev?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  _updatedAt?: InputMaybe<DateQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  digitalToolKit?: InputMaybe<SanityFileFilterInput>;
  endOfGameIntroductionText?: InputMaybe<SanityBlockFilterListInput>;
  endOfGameLeaderboardsHiddenText?: InputMaybe<SanityBlockFilterListInput>;
  endOfGameWinnersText?: InputMaybe<SanityBlockFilterListInput>;
  genericCardorFobLocation?: InputMaybe<SanityFaqQuestionFilterInput>;
  i18n_base?: InputMaybe<SanityGlobalSettingsFilterInput>;
  i18n_lang?: InputMaybe<StringQueryOperatorInput>;
  i18n_refs?: InputMaybe<SanityGlobalSettingsFilterListInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
};

export type SanityGlobalSettingsFilterListInput = {
  elemMatch?: InputMaybe<SanityGlobalSettingsFilterInput>;
};

export type SanityGlobalSettingsGroupConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SanityGlobalSettingsEdge>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
  group: Array<SanityGlobalSettingsGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<SanityGlobalSettings>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SanityGlobalSettingsGroupConnectionDistinctArgs = {
  field: SanityGlobalSettingsFieldSelector;
};


export type SanityGlobalSettingsGroupConnectionGroupArgs = {
  field: SanityGlobalSettingsFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SanityGlobalSettingsGroupConnectionMaxArgs = {
  field: SanityGlobalSettingsFieldSelector;
};


export type SanityGlobalSettingsGroupConnectionMinArgs = {
  field: SanityGlobalSettingsFieldSelector;
};


export type SanityGlobalSettingsGroupConnectionSumArgs = {
  field: SanityGlobalSettingsFieldSelector;
};

export type SanityGlobalSettingsSortInput = {
  _createdAt?: InputMaybe<SortOrderEnum>;
  _id?: InputMaybe<SortOrderEnum>;
  _key?: InputMaybe<SortOrderEnum>;
  _rawDigitalToolKit?: InputMaybe<SortOrderEnum>;
  _rawEndOfGameIntroductionText?: InputMaybe<SortOrderEnum>;
  _rawEndOfGameLeaderboardsHiddenText?: InputMaybe<SortOrderEnum>;
  _rawEndOfGameWinnersText?: InputMaybe<SortOrderEnum>;
  _rawGenericCardorFobLocation?: InputMaybe<SortOrderEnum>;
  _rawI18NBase?: InputMaybe<SortOrderEnum>;
  _rawI18NRefs?: InputMaybe<SortOrderEnum>;
  _rev?: InputMaybe<SortOrderEnum>;
  _type?: InputMaybe<SortOrderEnum>;
  _updatedAt?: InputMaybe<SortOrderEnum>;
  children?: InputMaybe<NodeSortInput>;
  digitalToolKit?: InputMaybe<SanityFileSortInput>;
  endOfGameIntroductionText?: InputMaybe<SanityBlockSortInput>;
  endOfGameLeaderboardsHiddenText?: InputMaybe<SanityBlockSortInput>;
  endOfGameWinnersText?: InputMaybe<SanityBlockSortInput>;
  genericCardorFobLocation?: InputMaybe<SanityFaqQuestionSortInput>;
  i18n_base?: InputMaybe<SanityGlobalSettingsSortInput>;
  i18n_lang?: InputMaybe<SortOrderEnum>;
  i18n_refs?: InputMaybe<SanityGlobalSettingsSortInput>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  parent?: InputMaybe<NodeSortInput>;
};

export type SanityHeadingWithRichText = {
  _key?: Maybe<Scalars['String']>;
  _rawText?: Maybe<Scalars['JSON']>;
  _type?: Maybe<Scalars['String']>;
  heading?: Maybe<Scalars['String']>;
  text?: Maybe<Array<Maybe<SanityBlock>>>;
};


export type SanityHeadingWithRichText_RawTextArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};

export type SanityHeadingWithRichTextFieldSelector = {
  _key?: InputMaybe<FieldSelectorEnum>;
  _rawText?: InputMaybe<FieldSelectorEnum>;
  _type?: InputMaybe<FieldSelectorEnum>;
  heading?: InputMaybe<FieldSelectorEnum>;
  text?: InputMaybe<SanityBlockFieldSelector>;
};

export type SanityHeadingWithRichTextFilterInput = {
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawText?: InputMaybe<JsonQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  heading?: InputMaybe<StringQueryOperatorInput>;
  text?: InputMaybe<SanityBlockFilterListInput>;
};

export type SanityHeadingWithRichTextFilterListInput = {
  elemMatch?: InputMaybe<SanityHeadingWithRichTextFilterInput>;
};

export type SanityHeadingWithRichTextSortInput = {
  _key?: InputMaybe<SortOrderEnum>;
  _rawText?: InputMaybe<SortOrderEnum>;
  _type?: InputMaybe<SortOrderEnum>;
  heading?: InputMaybe<SortOrderEnum>;
  text?: InputMaybe<SanityBlockSortInput>;
};

export type SanityHomepage = Node & SanityDocument & {
  _createdAt?: Maybe<Scalars['Date']>;
  _id?: Maybe<Scalars['String']>;
  _key?: Maybe<Scalars['String']>;
  _rawAboutUs?: Maybe<Scalars['JSON']>;
  _rawAccessibility?: Maybe<Scalars['JSON']>;
  _rawChildPrivacyPolicy?: Maybe<Scalars['JSON']>;
  _rawCookies?: Maybe<Scalars['JSON']>;
  _rawI18NBase?: Maybe<Scalars['JSON']>;
  _rawI18NRefs?: Maybe<Scalars['JSON']>;
  _rawIntroductionContent?: Maybe<Scalars['JSON']>;
  _rawIntroductionVideoCta?: Maybe<Scalars['JSON']>;
  _rawNewsletter?: Maybe<Scalars['JSON']>;
  _rawPartners?: Maybe<Scalars['JSON']>;
  _rawPrivacyPolicy?: Maybe<Scalars['JSON']>;
  _rawResourcesForSchools?: Maybe<Scalars['JSON']>;
  _rawTermsAndConditions?: Maybe<Scalars['JSON']>;
  _rev?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  _updatedAt?: Maybe<Scalars['Date']>;
  aboutUs?: Maybe<SanityContent>;
  accessibility?: Maybe<SanityContent>;
  childPrivacyPolicy?: Maybe<SanityContent>;
  children: Array<Node>;
  cookies?: Maybe<SanityContent>;
  gamesSectionHeading?: Maybe<Scalars['String']>;
  i18n_base?: Maybe<SanityHomepage>;
  i18n_lang?: Maybe<Scalars['String']>;
  i18n_refs?: Maybe<Array<Maybe<SanityHomepage>>>;
  id: Scalars['ID'];
  internal: Internal;
  introductionContent?: Maybe<Array<Maybe<SanityBlock>>>;
  introductionHeading?: Maybe<Scalars['String']>;
  introductionVideoCta?: Maybe<SanityVideoCta>;
  mainHeading?: Maybe<Scalars['String']>;
  newsletter?: Maybe<SanityContent>;
  parent?: Maybe<Node>;
  partners?: Maybe<Array<Maybe<SanityPartner>>>;
  privacyPolicy?: Maybe<SanityContent>;
  resourcesForSchools?: Maybe<SanityContent>;
  termsAndConditions?: Maybe<SanityContent>;
};


export type SanityHomepage_CreatedAtArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type SanityHomepage_RawAboutUsArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityHomepage_RawAccessibilityArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityHomepage_RawChildPrivacyPolicyArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityHomepage_RawCookiesArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityHomepage_RawI18NBaseArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityHomepage_RawI18NRefsArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityHomepage_RawIntroductionContentArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityHomepage_RawIntroductionVideoCtaArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityHomepage_RawNewsletterArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityHomepage_RawPartnersArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityHomepage_RawPrivacyPolicyArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityHomepage_RawResourcesForSchoolsArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityHomepage_RawTermsAndConditionsArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityHomepage_UpdatedAtArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type SanityHomepageConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SanityHomepageEdge>;
  group: Array<SanityHomepageGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<SanityHomepage>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SanityHomepageConnectionDistinctArgs = {
  field: SanityHomepageFieldSelector;
};


export type SanityHomepageConnectionGroupArgs = {
  field: SanityHomepageFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SanityHomepageConnectionMaxArgs = {
  field: SanityHomepageFieldSelector;
};


export type SanityHomepageConnectionMinArgs = {
  field: SanityHomepageFieldSelector;
};


export type SanityHomepageConnectionSumArgs = {
  field: SanityHomepageFieldSelector;
};

export type SanityHomepageEdge = {
  next?: Maybe<SanityHomepage>;
  node: SanityHomepage;
  previous?: Maybe<SanityHomepage>;
};

export type SanityHomepageFieldSelector = {
  _createdAt?: InputMaybe<FieldSelectorEnum>;
  _id?: InputMaybe<FieldSelectorEnum>;
  _key?: InputMaybe<FieldSelectorEnum>;
  _rawAboutUs?: InputMaybe<FieldSelectorEnum>;
  _rawAccessibility?: InputMaybe<FieldSelectorEnum>;
  _rawChildPrivacyPolicy?: InputMaybe<FieldSelectorEnum>;
  _rawCookies?: InputMaybe<FieldSelectorEnum>;
  _rawI18NBase?: InputMaybe<FieldSelectorEnum>;
  _rawI18NRefs?: InputMaybe<FieldSelectorEnum>;
  _rawIntroductionContent?: InputMaybe<FieldSelectorEnum>;
  _rawIntroductionVideoCta?: InputMaybe<FieldSelectorEnum>;
  _rawNewsletter?: InputMaybe<FieldSelectorEnum>;
  _rawPartners?: InputMaybe<FieldSelectorEnum>;
  _rawPrivacyPolicy?: InputMaybe<FieldSelectorEnum>;
  _rawResourcesForSchools?: InputMaybe<FieldSelectorEnum>;
  _rawTermsAndConditions?: InputMaybe<FieldSelectorEnum>;
  _rev?: InputMaybe<FieldSelectorEnum>;
  _type?: InputMaybe<FieldSelectorEnum>;
  _updatedAt?: InputMaybe<FieldSelectorEnum>;
  aboutUs?: InputMaybe<SanityContentFieldSelector>;
  accessibility?: InputMaybe<SanityContentFieldSelector>;
  childPrivacyPolicy?: InputMaybe<SanityContentFieldSelector>;
  children?: InputMaybe<NodeFieldSelector>;
  cookies?: InputMaybe<SanityContentFieldSelector>;
  gamesSectionHeading?: InputMaybe<FieldSelectorEnum>;
  i18n_base?: InputMaybe<SanityHomepageFieldSelector>;
  i18n_lang?: InputMaybe<FieldSelectorEnum>;
  i18n_refs?: InputMaybe<SanityHomepageFieldSelector>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  introductionContent?: InputMaybe<SanityBlockFieldSelector>;
  introductionHeading?: InputMaybe<FieldSelectorEnum>;
  introductionVideoCta?: InputMaybe<SanityVideoCtaFieldSelector>;
  mainHeading?: InputMaybe<FieldSelectorEnum>;
  newsletter?: InputMaybe<SanityContentFieldSelector>;
  parent?: InputMaybe<NodeFieldSelector>;
  partners?: InputMaybe<SanityPartnerFieldSelector>;
  privacyPolicy?: InputMaybe<SanityContentFieldSelector>;
  resourcesForSchools?: InputMaybe<SanityContentFieldSelector>;
  termsAndConditions?: InputMaybe<SanityContentFieldSelector>;
};

export type SanityHomepageFilterInput = {
  _createdAt?: InputMaybe<DateQueryOperatorInput>;
  _id?: InputMaybe<StringQueryOperatorInput>;
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawAboutUs?: InputMaybe<JsonQueryOperatorInput>;
  _rawAccessibility?: InputMaybe<JsonQueryOperatorInput>;
  _rawChildPrivacyPolicy?: InputMaybe<JsonQueryOperatorInput>;
  _rawCookies?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NBase?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NRefs?: InputMaybe<JsonQueryOperatorInput>;
  _rawIntroductionContent?: InputMaybe<JsonQueryOperatorInput>;
  _rawIntroductionVideoCta?: InputMaybe<JsonQueryOperatorInput>;
  _rawNewsletter?: InputMaybe<JsonQueryOperatorInput>;
  _rawPartners?: InputMaybe<JsonQueryOperatorInput>;
  _rawPrivacyPolicy?: InputMaybe<JsonQueryOperatorInput>;
  _rawResourcesForSchools?: InputMaybe<JsonQueryOperatorInput>;
  _rawTermsAndConditions?: InputMaybe<JsonQueryOperatorInput>;
  _rev?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  _updatedAt?: InputMaybe<DateQueryOperatorInput>;
  aboutUs?: InputMaybe<SanityContentFilterInput>;
  accessibility?: InputMaybe<SanityContentFilterInput>;
  childPrivacyPolicy?: InputMaybe<SanityContentFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  cookies?: InputMaybe<SanityContentFilterInput>;
  gamesSectionHeading?: InputMaybe<StringQueryOperatorInput>;
  i18n_base?: InputMaybe<SanityHomepageFilterInput>;
  i18n_lang?: InputMaybe<StringQueryOperatorInput>;
  i18n_refs?: InputMaybe<SanityHomepageFilterListInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  introductionContent?: InputMaybe<SanityBlockFilterListInput>;
  introductionHeading?: InputMaybe<StringQueryOperatorInput>;
  introductionVideoCta?: InputMaybe<SanityVideoCtaFilterInput>;
  mainHeading?: InputMaybe<StringQueryOperatorInput>;
  newsletter?: InputMaybe<SanityContentFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
  partners?: InputMaybe<SanityPartnerFilterListInput>;
  privacyPolicy?: InputMaybe<SanityContentFilterInput>;
  resourcesForSchools?: InputMaybe<SanityContentFilterInput>;
  termsAndConditions?: InputMaybe<SanityContentFilterInput>;
};

export type SanityHomepageFilterListInput = {
  elemMatch?: InputMaybe<SanityHomepageFilterInput>;
};

export type SanityHomepageGroupConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SanityHomepageEdge>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
  group: Array<SanityHomepageGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<SanityHomepage>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SanityHomepageGroupConnectionDistinctArgs = {
  field: SanityHomepageFieldSelector;
};


export type SanityHomepageGroupConnectionGroupArgs = {
  field: SanityHomepageFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SanityHomepageGroupConnectionMaxArgs = {
  field: SanityHomepageFieldSelector;
};


export type SanityHomepageGroupConnectionMinArgs = {
  field: SanityHomepageFieldSelector;
};


export type SanityHomepageGroupConnectionSumArgs = {
  field: SanityHomepageFieldSelector;
};

export type SanityHomepageSortInput = {
  _createdAt?: InputMaybe<SortOrderEnum>;
  _id?: InputMaybe<SortOrderEnum>;
  _key?: InputMaybe<SortOrderEnum>;
  _rawAboutUs?: InputMaybe<SortOrderEnum>;
  _rawAccessibility?: InputMaybe<SortOrderEnum>;
  _rawChildPrivacyPolicy?: InputMaybe<SortOrderEnum>;
  _rawCookies?: InputMaybe<SortOrderEnum>;
  _rawI18NBase?: InputMaybe<SortOrderEnum>;
  _rawI18NRefs?: InputMaybe<SortOrderEnum>;
  _rawIntroductionContent?: InputMaybe<SortOrderEnum>;
  _rawIntroductionVideoCta?: InputMaybe<SortOrderEnum>;
  _rawNewsletter?: InputMaybe<SortOrderEnum>;
  _rawPartners?: InputMaybe<SortOrderEnum>;
  _rawPrivacyPolicy?: InputMaybe<SortOrderEnum>;
  _rawResourcesForSchools?: InputMaybe<SortOrderEnum>;
  _rawTermsAndConditions?: InputMaybe<SortOrderEnum>;
  _rev?: InputMaybe<SortOrderEnum>;
  _type?: InputMaybe<SortOrderEnum>;
  _updatedAt?: InputMaybe<SortOrderEnum>;
  aboutUs?: InputMaybe<SanityContentSortInput>;
  accessibility?: InputMaybe<SanityContentSortInput>;
  childPrivacyPolicy?: InputMaybe<SanityContentSortInput>;
  children?: InputMaybe<NodeSortInput>;
  cookies?: InputMaybe<SanityContentSortInput>;
  gamesSectionHeading?: InputMaybe<SortOrderEnum>;
  i18n_base?: InputMaybe<SanityHomepageSortInput>;
  i18n_lang?: InputMaybe<SortOrderEnum>;
  i18n_refs?: InputMaybe<SanityHomepageSortInput>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  introductionContent?: InputMaybe<SanityBlockSortInput>;
  introductionHeading?: InputMaybe<SortOrderEnum>;
  introductionVideoCta?: InputMaybe<SanityVideoCtaSortInput>;
  mainHeading?: InputMaybe<SortOrderEnum>;
  newsletter?: InputMaybe<SanityContentSortInput>;
  parent?: InputMaybe<NodeSortInput>;
  partners?: InputMaybe<SanityPartnerSortInput>;
  privacyPolicy?: InputMaybe<SanityContentSortInput>;
  resourcesForSchools?: InputMaybe<SanityContentSortInput>;
  termsAndConditions?: InputMaybe<SanityContentSortInput>;
};

export type SanityHowToPlay = Node & SanityDocument & {
  _createdAt?: Maybe<Scalars['Date']>;
  _id?: Maybe<Scalars['String']>;
  _key?: Maybe<Scalars['String']>;
  _rawHowToPlayContent?: Maybe<Scalars['JSON']>;
  _rawI18NBase?: Maybe<Scalars['JSON']>;
  _rawI18NRefs?: Maybe<Scalars['JSON']>;
  _rev?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  _updatedAt?: Maybe<Scalars['Date']>;
  children: Array<Node>;
  howToPlayContent?: Maybe<Array<Maybe<SanityBlock>>>;
  i18n_base?: Maybe<SanityHowToPlay>;
  i18n_lang?: Maybe<Scalars['String']>;
  i18n_refs?: Maybe<Array<Maybe<SanityHowToPlay>>>;
  id: Scalars['ID'];
  internal: Internal;
  parent?: Maybe<Node>;
};


export type SanityHowToPlay_CreatedAtArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type SanityHowToPlay_RawHowToPlayContentArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityHowToPlay_RawI18NBaseArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityHowToPlay_RawI18NRefsArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityHowToPlay_UpdatedAtArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type SanityHowToPlayConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SanityHowToPlayEdge>;
  group: Array<SanityHowToPlayGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<SanityHowToPlay>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SanityHowToPlayConnectionDistinctArgs = {
  field: SanityHowToPlayFieldSelector;
};


export type SanityHowToPlayConnectionGroupArgs = {
  field: SanityHowToPlayFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SanityHowToPlayConnectionMaxArgs = {
  field: SanityHowToPlayFieldSelector;
};


export type SanityHowToPlayConnectionMinArgs = {
  field: SanityHowToPlayFieldSelector;
};


export type SanityHowToPlayConnectionSumArgs = {
  field: SanityHowToPlayFieldSelector;
};

export type SanityHowToPlayEdge = {
  next?: Maybe<SanityHowToPlay>;
  node: SanityHowToPlay;
  previous?: Maybe<SanityHowToPlay>;
};

export type SanityHowToPlayFieldSelector = {
  _createdAt?: InputMaybe<FieldSelectorEnum>;
  _id?: InputMaybe<FieldSelectorEnum>;
  _key?: InputMaybe<FieldSelectorEnum>;
  _rawHowToPlayContent?: InputMaybe<FieldSelectorEnum>;
  _rawI18NBase?: InputMaybe<FieldSelectorEnum>;
  _rawI18NRefs?: InputMaybe<FieldSelectorEnum>;
  _rev?: InputMaybe<FieldSelectorEnum>;
  _type?: InputMaybe<FieldSelectorEnum>;
  _updatedAt?: InputMaybe<FieldSelectorEnum>;
  children?: InputMaybe<NodeFieldSelector>;
  howToPlayContent?: InputMaybe<SanityBlockFieldSelector>;
  i18n_base?: InputMaybe<SanityHowToPlayFieldSelector>;
  i18n_lang?: InputMaybe<FieldSelectorEnum>;
  i18n_refs?: InputMaybe<SanityHowToPlayFieldSelector>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  parent?: InputMaybe<NodeFieldSelector>;
};

export type SanityHowToPlayFilterInput = {
  _createdAt?: InputMaybe<DateQueryOperatorInput>;
  _id?: InputMaybe<StringQueryOperatorInput>;
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawHowToPlayContent?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NBase?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NRefs?: InputMaybe<JsonQueryOperatorInput>;
  _rev?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  _updatedAt?: InputMaybe<DateQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  howToPlayContent?: InputMaybe<SanityBlockFilterListInput>;
  i18n_base?: InputMaybe<SanityHowToPlayFilterInput>;
  i18n_lang?: InputMaybe<StringQueryOperatorInput>;
  i18n_refs?: InputMaybe<SanityHowToPlayFilterListInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
};

export type SanityHowToPlayFilterListInput = {
  elemMatch?: InputMaybe<SanityHowToPlayFilterInput>;
};

export type SanityHowToPlayGroupConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SanityHowToPlayEdge>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
  group: Array<SanityHowToPlayGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<SanityHowToPlay>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SanityHowToPlayGroupConnectionDistinctArgs = {
  field: SanityHowToPlayFieldSelector;
};


export type SanityHowToPlayGroupConnectionGroupArgs = {
  field: SanityHowToPlayFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SanityHowToPlayGroupConnectionMaxArgs = {
  field: SanityHowToPlayFieldSelector;
};


export type SanityHowToPlayGroupConnectionMinArgs = {
  field: SanityHowToPlayFieldSelector;
};


export type SanityHowToPlayGroupConnectionSumArgs = {
  field: SanityHowToPlayFieldSelector;
};

export type SanityHowToPlaySortInput = {
  _createdAt?: InputMaybe<SortOrderEnum>;
  _id?: InputMaybe<SortOrderEnum>;
  _key?: InputMaybe<SortOrderEnum>;
  _rawHowToPlayContent?: InputMaybe<SortOrderEnum>;
  _rawI18NBase?: InputMaybe<SortOrderEnum>;
  _rawI18NRefs?: InputMaybe<SortOrderEnum>;
  _rev?: InputMaybe<SortOrderEnum>;
  _type?: InputMaybe<SortOrderEnum>;
  _updatedAt?: InputMaybe<SortOrderEnum>;
  children?: InputMaybe<NodeSortInput>;
  howToPlayContent?: InputMaybe<SanityBlockSortInput>;
  i18n_base?: InputMaybe<SanityHowToPlaySortInput>;
  i18n_lang?: InputMaybe<SortOrderEnum>;
  i18n_refs?: InputMaybe<SanityHowToPlaySortInput>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  parent?: InputMaybe<NodeSortInput>;
};

export type SanityHslaColor = {
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  a?: Maybe<Scalars['Float']>;
  h?: Maybe<Scalars['Float']>;
  l?: Maybe<Scalars['Float']>;
  s?: Maybe<Scalars['Float']>;
};

export type SanityHslaColorFieldSelector = {
  _key?: InputMaybe<FieldSelectorEnum>;
  _type?: InputMaybe<FieldSelectorEnum>;
  a?: InputMaybe<FieldSelectorEnum>;
  h?: InputMaybe<FieldSelectorEnum>;
  l?: InputMaybe<FieldSelectorEnum>;
  s?: InputMaybe<FieldSelectorEnum>;
};

export type SanityHslaColorFilterInput = {
  _key?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  a?: InputMaybe<FloatQueryOperatorInput>;
  h?: InputMaybe<FloatQueryOperatorInput>;
  l?: InputMaybe<FloatQueryOperatorInput>;
  s?: InputMaybe<FloatQueryOperatorInput>;
};

export type SanityHslaColorSortInput = {
  _key?: InputMaybe<SortOrderEnum>;
  _type?: InputMaybe<SortOrderEnum>;
  a?: InputMaybe<SortOrderEnum>;
  h?: InputMaybe<SortOrderEnum>;
  l?: InputMaybe<SortOrderEnum>;
  s?: InputMaybe<SortOrderEnum>;
};

export type SanityHsvaColor = {
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  a?: Maybe<Scalars['Float']>;
  h?: Maybe<Scalars['Float']>;
  s?: Maybe<Scalars['Float']>;
  v?: Maybe<Scalars['Float']>;
};

export type SanityHsvaColorFieldSelector = {
  _key?: InputMaybe<FieldSelectorEnum>;
  _type?: InputMaybe<FieldSelectorEnum>;
  a?: InputMaybe<FieldSelectorEnum>;
  h?: InputMaybe<FieldSelectorEnum>;
  s?: InputMaybe<FieldSelectorEnum>;
  v?: InputMaybe<FieldSelectorEnum>;
};

export type SanityHsvaColorFilterInput = {
  _key?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  a?: InputMaybe<FloatQueryOperatorInput>;
  h?: InputMaybe<FloatQueryOperatorInput>;
  s?: InputMaybe<FloatQueryOperatorInput>;
  v?: InputMaybe<FloatQueryOperatorInput>;
};

export type SanityHsvaColorSortInput = {
  _key?: InputMaybe<SortOrderEnum>;
  _type?: InputMaybe<SortOrderEnum>;
  a?: InputMaybe<SortOrderEnum>;
  h?: InputMaybe<SortOrderEnum>;
  s?: InputMaybe<SortOrderEnum>;
  v?: InputMaybe<SortOrderEnum>;
};

export type SanityImage = {
  _key?: Maybe<Scalars['String']>;
  _rawAsset?: Maybe<Scalars['JSON']>;
  _rawCrop?: Maybe<Scalars['JSON']>;
  _rawHotspot?: Maybe<Scalars['JSON']>;
  _type?: Maybe<Scalars['String']>;
  asset?: Maybe<SanityImageAsset>;
  crop?: Maybe<SanityImageCrop>;
  hotspot?: Maybe<SanityImageHotspot>;
};


export type SanityImage_RawAssetArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityImage_RawCropArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityImage_RawHotspotArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};

export type SanityImageAsset = Node & RemoteFile & SanityDocument & {
  _createdAt?: Maybe<Scalars['Date']>;
  _id?: Maybe<Scalars['String']>;
  _key?: Maybe<Scalars['String']>;
  _rawMetadata?: Maybe<Scalars['JSON']>;
  _rawSource?: Maybe<Scalars['JSON']>;
  _rev?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  _updatedAt?: Maybe<Scalars['Date']>;
  altText?: Maybe<Scalars['String']>;
  assetId?: Maybe<Scalars['String']>;
  children: Array<Node>;
  description?: Maybe<Scalars['String']>;
  extension?: Maybe<Scalars['String']>;
  filename: Scalars['String'];
  filesize?: Maybe<Scalars['Int']>;
  /** Data used in the <GatsbyImage /> component. See https://gatsby.dev/img for more info. */
  gatsbyImage?: Maybe<Scalars['GatsbyImageData']>;
  gatsbyImageData: Scalars['GatsbyImageData'];
  height?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  internal: Internal;
  label?: Maybe<Scalars['String']>;
  metadata?: Maybe<SanityImageMetadata>;
  mimeType: Scalars['String'];
  originalFilename?: Maybe<Scalars['String']>;
  parent?: Maybe<Node>;
  path?: Maybe<Scalars['String']>;
  publicUrl: Scalars['String'];
  resize?: Maybe<RemoteFileResize>;
  sha1hash?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Float']>;
  source?: Maybe<SanityAssetSourceData>;
  title?: Maybe<Scalars['String']>;
  uploadId?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
};


export type SanityImageAsset_CreatedAtArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type SanityImageAsset_RawMetadataArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityImageAsset_RawSourceArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityImageAsset_UpdatedAtArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type SanityImageAssetGatsbyImageArgs = {
  aspectRatio?: InputMaybe<Scalars['Float']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  breakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  cropFocus?: InputMaybe<Array<InputMaybe<RemoteFileCropFocus>>>;
  fit?: InputMaybe<RemoteFileFit>;
  formats?: InputMaybe<Array<RemoteFileFormat>>;
  height?: InputMaybe<Scalars['Int']>;
  layout?: InputMaybe<RemoteFileLayout>;
  outputPixelDensities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  placeholder?: InputMaybe<RemoteFilePlaceholder>;
  quality?: InputMaybe<Scalars['Int']>;
  sizes?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};


export type SanityImageAssetGatsbyImageDataArgs = {
  aspectRatio?: InputMaybe<Scalars['Float']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  breakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  fit?: InputMaybe<SanityImageFit>;
  formats?: InputMaybe<Array<InputMaybe<GatsbyImageFormat>>>;
  height?: InputMaybe<Scalars['Int']>;
  layout?: InputMaybe<GatsbyImageLayout>;
  outputPixelDensities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  placeholder?: InputMaybe<SanityGatsbyImagePlaceholder>;
  sizes?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};


export type SanityImageAssetResizeArgs = {
  aspectRatio?: InputMaybe<Scalars['Float']>;
  cropFocus?: InputMaybe<Array<InputMaybe<RemoteFileCropFocus>>>;
  fit?: InputMaybe<RemoteFileFit>;
  format?: InputMaybe<RemoteFileFormat>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  width?: InputMaybe<Scalars['Int']>;
};

export type SanityImageAssetConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SanityImageAssetEdge>;
  group: Array<SanityImageAssetGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<SanityImageAsset>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SanityImageAssetConnectionDistinctArgs = {
  field: SanityImageAssetFieldSelector;
};


export type SanityImageAssetConnectionGroupArgs = {
  field: SanityImageAssetFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SanityImageAssetConnectionMaxArgs = {
  field: SanityImageAssetFieldSelector;
};


export type SanityImageAssetConnectionMinArgs = {
  field: SanityImageAssetFieldSelector;
};


export type SanityImageAssetConnectionSumArgs = {
  field: SanityImageAssetFieldSelector;
};

export type SanityImageAssetEdge = {
  next?: Maybe<SanityImageAsset>;
  node: SanityImageAsset;
  previous?: Maybe<SanityImageAsset>;
};

export type SanityImageAssetFieldSelector = {
  _createdAt?: InputMaybe<FieldSelectorEnum>;
  _id?: InputMaybe<FieldSelectorEnum>;
  _key?: InputMaybe<FieldSelectorEnum>;
  _rawMetadata?: InputMaybe<FieldSelectorEnum>;
  _rawSource?: InputMaybe<FieldSelectorEnum>;
  _rev?: InputMaybe<FieldSelectorEnum>;
  _type?: InputMaybe<FieldSelectorEnum>;
  _updatedAt?: InputMaybe<FieldSelectorEnum>;
  altText?: InputMaybe<FieldSelectorEnum>;
  assetId?: InputMaybe<FieldSelectorEnum>;
  children?: InputMaybe<NodeFieldSelector>;
  description?: InputMaybe<FieldSelectorEnum>;
  extension?: InputMaybe<FieldSelectorEnum>;
  filename?: InputMaybe<FieldSelectorEnum>;
  filesize?: InputMaybe<FieldSelectorEnum>;
  gatsbyImage?: InputMaybe<FieldSelectorEnum>;
  gatsbyImageData?: InputMaybe<FieldSelectorEnum>;
  height?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  label?: InputMaybe<FieldSelectorEnum>;
  metadata?: InputMaybe<SanityImageMetadataFieldSelector>;
  mimeType?: InputMaybe<FieldSelectorEnum>;
  originalFilename?: InputMaybe<FieldSelectorEnum>;
  parent?: InputMaybe<NodeFieldSelector>;
  path?: InputMaybe<FieldSelectorEnum>;
  publicUrl?: InputMaybe<FieldSelectorEnum>;
  resize?: InputMaybe<RemoteFileResizeFieldSelector>;
  sha1hash?: InputMaybe<FieldSelectorEnum>;
  size?: InputMaybe<FieldSelectorEnum>;
  source?: InputMaybe<SanityAssetSourceDataFieldSelector>;
  title?: InputMaybe<FieldSelectorEnum>;
  uploadId?: InputMaybe<FieldSelectorEnum>;
  url?: InputMaybe<FieldSelectorEnum>;
  width?: InputMaybe<FieldSelectorEnum>;
};

export type SanityImageAssetFilterInput = {
  _createdAt?: InputMaybe<DateQueryOperatorInput>;
  _id?: InputMaybe<StringQueryOperatorInput>;
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawMetadata?: InputMaybe<JsonQueryOperatorInput>;
  _rawSource?: InputMaybe<JsonQueryOperatorInput>;
  _rev?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  _updatedAt?: InputMaybe<DateQueryOperatorInput>;
  altText?: InputMaybe<StringQueryOperatorInput>;
  assetId?: InputMaybe<StringQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  description?: InputMaybe<StringQueryOperatorInput>;
  extension?: InputMaybe<StringQueryOperatorInput>;
  filename?: InputMaybe<StringQueryOperatorInput>;
  filesize?: InputMaybe<IntQueryOperatorInput>;
  gatsbyImage?: InputMaybe<GatsbyImageDataQueryOperatorInput>;
  gatsbyImageData?: InputMaybe<GatsbyImageDataQueryOperatorInput>;
  height?: InputMaybe<IntQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  label?: InputMaybe<StringQueryOperatorInput>;
  metadata?: InputMaybe<SanityImageMetadataFilterInput>;
  mimeType?: InputMaybe<StringQueryOperatorInput>;
  originalFilename?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  path?: InputMaybe<StringQueryOperatorInput>;
  publicUrl?: InputMaybe<StringQueryOperatorInput>;
  resize?: InputMaybe<RemoteFileResizeFilterInput>;
  sha1hash?: InputMaybe<StringQueryOperatorInput>;
  size?: InputMaybe<FloatQueryOperatorInput>;
  source?: InputMaybe<SanityAssetSourceDataFilterInput>;
  title?: InputMaybe<StringQueryOperatorInput>;
  uploadId?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  width?: InputMaybe<IntQueryOperatorInput>;
};

export type SanityImageAssetGroupConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SanityImageAssetEdge>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
  group: Array<SanityImageAssetGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<SanityImageAsset>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SanityImageAssetGroupConnectionDistinctArgs = {
  field: SanityImageAssetFieldSelector;
};


export type SanityImageAssetGroupConnectionGroupArgs = {
  field: SanityImageAssetFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SanityImageAssetGroupConnectionMaxArgs = {
  field: SanityImageAssetFieldSelector;
};


export type SanityImageAssetGroupConnectionMinArgs = {
  field: SanityImageAssetFieldSelector;
};


export type SanityImageAssetGroupConnectionSumArgs = {
  field: SanityImageAssetFieldSelector;
};

export type SanityImageAssetSortInput = {
  _createdAt?: InputMaybe<SortOrderEnum>;
  _id?: InputMaybe<SortOrderEnum>;
  _key?: InputMaybe<SortOrderEnum>;
  _rawMetadata?: InputMaybe<SortOrderEnum>;
  _rawSource?: InputMaybe<SortOrderEnum>;
  _rev?: InputMaybe<SortOrderEnum>;
  _type?: InputMaybe<SortOrderEnum>;
  _updatedAt?: InputMaybe<SortOrderEnum>;
  altText?: InputMaybe<SortOrderEnum>;
  assetId?: InputMaybe<SortOrderEnum>;
  children?: InputMaybe<NodeSortInput>;
  description?: InputMaybe<SortOrderEnum>;
  extension?: InputMaybe<SortOrderEnum>;
  filename?: InputMaybe<SortOrderEnum>;
  filesize?: InputMaybe<SortOrderEnum>;
  gatsbyImage?: InputMaybe<SortOrderEnum>;
  gatsbyImageData?: InputMaybe<SortOrderEnum>;
  height?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  label?: InputMaybe<SortOrderEnum>;
  metadata?: InputMaybe<SanityImageMetadataSortInput>;
  mimeType?: InputMaybe<SortOrderEnum>;
  originalFilename?: InputMaybe<SortOrderEnum>;
  parent?: InputMaybe<NodeSortInput>;
  path?: InputMaybe<SortOrderEnum>;
  publicUrl?: InputMaybe<SortOrderEnum>;
  resize?: InputMaybe<RemoteFileResizeSortInput>;
  sha1hash?: InputMaybe<SortOrderEnum>;
  size?: InputMaybe<SortOrderEnum>;
  source?: InputMaybe<SanityAssetSourceDataSortInput>;
  title?: InputMaybe<SortOrderEnum>;
  uploadId?: InputMaybe<SortOrderEnum>;
  url?: InputMaybe<SortOrderEnum>;
  width?: InputMaybe<SortOrderEnum>;
};

export type SanityImageCrop = {
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  bottom?: Maybe<Scalars['Float']>;
  left?: Maybe<Scalars['Float']>;
  right?: Maybe<Scalars['Float']>;
  top?: Maybe<Scalars['Float']>;
};

export type SanityImageCropFieldSelector = {
  _key?: InputMaybe<FieldSelectorEnum>;
  _type?: InputMaybe<FieldSelectorEnum>;
  bottom?: InputMaybe<FieldSelectorEnum>;
  left?: InputMaybe<FieldSelectorEnum>;
  right?: InputMaybe<FieldSelectorEnum>;
  top?: InputMaybe<FieldSelectorEnum>;
};

export type SanityImageCropFilterInput = {
  _key?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  bottom?: InputMaybe<FloatQueryOperatorInput>;
  left?: InputMaybe<FloatQueryOperatorInput>;
  right?: InputMaybe<FloatQueryOperatorInput>;
  top?: InputMaybe<FloatQueryOperatorInput>;
};

export type SanityImageCropSortInput = {
  _key?: InputMaybe<SortOrderEnum>;
  _type?: InputMaybe<SortOrderEnum>;
  bottom?: InputMaybe<SortOrderEnum>;
  left?: InputMaybe<SortOrderEnum>;
  right?: InputMaybe<SortOrderEnum>;
  top?: InputMaybe<SortOrderEnum>;
};

export type SanityImageDimensions = {
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  aspectRatio?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

export type SanityImageDimensionsFieldSelector = {
  _key?: InputMaybe<FieldSelectorEnum>;
  _type?: InputMaybe<FieldSelectorEnum>;
  aspectRatio?: InputMaybe<FieldSelectorEnum>;
  height?: InputMaybe<FieldSelectorEnum>;
  width?: InputMaybe<FieldSelectorEnum>;
};

export type SanityImageDimensionsFilterInput = {
  _key?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  aspectRatio?: InputMaybe<FloatQueryOperatorInput>;
  height?: InputMaybe<FloatQueryOperatorInput>;
  width?: InputMaybe<FloatQueryOperatorInput>;
};

export type SanityImageDimensionsSortInput = {
  _key?: InputMaybe<SortOrderEnum>;
  _type?: InputMaybe<SortOrderEnum>;
  aspectRatio?: InputMaybe<SortOrderEnum>;
  height?: InputMaybe<SortOrderEnum>;
  width?: InputMaybe<SortOrderEnum>;
};

export type SanityImageFieldSelector = {
  _key?: InputMaybe<FieldSelectorEnum>;
  _rawAsset?: InputMaybe<FieldSelectorEnum>;
  _rawCrop?: InputMaybe<FieldSelectorEnum>;
  _rawHotspot?: InputMaybe<FieldSelectorEnum>;
  _type?: InputMaybe<FieldSelectorEnum>;
  asset?: InputMaybe<SanityImageAssetFieldSelector>;
  crop?: InputMaybe<SanityImageCropFieldSelector>;
  hotspot?: InputMaybe<SanityImageHotspotFieldSelector>;
};

export type SanityImageFilterInput = {
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawAsset?: InputMaybe<JsonQueryOperatorInput>;
  _rawCrop?: InputMaybe<JsonQueryOperatorInput>;
  _rawHotspot?: InputMaybe<JsonQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  asset?: InputMaybe<SanityImageAssetFilterInput>;
  crop?: InputMaybe<SanityImageCropFilterInput>;
  hotspot?: InputMaybe<SanityImageHotspotFilterInput>;
};

export enum SanityImageFit {
  Clip = 'CLIP',
  Crop = 'CROP',
  Fill = 'FILL',
  Fillmax = 'FILLMAX',
  Max = 'MAX',
  Min = 'MIN',
  Scale = 'SCALE'
}

export type SanityImageHotspot = {
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
  x?: Maybe<Scalars['Float']>;
  y?: Maybe<Scalars['Float']>;
};

export type SanityImageHotspotFieldSelector = {
  _key?: InputMaybe<FieldSelectorEnum>;
  _type?: InputMaybe<FieldSelectorEnum>;
  height?: InputMaybe<FieldSelectorEnum>;
  width?: InputMaybe<FieldSelectorEnum>;
  x?: InputMaybe<FieldSelectorEnum>;
  y?: InputMaybe<FieldSelectorEnum>;
};

export type SanityImageHotspotFilterInput = {
  _key?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  height?: InputMaybe<FloatQueryOperatorInput>;
  width?: InputMaybe<FloatQueryOperatorInput>;
  x?: InputMaybe<FloatQueryOperatorInput>;
  y?: InputMaybe<FloatQueryOperatorInput>;
};

export type SanityImageHotspotSortInput = {
  _key?: InputMaybe<SortOrderEnum>;
  _type?: InputMaybe<SortOrderEnum>;
  height?: InputMaybe<SortOrderEnum>;
  width?: InputMaybe<SortOrderEnum>;
  x?: InputMaybe<SortOrderEnum>;
  y?: InputMaybe<SortOrderEnum>;
};

export type SanityImageMetadata = {
  _key?: Maybe<Scalars['String']>;
  _rawDimensions?: Maybe<Scalars['JSON']>;
  _rawLocation?: Maybe<Scalars['JSON']>;
  _rawPalette?: Maybe<Scalars['JSON']>;
  _type?: Maybe<Scalars['String']>;
  blurHash?: Maybe<Scalars['String']>;
  dimensions?: Maybe<SanityImageDimensions>;
  hasAlpha?: Maybe<Scalars['Boolean']>;
  isOpaque?: Maybe<Scalars['Boolean']>;
  location?: Maybe<SanityGeopoint>;
  lqip?: Maybe<Scalars['String']>;
  palette?: Maybe<SanityImagePalette>;
};


export type SanityImageMetadata_RawDimensionsArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityImageMetadata_RawLocationArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityImageMetadata_RawPaletteArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};

export type SanityImageMetadataFieldSelector = {
  _key?: InputMaybe<FieldSelectorEnum>;
  _rawDimensions?: InputMaybe<FieldSelectorEnum>;
  _rawLocation?: InputMaybe<FieldSelectorEnum>;
  _rawPalette?: InputMaybe<FieldSelectorEnum>;
  _type?: InputMaybe<FieldSelectorEnum>;
  blurHash?: InputMaybe<FieldSelectorEnum>;
  dimensions?: InputMaybe<SanityImageDimensionsFieldSelector>;
  hasAlpha?: InputMaybe<FieldSelectorEnum>;
  isOpaque?: InputMaybe<FieldSelectorEnum>;
  location?: InputMaybe<SanityGeopointFieldSelector>;
  lqip?: InputMaybe<FieldSelectorEnum>;
  palette?: InputMaybe<SanityImagePaletteFieldSelector>;
};

export type SanityImageMetadataFilterInput = {
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawDimensions?: InputMaybe<JsonQueryOperatorInput>;
  _rawLocation?: InputMaybe<JsonQueryOperatorInput>;
  _rawPalette?: InputMaybe<JsonQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  blurHash?: InputMaybe<StringQueryOperatorInput>;
  dimensions?: InputMaybe<SanityImageDimensionsFilterInput>;
  hasAlpha?: InputMaybe<BooleanQueryOperatorInput>;
  isOpaque?: InputMaybe<BooleanQueryOperatorInput>;
  location?: InputMaybe<SanityGeopointFilterInput>;
  lqip?: InputMaybe<StringQueryOperatorInput>;
  palette?: InputMaybe<SanityImagePaletteFilterInput>;
};

export type SanityImageMetadataSortInput = {
  _key?: InputMaybe<SortOrderEnum>;
  _rawDimensions?: InputMaybe<SortOrderEnum>;
  _rawLocation?: InputMaybe<SortOrderEnum>;
  _rawPalette?: InputMaybe<SortOrderEnum>;
  _type?: InputMaybe<SortOrderEnum>;
  blurHash?: InputMaybe<SortOrderEnum>;
  dimensions?: InputMaybe<SanityImageDimensionsSortInput>;
  hasAlpha?: InputMaybe<SortOrderEnum>;
  isOpaque?: InputMaybe<SortOrderEnum>;
  location?: InputMaybe<SanityGeopointSortInput>;
  lqip?: InputMaybe<SortOrderEnum>;
  palette?: InputMaybe<SanityImagePaletteSortInput>;
};

export type SanityImagePalette = {
  _key?: Maybe<Scalars['String']>;
  _rawDarkMuted?: Maybe<Scalars['JSON']>;
  _rawDarkVibrant?: Maybe<Scalars['JSON']>;
  _rawDominant?: Maybe<Scalars['JSON']>;
  _rawLightMuted?: Maybe<Scalars['JSON']>;
  _rawLightVibrant?: Maybe<Scalars['JSON']>;
  _rawMuted?: Maybe<Scalars['JSON']>;
  _rawVibrant?: Maybe<Scalars['JSON']>;
  _type?: Maybe<Scalars['String']>;
  darkMuted?: Maybe<SanityImagePaletteSwatch>;
  darkVibrant?: Maybe<SanityImagePaletteSwatch>;
  dominant?: Maybe<SanityImagePaletteSwatch>;
  lightMuted?: Maybe<SanityImagePaletteSwatch>;
  lightVibrant?: Maybe<SanityImagePaletteSwatch>;
  muted?: Maybe<SanityImagePaletteSwatch>;
  vibrant?: Maybe<SanityImagePaletteSwatch>;
};


export type SanityImagePalette_RawDarkMutedArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityImagePalette_RawDarkVibrantArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityImagePalette_RawDominantArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityImagePalette_RawLightMutedArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityImagePalette_RawLightVibrantArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityImagePalette_RawMutedArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityImagePalette_RawVibrantArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};

export type SanityImagePaletteFieldSelector = {
  _key?: InputMaybe<FieldSelectorEnum>;
  _rawDarkMuted?: InputMaybe<FieldSelectorEnum>;
  _rawDarkVibrant?: InputMaybe<FieldSelectorEnum>;
  _rawDominant?: InputMaybe<FieldSelectorEnum>;
  _rawLightMuted?: InputMaybe<FieldSelectorEnum>;
  _rawLightVibrant?: InputMaybe<FieldSelectorEnum>;
  _rawMuted?: InputMaybe<FieldSelectorEnum>;
  _rawVibrant?: InputMaybe<FieldSelectorEnum>;
  _type?: InputMaybe<FieldSelectorEnum>;
  darkMuted?: InputMaybe<SanityImagePaletteSwatchFieldSelector>;
  darkVibrant?: InputMaybe<SanityImagePaletteSwatchFieldSelector>;
  dominant?: InputMaybe<SanityImagePaletteSwatchFieldSelector>;
  lightMuted?: InputMaybe<SanityImagePaletteSwatchFieldSelector>;
  lightVibrant?: InputMaybe<SanityImagePaletteSwatchFieldSelector>;
  muted?: InputMaybe<SanityImagePaletteSwatchFieldSelector>;
  vibrant?: InputMaybe<SanityImagePaletteSwatchFieldSelector>;
};

export type SanityImagePaletteFilterInput = {
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawDarkMuted?: InputMaybe<JsonQueryOperatorInput>;
  _rawDarkVibrant?: InputMaybe<JsonQueryOperatorInput>;
  _rawDominant?: InputMaybe<JsonQueryOperatorInput>;
  _rawLightMuted?: InputMaybe<JsonQueryOperatorInput>;
  _rawLightVibrant?: InputMaybe<JsonQueryOperatorInput>;
  _rawMuted?: InputMaybe<JsonQueryOperatorInput>;
  _rawVibrant?: InputMaybe<JsonQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  darkMuted?: InputMaybe<SanityImagePaletteSwatchFilterInput>;
  darkVibrant?: InputMaybe<SanityImagePaletteSwatchFilterInput>;
  dominant?: InputMaybe<SanityImagePaletteSwatchFilterInput>;
  lightMuted?: InputMaybe<SanityImagePaletteSwatchFilterInput>;
  lightVibrant?: InputMaybe<SanityImagePaletteSwatchFilterInput>;
  muted?: InputMaybe<SanityImagePaletteSwatchFilterInput>;
  vibrant?: InputMaybe<SanityImagePaletteSwatchFilterInput>;
};

export type SanityImagePaletteSortInput = {
  _key?: InputMaybe<SortOrderEnum>;
  _rawDarkMuted?: InputMaybe<SortOrderEnum>;
  _rawDarkVibrant?: InputMaybe<SortOrderEnum>;
  _rawDominant?: InputMaybe<SortOrderEnum>;
  _rawLightMuted?: InputMaybe<SortOrderEnum>;
  _rawLightVibrant?: InputMaybe<SortOrderEnum>;
  _rawMuted?: InputMaybe<SortOrderEnum>;
  _rawVibrant?: InputMaybe<SortOrderEnum>;
  _type?: InputMaybe<SortOrderEnum>;
  darkMuted?: InputMaybe<SanityImagePaletteSwatchSortInput>;
  darkVibrant?: InputMaybe<SanityImagePaletteSwatchSortInput>;
  dominant?: InputMaybe<SanityImagePaletteSwatchSortInput>;
  lightMuted?: InputMaybe<SanityImagePaletteSwatchSortInput>;
  lightVibrant?: InputMaybe<SanityImagePaletteSwatchSortInput>;
  muted?: InputMaybe<SanityImagePaletteSwatchSortInput>;
  vibrant?: InputMaybe<SanityImagePaletteSwatchSortInput>;
};

export type SanityImagePaletteSwatch = {
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  background?: Maybe<Scalars['String']>;
  foreground?: Maybe<Scalars['String']>;
  population?: Maybe<Scalars['Float']>;
  title?: Maybe<Scalars['String']>;
};

export type SanityImagePaletteSwatchFieldSelector = {
  _key?: InputMaybe<FieldSelectorEnum>;
  _type?: InputMaybe<FieldSelectorEnum>;
  background?: InputMaybe<FieldSelectorEnum>;
  foreground?: InputMaybe<FieldSelectorEnum>;
  population?: InputMaybe<FieldSelectorEnum>;
  title?: InputMaybe<FieldSelectorEnum>;
};

export type SanityImagePaletteSwatchFilterInput = {
  _key?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  background?: InputMaybe<StringQueryOperatorInput>;
  foreground?: InputMaybe<StringQueryOperatorInput>;
  population?: InputMaybe<FloatQueryOperatorInput>;
  title?: InputMaybe<StringQueryOperatorInput>;
};

export type SanityImagePaletteSwatchSortInput = {
  _key?: InputMaybe<SortOrderEnum>;
  _type?: InputMaybe<SortOrderEnum>;
  background?: InputMaybe<SortOrderEnum>;
  foreground?: InputMaybe<SortOrderEnum>;
  population?: InputMaybe<SortOrderEnum>;
  title?: InputMaybe<SortOrderEnum>;
};

export type SanityImageSortInput = {
  _key?: InputMaybe<SortOrderEnum>;
  _rawAsset?: InputMaybe<SortOrderEnum>;
  _rawCrop?: InputMaybe<SortOrderEnum>;
  _rawHotspot?: InputMaybe<SortOrderEnum>;
  _type?: InputMaybe<SortOrderEnum>;
  asset?: InputMaybe<SanityImageAssetSortInput>;
  crop?: InputMaybe<SanityImageCropSortInput>;
  hotspot?: InputMaybe<SanityImageHotspotSortInput>;
};

export type SanityInternalLinkWithText = {
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  internalLink?: Maybe<Scalars['String']>;
  linkText?: Maybe<Scalars['String']>;
};

export type SanityLeaderboardSettings = Node & SanityDocument & {
  _createdAt?: Maybe<Scalars['Date']>;
  _id?: Maybe<Scalars['String']>;
  _key?: Maybe<Scalars['String']>;
  _rawHowItWorksContent?: Maybe<Scalars['JSON']>;
  _rawI18NBase?: Maybe<Scalars['JSON']>;
  _rawI18NRefs?: Maybe<Scalars['JSON']>;
  _rev?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  _updatedAt?: Maybe<Scalars['Date']>;
  children: Array<Node>;
  howItWorksContent?: Maybe<Array<Maybe<SanityHeadingWithRichText>>>;
  i18n_base?: Maybe<SanityLeaderboardSettings>;
  i18n_lang?: Maybe<Scalars['String']>;
  i18n_refs?: Maybe<Array<Maybe<SanityLeaderboardSettings>>>;
  id: Scalars['ID'];
  internal: Internal;
  internalTitle?: Maybe<Scalars['String']>;
  parent?: Maybe<Node>;
  pointsHelpText?: Maybe<Scalars['String']>;
};


export type SanityLeaderboardSettings_CreatedAtArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type SanityLeaderboardSettings_RawHowItWorksContentArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityLeaderboardSettings_RawI18NBaseArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityLeaderboardSettings_RawI18NRefsArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityLeaderboardSettings_UpdatedAtArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type SanityLeaderboardSettingsConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SanityLeaderboardSettingsEdge>;
  group: Array<SanityLeaderboardSettingsGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<SanityLeaderboardSettings>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SanityLeaderboardSettingsConnectionDistinctArgs = {
  field: SanityLeaderboardSettingsFieldSelector;
};


export type SanityLeaderboardSettingsConnectionGroupArgs = {
  field: SanityLeaderboardSettingsFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SanityLeaderboardSettingsConnectionMaxArgs = {
  field: SanityLeaderboardSettingsFieldSelector;
};


export type SanityLeaderboardSettingsConnectionMinArgs = {
  field: SanityLeaderboardSettingsFieldSelector;
};


export type SanityLeaderboardSettingsConnectionSumArgs = {
  field: SanityLeaderboardSettingsFieldSelector;
};

export type SanityLeaderboardSettingsEdge = {
  next?: Maybe<SanityLeaderboardSettings>;
  node: SanityLeaderboardSettings;
  previous?: Maybe<SanityLeaderboardSettings>;
};

export type SanityLeaderboardSettingsFieldSelector = {
  _createdAt?: InputMaybe<FieldSelectorEnum>;
  _id?: InputMaybe<FieldSelectorEnum>;
  _key?: InputMaybe<FieldSelectorEnum>;
  _rawHowItWorksContent?: InputMaybe<FieldSelectorEnum>;
  _rawI18NBase?: InputMaybe<FieldSelectorEnum>;
  _rawI18NRefs?: InputMaybe<FieldSelectorEnum>;
  _rev?: InputMaybe<FieldSelectorEnum>;
  _type?: InputMaybe<FieldSelectorEnum>;
  _updatedAt?: InputMaybe<FieldSelectorEnum>;
  children?: InputMaybe<NodeFieldSelector>;
  howItWorksContent?: InputMaybe<SanityHeadingWithRichTextFieldSelector>;
  i18n_base?: InputMaybe<SanityLeaderboardSettingsFieldSelector>;
  i18n_lang?: InputMaybe<FieldSelectorEnum>;
  i18n_refs?: InputMaybe<SanityLeaderboardSettingsFieldSelector>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  internalTitle?: InputMaybe<FieldSelectorEnum>;
  parent?: InputMaybe<NodeFieldSelector>;
  pointsHelpText?: InputMaybe<FieldSelectorEnum>;
};

export type SanityLeaderboardSettingsFilterInput = {
  _createdAt?: InputMaybe<DateQueryOperatorInput>;
  _id?: InputMaybe<StringQueryOperatorInput>;
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawHowItWorksContent?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NBase?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NRefs?: InputMaybe<JsonQueryOperatorInput>;
  _rev?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  _updatedAt?: InputMaybe<DateQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  howItWorksContent?: InputMaybe<SanityHeadingWithRichTextFilterListInput>;
  i18n_base?: InputMaybe<SanityLeaderboardSettingsFilterInput>;
  i18n_lang?: InputMaybe<StringQueryOperatorInput>;
  i18n_refs?: InputMaybe<SanityLeaderboardSettingsFilterListInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  internalTitle?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  pointsHelpText?: InputMaybe<StringQueryOperatorInput>;
};

export type SanityLeaderboardSettingsFilterListInput = {
  elemMatch?: InputMaybe<SanityLeaderboardSettingsFilterInput>;
};

export type SanityLeaderboardSettingsGroupConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SanityLeaderboardSettingsEdge>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
  group: Array<SanityLeaderboardSettingsGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<SanityLeaderboardSettings>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SanityLeaderboardSettingsGroupConnectionDistinctArgs = {
  field: SanityLeaderboardSettingsFieldSelector;
};


export type SanityLeaderboardSettingsGroupConnectionGroupArgs = {
  field: SanityLeaderboardSettingsFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SanityLeaderboardSettingsGroupConnectionMaxArgs = {
  field: SanityLeaderboardSettingsFieldSelector;
};


export type SanityLeaderboardSettingsGroupConnectionMinArgs = {
  field: SanityLeaderboardSettingsFieldSelector;
};


export type SanityLeaderboardSettingsGroupConnectionSumArgs = {
  field: SanityLeaderboardSettingsFieldSelector;
};

export type SanityLeaderboardSettingsSortInput = {
  _createdAt?: InputMaybe<SortOrderEnum>;
  _id?: InputMaybe<SortOrderEnum>;
  _key?: InputMaybe<SortOrderEnum>;
  _rawHowItWorksContent?: InputMaybe<SortOrderEnum>;
  _rawI18NBase?: InputMaybe<SortOrderEnum>;
  _rawI18NRefs?: InputMaybe<SortOrderEnum>;
  _rev?: InputMaybe<SortOrderEnum>;
  _type?: InputMaybe<SortOrderEnum>;
  _updatedAt?: InputMaybe<SortOrderEnum>;
  children?: InputMaybe<NodeSortInput>;
  howItWorksContent?: InputMaybe<SanityHeadingWithRichTextSortInput>;
  i18n_base?: InputMaybe<SanityLeaderboardSettingsSortInput>;
  i18n_lang?: InputMaybe<SortOrderEnum>;
  i18n_refs?: InputMaybe<SanityLeaderboardSettingsSortInput>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  internalTitle?: InputMaybe<SortOrderEnum>;
  parent?: InputMaybe<NodeSortInput>;
  pointsHelpText?: InputMaybe<SortOrderEnum>;
};

export type SanityLinkWithText = {
  _key?: Maybe<Scalars['String']>;
  _rawOverlayLink?: Maybe<Scalars['JSON']>;
  _type?: Maybe<Scalars['String']>;
  externalUrl?: Maybe<Scalars['String']>;
  externalUrlToggle?: Maybe<Scalars['Boolean']>;
  internalLink?: Maybe<Scalars['String']>;
  internalLinkHash?: Maybe<Scalars['String']>;
  internalLinkToggle?: Maybe<Scalars['Boolean']>;
  linkText?: Maybe<Scalars['String']>;
  overlayLink?: Maybe<SanityContent>;
  overlayToggle?: Maybe<Scalars['Boolean']>;
};


export type SanityLinkWithText_RawOverlayLinkArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};

export type SanityLinkWithTextFieldSelector = {
  _key?: InputMaybe<FieldSelectorEnum>;
  _rawOverlayLink?: InputMaybe<FieldSelectorEnum>;
  _type?: InputMaybe<FieldSelectorEnum>;
  externalUrl?: InputMaybe<FieldSelectorEnum>;
  externalUrlToggle?: InputMaybe<FieldSelectorEnum>;
  internalLink?: InputMaybe<FieldSelectorEnum>;
  internalLinkHash?: InputMaybe<FieldSelectorEnum>;
  internalLinkToggle?: InputMaybe<FieldSelectorEnum>;
  linkText?: InputMaybe<FieldSelectorEnum>;
  overlayLink?: InputMaybe<SanityContentFieldSelector>;
  overlayToggle?: InputMaybe<FieldSelectorEnum>;
};

export type SanityLinkWithTextFilterInput = {
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawOverlayLink?: InputMaybe<JsonQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  externalUrl?: InputMaybe<StringQueryOperatorInput>;
  externalUrlToggle?: InputMaybe<BooleanQueryOperatorInput>;
  internalLink?: InputMaybe<StringQueryOperatorInput>;
  internalLinkHash?: InputMaybe<StringQueryOperatorInput>;
  internalLinkToggle?: InputMaybe<BooleanQueryOperatorInput>;
  linkText?: InputMaybe<StringQueryOperatorInput>;
  overlayLink?: InputMaybe<SanityContentFilterInput>;
  overlayToggle?: InputMaybe<BooleanQueryOperatorInput>;
};

export type SanityLinkWithTextSortInput = {
  _key?: InputMaybe<SortOrderEnum>;
  _rawOverlayLink?: InputMaybe<SortOrderEnum>;
  _type?: InputMaybe<SortOrderEnum>;
  externalUrl?: InputMaybe<SortOrderEnum>;
  externalUrlToggle?: InputMaybe<SortOrderEnum>;
  internalLink?: InputMaybe<SortOrderEnum>;
  internalLinkHash?: InputMaybe<SortOrderEnum>;
  internalLinkToggle?: InputMaybe<SortOrderEnum>;
  linkText?: InputMaybe<SortOrderEnum>;
  overlayLink?: InputMaybe<SanityContentSortInput>;
  overlayToggle?: InputMaybe<SortOrderEnum>;
};

export type SanityLocality = Node & SanityDocument & {
  _createdAt?: Maybe<Scalars['Date']>;
  _id?: Maybe<Scalars['String']>;
  _key?: Maybe<Scalars['String']>;
  _rawActivities?: Maybe<Scalars['JSON']>;
  _rawClosingSurveyShownFrom?: Maybe<Scalars['JSON']>;
  _rawContactPage?: Maybe<Scalars['JSON']>;
  _rawCtaListForLoggedInUsers?: Maybe<Scalars['JSON']>;
  _rawCtaListForLoggedOutUsers?: Maybe<Scalars['JSON']>;
  _rawEndOfGameWinnersText?: Maybe<Scalars['JSON']>;
  _rawFaqs?: Maybe<Scalars['JSON']>;
  _rawFooterPartners?: Maybe<Scalars['JSON']>;
  _rawGameIcon?: Maybe<Scalars['JSON']>;
  _rawGamePartnerConsentIntroduction?: Maybe<Scalars['JSON']>;
  _rawHowToPlay?: Maybe<Scalars['JSON']>;
  _rawI18NBase?: Maybe<Scalars['JSON']>;
  _rawI18NRefs?: Maybe<Scalars['JSON']>;
  _rawIntroductionContent?: Maybe<Scalars['JSON']>;
  _rawIntroductionVideoCta?: Maybe<Scalars['JSON']>;
  _rawLeaderboardSettings?: Maybe<Scalars['JSON']>;
  _rawPartners?: Maybe<Scalars['JSON']>;
  _rawPartnersPage?: Maybe<Scalars['JSON']>;
  _rawWeeklyThemes?: Maybe<Scalars['JSON']>;
  _rev?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  _updatedAt?: Maybe<Scalars['Date']>;
  active?: Maybe<Scalars['Boolean']>;
  activities?: Maybe<Array<Maybe<SanityActivity>>>;
  awards?: Maybe<Scalars['Boolean']>;
  bbox?: Maybe<Scalars['String']>;
  children: Array<Node>;
  closingSurveyCollectorUrl?: Maybe<Scalars['String']>;
  closingSurveyId?: Maybe<Scalars['Float']>;
  closingSurveyShownFrom?: Maybe<SanityRichDate>;
  contactPage?: Maybe<SanityContent>;
  ctaListForLoggedInUsers?: Maybe<Array<Maybe<SanityCta>>>;
  ctaListForLoggedOutUsers?: Maybe<Array<Maybe<SanityCta>>>;
  displayAll?: Maybe<Scalars['Boolean']>;
  emailAddress?: Maybe<Scalars['String']>;
  endOfGameShowWinners?: Maybe<Scalars['Boolean']>;
  endOfGameWinnersText?: Maybe<Array<Maybe<SanityBlock>>>;
  facebookUsername?: Maybe<Scalars['String']>;
  faqs?: Maybe<SanityContentOrFaqs>;
  footerPartners?: Maybe<Array<Maybe<SanityPartner>>>;
  gameIcon?: Maybe<SanityGameIcon>;
  gamePartnerConsentIntroduction?: Maybe<Array<Maybe<SanityBlock>>>;
  gamePartnerConsentText?: Maybe<Scalars['String']>;
  howToPlay?: Maybe<SanityContent>;
  i18n_base?: Maybe<SanityLocality>;
  i18n_lang?: Maybe<Scalars['String']>;
  i18n_refs?: Maybe<Array<Maybe<SanityLocality>>>;
  id: Scalars['ID'];
  internal: Internal;
  internalName?: Maybe<Scalars['String']>;
  introductionContent?: Maybe<Array<Maybe<SanityBlock>>>;
  introductionHeading?: Maybe<Scalars['String']>;
  introductionVideoCta?: Maybe<SanityVideoCta>;
  leaderboardSettings?: Maybe<SanityLeaderboardSettings>;
  mapsKmlUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  numberOfPartnersInFooter?: Maybe<Scalars['Float']>;
  parent?: Maybe<Node>;
  partners?: Maybe<Array<Maybe<SanityPartner>>>;
  partnersPage?: Maybe<SanityPartnersPage>;
  tellUsAboutYouSurveyCollectorUrl?: Maybe<Scalars['String']>;
  tellUsAboutYouSurveyId?: Maybe<Scalars['Float']>;
  tellUsAboutYouSurveyMandatory?: Maybe<Scalars['Boolean']>;
  twitterUsername?: Maybe<Scalars['String']>;
  urlSlug?: Maybe<Scalars['String']>;
  weeklyThemes?: Maybe<Array<Maybe<SanityTheme>>>;
};


export type SanityLocality_CreatedAtArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type SanityLocality_RawActivitiesArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityLocality_RawClosingSurveyShownFromArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityLocality_RawContactPageArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityLocality_RawCtaListForLoggedInUsersArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityLocality_RawCtaListForLoggedOutUsersArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityLocality_RawEndOfGameWinnersTextArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityLocality_RawFaqsArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityLocality_RawFooterPartnersArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityLocality_RawGameIconArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityLocality_RawGamePartnerConsentIntroductionArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityLocality_RawHowToPlayArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityLocality_RawI18NBaseArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityLocality_RawI18NRefsArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityLocality_RawIntroductionContentArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityLocality_RawIntroductionVideoCtaArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityLocality_RawLeaderboardSettingsArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityLocality_RawPartnersArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityLocality_RawPartnersPageArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityLocality_RawWeeklyThemesArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityLocality_UpdatedAtArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type SanityLocalityConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SanityLocalityEdge>;
  group: Array<SanityLocalityGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<SanityLocality>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SanityLocalityConnectionDistinctArgs = {
  field: SanityLocalityFieldSelector;
};


export type SanityLocalityConnectionGroupArgs = {
  field: SanityLocalityFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SanityLocalityConnectionMaxArgs = {
  field: SanityLocalityFieldSelector;
};


export type SanityLocalityConnectionMinArgs = {
  field: SanityLocalityFieldSelector;
};


export type SanityLocalityConnectionSumArgs = {
  field: SanityLocalityFieldSelector;
};

export type SanityLocalityEdge = {
  next?: Maybe<SanityLocality>;
  node: SanityLocality;
  previous?: Maybe<SanityLocality>;
};

export type SanityLocalityFieldSelector = {
  _createdAt?: InputMaybe<FieldSelectorEnum>;
  _id?: InputMaybe<FieldSelectorEnum>;
  _key?: InputMaybe<FieldSelectorEnum>;
  _rawActivities?: InputMaybe<FieldSelectorEnum>;
  _rawClosingSurveyShownFrom?: InputMaybe<FieldSelectorEnum>;
  _rawContactPage?: InputMaybe<FieldSelectorEnum>;
  _rawCtaListForLoggedInUsers?: InputMaybe<FieldSelectorEnum>;
  _rawCtaListForLoggedOutUsers?: InputMaybe<FieldSelectorEnum>;
  _rawEndOfGameWinnersText?: InputMaybe<FieldSelectorEnum>;
  _rawFaqs?: InputMaybe<FieldSelectorEnum>;
  _rawFooterPartners?: InputMaybe<FieldSelectorEnum>;
  _rawGameIcon?: InputMaybe<FieldSelectorEnum>;
  _rawGamePartnerConsentIntroduction?: InputMaybe<FieldSelectorEnum>;
  _rawHowToPlay?: InputMaybe<FieldSelectorEnum>;
  _rawI18NBase?: InputMaybe<FieldSelectorEnum>;
  _rawI18NRefs?: InputMaybe<FieldSelectorEnum>;
  _rawIntroductionContent?: InputMaybe<FieldSelectorEnum>;
  _rawIntroductionVideoCta?: InputMaybe<FieldSelectorEnum>;
  _rawLeaderboardSettings?: InputMaybe<FieldSelectorEnum>;
  _rawPartners?: InputMaybe<FieldSelectorEnum>;
  _rawPartnersPage?: InputMaybe<FieldSelectorEnum>;
  _rawWeeklyThemes?: InputMaybe<FieldSelectorEnum>;
  _rev?: InputMaybe<FieldSelectorEnum>;
  _type?: InputMaybe<FieldSelectorEnum>;
  _updatedAt?: InputMaybe<FieldSelectorEnum>;
  active?: InputMaybe<FieldSelectorEnum>;
  activities?: InputMaybe<SanityActivityFieldSelector>;
  awards?: InputMaybe<FieldSelectorEnum>;
  bbox?: InputMaybe<FieldSelectorEnum>;
  children?: InputMaybe<NodeFieldSelector>;
  closingSurveyCollectorUrl?: InputMaybe<FieldSelectorEnum>;
  closingSurveyId?: InputMaybe<FieldSelectorEnum>;
  closingSurveyShownFrom?: InputMaybe<SanityRichDateFieldSelector>;
  contactPage?: InputMaybe<SanityContentFieldSelector>;
  ctaListForLoggedInUsers?: InputMaybe<SanityCtaFieldSelector>;
  ctaListForLoggedOutUsers?: InputMaybe<SanityCtaFieldSelector>;
  displayAll?: InputMaybe<FieldSelectorEnum>;
  emailAddress?: InputMaybe<FieldSelectorEnum>;
  endOfGameShowWinners?: InputMaybe<FieldSelectorEnum>;
  endOfGameWinnersText?: InputMaybe<SanityBlockFieldSelector>;
  facebookUsername?: InputMaybe<FieldSelectorEnum>;
  footerPartners?: InputMaybe<SanityPartnerFieldSelector>;
  gameIcon?: InputMaybe<SanityGameIconFieldSelector>;
  gamePartnerConsentIntroduction?: InputMaybe<SanityBlockFieldSelector>;
  gamePartnerConsentText?: InputMaybe<FieldSelectorEnum>;
  howToPlay?: InputMaybe<SanityContentFieldSelector>;
  i18n_base?: InputMaybe<SanityLocalityFieldSelector>;
  i18n_lang?: InputMaybe<FieldSelectorEnum>;
  i18n_refs?: InputMaybe<SanityLocalityFieldSelector>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  internalName?: InputMaybe<FieldSelectorEnum>;
  introductionContent?: InputMaybe<SanityBlockFieldSelector>;
  introductionHeading?: InputMaybe<FieldSelectorEnum>;
  introductionVideoCta?: InputMaybe<SanityVideoCtaFieldSelector>;
  leaderboardSettings?: InputMaybe<SanityLeaderboardSettingsFieldSelector>;
  mapsKmlUrl?: InputMaybe<FieldSelectorEnum>;
  name?: InputMaybe<FieldSelectorEnum>;
  numberOfPartnersInFooter?: InputMaybe<FieldSelectorEnum>;
  parent?: InputMaybe<NodeFieldSelector>;
  partners?: InputMaybe<SanityPartnerFieldSelector>;
  partnersPage?: InputMaybe<SanityPartnersPageFieldSelector>;
  tellUsAboutYouSurveyCollectorUrl?: InputMaybe<FieldSelectorEnum>;
  tellUsAboutYouSurveyId?: InputMaybe<FieldSelectorEnum>;
  tellUsAboutYouSurveyMandatory?: InputMaybe<FieldSelectorEnum>;
  twitterUsername?: InputMaybe<FieldSelectorEnum>;
  urlSlug?: InputMaybe<FieldSelectorEnum>;
  weeklyThemes?: InputMaybe<SanityThemeFieldSelector>;
};

export type SanityLocalityFilterInput = {
  _createdAt?: InputMaybe<DateQueryOperatorInput>;
  _id?: InputMaybe<StringQueryOperatorInput>;
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawActivities?: InputMaybe<JsonQueryOperatorInput>;
  _rawClosingSurveyShownFrom?: InputMaybe<JsonQueryOperatorInput>;
  _rawContactPage?: InputMaybe<JsonQueryOperatorInput>;
  _rawCtaListForLoggedInUsers?: InputMaybe<JsonQueryOperatorInput>;
  _rawCtaListForLoggedOutUsers?: InputMaybe<JsonQueryOperatorInput>;
  _rawEndOfGameWinnersText?: InputMaybe<JsonQueryOperatorInput>;
  _rawFaqs?: InputMaybe<JsonQueryOperatorInput>;
  _rawFooterPartners?: InputMaybe<JsonQueryOperatorInput>;
  _rawGameIcon?: InputMaybe<JsonQueryOperatorInput>;
  _rawGamePartnerConsentIntroduction?: InputMaybe<JsonQueryOperatorInput>;
  _rawHowToPlay?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NBase?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NRefs?: InputMaybe<JsonQueryOperatorInput>;
  _rawIntroductionContent?: InputMaybe<JsonQueryOperatorInput>;
  _rawIntroductionVideoCta?: InputMaybe<JsonQueryOperatorInput>;
  _rawLeaderboardSettings?: InputMaybe<JsonQueryOperatorInput>;
  _rawPartners?: InputMaybe<JsonQueryOperatorInput>;
  _rawPartnersPage?: InputMaybe<JsonQueryOperatorInput>;
  _rawWeeklyThemes?: InputMaybe<JsonQueryOperatorInput>;
  _rev?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  _updatedAt?: InputMaybe<DateQueryOperatorInput>;
  active?: InputMaybe<BooleanQueryOperatorInput>;
  activities?: InputMaybe<SanityActivityFilterListInput>;
  awards?: InputMaybe<BooleanQueryOperatorInput>;
  bbox?: InputMaybe<StringQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  closingSurveyCollectorUrl?: InputMaybe<StringQueryOperatorInput>;
  closingSurveyId?: InputMaybe<FloatQueryOperatorInput>;
  closingSurveyShownFrom?: InputMaybe<SanityRichDateFilterInput>;
  contactPage?: InputMaybe<SanityContentFilterInput>;
  ctaListForLoggedInUsers?: InputMaybe<SanityCtaFilterListInput>;
  ctaListForLoggedOutUsers?: InputMaybe<SanityCtaFilterListInput>;
  displayAll?: InputMaybe<BooleanQueryOperatorInput>;
  emailAddress?: InputMaybe<StringQueryOperatorInput>;
  endOfGameShowWinners?: InputMaybe<BooleanQueryOperatorInput>;
  endOfGameWinnersText?: InputMaybe<SanityBlockFilterListInput>;
  facebookUsername?: InputMaybe<StringQueryOperatorInput>;
  footerPartners?: InputMaybe<SanityPartnerFilterListInput>;
  gameIcon?: InputMaybe<SanityGameIconFilterInput>;
  gamePartnerConsentIntroduction?: InputMaybe<SanityBlockFilterListInput>;
  gamePartnerConsentText?: InputMaybe<StringQueryOperatorInput>;
  howToPlay?: InputMaybe<SanityContentFilterInput>;
  i18n_base?: InputMaybe<SanityLocalityFilterInput>;
  i18n_lang?: InputMaybe<StringQueryOperatorInput>;
  i18n_refs?: InputMaybe<SanityLocalityFilterListInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  internalName?: InputMaybe<StringQueryOperatorInput>;
  introductionContent?: InputMaybe<SanityBlockFilterListInput>;
  introductionHeading?: InputMaybe<StringQueryOperatorInput>;
  introductionVideoCta?: InputMaybe<SanityVideoCtaFilterInput>;
  leaderboardSettings?: InputMaybe<SanityLeaderboardSettingsFilterInput>;
  mapsKmlUrl?: InputMaybe<StringQueryOperatorInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  numberOfPartnersInFooter?: InputMaybe<FloatQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  partners?: InputMaybe<SanityPartnerFilterListInput>;
  partnersPage?: InputMaybe<SanityPartnersPageFilterInput>;
  tellUsAboutYouSurveyCollectorUrl?: InputMaybe<StringQueryOperatorInput>;
  tellUsAboutYouSurveyId?: InputMaybe<FloatQueryOperatorInput>;
  tellUsAboutYouSurveyMandatory?: InputMaybe<BooleanQueryOperatorInput>;
  twitterUsername?: InputMaybe<StringQueryOperatorInput>;
  urlSlug?: InputMaybe<StringQueryOperatorInput>;
  weeklyThemes?: InputMaybe<SanityThemeFilterListInput>;
};

export type SanityLocalityFilterListInput = {
  elemMatch?: InputMaybe<SanityLocalityFilterInput>;
};

export type SanityLocalityGroupConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SanityLocalityEdge>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
  group: Array<SanityLocalityGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<SanityLocality>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SanityLocalityGroupConnectionDistinctArgs = {
  field: SanityLocalityFieldSelector;
};


export type SanityLocalityGroupConnectionGroupArgs = {
  field: SanityLocalityFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SanityLocalityGroupConnectionMaxArgs = {
  field: SanityLocalityFieldSelector;
};


export type SanityLocalityGroupConnectionMinArgs = {
  field: SanityLocalityFieldSelector;
};


export type SanityLocalityGroupConnectionSumArgs = {
  field: SanityLocalityFieldSelector;
};

export type SanityLocalitySortInput = {
  _createdAt?: InputMaybe<SortOrderEnum>;
  _id?: InputMaybe<SortOrderEnum>;
  _key?: InputMaybe<SortOrderEnum>;
  _rawActivities?: InputMaybe<SortOrderEnum>;
  _rawClosingSurveyShownFrom?: InputMaybe<SortOrderEnum>;
  _rawContactPage?: InputMaybe<SortOrderEnum>;
  _rawCtaListForLoggedInUsers?: InputMaybe<SortOrderEnum>;
  _rawCtaListForLoggedOutUsers?: InputMaybe<SortOrderEnum>;
  _rawEndOfGameWinnersText?: InputMaybe<SortOrderEnum>;
  _rawFaqs?: InputMaybe<SortOrderEnum>;
  _rawFooterPartners?: InputMaybe<SortOrderEnum>;
  _rawGameIcon?: InputMaybe<SortOrderEnum>;
  _rawGamePartnerConsentIntroduction?: InputMaybe<SortOrderEnum>;
  _rawHowToPlay?: InputMaybe<SortOrderEnum>;
  _rawI18NBase?: InputMaybe<SortOrderEnum>;
  _rawI18NRefs?: InputMaybe<SortOrderEnum>;
  _rawIntroductionContent?: InputMaybe<SortOrderEnum>;
  _rawIntroductionVideoCta?: InputMaybe<SortOrderEnum>;
  _rawLeaderboardSettings?: InputMaybe<SortOrderEnum>;
  _rawPartners?: InputMaybe<SortOrderEnum>;
  _rawPartnersPage?: InputMaybe<SortOrderEnum>;
  _rawWeeklyThemes?: InputMaybe<SortOrderEnum>;
  _rev?: InputMaybe<SortOrderEnum>;
  _type?: InputMaybe<SortOrderEnum>;
  _updatedAt?: InputMaybe<SortOrderEnum>;
  active?: InputMaybe<SortOrderEnum>;
  activities?: InputMaybe<SanityActivitySortInput>;
  awards?: InputMaybe<SortOrderEnum>;
  bbox?: InputMaybe<SortOrderEnum>;
  children?: InputMaybe<NodeSortInput>;
  closingSurveyCollectorUrl?: InputMaybe<SortOrderEnum>;
  closingSurveyId?: InputMaybe<SortOrderEnum>;
  closingSurveyShownFrom?: InputMaybe<SanityRichDateSortInput>;
  contactPage?: InputMaybe<SanityContentSortInput>;
  ctaListForLoggedInUsers?: InputMaybe<SanityCtaSortInput>;
  ctaListForLoggedOutUsers?: InputMaybe<SanityCtaSortInput>;
  displayAll?: InputMaybe<SortOrderEnum>;
  emailAddress?: InputMaybe<SortOrderEnum>;
  endOfGameShowWinners?: InputMaybe<SortOrderEnum>;
  endOfGameWinnersText?: InputMaybe<SanityBlockSortInput>;
  facebookUsername?: InputMaybe<SortOrderEnum>;
  footerPartners?: InputMaybe<SanityPartnerSortInput>;
  gameIcon?: InputMaybe<SanityGameIconSortInput>;
  gamePartnerConsentIntroduction?: InputMaybe<SanityBlockSortInput>;
  gamePartnerConsentText?: InputMaybe<SortOrderEnum>;
  howToPlay?: InputMaybe<SanityContentSortInput>;
  i18n_base?: InputMaybe<SanityLocalitySortInput>;
  i18n_lang?: InputMaybe<SortOrderEnum>;
  i18n_refs?: InputMaybe<SanityLocalitySortInput>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  internalName?: InputMaybe<SortOrderEnum>;
  introductionContent?: InputMaybe<SanityBlockSortInput>;
  introductionHeading?: InputMaybe<SortOrderEnum>;
  introductionVideoCta?: InputMaybe<SanityVideoCtaSortInput>;
  leaderboardSettings?: InputMaybe<SanityLeaderboardSettingsSortInput>;
  mapsKmlUrl?: InputMaybe<SortOrderEnum>;
  name?: InputMaybe<SortOrderEnum>;
  numberOfPartnersInFooter?: InputMaybe<SortOrderEnum>;
  parent?: InputMaybe<NodeSortInput>;
  partners?: InputMaybe<SanityPartnerSortInput>;
  partnersPage?: InputMaybe<SanityPartnersPageSortInput>;
  tellUsAboutYouSurveyCollectorUrl?: InputMaybe<SortOrderEnum>;
  tellUsAboutYouSurveyId?: InputMaybe<SortOrderEnum>;
  tellUsAboutYouSurveyMandatory?: InputMaybe<SortOrderEnum>;
  twitterUsername?: InputMaybe<SortOrderEnum>;
  urlSlug?: InputMaybe<SortOrderEnum>;
  weeklyThemes?: InputMaybe<SanityThemeSortInput>;
};

export type SanityMessage = Node & SanityDocument & {
  _createdAt?: Maybe<Scalars['Date']>;
  _id?: Maybe<Scalars['String']>;
  _key?: Maybe<Scalars['String']>;
  _rawBody?: Maybe<Scalars['JSON']>;
  _rawCategory?: Maybe<Scalars['JSON']>;
  _rawCta1?: Maybe<Scalars['JSON']>;
  _rawCta2?: Maybe<Scalars['JSON']>;
  _rawGame?: Maybe<Scalars['JSON']>;
  _rawImage?: Maybe<Scalars['JSON']>;
  _rev?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  _updatedAt?: Maybe<Scalars['Date']>;
  body?: Maybe<Array<Maybe<SanityBlock>>>;
  category?: Maybe<SanityMessageCategory>;
  children: Array<Node>;
  cta1?: Maybe<SanityMessageCta>;
  cta2?: Maybe<SanityMessageCta>;
  game?: Maybe<SanityGame>;
  id: Scalars['ID'];
  image?: Maybe<SanityImage>;
  imagePosition?: Maybe<Scalars['String']>;
  internal: Internal;
  parent?: Maybe<Node>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};


export type SanityMessage_CreatedAtArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type SanityMessage_RawBodyArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityMessage_RawCategoryArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityMessage_RawCta1Args = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityMessage_RawCta2Args = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityMessage_RawGameArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityMessage_RawImageArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityMessage_UpdatedAtArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type SanityMessageCategory = Node & SanityDocument & {
  _createdAt?: Maybe<Scalars['Date']>;
  _id?: Maybe<Scalars['String']>;
  _key?: Maybe<Scalars['String']>;
  _rawIcon?: Maybe<Scalars['JSON']>;
  _rawImage?: Maybe<Scalars['JSON']>;
  _rev?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  _updatedAt?: Maybe<Scalars['Date']>;
  children: Array<Node>;
  icon?: Maybe<SanityImage>;
  id: Scalars['ID'];
  image?: Maybe<SanityImage>;
  internal: Internal;
  name?: Maybe<Scalars['String']>;
  parent?: Maybe<Node>;
  playerCategory?: Maybe<Scalars['String']>;
};


export type SanityMessageCategory_CreatedAtArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type SanityMessageCategory_RawIconArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityMessageCategory_RawImageArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityMessageCategory_UpdatedAtArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type SanityMessageCategoryConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SanityMessageCategoryEdge>;
  group: Array<SanityMessageCategoryGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<SanityMessageCategory>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SanityMessageCategoryConnectionDistinctArgs = {
  field: SanityMessageCategoryFieldSelector;
};


export type SanityMessageCategoryConnectionGroupArgs = {
  field: SanityMessageCategoryFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SanityMessageCategoryConnectionMaxArgs = {
  field: SanityMessageCategoryFieldSelector;
};


export type SanityMessageCategoryConnectionMinArgs = {
  field: SanityMessageCategoryFieldSelector;
};


export type SanityMessageCategoryConnectionSumArgs = {
  field: SanityMessageCategoryFieldSelector;
};

export type SanityMessageCategoryEdge = {
  next?: Maybe<SanityMessageCategory>;
  node: SanityMessageCategory;
  previous?: Maybe<SanityMessageCategory>;
};

export type SanityMessageCategoryFieldSelector = {
  _createdAt?: InputMaybe<FieldSelectorEnum>;
  _id?: InputMaybe<FieldSelectorEnum>;
  _key?: InputMaybe<FieldSelectorEnum>;
  _rawIcon?: InputMaybe<FieldSelectorEnum>;
  _rawImage?: InputMaybe<FieldSelectorEnum>;
  _rev?: InputMaybe<FieldSelectorEnum>;
  _type?: InputMaybe<FieldSelectorEnum>;
  _updatedAt?: InputMaybe<FieldSelectorEnum>;
  children?: InputMaybe<NodeFieldSelector>;
  icon?: InputMaybe<SanityImageFieldSelector>;
  id?: InputMaybe<FieldSelectorEnum>;
  image?: InputMaybe<SanityImageFieldSelector>;
  internal?: InputMaybe<InternalFieldSelector>;
  name?: InputMaybe<FieldSelectorEnum>;
  parent?: InputMaybe<NodeFieldSelector>;
  playerCategory?: InputMaybe<FieldSelectorEnum>;
};

export type SanityMessageCategoryFilterInput = {
  _createdAt?: InputMaybe<DateQueryOperatorInput>;
  _id?: InputMaybe<StringQueryOperatorInput>;
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawIcon?: InputMaybe<JsonQueryOperatorInput>;
  _rawImage?: InputMaybe<JsonQueryOperatorInput>;
  _rev?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  _updatedAt?: InputMaybe<DateQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  icon?: InputMaybe<SanityImageFilterInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  image?: InputMaybe<SanityImageFilterInput>;
  internal?: InputMaybe<InternalFilterInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  playerCategory?: InputMaybe<StringQueryOperatorInput>;
};

export type SanityMessageCategoryGroupConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SanityMessageCategoryEdge>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
  group: Array<SanityMessageCategoryGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<SanityMessageCategory>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SanityMessageCategoryGroupConnectionDistinctArgs = {
  field: SanityMessageCategoryFieldSelector;
};


export type SanityMessageCategoryGroupConnectionGroupArgs = {
  field: SanityMessageCategoryFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SanityMessageCategoryGroupConnectionMaxArgs = {
  field: SanityMessageCategoryFieldSelector;
};


export type SanityMessageCategoryGroupConnectionMinArgs = {
  field: SanityMessageCategoryFieldSelector;
};


export type SanityMessageCategoryGroupConnectionSumArgs = {
  field: SanityMessageCategoryFieldSelector;
};

export type SanityMessageCategorySortInput = {
  _createdAt?: InputMaybe<SortOrderEnum>;
  _id?: InputMaybe<SortOrderEnum>;
  _key?: InputMaybe<SortOrderEnum>;
  _rawIcon?: InputMaybe<SortOrderEnum>;
  _rawImage?: InputMaybe<SortOrderEnum>;
  _rev?: InputMaybe<SortOrderEnum>;
  _type?: InputMaybe<SortOrderEnum>;
  _updatedAt?: InputMaybe<SortOrderEnum>;
  children?: InputMaybe<NodeSortInput>;
  icon?: InputMaybe<SanityImageSortInput>;
  id?: InputMaybe<SortOrderEnum>;
  image?: InputMaybe<SanityImageSortInput>;
  internal?: InputMaybe<InternalSortInput>;
  name?: InputMaybe<SortOrderEnum>;
  parent?: InputMaybe<NodeSortInput>;
  playerCategory?: InputMaybe<SortOrderEnum>;
};

export type SanityMessageConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SanityMessageEdge>;
  group: Array<SanityMessageGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<SanityMessage>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SanityMessageConnectionDistinctArgs = {
  field: SanityMessageFieldSelector;
};


export type SanityMessageConnectionGroupArgs = {
  field: SanityMessageFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SanityMessageConnectionMaxArgs = {
  field: SanityMessageFieldSelector;
};


export type SanityMessageConnectionMinArgs = {
  field: SanityMessageFieldSelector;
};


export type SanityMessageConnectionSumArgs = {
  field: SanityMessageFieldSelector;
};

export type SanityMessageCta = Node & SanityDocument & {
  _createdAt?: Maybe<Scalars['Date']>;
  _id?: Maybe<Scalars['String']>;
  _key?: Maybe<Scalars['String']>;
  _rawEvent?: Maybe<Scalars['JSON']>;
  _rev?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  _updatedAt?: Maybe<Scalars['Date']>;
  children: Array<Node>;
  event?: Maybe<SanityEvent>;
  externalLink?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  internal: Internal;
  internalLink?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  parent?: Maybe<Node>;
  type?: Maybe<Scalars['String']>;
};


export type SanityMessageCta_CreatedAtArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type SanityMessageCta_RawEventArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityMessageCta_UpdatedAtArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type SanityMessageCtaConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SanityMessageCtaEdge>;
  group: Array<SanityMessageCtaGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<SanityMessageCta>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SanityMessageCtaConnectionDistinctArgs = {
  field: SanityMessageCtaFieldSelector;
};


export type SanityMessageCtaConnectionGroupArgs = {
  field: SanityMessageCtaFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SanityMessageCtaConnectionMaxArgs = {
  field: SanityMessageCtaFieldSelector;
};


export type SanityMessageCtaConnectionMinArgs = {
  field: SanityMessageCtaFieldSelector;
};


export type SanityMessageCtaConnectionSumArgs = {
  field: SanityMessageCtaFieldSelector;
};

export type SanityMessageCtaEdge = {
  next?: Maybe<SanityMessageCta>;
  node: SanityMessageCta;
  previous?: Maybe<SanityMessageCta>;
};

export type SanityMessageCtaFieldSelector = {
  _createdAt?: InputMaybe<FieldSelectorEnum>;
  _id?: InputMaybe<FieldSelectorEnum>;
  _key?: InputMaybe<FieldSelectorEnum>;
  _rawEvent?: InputMaybe<FieldSelectorEnum>;
  _rev?: InputMaybe<FieldSelectorEnum>;
  _type?: InputMaybe<FieldSelectorEnum>;
  _updatedAt?: InputMaybe<FieldSelectorEnum>;
  children?: InputMaybe<NodeFieldSelector>;
  event?: InputMaybe<SanityEventFieldSelector>;
  externalLink?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  internalLink?: InputMaybe<FieldSelectorEnum>;
  label?: InputMaybe<FieldSelectorEnum>;
  parent?: InputMaybe<NodeFieldSelector>;
  type?: InputMaybe<FieldSelectorEnum>;
};

export type SanityMessageCtaFilterInput = {
  _createdAt?: InputMaybe<DateQueryOperatorInput>;
  _id?: InputMaybe<StringQueryOperatorInput>;
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawEvent?: InputMaybe<JsonQueryOperatorInput>;
  _rev?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  _updatedAt?: InputMaybe<DateQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  event?: InputMaybe<SanityEventFilterInput>;
  externalLink?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  internalLink?: InputMaybe<StringQueryOperatorInput>;
  label?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
};

export type SanityMessageCtaGroupConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SanityMessageCtaEdge>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
  group: Array<SanityMessageCtaGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<SanityMessageCta>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SanityMessageCtaGroupConnectionDistinctArgs = {
  field: SanityMessageCtaFieldSelector;
};


export type SanityMessageCtaGroupConnectionGroupArgs = {
  field: SanityMessageCtaFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SanityMessageCtaGroupConnectionMaxArgs = {
  field: SanityMessageCtaFieldSelector;
};


export type SanityMessageCtaGroupConnectionMinArgs = {
  field: SanityMessageCtaFieldSelector;
};


export type SanityMessageCtaGroupConnectionSumArgs = {
  field: SanityMessageCtaFieldSelector;
};

export type SanityMessageCtaSortInput = {
  _createdAt?: InputMaybe<SortOrderEnum>;
  _id?: InputMaybe<SortOrderEnum>;
  _key?: InputMaybe<SortOrderEnum>;
  _rawEvent?: InputMaybe<SortOrderEnum>;
  _rev?: InputMaybe<SortOrderEnum>;
  _type?: InputMaybe<SortOrderEnum>;
  _updatedAt?: InputMaybe<SortOrderEnum>;
  children?: InputMaybe<NodeSortInput>;
  event?: InputMaybe<SanityEventSortInput>;
  externalLink?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  internalLink?: InputMaybe<SortOrderEnum>;
  label?: InputMaybe<SortOrderEnum>;
  parent?: InputMaybe<NodeSortInput>;
  type?: InputMaybe<SortOrderEnum>;
};

export type SanityMessageEdge = {
  next?: Maybe<SanityMessage>;
  node: SanityMessage;
  previous?: Maybe<SanityMessage>;
};

export type SanityMessageFieldSelector = {
  _createdAt?: InputMaybe<FieldSelectorEnum>;
  _id?: InputMaybe<FieldSelectorEnum>;
  _key?: InputMaybe<FieldSelectorEnum>;
  _rawBody?: InputMaybe<FieldSelectorEnum>;
  _rawCategory?: InputMaybe<FieldSelectorEnum>;
  _rawCta1?: InputMaybe<FieldSelectorEnum>;
  _rawCta2?: InputMaybe<FieldSelectorEnum>;
  _rawGame?: InputMaybe<FieldSelectorEnum>;
  _rawImage?: InputMaybe<FieldSelectorEnum>;
  _rev?: InputMaybe<FieldSelectorEnum>;
  _type?: InputMaybe<FieldSelectorEnum>;
  _updatedAt?: InputMaybe<FieldSelectorEnum>;
  body?: InputMaybe<SanityBlockFieldSelector>;
  category?: InputMaybe<SanityMessageCategoryFieldSelector>;
  children?: InputMaybe<NodeFieldSelector>;
  cta1?: InputMaybe<SanityMessageCtaFieldSelector>;
  cta2?: InputMaybe<SanityMessageCtaFieldSelector>;
  game?: InputMaybe<SanityGameFieldSelector>;
  id?: InputMaybe<FieldSelectorEnum>;
  image?: InputMaybe<SanityImageFieldSelector>;
  imagePosition?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  parent?: InputMaybe<NodeFieldSelector>;
  subtitle?: InputMaybe<FieldSelectorEnum>;
  title?: InputMaybe<FieldSelectorEnum>;
};

export type SanityMessageFilterInput = {
  _createdAt?: InputMaybe<DateQueryOperatorInput>;
  _id?: InputMaybe<StringQueryOperatorInput>;
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawBody?: InputMaybe<JsonQueryOperatorInput>;
  _rawCategory?: InputMaybe<JsonQueryOperatorInput>;
  _rawCta1?: InputMaybe<JsonQueryOperatorInput>;
  _rawCta2?: InputMaybe<JsonQueryOperatorInput>;
  _rawGame?: InputMaybe<JsonQueryOperatorInput>;
  _rawImage?: InputMaybe<JsonQueryOperatorInput>;
  _rev?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  _updatedAt?: InputMaybe<DateQueryOperatorInput>;
  body?: InputMaybe<SanityBlockFilterListInput>;
  category?: InputMaybe<SanityMessageCategoryFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  cta1?: InputMaybe<SanityMessageCtaFilterInput>;
  cta2?: InputMaybe<SanityMessageCtaFilterInput>;
  game?: InputMaybe<SanityGameFilterInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  image?: InputMaybe<SanityImageFilterInput>;
  imagePosition?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
  subtitle?: InputMaybe<StringQueryOperatorInput>;
  title?: InputMaybe<StringQueryOperatorInput>;
};

export type SanityMessageGroupConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SanityMessageEdge>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
  group: Array<SanityMessageGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<SanityMessage>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SanityMessageGroupConnectionDistinctArgs = {
  field: SanityMessageFieldSelector;
};


export type SanityMessageGroupConnectionGroupArgs = {
  field: SanityMessageFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SanityMessageGroupConnectionMaxArgs = {
  field: SanityMessageFieldSelector;
};


export type SanityMessageGroupConnectionMinArgs = {
  field: SanityMessageFieldSelector;
};


export type SanityMessageGroupConnectionSumArgs = {
  field: SanityMessageFieldSelector;
};

export type SanityMessageSortInput = {
  _createdAt?: InputMaybe<SortOrderEnum>;
  _id?: InputMaybe<SortOrderEnum>;
  _key?: InputMaybe<SortOrderEnum>;
  _rawBody?: InputMaybe<SortOrderEnum>;
  _rawCategory?: InputMaybe<SortOrderEnum>;
  _rawCta1?: InputMaybe<SortOrderEnum>;
  _rawCta2?: InputMaybe<SortOrderEnum>;
  _rawGame?: InputMaybe<SortOrderEnum>;
  _rawImage?: InputMaybe<SortOrderEnum>;
  _rev?: InputMaybe<SortOrderEnum>;
  _type?: InputMaybe<SortOrderEnum>;
  _updatedAt?: InputMaybe<SortOrderEnum>;
  body?: InputMaybe<SanityBlockSortInput>;
  category?: InputMaybe<SanityMessageCategorySortInput>;
  children?: InputMaybe<NodeSortInput>;
  cta1?: InputMaybe<SanityMessageCtaSortInput>;
  cta2?: InputMaybe<SanityMessageCtaSortInput>;
  game?: InputMaybe<SanityGameSortInput>;
  id?: InputMaybe<SortOrderEnum>;
  image?: InputMaybe<SanityImageSortInput>;
  imagePosition?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  parent?: InputMaybe<NodeSortInput>;
  subtitle?: InputMaybe<SortOrderEnum>;
  title?: InputMaybe<SortOrderEnum>;
};

export type SanityPartner = Node & SanityDocument & {
  _createdAt?: Maybe<Scalars['Date']>;
  _id?: Maybe<Scalars['String']>;
  _key?: Maybe<Scalars['String']>;
  _rawI18NBase?: Maybe<Scalars['JSON']>;
  _rawI18NRefs?: Maybe<Scalars['JSON']>;
  _rawLogo?: Maybe<Scalars['JSON']>;
  _rev?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  _updatedAt?: Maybe<Scalars['Date']>;
  children: Array<Node>;
  i18n_base?: Maybe<SanityPartner>;
  i18n_lang?: Maybe<Scalars['String']>;
  i18n_refs?: Maybe<Array<Maybe<SanityPartner>>>;
  id: Scalars['ID'];
  internal: Internal;
  logo?: Maybe<SanityImage>;
  name?: Maybe<Scalars['String']>;
  parent?: Maybe<Node>;
  websiteUrl?: Maybe<Scalars['String']>;
};


export type SanityPartner_CreatedAtArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type SanityPartner_RawI18NBaseArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityPartner_RawI18NRefsArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityPartner_RawLogoArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityPartner_UpdatedAtArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type SanityPartnerConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SanityPartnerEdge>;
  group: Array<SanityPartnerGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<SanityPartner>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SanityPartnerConnectionDistinctArgs = {
  field: SanityPartnerFieldSelector;
};


export type SanityPartnerConnectionGroupArgs = {
  field: SanityPartnerFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SanityPartnerConnectionMaxArgs = {
  field: SanityPartnerFieldSelector;
};


export type SanityPartnerConnectionMinArgs = {
  field: SanityPartnerFieldSelector;
};


export type SanityPartnerConnectionSumArgs = {
  field: SanityPartnerFieldSelector;
};

export type SanityPartnerEdge = {
  next?: Maybe<SanityPartner>;
  node: SanityPartner;
  previous?: Maybe<SanityPartner>;
};

export type SanityPartnerFieldSelector = {
  _createdAt?: InputMaybe<FieldSelectorEnum>;
  _id?: InputMaybe<FieldSelectorEnum>;
  _key?: InputMaybe<FieldSelectorEnum>;
  _rawI18NBase?: InputMaybe<FieldSelectorEnum>;
  _rawI18NRefs?: InputMaybe<FieldSelectorEnum>;
  _rawLogo?: InputMaybe<FieldSelectorEnum>;
  _rev?: InputMaybe<FieldSelectorEnum>;
  _type?: InputMaybe<FieldSelectorEnum>;
  _updatedAt?: InputMaybe<FieldSelectorEnum>;
  children?: InputMaybe<NodeFieldSelector>;
  i18n_base?: InputMaybe<SanityPartnerFieldSelector>;
  i18n_lang?: InputMaybe<FieldSelectorEnum>;
  i18n_refs?: InputMaybe<SanityPartnerFieldSelector>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  logo?: InputMaybe<SanityImageFieldSelector>;
  name?: InputMaybe<FieldSelectorEnum>;
  parent?: InputMaybe<NodeFieldSelector>;
  websiteUrl?: InputMaybe<FieldSelectorEnum>;
};

export type SanityPartnerFilterInput = {
  _createdAt?: InputMaybe<DateQueryOperatorInput>;
  _id?: InputMaybe<StringQueryOperatorInput>;
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawI18NBase?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NRefs?: InputMaybe<JsonQueryOperatorInput>;
  _rawLogo?: InputMaybe<JsonQueryOperatorInput>;
  _rev?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  _updatedAt?: InputMaybe<DateQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  i18n_base?: InputMaybe<SanityPartnerFilterInput>;
  i18n_lang?: InputMaybe<StringQueryOperatorInput>;
  i18n_refs?: InputMaybe<SanityPartnerFilterListInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  logo?: InputMaybe<SanityImageFilterInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  websiteUrl?: InputMaybe<StringQueryOperatorInput>;
};

export type SanityPartnerFilterListInput = {
  elemMatch?: InputMaybe<SanityPartnerFilterInput>;
};

export type SanityPartnerGroupConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SanityPartnerEdge>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
  group: Array<SanityPartnerGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<SanityPartner>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SanityPartnerGroupConnectionDistinctArgs = {
  field: SanityPartnerFieldSelector;
};


export type SanityPartnerGroupConnectionGroupArgs = {
  field: SanityPartnerFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SanityPartnerGroupConnectionMaxArgs = {
  field: SanityPartnerFieldSelector;
};


export type SanityPartnerGroupConnectionMinArgs = {
  field: SanityPartnerFieldSelector;
};


export type SanityPartnerGroupConnectionSumArgs = {
  field: SanityPartnerFieldSelector;
};

export type SanityPartnerSortInput = {
  _createdAt?: InputMaybe<SortOrderEnum>;
  _id?: InputMaybe<SortOrderEnum>;
  _key?: InputMaybe<SortOrderEnum>;
  _rawI18NBase?: InputMaybe<SortOrderEnum>;
  _rawI18NRefs?: InputMaybe<SortOrderEnum>;
  _rawLogo?: InputMaybe<SortOrderEnum>;
  _rev?: InputMaybe<SortOrderEnum>;
  _type?: InputMaybe<SortOrderEnum>;
  _updatedAt?: InputMaybe<SortOrderEnum>;
  children?: InputMaybe<NodeSortInput>;
  i18n_base?: InputMaybe<SanityPartnerSortInput>;
  i18n_lang?: InputMaybe<SortOrderEnum>;
  i18n_refs?: InputMaybe<SanityPartnerSortInput>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  logo?: InputMaybe<SanityImageSortInput>;
  name?: InputMaybe<SortOrderEnum>;
  parent?: InputMaybe<NodeSortInput>;
  websiteUrl?: InputMaybe<SortOrderEnum>;
};

export type SanityPartnersPage = Node & SanityDocument & {
  _createdAt?: Maybe<Scalars['Date']>;
  _id?: Maybe<Scalars['String']>;
  _key?: Maybe<Scalars['String']>;
  _rawI18NBase?: Maybe<Scalars['JSON']>;
  _rawI18NRefs?: Maybe<Scalars['JSON']>;
  _rawIntroduction?: Maybe<Scalars['JSON']>;
  _rev?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  _updatedAt?: Maybe<Scalars['Date']>;
  children: Array<Node>;
  i18n_base?: Maybe<SanityPartnersPage>;
  i18n_lang?: Maybe<Scalars['String']>;
  i18n_refs?: Maybe<Array<Maybe<SanityPartnersPage>>>;
  id: Scalars['ID'];
  internal: Internal;
  introduction?: Maybe<Array<Maybe<SanityBlock>>>;
  parent?: Maybe<Node>;
  title?: Maybe<Scalars['String']>;
};


export type SanityPartnersPage_CreatedAtArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type SanityPartnersPage_RawI18NBaseArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityPartnersPage_RawI18NRefsArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityPartnersPage_RawIntroductionArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityPartnersPage_UpdatedAtArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type SanityPartnersPageConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SanityPartnersPageEdge>;
  group: Array<SanityPartnersPageGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<SanityPartnersPage>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SanityPartnersPageConnectionDistinctArgs = {
  field: SanityPartnersPageFieldSelector;
};


export type SanityPartnersPageConnectionGroupArgs = {
  field: SanityPartnersPageFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SanityPartnersPageConnectionMaxArgs = {
  field: SanityPartnersPageFieldSelector;
};


export type SanityPartnersPageConnectionMinArgs = {
  field: SanityPartnersPageFieldSelector;
};


export type SanityPartnersPageConnectionSumArgs = {
  field: SanityPartnersPageFieldSelector;
};

export type SanityPartnersPageEdge = {
  next?: Maybe<SanityPartnersPage>;
  node: SanityPartnersPage;
  previous?: Maybe<SanityPartnersPage>;
};

export type SanityPartnersPageFieldSelector = {
  _createdAt?: InputMaybe<FieldSelectorEnum>;
  _id?: InputMaybe<FieldSelectorEnum>;
  _key?: InputMaybe<FieldSelectorEnum>;
  _rawI18NBase?: InputMaybe<FieldSelectorEnum>;
  _rawI18NRefs?: InputMaybe<FieldSelectorEnum>;
  _rawIntroduction?: InputMaybe<FieldSelectorEnum>;
  _rev?: InputMaybe<FieldSelectorEnum>;
  _type?: InputMaybe<FieldSelectorEnum>;
  _updatedAt?: InputMaybe<FieldSelectorEnum>;
  children?: InputMaybe<NodeFieldSelector>;
  i18n_base?: InputMaybe<SanityPartnersPageFieldSelector>;
  i18n_lang?: InputMaybe<FieldSelectorEnum>;
  i18n_refs?: InputMaybe<SanityPartnersPageFieldSelector>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  introduction?: InputMaybe<SanityBlockFieldSelector>;
  parent?: InputMaybe<NodeFieldSelector>;
  title?: InputMaybe<FieldSelectorEnum>;
};

export type SanityPartnersPageFilterInput = {
  _createdAt?: InputMaybe<DateQueryOperatorInput>;
  _id?: InputMaybe<StringQueryOperatorInput>;
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawI18NBase?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NRefs?: InputMaybe<JsonQueryOperatorInput>;
  _rawIntroduction?: InputMaybe<JsonQueryOperatorInput>;
  _rev?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  _updatedAt?: InputMaybe<DateQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  i18n_base?: InputMaybe<SanityPartnersPageFilterInput>;
  i18n_lang?: InputMaybe<StringQueryOperatorInput>;
  i18n_refs?: InputMaybe<SanityPartnersPageFilterListInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  introduction?: InputMaybe<SanityBlockFilterListInput>;
  parent?: InputMaybe<NodeFilterInput>;
  title?: InputMaybe<StringQueryOperatorInput>;
};

export type SanityPartnersPageFilterListInput = {
  elemMatch?: InputMaybe<SanityPartnersPageFilterInput>;
};

export type SanityPartnersPageGroupConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SanityPartnersPageEdge>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
  group: Array<SanityPartnersPageGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<SanityPartnersPage>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SanityPartnersPageGroupConnectionDistinctArgs = {
  field: SanityPartnersPageFieldSelector;
};


export type SanityPartnersPageGroupConnectionGroupArgs = {
  field: SanityPartnersPageFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SanityPartnersPageGroupConnectionMaxArgs = {
  field: SanityPartnersPageFieldSelector;
};


export type SanityPartnersPageGroupConnectionMinArgs = {
  field: SanityPartnersPageFieldSelector;
};


export type SanityPartnersPageGroupConnectionSumArgs = {
  field: SanityPartnersPageFieldSelector;
};

export type SanityPartnersPageSortInput = {
  _createdAt?: InputMaybe<SortOrderEnum>;
  _id?: InputMaybe<SortOrderEnum>;
  _key?: InputMaybe<SortOrderEnum>;
  _rawI18NBase?: InputMaybe<SortOrderEnum>;
  _rawI18NRefs?: InputMaybe<SortOrderEnum>;
  _rawIntroduction?: InputMaybe<SortOrderEnum>;
  _rev?: InputMaybe<SortOrderEnum>;
  _type?: InputMaybe<SortOrderEnum>;
  _updatedAt?: InputMaybe<SortOrderEnum>;
  children?: InputMaybe<NodeSortInput>;
  i18n_base?: InputMaybe<SanityPartnersPageSortInput>;
  i18n_lang?: InputMaybe<SortOrderEnum>;
  i18n_refs?: InputMaybe<SanityPartnersPageSortInput>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  introduction?: InputMaybe<SanityBlockSortInput>;
  parent?: InputMaybe<NodeSortInput>;
  title?: InputMaybe<SortOrderEnum>;
};

export type SanityProductGrid = {
  _key?: Maybe<Scalars['String']>;
  _rawItems?: Maybe<Scalars['JSON']>;
  _type?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<SanityProducts>>>;
};


export type SanityProductGrid_RawItemsArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};

export type SanityProducts = Node & SanityDocument & {
  _createdAt?: Maybe<Scalars['Date']>;
  _id?: Maybe<Scalars['String']>;
  _key?: Maybe<Scalars['String']>;
  _rawI18NBase?: Maybe<Scalars['JSON']>;
  _rawI18NRefs?: Maybe<Scalars['JSON']>;
  _rawImage?: Maybe<Scalars['JSON']>;
  _rev?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  _updatedAt?: Maybe<Scalars['Date']>;
  alt?: Maybe<Scalars['String']>;
  children: Array<Node>;
  description?: Maybe<Scalars['String']>;
  i18n_base?: Maybe<SanityProducts>;
  i18n_lang?: Maybe<Scalars['String']>;
  i18n_refs?: Maybe<Array<Maybe<SanityProducts>>>;
  id: Scalars['ID'];
  image?: Maybe<SanityImage>;
  internal: Internal;
  name?: Maybe<Scalars['String']>;
  parent?: Maybe<Node>;
  price?: Maybe<Scalars['Float']>;
  productID?: Maybe<Scalars['String']>;
  weight?: Maybe<Scalars['Float']>;
};


export type SanityProducts_CreatedAtArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type SanityProducts_RawI18NBaseArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityProducts_RawI18NRefsArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityProducts_RawImageArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityProducts_UpdatedAtArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type SanityProductsConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SanityProductsEdge>;
  group: Array<SanityProductsGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<SanityProducts>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SanityProductsConnectionDistinctArgs = {
  field: SanityProductsFieldSelector;
};


export type SanityProductsConnectionGroupArgs = {
  field: SanityProductsFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SanityProductsConnectionMaxArgs = {
  field: SanityProductsFieldSelector;
};


export type SanityProductsConnectionMinArgs = {
  field: SanityProductsFieldSelector;
};


export type SanityProductsConnectionSumArgs = {
  field: SanityProductsFieldSelector;
};

export type SanityProductsEdge = {
  next?: Maybe<SanityProducts>;
  node: SanityProducts;
  previous?: Maybe<SanityProducts>;
};

export type SanityProductsFieldSelector = {
  _createdAt?: InputMaybe<FieldSelectorEnum>;
  _id?: InputMaybe<FieldSelectorEnum>;
  _key?: InputMaybe<FieldSelectorEnum>;
  _rawI18NBase?: InputMaybe<FieldSelectorEnum>;
  _rawI18NRefs?: InputMaybe<FieldSelectorEnum>;
  _rawImage?: InputMaybe<FieldSelectorEnum>;
  _rev?: InputMaybe<FieldSelectorEnum>;
  _type?: InputMaybe<FieldSelectorEnum>;
  _updatedAt?: InputMaybe<FieldSelectorEnum>;
  alt?: InputMaybe<FieldSelectorEnum>;
  children?: InputMaybe<NodeFieldSelector>;
  description?: InputMaybe<FieldSelectorEnum>;
  i18n_base?: InputMaybe<SanityProductsFieldSelector>;
  i18n_lang?: InputMaybe<FieldSelectorEnum>;
  i18n_refs?: InputMaybe<SanityProductsFieldSelector>;
  id?: InputMaybe<FieldSelectorEnum>;
  image?: InputMaybe<SanityImageFieldSelector>;
  internal?: InputMaybe<InternalFieldSelector>;
  name?: InputMaybe<FieldSelectorEnum>;
  parent?: InputMaybe<NodeFieldSelector>;
  price?: InputMaybe<FieldSelectorEnum>;
  productID?: InputMaybe<FieldSelectorEnum>;
  weight?: InputMaybe<FieldSelectorEnum>;
};

export type SanityProductsFilterInput = {
  _createdAt?: InputMaybe<DateQueryOperatorInput>;
  _id?: InputMaybe<StringQueryOperatorInput>;
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawI18NBase?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NRefs?: InputMaybe<JsonQueryOperatorInput>;
  _rawImage?: InputMaybe<JsonQueryOperatorInput>;
  _rev?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  _updatedAt?: InputMaybe<DateQueryOperatorInput>;
  alt?: InputMaybe<StringQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  description?: InputMaybe<StringQueryOperatorInput>;
  i18n_base?: InputMaybe<SanityProductsFilterInput>;
  i18n_lang?: InputMaybe<StringQueryOperatorInput>;
  i18n_refs?: InputMaybe<SanityProductsFilterListInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  image?: InputMaybe<SanityImageFilterInput>;
  internal?: InputMaybe<InternalFilterInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  price?: InputMaybe<FloatQueryOperatorInput>;
  productID?: InputMaybe<StringQueryOperatorInput>;
  weight?: InputMaybe<FloatQueryOperatorInput>;
};

export type SanityProductsFilterListInput = {
  elemMatch?: InputMaybe<SanityProductsFilterInput>;
};

export type SanityProductsGroupConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SanityProductsEdge>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
  group: Array<SanityProductsGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<SanityProducts>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SanityProductsGroupConnectionDistinctArgs = {
  field: SanityProductsFieldSelector;
};


export type SanityProductsGroupConnectionGroupArgs = {
  field: SanityProductsFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SanityProductsGroupConnectionMaxArgs = {
  field: SanityProductsFieldSelector;
};


export type SanityProductsGroupConnectionMinArgs = {
  field: SanityProductsFieldSelector;
};


export type SanityProductsGroupConnectionSumArgs = {
  field: SanityProductsFieldSelector;
};

export type SanityProductsSortInput = {
  _createdAt?: InputMaybe<SortOrderEnum>;
  _id?: InputMaybe<SortOrderEnum>;
  _key?: InputMaybe<SortOrderEnum>;
  _rawI18NBase?: InputMaybe<SortOrderEnum>;
  _rawI18NRefs?: InputMaybe<SortOrderEnum>;
  _rawImage?: InputMaybe<SortOrderEnum>;
  _rev?: InputMaybe<SortOrderEnum>;
  _type?: InputMaybe<SortOrderEnum>;
  _updatedAt?: InputMaybe<SortOrderEnum>;
  alt?: InputMaybe<SortOrderEnum>;
  children?: InputMaybe<NodeSortInput>;
  description?: InputMaybe<SortOrderEnum>;
  i18n_base?: InputMaybe<SanityProductsSortInput>;
  i18n_lang?: InputMaybe<SortOrderEnum>;
  i18n_refs?: InputMaybe<SanityProductsSortInput>;
  id?: InputMaybe<SortOrderEnum>;
  image?: InputMaybe<SanityImageSortInput>;
  internal?: InputMaybe<InternalSortInput>;
  name?: InputMaybe<SortOrderEnum>;
  parent?: InputMaybe<NodeSortInput>;
  price?: InputMaybe<SortOrderEnum>;
  productID?: InputMaybe<SortOrderEnum>;
  weight?: InputMaybe<SortOrderEnum>;
};

export type SanityRegistrationSettings = Node & SanityDocument & {
  _createdAt?: Maybe<Scalars['Date']>;
  _id?: Maybe<Scalars['String']>;
  _key?: Maybe<Scalars['String']>;
  _rawAppTermsOfServiceText?: Maybe<Scalars['JSON']>;
  _rawI18NBase?: Maybe<Scalars['JSON']>;
  _rawI18NRefs?: Maybe<Scalars['JSON']>;
  _rawTermsAndConditionsConsentText?: Maybe<Scalars['JSON']>;
  _rev?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  _updatedAt?: Maybe<Scalars['Date']>;
  appTermsOfServiceText?: Maybe<Array<Maybe<SanityBlock>>>;
  children: Array<Node>;
  contactConsentText?: Maybe<Scalars['String']>;
  i18n_base?: Maybe<SanityRegistrationSettings>;
  i18n_lang?: Maybe<Scalars['String']>;
  i18n_refs?: Maybe<Array<Maybe<SanityRegistrationSettings>>>;
  id: Scalars['ID'];
  internal: Internal;
  joinGameMessage?: Maybe<Scalars['String']>;
  parent?: Maybe<Node>;
  termsAndConditionsConsentText?: Maybe<Array<Maybe<SanityBlock>>>;
};


export type SanityRegistrationSettings_CreatedAtArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type SanityRegistrationSettings_RawAppTermsOfServiceTextArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityRegistrationSettings_RawI18NBaseArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityRegistrationSettings_RawI18NRefsArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityRegistrationSettings_RawTermsAndConditionsConsentTextArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityRegistrationSettings_UpdatedAtArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type SanityRegistrationSettingsConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SanityRegistrationSettingsEdge>;
  group: Array<SanityRegistrationSettingsGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<SanityRegistrationSettings>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SanityRegistrationSettingsConnectionDistinctArgs = {
  field: SanityRegistrationSettingsFieldSelector;
};


export type SanityRegistrationSettingsConnectionGroupArgs = {
  field: SanityRegistrationSettingsFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SanityRegistrationSettingsConnectionMaxArgs = {
  field: SanityRegistrationSettingsFieldSelector;
};


export type SanityRegistrationSettingsConnectionMinArgs = {
  field: SanityRegistrationSettingsFieldSelector;
};


export type SanityRegistrationSettingsConnectionSumArgs = {
  field: SanityRegistrationSettingsFieldSelector;
};

export type SanityRegistrationSettingsEdge = {
  next?: Maybe<SanityRegistrationSettings>;
  node: SanityRegistrationSettings;
  previous?: Maybe<SanityRegistrationSettings>;
};

export type SanityRegistrationSettingsFieldSelector = {
  _createdAt?: InputMaybe<FieldSelectorEnum>;
  _id?: InputMaybe<FieldSelectorEnum>;
  _key?: InputMaybe<FieldSelectorEnum>;
  _rawAppTermsOfServiceText?: InputMaybe<FieldSelectorEnum>;
  _rawI18NBase?: InputMaybe<FieldSelectorEnum>;
  _rawI18NRefs?: InputMaybe<FieldSelectorEnum>;
  _rawTermsAndConditionsConsentText?: InputMaybe<FieldSelectorEnum>;
  _rev?: InputMaybe<FieldSelectorEnum>;
  _type?: InputMaybe<FieldSelectorEnum>;
  _updatedAt?: InputMaybe<FieldSelectorEnum>;
  appTermsOfServiceText?: InputMaybe<SanityBlockFieldSelector>;
  children?: InputMaybe<NodeFieldSelector>;
  contactConsentText?: InputMaybe<FieldSelectorEnum>;
  i18n_base?: InputMaybe<SanityRegistrationSettingsFieldSelector>;
  i18n_lang?: InputMaybe<FieldSelectorEnum>;
  i18n_refs?: InputMaybe<SanityRegistrationSettingsFieldSelector>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  joinGameMessage?: InputMaybe<FieldSelectorEnum>;
  parent?: InputMaybe<NodeFieldSelector>;
  termsAndConditionsConsentText?: InputMaybe<SanityBlockFieldSelector>;
};

export type SanityRegistrationSettingsFilterInput = {
  _createdAt?: InputMaybe<DateQueryOperatorInput>;
  _id?: InputMaybe<StringQueryOperatorInput>;
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawAppTermsOfServiceText?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NBase?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NRefs?: InputMaybe<JsonQueryOperatorInput>;
  _rawTermsAndConditionsConsentText?: InputMaybe<JsonQueryOperatorInput>;
  _rev?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  _updatedAt?: InputMaybe<DateQueryOperatorInput>;
  appTermsOfServiceText?: InputMaybe<SanityBlockFilterListInput>;
  children?: InputMaybe<NodeFilterListInput>;
  contactConsentText?: InputMaybe<StringQueryOperatorInput>;
  i18n_base?: InputMaybe<SanityRegistrationSettingsFilterInput>;
  i18n_lang?: InputMaybe<StringQueryOperatorInput>;
  i18n_refs?: InputMaybe<SanityRegistrationSettingsFilterListInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  joinGameMessage?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  termsAndConditionsConsentText?: InputMaybe<SanityBlockFilterListInput>;
};

export type SanityRegistrationSettingsFilterListInput = {
  elemMatch?: InputMaybe<SanityRegistrationSettingsFilterInput>;
};

export type SanityRegistrationSettingsGroupConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SanityRegistrationSettingsEdge>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
  group: Array<SanityRegistrationSettingsGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<SanityRegistrationSettings>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SanityRegistrationSettingsGroupConnectionDistinctArgs = {
  field: SanityRegistrationSettingsFieldSelector;
};


export type SanityRegistrationSettingsGroupConnectionGroupArgs = {
  field: SanityRegistrationSettingsFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SanityRegistrationSettingsGroupConnectionMaxArgs = {
  field: SanityRegistrationSettingsFieldSelector;
};


export type SanityRegistrationSettingsGroupConnectionMinArgs = {
  field: SanityRegistrationSettingsFieldSelector;
};


export type SanityRegistrationSettingsGroupConnectionSumArgs = {
  field: SanityRegistrationSettingsFieldSelector;
};

export type SanityRegistrationSettingsSortInput = {
  _createdAt?: InputMaybe<SortOrderEnum>;
  _id?: InputMaybe<SortOrderEnum>;
  _key?: InputMaybe<SortOrderEnum>;
  _rawAppTermsOfServiceText?: InputMaybe<SortOrderEnum>;
  _rawI18NBase?: InputMaybe<SortOrderEnum>;
  _rawI18NRefs?: InputMaybe<SortOrderEnum>;
  _rawTermsAndConditionsConsentText?: InputMaybe<SortOrderEnum>;
  _rev?: InputMaybe<SortOrderEnum>;
  _type?: InputMaybe<SortOrderEnum>;
  _updatedAt?: InputMaybe<SortOrderEnum>;
  appTermsOfServiceText?: InputMaybe<SanityBlockSortInput>;
  children?: InputMaybe<NodeSortInput>;
  contactConsentText?: InputMaybe<SortOrderEnum>;
  i18n_base?: InputMaybe<SanityRegistrationSettingsSortInput>;
  i18n_lang?: InputMaybe<SortOrderEnum>;
  i18n_refs?: InputMaybe<SanityRegistrationSettingsSortInput>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  joinGameMessage?: InputMaybe<SortOrderEnum>;
  parent?: InputMaybe<NodeSortInput>;
  termsAndConditionsConsentText?: InputMaybe<SanityBlockSortInput>;
};

export type SanityResolveReferencesConfiguration = {
  /** Max depth to resolve references to */
  maxDepth: Scalars['Int'];
};

export type SanityResource = {
  _key?: Maybe<Scalars['String']>;
  _rawAsset?: Maybe<Scalars['JSON']>;
  _rawThumbnail?: Maybe<Scalars['JSON']>;
  _type?: Maybe<Scalars['String']>;
  alt?: Maybe<Scalars['String']>;
  asset?: Maybe<SanityFileAsset>;
  thumbnail?: Maybe<SanityImage>;
  title?: Maybe<Scalars['String']>;
};


export type SanityResource_RawAssetArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityResource_RawThumbnailArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};

export type SanityResources = {
  _key?: Maybe<Scalars['String']>;
  _rawResources?: Maybe<Scalars['JSON']>;
  _type?: Maybe<Scalars['String']>;
  resources?: Maybe<Array<Maybe<SanityResource>>>;
  title?: Maybe<Scalars['String']>;
};


export type SanityResources_RawResourcesArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};

export type SanityRgbaColor = {
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  a?: Maybe<Scalars['Float']>;
  b?: Maybe<Scalars['Float']>;
  g?: Maybe<Scalars['Float']>;
  r?: Maybe<Scalars['Float']>;
};

export type SanityRgbaColorFieldSelector = {
  _key?: InputMaybe<FieldSelectorEnum>;
  _type?: InputMaybe<FieldSelectorEnum>;
  a?: InputMaybe<FieldSelectorEnum>;
  b?: InputMaybe<FieldSelectorEnum>;
  g?: InputMaybe<FieldSelectorEnum>;
  r?: InputMaybe<FieldSelectorEnum>;
};

export type SanityRgbaColorFilterInput = {
  _key?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  a?: InputMaybe<FloatQueryOperatorInput>;
  b?: InputMaybe<FloatQueryOperatorInput>;
  g?: InputMaybe<FloatQueryOperatorInput>;
  r?: InputMaybe<FloatQueryOperatorInput>;
};

export type SanityRgbaColorSortInput = {
  _key?: InputMaybe<SortOrderEnum>;
  _type?: InputMaybe<SortOrderEnum>;
  a?: InputMaybe<SortOrderEnum>;
  b?: InputMaybe<SortOrderEnum>;
  g?: InputMaybe<SortOrderEnum>;
  r?: InputMaybe<SortOrderEnum>;
};

export type SanityRichDate = {
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  local?: Maybe<Scalars['Date']>;
  offset?: Maybe<Scalars['Float']>;
  timezone?: Maybe<Scalars['String']>;
  utc?: Maybe<Scalars['Date']>;
};


export type SanityRichDateLocalArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type SanityRichDateUtcArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type SanityRichDateFieldSelector = {
  _key?: InputMaybe<FieldSelectorEnum>;
  _type?: InputMaybe<FieldSelectorEnum>;
  local?: InputMaybe<FieldSelectorEnum>;
  offset?: InputMaybe<FieldSelectorEnum>;
  timezone?: InputMaybe<FieldSelectorEnum>;
  utc?: InputMaybe<FieldSelectorEnum>;
};

export type SanityRichDateFilterInput = {
  _key?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  local?: InputMaybe<DateQueryOperatorInput>;
  offset?: InputMaybe<FloatQueryOperatorInput>;
  timezone?: InputMaybe<StringQueryOperatorInput>;
  utc?: InputMaybe<DateQueryOperatorInput>;
};

export type SanityRichDateSortInput = {
  _key?: InputMaybe<SortOrderEnum>;
  _type?: InputMaybe<SortOrderEnum>;
  local?: InputMaybe<SortOrderEnum>;
  offset?: InputMaybe<SortOrderEnum>;
  timezone?: InputMaybe<SortOrderEnum>;
  utc?: InputMaybe<SortOrderEnum>;
};

export type SanitySlug = {
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  current?: Maybe<Scalars['String']>;
};

export type SanitySpan = {
  _key?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  marks?: Maybe<Array<Maybe<Scalars['String']>>>;
  text?: Maybe<Scalars['String']>;
};

export type SanitySpanFieldSelector = {
  _key?: InputMaybe<FieldSelectorEnum>;
  _type?: InputMaybe<FieldSelectorEnum>;
  marks?: InputMaybe<FieldSelectorEnum>;
  text?: InputMaybe<FieldSelectorEnum>;
};

export type SanitySpanFilterInput = {
  _key?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  marks?: InputMaybe<StringQueryOperatorInput>;
  text?: InputMaybe<StringQueryOperatorInput>;
};

export type SanitySpanFilterListInput = {
  elemMatch?: InputMaybe<SanitySpanFilterInput>;
};

export type SanitySpanSortInput = {
  _key?: InputMaybe<SortOrderEnum>;
  _type?: InputMaybe<SortOrderEnum>;
  marks?: InputMaybe<SortOrderEnum>;
  text?: InputMaybe<SortOrderEnum>;
};

export type SanityTheme = Node & SanityDocument & {
  _createdAt?: Maybe<Scalars['Date']>;
  _id?: Maybe<Scalars['String']>;
  _key?: Maybe<Scalars['String']>;
  _rawDescription?: Maybe<Scalars['JSON']>;
  _rawI18NBase?: Maybe<Scalars['JSON']>;
  _rawI18NRefs?: Maybe<Scalars['JSON']>;
  _rawLogo?: Maybe<Scalars['JSON']>;
  _rev?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  _updatedAt?: Maybe<Scalars['Date']>;
  children: Array<Node>;
  description?: Maybe<Array<Maybe<SanityBlock>>>;
  i18n_base?: Maybe<SanityTheme>;
  i18n_lang?: Maybe<Scalars['String']>;
  i18n_refs?: Maybe<Array<Maybe<SanityTheme>>>;
  id: Scalars['ID'];
  internal: Internal;
  logo?: Maybe<SanityImage>;
  name?: Maybe<Scalars['String']>;
  parent?: Maybe<Node>;
  subtitle?: Maybe<Scalars['String']>;
  themeColours?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};


export type SanityTheme_CreatedAtArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type SanityTheme_RawDescriptionArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityTheme_RawI18NBaseArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityTheme_RawI18NRefsArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityTheme_RawLogoArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityTheme_UpdatedAtArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type SanityThemeConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SanityThemeEdge>;
  group: Array<SanityThemeGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<SanityTheme>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SanityThemeConnectionDistinctArgs = {
  field: SanityThemeFieldSelector;
};


export type SanityThemeConnectionGroupArgs = {
  field: SanityThemeFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SanityThemeConnectionMaxArgs = {
  field: SanityThemeFieldSelector;
};


export type SanityThemeConnectionMinArgs = {
  field: SanityThemeFieldSelector;
};


export type SanityThemeConnectionSumArgs = {
  field: SanityThemeFieldSelector;
};

export type SanityThemeEdge = {
  next?: Maybe<SanityTheme>;
  node: SanityTheme;
  previous?: Maybe<SanityTheme>;
};

export type SanityThemeFieldSelector = {
  _createdAt?: InputMaybe<FieldSelectorEnum>;
  _id?: InputMaybe<FieldSelectorEnum>;
  _key?: InputMaybe<FieldSelectorEnum>;
  _rawDescription?: InputMaybe<FieldSelectorEnum>;
  _rawI18NBase?: InputMaybe<FieldSelectorEnum>;
  _rawI18NRefs?: InputMaybe<FieldSelectorEnum>;
  _rawLogo?: InputMaybe<FieldSelectorEnum>;
  _rev?: InputMaybe<FieldSelectorEnum>;
  _type?: InputMaybe<FieldSelectorEnum>;
  _updatedAt?: InputMaybe<FieldSelectorEnum>;
  children?: InputMaybe<NodeFieldSelector>;
  description?: InputMaybe<SanityBlockFieldSelector>;
  i18n_base?: InputMaybe<SanityThemeFieldSelector>;
  i18n_lang?: InputMaybe<FieldSelectorEnum>;
  i18n_refs?: InputMaybe<SanityThemeFieldSelector>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  logo?: InputMaybe<SanityImageFieldSelector>;
  name?: InputMaybe<FieldSelectorEnum>;
  parent?: InputMaybe<NodeFieldSelector>;
  subtitle?: InputMaybe<FieldSelectorEnum>;
  themeColours?: InputMaybe<FieldSelectorEnum>;
  title?: InputMaybe<FieldSelectorEnum>;
};

export type SanityThemeFilterInput = {
  _createdAt?: InputMaybe<DateQueryOperatorInput>;
  _id?: InputMaybe<StringQueryOperatorInput>;
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawDescription?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NBase?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NRefs?: InputMaybe<JsonQueryOperatorInput>;
  _rawLogo?: InputMaybe<JsonQueryOperatorInput>;
  _rev?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  _updatedAt?: InputMaybe<DateQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  description?: InputMaybe<SanityBlockFilterListInput>;
  i18n_base?: InputMaybe<SanityThemeFilterInput>;
  i18n_lang?: InputMaybe<StringQueryOperatorInput>;
  i18n_refs?: InputMaybe<SanityThemeFilterListInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  logo?: InputMaybe<SanityImageFilterInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  subtitle?: InputMaybe<StringQueryOperatorInput>;
  themeColours?: InputMaybe<StringQueryOperatorInput>;
  title?: InputMaybe<StringQueryOperatorInput>;
};

export type SanityThemeFilterListInput = {
  elemMatch?: InputMaybe<SanityThemeFilterInput>;
};

export type SanityThemeGroupConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SanityThemeEdge>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
  group: Array<SanityThemeGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<SanityTheme>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SanityThemeGroupConnectionDistinctArgs = {
  field: SanityThemeFieldSelector;
};


export type SanityThemeGroupConnectionGroupArgs = {
  field: SanityThemeFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SanityThemeGroupConnectionMaxArgs = {
  field: SanityThemeFieldSelector;
};


export type SanityThemeGroupConnectionMinArgs = {
  field: SanityThemeFieldSelector;
};


export type SanityThemeGroupConnectionSumArgs = {
  field: SanityThemeFieldSelector;
};

export type SanityThemeSortInput = {
  _createdAt?: InputMaybe<SortOrderEnum>;
  _id?: InputMaybe<SortOrderEnum>;
  _key?: InputMaybe<SortOrderEnum>;
  _rawDescription?: InputMaybe<SortOrderEnum>;
  _rawI18NBase?: InputMaybe<SortOrderEnum>;
  _rawI18NRefs?: InputMaybe<SortOrderEnum>;
  _rawLogo?: InputMaybe<SortOrderEnum>;
  _rev?: InputMaybe<SortOrderEnum>;
  _type?: InputMaybe<SortOrderEnum>;
  _updatedAt?: InputMaybe<SortOrderEnum>;
  children?: InputMaybe<NodeSortInput>;
  description?: InputMaybe<SanityBlockSortInput>;
  i18n_base?: InputMaybe<SanityThemeSortInput>;
  i18n_lang?: InputMaybe<SortOrderEnum>;
  i18n_refs?: InputMaybe<SanityThemeSortInput>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  logo?: InputMaybe<SanityImageSortInput>;
  name?: InputMaybe<SortOrderEnum>;
  parent?: InputMaybe<NodeSortInput>;
  subtitle?: InputMaybe<SortOrderEnum>;
  themeColours?: InputMaybe<SortOrderEnum>;
  title?: InputMaybe<SortOrderEnum>;
};

export type SanityVideoCta = Node & SanityDocument & {
  _createdAt?: Maybe<Scalars['Date']>;
  _id?: Maybe<Scalars['String']>;
  _key?: Maybe<Scalars['String']>;
  _rawI18NBase?: Maybe<Scalars['JSON']>;
  _rawI18NRefs?: Maybe<Scalars['JSON']>;
  _rawPlaceholderImage?: Maybe<Scalars['JSON']>;
  _rev?: Maybe<Scalars['String']>;
  _type?: Maybe<Scalars['String']>;
  _updatedAt?: Maybe<Scalars['Date']>;
  children: Array<Node>;
  i18n_base?: Maybe<SanityVideoCta>;
  i18n_lang?: Maybe<Scalars['String']>;
  i18n_refs?: Maybe<Array<Maybe<SanityVideoCta>>>;
  id: Scalars['ID'];
  internal: Internal;
  internalTitle?: Maybe<Scalars['String']>;
  parent?: Maybe<Node>;
  placeholderImage?: Maybe<SanityImage>;
  text?: Maybe<Scalars['String']>;
  videoUrl?: Maybe<Scalars['String']>;
};


export type SanityVideoCta_CreatedAtArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type SanityVideoCta_RawI18NBaseArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityVideoCta_RawI18NRefsArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityVideoCta_RawPlaceholderImageArgs = {
  resolveReferences?: InputMaybe<SanityResolveReferencesConfiguration>;
};


export type SanityVideoCta_UpdatedAtArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type SanityVideoCtaConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SanityVideoCtaEdge>;
  group: Array<SanityVideoCtaGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<SanityVideoCta>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SanityVideoCtaConnectionDistinctArgs = {
  field: SanityVideoCtaFieldSelector;
};


export type SanityVideoCtaConnectionGroupArgs = {
  field: SanityVideoCtaFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SanityVideoCtaConnectionMaxArgs = {
  field: SanityVideoCtaFieldSelector;
};


export type SanityVideoCtaConnectionMinArgs = {
  field: SanityVideoCtaFieldSelector;
};


export type SanityVideoCtaConnectionSumArgs = {
  field: SanityVideoCtaFieldSelector;
};

export type SanityVideoCtaEdge = {
  next?: Maybe<SanityVideoCta>;
  node: SanityVideoCta;
  previous?: Maybe<SanityVideoCta>;
};

export type SanityVideoCtaFieldSelector = {
  _createdAt?: InputMaybe<FieldSelectorEnum>;
  _id?: InputMaybe<FieldSelectorEnum>;
  _key?: InputMaybe<FieldSelectorEnum>;
  _rawI18NBase?: InputMaybe<FieldSelectorEnum>;
  _rawI18NRefs?: InputMaybe<FieldSelectorEnum>;
  _rawPlaceholderImage?: InputMaybe<FieldSelectorEnum>;
  _rev?: InputMaybe<FieldSelectorEnum>;
  _type?: InputMaybe<FieldSelectorEnum>;
  _updatedAt?: InputMaybe<FieldSelectorEnum>;
  children?: InputMaybe<NodeFieldSelector>;
  i18n_base?: InputMaybe<SanityVideoCtaFieldSelector>;
  i18n_lang?: InputMaybe<FieldSelectorEnum>;
  i18n_refs?: InputMaybe<SanityVideoCtaFieldSelector>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  internalTitle?: InputMaybe<FieldSelectorEnum>;
  parent?: InputMaybe<NodeFieldSelector>;
  placeholderImage?: InputMaybe<SanityImageFieldSelector>;
  text?: InputMaybe<FieldSelectorEnum>;
  videoUrl?: InputMaybe<FieldSelectorEnum>;
};

export type SanityVideoCtaFilterInput = {
  _createdAt?: InputMaybe<DateQueryOperatorInput>;
  _id?: InputMaybe<StringQueryOperatorInput>;
  _key?: InputMaybe<StringQueryOperatorInput>;
  _rawI18NBase?: InputMaybe<JsonQueryOperatorInput>;
  _rawI18NRefs?: InputMaybe<JsonQueryOperatorInput>;
  _rawPlaceholderImage?: InputMaybe<JsonQueryOperatorInput>;
  _rev?: InputMaybe<StringQueryOperatorInput>;
  _type?: InputMaybe<StringQueryOperatorInput>;
  _updatedAt?: InputMaybe<DateQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  i18n_base?: InputMaybe<SanityVideoCtaFilterInput>;
  i18n_lang?: InputMaybe<StringQueryOperatorInput>;
  i18n_refs?: InputMaybe<SanityVideoCtaFilterListInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  internalTitle?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  placeholderImage?: InputMaybe<SanityImageFilterInput>;
  text?: InputMaybe<StringQueryOperatorInput>;
  videoUrl?: InputMaybe<StringQueryOperatorInput>;
};

export type SanityVideoCtaFilterListInput = {
  elemMatch?: InputMaybe<SanityVideoCtaFilterInput>;
};

export type SanityVideoCtaGroupConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SanityVideoCtaEdge>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
  group: Array<SanityVideoCtaGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<SanityVideoCta>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SanityVideoCtaGroupConnectionDistinctArgs = {
  field: SanityVideoCtaFieldSelector;
};


export type SanityVideoCtaGroupConnectionGroupArgs = {
  field: SanityVideoCtaFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SanityVideoCtaGroupConnectionMaxArgs = {
  field: SanityVideoCtaFieldSelector;
};


export type SanityVideoCtaGroupConnectionMinArgs = {
  field: SanityVideoCtaFieldSelector;
};


export type SanityVideoCtaGroupConnectionSumArgs = {
  field: SanityVideoCtaFieldSelector;
};

export type SanityVideoCtaSortInput = {
  _createdAt?: InputMaybe<SortOrderEnum>;
  _id?: InputMaybe<SortOrderEnum>;
  _key?: InputMaybe<SortOrderEnum>;
  _rawI18NBase?: InputMaybe<SortOrderEnum>;
  _rawI18NRefs?: InputMaybe<SortOrderEnum>;
  _rawPlaceholderImage?: InputMaybe<SortOrderEnum>;
  _rev?: InputMaybe<SortOrderEnum>;
  _type?: InputMaybe<SortOrderEnum>;
  _updatedAt?: InputMaybe<SortOrderEnum>;
  children?: InputMaybe<NodeSortInput>;
  i18n_base?: InputMaybe<SanityVideoCtaSortInput>;
  i18n_lang?: InputMaybe<SortOrderEnum>;
  i18n_refs?: InputMaybe<SanityVideoCtaSortInput>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  internalTitle?: InputMaybe<SortOrderEnum>;
  parent?: InputMaybe<NodeSortInput>;
  placeholderImage?: InputMaybe<SanityImageSortInput>;
  text?: InputMaybe<SortOrderEnum>;
  videoUrl?: InputMaybe<SortOrderEnum>;
};

export type SearchPlayerByInput = {
  gameId?: InputMaybe<Scalars['String']>;
  type: SearchType;
  value: Scalars['String'];
};

/** Option type for players search */
export enum SearchType {
  Email = 'email',
  PlayerId = 'playerId',
  PublicName = 'publicName',
  TagNumber = 'tagNumber'
}

export type Settings = {
  POIName?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  defaultPoints: Scalars['Int'];
  lat?: Maybe<Scalars['Float']>;
  locationDistance: Scalars['Float'];
  locationDistanceMeters: Scalars['Int'];
  lon?: Maybe<Scalars['Float']>;
  maxSwipeTime: Scalars['Int'];
  minSwipeTime: Scalars['Int'];
  target: Scalars['Int'];
  timezone: Scalars['String'];
};

export type SettingsInput = {
  POIName?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  defaultPoints?: InputMaybe<Scalars['Int']>;
  lat?: InputMaybe<Scalars['Float']>;
  locationDistanceMeters?: InputMaybe<Scalars['Int']>;
  lon?: InputMaybe<Scalars['Float']>;
  maxSwipeTime?: InputMaybe<Scalars['Int']>;
  minSwipeTime?: InputMaybe<Scalars['Int']>;
  target?: InputMaybe<Scalars['Int']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Signup Player */
export type SignupPlayerInput = {
  email: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
};

export type Site = Node & {
  buildTime?: Maybe<Scalars['Date']>;
  children: Array<Node>;
  flags?: Maybe<SiteFlags>;
  graphqlTypegen?: Maybe<SiteGraphqlTypegen>;
  host?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  internal: Internal;
  jsxRuntime?: Maybe<Scalars['String']>;
  parent?: Maybe<Node>;
  pathPrefix?: Maybe<Scalars['String']>;
  polyfill?: Maybe<Scalars['Boolean']>;
  port?: Maybe<Scalars['Int']>;
  siteMetadata?: Maybe<SiteSiteMetadata>;
  trailingSlash?: Maybe<Scalars['String']>;
};


export type SiteBuildTimeArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type SiteBuildMetadata = Node & {
  buildTime?: Maybe<Scalars['Date']>;
  children: Array<Node>;
  id: Scalars['ID'];
  internal: Internal;
  parent?: Maybe<Node>;
};


export type SiteBuildMetadataBuildTimeArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type SiteBuildMetadataConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SiteBuildMetadataEdge>;
  group: Array<SiteBuildMetadataGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<SiteBuildMetadata>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SiteBuildMetadataConnectionDistinctArgs = {
  field: SiteBuildMetadataFieldSelector;
};


export type SiteBuildMetadataConnectionGroupArgs = {
  field: SiteBuildMetadataFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SiteBuildMetadataConnectionMaxArgs = {
  field: SiteBuildMetadataFieldSelector;
};


export type SiteBuildMetadataConnectionMinArgs = {
  field: SiteBuildMetadataFieldSelector;
};


export type SiteBuildMetadataConnectionSumArgs = {
  field: SiteBuildMetadataFieldSelector;
};

export type SiteBuildMetadataEdge = {
  next?: Maybe<SiteBuildMetadata>;
  node: SiteBuildMetadata;
  previous?: Maybe<SiteBuildMetadata>;
};

export type SiteBuildMetadataFieldSelector = {
  buildTime?: InputMaybe<FieldSelectorEnum>;
  children?: InputMaybe<NodeFieldSelector>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  parent?: InputMaybe<NodeFieldSelector>;
};

export type SiteBuildMetadataFilterInput = {
  buildTime?: InputMaybe<DateQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
};

export type SiteBuildMetadataGroupConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SiteBuildMetadataEdge>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
  group: Array<SiteBuildMetadataGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<SiteBuildMetadata>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SiteBuildMetadataGroupConnectionDistinctArgs = {
  field: SiteBuildMetadataFieldSelector;
};


export type SiteBuildMetadataGroupConnectionGroupArgs = {
  field: SiteBuildMetadataFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SiteBuildMetadataGroupConnectionMaxArgs = {
  field: SiteBuildMetadataFieldSelector;
};


export type SiteBuildMetadataGroupConnectionMinArgs = {
  field: SiteBuildMetadataFieldSelector;
};


export type SiteBuildMetadataGroupConnectionSumArgs = {
  field: SiteBuildMetadataFieldSelector;
};

export type SiteBuildMetadataSortInput = {
  buildTime?: InputMaybe<SortOrderEnum>;
  children?: InputMaybe<NodeSortInput>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  parent?: InputMaybe<NodeSortInput>;
};

export type SiteConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SiteEdge>;
  group: Array<SiteGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<Site>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SiteConnectionDistinctArgs = {
  field: SiteFieldSelector;
};


export type SiteConnectionGroupArgs = {
  field: SiteFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SiteConnectionMaxArgs = {
  field: SiteFieldSelector;
};


export type SiteConnectionMinArgs = {
  field: SiteFieldSelector;
};


export type SiteConnectionSumArgs = {
  field: SiteFieldSelector;
};

export type SiteEdge = {
  next?: Maybe<Site>;
  node: Site;
  previous?: Maybe<Site>;
};

export type SiteFieldSelector = {
  buildTime?: InputMaybe<FieldSelectorEnum>;
  children?: InputMaybe<NodeFieldSelector>;
  flags?: InputMaybe<SiteFlagsFieldSelector>;
  graphqlTypegen?: InputMaybe<SiteGraphqlTypegenFieldSelector>;
  host?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  jsxRuntime?: InputMaybe<FieldSelectorEnum>;
  parent?: InputMaybe<NodeFieldSelector>;
  pathPrefix?: InputMaybe<FieldSelectorEnum>;
  polyfill?: InputMaybe<FieldSelectorEnum>;
  port?: InputMaybe<FieldSelectorEnum>;
  siteMetadata?: InputMaybe<SiteSiteMetadataFieldSelector>;
  trailingSlash?: InputMaybe<FieldSelectorEnum>;
};

export type SiteFilterInput = {
  buildTime?: InputMaybe<DateQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  flags?: InputMaybe<SiteFlagsFilterInput>;
  graphqlTypegen?: InputMaybe<SiteGraphqlTypegenFilterInput>;
  host?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  jsxRuntime?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  pathPrefix?: InputMaybe<StringQueryOperatorInput>;
  polyfill?: InputMaybe<BooleanQueryOperatorInput>;
  port?: InputMaybe<IntQueryOperatorInput>;
  siteMetadata?: InputMaybe<SiteSiteMetadataFilterInput>;
  trailingSlash?: InputMaybe<StringQueryOperatorInput>;
};

export type SiteFlags = {
  DEV_SSR?: Maybe<Scalars['Boolean']>;
};

export type SiteFlagsFieldSelector = {
  DEV_SSR?: InputMaybe<FieldSelectorEnum>;
};

export type SiteFlagsFilterInput = {
  DEV_SSR?: InputMaybe<BooleanQueryOperatorInput>;
};

export type SiteFlagsSortInput = {
  DEV_SSR?: InputMaybe<SortOrderEnum>;
};

export type SiteFunction = Node & {
  absoluteCompiledFilePath: Scalars['String'];
  children: Array<Node>;
  functionRoute: Scalars['String'];
  id: Scalars['ID'];
  internal: Internal;
  matchPath?: Maybe<Scalars['String']>;
  originalAbsoluteFilePath: Scalars['String'];
  originalRelativeFilePath: Scalars['String'];
  parent?: Maybe<Node>;
  pluginName: Scalars['String'];
  relativeCompiledFilePath: Scalars['String'];
};

export type SiteFunctionConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SiteFunctionEdge>;
  group: Array<SiteFunctionGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<SiteFunction>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SiteFunctionConnectionDistinctArgs = {
  field: SiteFunctionFieldSelector;
};


export type SiteFunctionConnectionGroupArgs = {
  field: SiteFunctionFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SiteFunctionConnectionMaxArgs = {
  field: SiteFunctionFieldSelector;
};


export type SiteFunctionConnectionMinArgs = {
  field: SiteFunctionFieldSelector;
};


export type SiteFunctionConnectionSumArgs = {
  field: SiteFunctionFieldSelector;
};

export type SiteFunctionEdge = {
  next?: Maybe<SiteFunction>;
  node: SiteFunction;
  previous?: Maybe<SiteFunction>;
};

export type SiteFunctionFieldSelector = {
  absoluteCompiledFilePath?: InputMaybe<FieldSelectorEnum>;
  children?: InputMaybe<NodeFieldSelector>;
  functionRoute?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  matchPath?: InputMaybe<FieldSelectorEnum>;
  originalAbsoluteFilePath?: InputMaybe<FieldSelectorEnum>;
  originalRelativeFilePath?: InputMaybe<FieldSelectorEnum>;
  parent?: InputMaybe<NodeFieldSelector>;
  pluginName?: InputMaybe<FieldSelectorEnum>;
  relativeCompiledFilePath?: InputMaybe<FieldSelectorEnum>;
};

export type SiteFunctionFilterInput = {
  absoluteCompiledFilePath?: InputMaybe<StringQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  functionRoute?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  matchPath?: InputMaybe<StringQueryOperatorInput>;
  originalAbsoluteFilePath?: InputMaybe<StringQueryOperatorInput>;
  originalRelativeFilePath?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  pluginName?: InputMaybe<StringQueryOperatorInput>;
  relativeCompiledFilePath?: InputMaybe<StringQueryOperatorInput>;
};

export type SiteFunctionGroupConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SiteFunctionEdge>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
  group: Array<SiteFunctionGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<SiteFunction>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SiteFunctionGroupConnectionDistinctArgs = {
  field: SiteFunctionFieldSelector;
};


export type SiteFunctionGroupConnectionGroupArgs = {
  field: SiteFunctionFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SiteFunctionGroupConnectionMaxArgs = {
  field: SiteFunctionFieldSelector;
};


export type SiteFunctionGroupConnectionMinArgs = {
  field: SiteFunctionFieldSelector;
};


export type SiteFunctionGroupConnectionSumArgs = {
  field: SiteFunctionFieldSelector;
};

export type SiteFunctionSortInput = {
  absoluteCompiledFilePath?: InputMaybe<SortOrderEnum>;
  children?: InputMaybe<NodeSortInput>;
  functionRoute?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  matchPath?: InputMaybe<SortOrderEnum>;
  originalAbsoluteFilePath?: InputMaybe<SortOrderEnum>;
  originalRelativeFilePath?: InputMaybe<SortOrderEnum>;
  parent?: InputMaybe<NodeSortInput>;
  pluginName?: InputMaybe<SortOrderEnum>;
  relativeCompiledFilePath?: InputMaybe<SortOrderEnum>;
};

export type SiteGraphqlTypegen = {
  documentSearchPaths?: Maybe<Array<Maybe<Scalars['String']>>>;
  generateOnBuild?: Maybe<Scalars['Boolean']>;
  typesOutputPath?: Maybe<Scalars['String']>;
};

export type SiteGraphqlTypegenFieldSelector = {
  documentSearchPaths?: InputMaybe<FieldSelectorEnum>;
  generateOnBuild?: InputMaybe<FieldSelectorEnum>;
  typesOutputPath?: InputMaybe<FieldSelectorEnum>;
};

export type SiteGraphqlTypegenFilterInput = {
  documentSearchPaths?: InputMaybe<StringQueryOperatorInput>;
  generateOnBuild?: InputMaybe<BooleanQueryOperatorInput>;
  typesOutputPath?: InputMaybe<StringQueryOperatorInput>;
};

export type SiteGraphqlTypegenSortInput = {
  documentSearchPaths?: InputMaybe<SortOrderEnum>;
  generateOnBuild?: InputMaybe<SortOrderEnum>;
  typesOutputPath?: InputMaybe<SortOrderEnum>;
};

export type SiteGroupConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SiteEdge>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
  group: Array<SiteGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<Site>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SiteGroupConnectionDistinctArgs = {
  field: SiteFieldSelector;
};


export type SiteGroupConnectionGroupArgs = {
  field: SiteFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SiteGroupConnectionMaxArgs = {
  field: SiteFieldSelector;
};


export type SiteGroupConnectionMinArgs = {
  field: SiteFieldSelector;
};


export type SiteGroupConnectionSumArgs = {
  field: SiteFieldSelector;
};

export type SitePage = Node & {
  children: Array<Node>;
  component: Scalars['String'];
  componentChunkName: Scalars['String'];
  id: Scalars['ID'];
  internal: Internal;
  internalComponentName: Scalars['String'];
  matchPath?: Maybe<Scalars['String']>;
  pageContext?: Maybe<Scalars['JSON']>;
  parent?: Maybe<Node>;
  path: Scalars['String'];
  pluginCreator?: Maybe<SitePlugin>;
};

export type SitePageConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SitePageEdge>;
  group: Array<SitePageGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<SitePage>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SitePageConnectionDistinctArgs = {
  field: SitePageFieldSelector;
};


export type SitePageConnectionGroupArgs = {
  field: SitePageFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SitePageConnectionMaxArgs = {
  field: SitePageFieldSelector;
};


export type SitePageConnectionMinArgs = {
  field: SitePageFieldSelector;
};


export type SitePageConnectionSumArgs = {
  field: SitePageFieldSelector;
};

export type SitePageEdge = {
  next?: Maybe<SitePage>;
  node: SitePage;
  previous?: Maybe<SitePage>;
};

export type SitePageFieldSelector = {
  children?: InputMaybe<NodeFieldSelector>;
  component?: InputMaybe<FieldSelectorEnum>;
  componentChunkName?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  internalComponentName?: InputMaybe<FieldSelectorEnum>;
  matchPath?: InputMaybe<FieldSelectorEnum>;
  pageContext?: InputMaybe<FieldSelectorEnum>;
  parent?: InputMaybe<NodeFieldSelector>;
  path?: InputMaybe<FieldSelectorEnum>;
  pluginCreator?: InputMaybe<SitePluginFieldSelector>;
};

export type SitePageFilterInput = {
  children?: InputMaybe<NodeFilterListInput>;
  component?: InputMaybe<StringQueryOperatorInput>;
  componentChunkName?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  internalComponentName?: InputMaybe<StringQueryOperatorInput>;
  matchPath?: InputMaybe<StringQueryOperatorInput>;
  pageContext?: InputMaybe<JsonQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  path?: InputMaybe<StringQueryOperatorInput>;
  pluginCreator?: InputMaybe<SitePluginFilterInput>;
};

export type SitePageGroupConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SitePageEdge>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
  group: Array<SitePageGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<SitePage>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SitePageGroupConnectionDistinctArgs = {
  field: SitePageFieldSelector;
};


export type SitePageGroupConnectionGroupArgs = {
  field: SitePageFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SitePageGroupConnectionMaxArgs = {
  field: SitePageFieldSelector;
};


export type SitePageGroupConnectionMinArgs = {
  field: SitePageFieldSelector;
};


export type SitePageGroupConnectionSumArgs = {
  field: SitePageFieldSelector;
};

export type SitePageSortInput = {
  children?: InputMaybe<NodeSortInput>;
  component?: InputMaybe<SortOrderEnum>;
  componentChunkName?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  internalComponentName?: InputMaybe<SortOrderEnum>;
  matchPath?: InputMaybe<SortOrderEnum>;
  pageContext?: InputMaybe<SortOrderEnum>;
  parent?: InputMaybe<NodeSortInput>;
  path?: InputMaybe<SortOrderEnum>;
  pluginCreator?: InputMaybe<SitePluginSortInput>;
};

export type SitePlugin = Node & {
  browserAPIs?: Maybe<Array<Maybe<Scalars['String']>>>;
  children: Array<Node>;
  id: Scalars['ID'];
  internal: Internal;
  name?: Maybe<Scalars['String']>;
  nodeAPIs?: Maybe<Array<Maybe<Scalars['String']>>>;
  packageJson?: Maybe<Scalars['JSON']>;
  parent?: Maybe<Node>;
  pluginFilepath?: Maybe<Scalars['String']>;
  pluginOptions?: Maybe<Scalars['JSON']>;
  resolve?: Maybe<Scalars['String']>;
  ssrAPIs?: Maybe<Array<Maybe<Scalars['String']>>>;
  version?: Maybe<Scalars['String']>;
};

export type SitePluginConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SitePluginEdge>;
  group: Array<SitePluginGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<SitePlugin>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SitePluginConnectionDistinctArgs = {
  field: SitePluginFieldSelector;
};


export type SitePluginConnectionGroupArgs = {
  field: SitePluginFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SitePluginConnectionMaxArgs = {
  field: SitePluginFieldSelector;
};


export type SitePluginConnectionMinArgs = {
  field: SitePluginFieldSelector;
};


export type SitePluginConnectionSumArgs = {
  field: SitePluginFieldSelector;
};

export type SitePluginEdge = {
  next?: Maybe<SitePlugin>;
  node: SitePlugin;
  previous?: Maybe<SitePlugin>;
};

export type SitePluginFieldSelector = {
  browserAPIs?: InputMaybe<FieldSelectorEnum>;
  children?: InputMaybe<NodeFieldSelector>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  name?: InputMaybe<FieldSelectorEnum>;
  nodeAPIs?: InputMaybe<FieldSelectorEnum>;
  packageJson?: InputMaybe<FieldSelectorEnum>;
  parent?: InputMaybe<NodeFieldSelector>;
  pluginFilepath?: InputMaybe<FieldSelectorEnum>;
  pluginOptions?: InputMaybe<FieldSelectorEnum>;
  resolve?: InputMaybe<FieldSelectorEnum>;
  ssrAPIs?: InputMaybe<FieldSelectorEnum>;
  version?: InputMaybe<FieldSelectorEnum>;
};

export type SitePluginFilterInput = {
  browserAPIs?: InputMaybe<StringQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  nodeAPIs?: InputMaybe<StringQueryOperatorInput>;
  packageJson?: InputMaybe<JsonQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  pluginFilepath?: InputMaybe<StringQueryOperatorInput>;
  pluginOptions?: InputMaybe<JsonQueryOperatorInput>;
  resolve?: InputMaybe<StringQueryOperatorInput>;
  ssrAPIs?: InputMaybe<StringQueryOperatorInput>;
  version?: InputMaybe<StringQueryOperatorInput>;
};

export type SitePluginGroupConnection = {
  distinct: Array<Scalars['String']>;
  edges: Array<SitePluginEdge>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
  group: Array<SitePluginGroupConnection>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  nodes: Array<SitePlugin>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SitePluginGroupConnectionDistinctArgs = {
  field: SitePluginFieldSelector;
};


export type SitePluginGroupConnectionGroupArgs = {
  field: SitePluginFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SitePluginGroupConnectionMaxArgs = {
  field: SitePluginFieldSelector;
};


export type SitePluginGroupConnectionMinArgs = {
  field: SitePluginFieldSelector;
};


export type SitePluginGroupConnectionSumArgs = {
  field: SitePluginFieldSelector;
};

export type SitePluginSortInput = {
  browserAPIs?: InputMaybe<SortOrderEnum>;
  children?: InputMaybe<NodeSortInput>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  name?: InputMaybe<SortOrderEnum>;
  nodeAPIs?: InputMaybe<SortOrderEnum>;
  packageJson?: InputMaybe<SortOrderEnum>;
  parent?: InputMaybe<NodeSortInput>;
  pluginFilepath?: InputMaybe<SortOrderEnum>;
  pluginOptions?: InputMaybe<SortOrderEnum>;
  resolve?: InputMaybe<SortOrderEnum>;
  ssrAPIs?: InputMaybe<SortOrderEnum>;
  version?: InputMaybe<SortOrderEnum>;
};

export type SiteSiteMetadata = {
  author?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  siteUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type SiteSiteMetadataFieldSelector = {
  author?: InputMaybe<FieldSelectorEnum>;
  description?: InputMaybe<FieldSelectorEnum>;
  siteUrl?: InputMaybe<FieldSelectorEnum>;
  title?: InputMaybe<FieldSelectorEnum>;
};

export type SiteSiteMetadataFilterInput = {
  author?: InputMaybe<StringQueryOperatorInput>;
  description?: InputMaybe<StringQueryOperatorInput>;
  siteUrl?: InputMaybe<StringQueryOperatorInput>;
  title?: InputMaybe<StringQueryOperatorInput>;
};

export type SiteSiteMetadataSortInput = {
  author?: InputMaybe<SortOrderEnum>;
  description?: InputMaybe<SortOrderEnum>;
  siteUrl?: InputMaybe<SortOrderEnum>;
  title?: InputMaybe<SortOrderEnum>;
};

export type SiteSortInput = {
  buildTime?: InputMaybe<SortOrderEnum>;
  children?: InputMaybe<NodeSortInput>;
  flags?: InputMaybe<SiteFlagsSortInput>;
  graphqlTypegen?: InputMaybe<SiteGraphqlTypegenSortInput>;
  host?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  jsxRuntime?: InputMaybe<SortOrderEnum>;
  parent?: InputMaybe<NodeSortInput>;
  pathPrefix?: InputMaybe<SortOrderEnum>;
  polyfill?: InputMaybe<SortOrderEnum>;
  port?: InputMaybe<SortOrderEnum>;
  siteMetadata?: InputMaybe<SiteSiteMetadataSortInput>;
  trailingSlash?: InputMaybe<SortOrderEnum>;
};

export type SortKeyBoolean = {
  attributeExists?: InputMaybe<Scalars['Boolean']>;
  eq?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
};

export type SortKeyNumber = {
  attributeExists?: InputMaybe<Scalars['Boolean']>;
  eq?: InputMaybe<Scalars['Float']>;
  ge?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  le?: InputMaybe<Scalars['Float']>;
  lt?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
};

export enum SortOrderEnum {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StringQueryOperatorInput = {
  eq?: InputMaybe<Scalars['String']>;
  glob?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['String']>;
};

export type SubrangeFilter = {
  from?: InputMaybe<SortKeyNumber>;
  isApproved?: InputMaybe<SortKeyBoolean>;
  isLocked?: InputMaybe<SortKeyBoolean>;
  to?: InputMaybe<SortKeyNumber>;
};

/** Game sub-ranges types */
export enum SubrangesTypes {
  Custom = 'custom',
  DistributionPoint = 'distributionPoint',
  LocalTeamSpares = 'localTeamSpares',
  Team = 'team'
}

export type Survey = {
  active?: Maybe<Scalars['String']>;
  bame?: Maybe<AnswerType>;
  condition?: Maybe<AnswerType>;
  confirmedDate: Scalars['String'];
  count: Scalars['Int'];
  createdAt: Scalars['String'];
  disability?: Maybe<AnswerType>;
  gameId: Scalars['String'];
  id: Scalars['String'];
  isChild?: Maybe<Scalars['Boolean']>;
  isConfirmed: Scalars['Boolean'];
  lastResponseId: Scalars['String'];
  playerId: Scalars['String'];
  status: SurveyStatus;
  surveyType: SurveyTypes;
};

export type SurveyDataShared = {
  link: Scalars['String'];
  surveyID: Scalars['String'];
};

export type SurveyDataSharedInput = {
  link: Scalars['String'];
  surveyID: Scalars['String'];
};

export type SurveyOptions = {
  closing?: Maybe<ClosingSurvey>;
  oneYear?: Maybe<AfterGameSurvey>;
  sixMonths?: Maybe<AfterGameSurvey>;
  tellUsAboutYou?: Maybe<SurveyDataShared>;
};

export type SurveyOptionsInput = {
  closing?: InputMaybe<ClosingSurveyInput>;
  oneYear?: InputMaybe<AfterGameSurveyInput>;
  sixMonths?: InputMaybe<AfterGameSurveyInput>;
  tellUsAboutYou?: InputMaybe<SurveyDataSharedInput>;
};

export type SurveySharedInput = {
  confirmedDate?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['String']>;
  gameId: Scalars['String'];
  isConfirmed?: InputMaybe<Scalars['Boolean']>;
  lastModified?: InputMaybe<Scalars['String']>;
  playerId: Scalars['String'];
  surveyType: SurveyTypes;
};

/** The status of the survey response */
export enum SurveyStatus {
  Completed = 'completed',
  Disqualified = 'disqualified',
  Overquota = 'overquota',
  Partial = 'partial'
}

/** Types of surveys */
export enum SurveyTypes {
  Closing = 'closing',
  OneYear = 'oneYear',
  SixMonths = 'sixMonths',
  TellUsAboutYou = 'tellUsAboutYou'
}

export type Swipe = {
  controlID?: Maybe<Scalars['Int']>;
  createdAt: Scalars['String'];
  gameId: Scalars['String'];
  id: Scalars['String'];
  locationId?: Maybe<Scalars['String']>;
  locationName?: Maybe<Scalars['String']>;
  status: SwipeStatus;
  tagNumber: Scalars['Int'];
  timestamp: Scalars['String'];
  wtuLat?: Maybe<Scalars['Float']>;
  wtuLng?: Maybe<Scalars['Float']>;
  wtuSequence?: Maybe<Scalars['Int']>;
  wtuSerial?: Maybe<Scalars['Int']>;
};

export type SwipeLocation = {
  id: Scalars['String'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

/** SwipeStatus */
export enum SwipeStatus {
  Duplicated = 'duplicated',
  Handled = 'handled',
  Init = 'init',
  Invalid = 'invalid',
  Unknown = 'unknown'
}

export type SwipesActivity = {
  location: SwipeLocation;
  swipes: Scalars['Float'];
};

export type SwipesFrequenciesDaily = {
  fri: Scalars['Float'];
  mon: Scalars['Float'];
  sat: Scalars['Float'];
  sun: Scalars['Float'];
  thu: Scalars['Float'];
  tue: Scalars['Float'];
  wed: Scalars['Float'];
};

export type SwipesFrequenciesHourly = {
  h0: Scalars['Float'];
  h1: Scalars['Float'];
  h2: Scalars['Float'];
  h3: Scalars['Float'];
  h4: Scalars['Float'];
  h5: Scalars['Float'];
  h6: Scalars['Float'];
  h7: Scalars['Float'];
  h8: Scalars['Float'];
  h9: Scalars['Float'];
  h10: Scalars['Float'];
  h11: Scalars['Float'];
  h12: Scalars['Float'];
  h13: Scalars['Float'];
  h14: Scalars['Float'];
  h15: Scalars['Float'];
  h16: Scalars['Float'];
  h17: Scalars['Float'];
  h18: Scalars['Float'];
  h19: Scalars['Float'];
  h20: Scalars['Float'];
  h21: Scalars['Float'];
  h22: Scalars['Float'];
  h23: Scalars['Float'];
};

export type SwipesFrequenciesHourlyChart = {
  visited0003: SwipesFrequenciesTypes;
  visited0306: SwipesFrequenciesTypes;
  visited0609: SwipesFrequenciesTypes;
  visited0912: SwipesFrequenciesTypes;
  visited1215: SwipesFrequenciesTypes;
  visited1518: SwipesFrequenciesTypes;
  visited1820: SwipesFrequenciesTypes;
  visited2100: SwipesFrequenciesTypes;
};

export type SwipesFrequenciesTypes = {
  app: Scalars['Float'];
  card: Scalars['Float'];
};

export type TagGlobalRange = {
  createdAt: Scalars['String'];
  deliveryDate?: Maybe<Scalars['String']>;
  end: Scalars['Int'];
  id: Scalars['String'];
  name: Scalars['String'];
  quantity: Scalars['Int'];
  start: Scalars['Int'];
  status: CardOrderStatus;
  supplier?: Maybe<Scalars['String']>;
  type: OrderTagTypes;
};

export type TagGlobalRangeCreateInput = {
  deliveryDate?: InputMaybe<Scalars['String']>;
  end: Scalars['Int'];
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  quantity: Scalars['Int'];
  start: Scalars['Int'];
  status: CardOrderStatus;
  supplier?: InputMaybe<Scalars['String']>;
};

export type TagGlobalRangeUpdateInput = {
  deliveryDate?: InputMaybe<Scalars['String']>;
  end: Scalars['Int'];
  id: Scalars['String'];
  name: Scalars['String'];
  quantity: Scalars['Int'];
  start: Scalars['Int'];
  status: CardOrderStatus;
  supplier?: InputMaybe<Scalars['String']>;
};

/** Option type for players to collect points */
export enum TagTypes {
  App = 'app',
  Card = 'card',
  Fob = 'fob'
}

/** Types of tag */
export enum TagsTypes {
  Card = 'card',
  Fob = 'fob'
}

export type TargetedEmailsSetting = {
  gameCountdown: Scalars['Boolean'];
  noActivity: Scalars['Boolean'];
  stoppedPlaying: Scalars['Boolean'];
};

export type TargetedEmailsSettingInput = {
  gameCountdown: Scalars['Boolean'];
  noActivity: Scalars['Boolean'];
  stoppedPlaying: Scalars['Boolean'];
};

export type Team = {
  all: Scalars['Float'];
  /** Team details. Always accessible in resolver. */
  details: TeamDetails;
  extra: Scalars['Float'];
  gameId: Scalars['String'];
  gems: Scalars['Float'];
  id: Scalars['String'];
  leaderboardId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  routes: Scalars['Float'];
  status: TeamStatus;
  /** Tag sub-ranges connected to team. Always accessible in resolver. */
  subranges: Array<GameTagSubrange>;
  totalMembers: Scalars['Float'];
  type: TeamTypes;
};

/** Create Team */
export type TeamCreateInput = {
  details: TeamDetailsCreateInput;
  gameId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  leaderboardId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  status?: InputMaybe<TeamStatus>;
  type: TeamTypes;
};

/** Delete Team */
export type TeamDeleteInput = {
  gameId: Scalars['String'];
  id: Scalars['String'];
};

export type TeamDetails = {
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  leaders?: Maybe<Array<Scalars['String']>>;
  leadersEmails?: Maybe<Array<Scalars['String']>>;
  rejectionReason?: Maybe<Scalars['String']>;
  rollNumber?: Maybe<Scalars['Int']>;
};

/** Create Team Details */
export type TeamDetailsCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  gameId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  rejectionReason?: InputMaybe<Scalars['String']>;
  rollNumber?: InputMaybe<Scalars['Int']>;
};

/** Update Team Details */
export type TeamDetailsUpdateInput = {
  description?: InputMaybe<Scalars['String']>;
  gameId: Scalars['String'];
  id: Scalars['String'];
  leadersEmails?: InputMaybe<Array<Scalars['String']>>;
  rejectionReason?: InputMaybe<Scalars['String']>;
  rollNumber?: InputMaybe<Scalars['Int']>;
};

export type TeamFilterInput = {
  SENSchool: Scalars['Boolean'];
  charity: Scalars['Boolean'];
  community: Scalars['Boolean'];
  cycling: Scalars['Boolean'];
  noTeam: Scalars['Boolean'];
  running: Scalars['Boolean'];
  school: Scalars['Boolean'];
  workplace: Scalars['Boolean'];
};

export type TeamMessageContent = {
  body: Scalars['String'];
  title: Scalars['String'];
};

export type TeamNames = {
  teamNames: Array<Scalars['String']>;
};

/** Team status */
export enum TeamStatus {
  Approved = 'approved',
  Pending = 'pending',
  Rejected = 'rejected'
}

/** Team types */
export enum TeamTypes {
  SenSchool = 'SENSchool',
  Charity = 'charity',
  Community = 'community',
  Cycling = 'cycling',
  Running = 'running',
  School = 'school',
  Workplace = 'workplace'
}

/** Update Team */
export type TeamUpdateInput = {
  details?: InputMaybe<TeamDetailsUpdateInput>;
  gameId: Scalars['String'];
  id: Scalars['String'];
  leaderboardId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<TeamStatus>;
  type?: InputMaybe<TeamTypes>;
};

export type TeamV2 = {
  createdAt: Scalars['String'];
  createdBy: Scalars['String'];
  gameId: Scalars['String'];
  name: Scalars['String'];
  parentTeamId?: Maybe<Scalars['String']>;
  teamId: Scalars['String'];
};

export type TeamV2Membership = {
  isLeader: Scalars['Boolean'];
  joinedAt: Scalars['String'];
  playerId: Scalars['String'];
  teamId: Scalars['String'];
};

export type Timing = {
  endTime: Scalars['String'];
  startTime: Scalars['String'];
};

export type TimingInput = {
  endTime: Scalars['String'];
  startTime: Scalars['String'];
};

export type TransformOptions = {
  cropFocus?: InputMaybe<ImageCropFocus>;
  duotone?: InputMaybe<DuotoneGradient>;
  fit?: InputMaybe<ImageFit>;
  grayscale?: InputMaybe<Scalars['Boolean']>;
  rotate?: InputMaybe<Scalars['Int']>;
  trim?: InputMaybe<Scalars['Float']>;
};

/** Update Game Info */
export type UpdateGameInfoInput = {
  anticipation?: InputMaybe<Scalars['String']>;
  anticipationStartsAt?: InputMaybe<Scalars['String']>;
  boundingBox?: InputMaybe<Scalars['String']>;
  endCountdownDays?: InputMaybe<Scalars['Float']>;
  endsAt?: InputMaybe<Scalars['String']>;
  helpWidget?: InputMaybe<HelpWidget>;
  hideOnLanding?: InputMaybe<Scalars['Boolean']>;
  isMobileGame?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<GameRegion>;
  restrictAtDays?: InputMaybe<Scalars['Float']>;
  sanityID?: InputMaybe<Scalars['String']>;
  settings?: InputMaybe<SettingsInput>;
  slug?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<GameStatus>;
  surveys?: InputMaybe<SurveyOptionsInput>;
  sustainEndsAt?: InputMaybe<Scalars['String']>;
  targetedEmails?: InputMaybe<TargetedEmailsSettingInput>;
  teamsStartsAt?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<GameType>;
};

/** Update Game */
export type UpdateGameInput = {
  id: Scalars['String'];
  info?: InputMaybe<UpdateGameInfoInput>;
};

/** Update Group */
export type UpdateGroupInput = {
  color?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  gameId: Scalars['String'];
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
};

/** Update player */
export type UpdatePlayerInput = {
  ageGroup?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  info?: InputMaybe<PlayerInfoInput>;
  profile?: InputMaybe<PlayerProfileInput>;
};

export type UserAttributes = {
  AdultIsActive: Scalars['String'];
  ClosingSurveyCompleted: Scalars['Boolean'];
  EthCulDiverse: Scalars['String'];
  HealthSurveyCompleted: Scalars['Boolean'];
  MedicalCondition: Scalars['String'];
};

export type ValidateAnswers = {
  days: ValidateSurveyAnswer;
  flag: ValidateSurveyAnswer;
  hours: ValidateSurveyAnswer;
  minutes: ValidateSurveyAnswer;
};

export type ValidateExtraQuestions = {
  bame: ValidateSurveyQuestion;
  condition: ValidateSurveyQuestion;
  disability: ValidateSurveyQuestion;
};

export type ValidateQuestions = {
  days: ValidateSurveyQuestion;
  flag: ValidateSurveyQuestion;
  hours: ValidateSurveyQuestion;
  minutes: ValidateSurveyQuestion;
};

export type ValidateSurveyAnswer = {
  errors: Scalars['JSON'];
  status: ValidateSurveyStatus;
};

export type ValidateSurveyQuestion = {
  message: Scalars['String'];
  status: ValidateSurveyStatus;
};

export type ValidateSurveyResponse = {
  adultAnswers: ValidateAnswers;
  adultQuestions: ValidateQuestions;
  childrenAnswers: ValidateAnswers;
  childrenQuestions: ValidateQuestions;
  extraQuestions: ValidateExtraQuestions;
};

/** Status of survey validation. */
export enum ValidateSurveyStatus {
  Failed = 'failed',
  Success = 'success'
}

export type WebPOptions = {
  quality?: InputMaybe<Scalars['Int']>;
};

export type PlayerSurveysQueryVariables = Exact<{
  gameId: Scalars['String'];
  playerId: Scalars['String'];
}>;


export type PlayerSurveysQuery = { findPlayerSurveys: Array<{ surveyType: SurveyTypes }> };

export type GetGameSurveyInfoQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
}>;


export type GetGameSurveyInfoQuery = { getGame: { id: string, info: { surveys?: { tellUsAboutYou?: { link: string } | null, closing?: { link: string, shownFromDate: string } | null } | null } } };

export type SignupPlayerMutationVariables = Exact<{
  input: SignupPlayerInput;
}>;


export type SignupPlayerMutation = { signup: { id: string } };

export type UserFragment = { id: string, role: { authID?: string | null, isInstaller?: boolean | null, isChild?: boolean | null, parentId?: string | null, policies?: Array<{ name: string, options?: any | null }> | null }, tags: Array<{ tagType: TagTypes, tagNumber: number, deviceID?: string | null }>, team?: { name: string, leaderboardId?: string | null, all: number, gems: number, totalMembers: number, type: TeamTypes, details: { leaders?: Array<string> | null, leadersEmails?: Array<string> | null, description?: string | null, rejectionReason?: string | null } } | null, info: { gameId?: string | null, teamId?: string | null, publicName?: string | null }, profile: { firstName?: string | null, lastName?: string | null, fullName?: string | null, email: string, birthDate?: string | null, gender?: string | null, allowMarketingEmails?: boolean | null, isRegistered?: boolean | null, isVerified?: boolean | null, postCode?: string | null, lsoaCode?: string | null, ageGroup?: string | null }, points?: { all: number, gems: number } | null };

export type AuthPlayerQueryVariables = Exact<{
  authID: Scalars['String'];
}>;


export type AuthPlayerQuery = { getPlayerByAuth: { id: string, role: { authID?: string | null, isInstaller?: boolean | null, isChild?: boolean | null, parentId?: string | null, policies?: Array<{ name: string, options?: any | null }> | null }, tags: Array<{ tagType: TagTypes, tagNumber: number, deviceID?: string | null }>, team?: { name: string, leaderboardId?: string | null, all: number, gems: number, totalMembers: number, type: TeamTypes, details: { leaders?: Array<string> | null, leadersEmails?: Array<string> | null, description?: string | null, rejectionReason?: string | null } } | null, info: { gameId?: string | null, teamId?: string | null, publicName?: string | null }, profile: { firstName?: string | null, lastName?: string | null, fullName?: string | null, email: string, birthDate?: string | null, gender?: string | null, allowMarketingEmails?: boolean | null, isRegistered?: boolean | null, isVerified?: boolean | null, postCode?: string | null, lsoaCode?: string | null, ageGroup?: string | null }, points?: { all: number, gems: number } | null } };

export type GetPlayerByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPlayerByIdQuery = { getPlayer: { id: string, role: { authID?: string | null, isInstaller?: boolean | null, isChild?: boolean | null, parentId?: string | null, policies?: Array<{ name: string, options?: any | null }> | null }, tags: Array<{ tagType: TagTypes, tagNumber: number, deviceID?: string | null }>, team?: { name: string, leaderboardId?: string | null, all: number, gems: number, totalMembers: number, type: TeamTypes, details: { leaders?: Array<string> | null, leadersEmails?: Array<string> | null, description?: string | null, rejectionReason?: string | null } } | null, info: { gameId?: string | null, teamId?: string | null, publicName?: string | null }, profile: { firstName?: string | null, lastName?: string | null, fullName?: string | null, email: string, birthDate?: string | null, gender?: string | null, allowMarketingEmails?: boolean | null, isRegistered?: boolean | null, isVerified?: boolean | null, postCode?: string | null, lsoaCode?: string | null, ageGroup?: string | null }, points?: { all: number, gems: number } | null } };

export type LocalPlayerQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type LocalPlayerQuery = { getPlayerByEmail: { id: string, role: { authID?: string | null, isInstaller?: boolean | null, isChild?: boolean | null, parentId?: string | null, policies?: Array<{ name: string, options?: any | null }> | null }, tags: Array<{ tagType: TagTypes, tagNumber: number, deviceID?: string | null }>, team?: { name: string, leaderboardId?: string | null, all: number, gems: number, totalMembers: number, type: TeamTypes, details: { leaders?: Array<string> | null, leadersEmails?: Array<string> | null, description?: string | null, rejectionReason?: string | null } } | null, info: { gameId?: string | null, teamId?: string | null, publicName?: string | null }, profile: { firstName?: string | null, lastName?: string | null, fullName?: string | null, email: string, birthDate?: string | null, gender?: string | null, allowMarketingEmails?: boolean | null, isRegistered?: boolean | null, isVerified?: boolean | null, postCode?: string | null, lsoaCode?: string | null, ageGroup?: string | null }, points?: { all: number, gems: number } | null } };

export type FindFamilyPlayersQueryVariables = Exact<{
  input: FindFamilyPlayersInput;
}>;


export type FindFamilyPlayersQuery = { findFamilyPlayers: Array<{ id: string, role: { authID?: string | null, isInstaller?: boolean | null, isChild?: boolean | null, parentId?: string | null, policies?: Array<{ name: string, options?: any | null }> | null }, tags: Array<{ tagType: TagTypes, tagNumber: number, deviceID?: string | null }>, team?: { name: string, leaderboardId?: string | null, all: number, gems: number, totalMembers: number, type: TeamTypes, details: { leaders?: Array<string> | null, leadersEmails?: Array<string> | null, description?: string | null, rejectionReason?: string | null } } | null, info: { gameId?: string | null, teamId?: string | null, publicName?: string | null }, profile: { firstName?: string | null, lastName?: string | null, fullName?: string | null, email: string, birthDate?: string | null, gender?: string | null, allowMarketingEmails?: boolean | null, isRegistered?: boolean | null, isVerified?: boolean | null, postCode?: string | null, lsoaCode?: string | null, ageGroup?: string | null }, points?: { all: number, gems: number } | null }> };

export type GetActiveGameQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
}>;


export type GetActiveGameQuery = { getGame: { id: string, leaderboards: Array<{ id: string, name: string }>, teams: Array<{ name: string, leaderboardId?: string | null, totalMembers: number, gems: number, all: number }>, info: { region?: GameRegion | null, slug: string, name: string, status: GameStatus, anticipationStartsAt: string, teamsStartsAt: string, startsAt: string, endsAt: string, sustainEndsAt: string, hideOnLanding?: boolean | null, originalSlug?: string | null, boundingBox?: string | null, helpWidget: HelpWidget, isMobileGame?: boolean | null, restrictAtDays?: number | null, settings: { locationDistanceMeters: number, locationDistance: number, POIName?: string | null } }, counter: { totalMiles: number, totalPlayers: number } } };

export type FGameInfoBasicFragment = { slug: string, name: string, status: GameStatus };

export type FGameInfoDatesFragment = { anticipationStartsAt: string, teamsStartsAt: string, startsAt: string, endsAt: string, sustainEndsAt: string };

export type FGameInfoRestFragment = { hideOnLanding?: boolean | null, originalSlug?: string | null, boundingBox?: string | null, helpWidget: HelpWidget, isMobileGame?: boolean | null, restrictAtDays?: number | null };

export type FGameInfoSurveysFragment = { surveys?: { tellUsAboutYou?: { link: string } | null, closing?: { link: string, shownFromDate: string } | null } | null };

export type FGameSettingsFragment = { settings: { locationDistanceMeters: number, locationDistance: number, POIName?: string | null } };

export type FGameInfoFragment = { info: { region?: GameRegion | null, slug: string, name: string, status: GameStatus, anticipationStartsAt: string, teamsStartsAt: string, startsAt: string, endsAt: string, sustainEndsAt: string, hideOnLanding?: boolean | null, originalSlug?: string | null, boundingBox?: string | null, helpWidget: HelpWidget, isMobileGame?: boolean | null, restrictAtDays?: number | null, settings: { locationDistanceMeters: number, locationDistance: number, POIName?: string | null } } };

export type FGameCounterFragment = { counter: { totalMiles: number, totalPlayers: number } };

export type GetAllGamesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllGamesQuery = { findGames: Array<{ id: string, info: { region?: GameRegion | null, slug: string, name: string, status: GameStatus, anticipationStartsAt: string, teamsStartsAt: string, startsAt: string, endsAt: string, sustainEndsAt: string, hideOnLanding?: boolean | null, originalSlug?: string | null, boundingBox?: string | null, helpWidget: HelpWidget, isMobileGame?: boolean | null, restrictAtDays?: number | null, settings: { locationDistanceMeters: number, locationDistance: number, POIName?: string | null } } }> };

export type GetAllInitialGamesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllInitialGamesQuery = { allSanityGame: { nodes: Array<{ name?: string | null, slug?: string | null, dynamoId?: string | null, status?: string | null, numberOfPartnersInFooter?: number | null, facebookUsername?: string | null, emailAddress?: string | null, twitterUsername?: string | null, introductionHeading?: string | null, hideLeaderboards?: boolean | null, showMessage?: boolean | null, maintenanceTitle?: string | null, i18n_lang?: string | null, awards?: boolean | null, endOfGameShowWinners?: boolean | null, maintenanceDescription?: any | null, introductionContent?: any | null, endOfGameWinnersText?: any | null, faqs?: { id: string } | { id: string } | null, howToPlay?: { id: string } | null, partners?: Array<{ id: string, name?: string | null, websiteUrl?: string | null, logo?: { asset?: { gatsbyImageData: any } | null } | null } | null> | null, footerPartners?: Array<{ id: string, name?: string | null, websiteUrl?: string | null, logo?: { asset?: { gatsbyImageData: any } | null } | null } | null> | null, partnersPage?: { id: string, title?: string | null, _rawIntroduction?: any | null } | null, leaderboardSettings?: { pointsHelpText?: string | null, howItWorksContent?: any | null } | null, introductionVideoCta?: { text?: string | null, videoUrl?: string | null, placeholderImage?: { asset?: { gatsbyImageData: any } | null } | null } | null, ctaListForLoggedInUsers?: Array<{ id: string, title?: string | null, text?: string | null, icon?: string | null, size?: string | null, style?: string | null, link?: { internalLinkToggle?: boolean | null, internalLink?: string | null, internalLinkHash?: string | null, externalUrlToggle?: boolean | null, externalUrl?: string | null, overlayToggle?: boolean | null, linkText?: string | null, overlayLink?: { id: string, title?: string | null, body?: any | null } | null } | null } | null> | null, ctaListForLoggedOutUsers?: Array<{ id: string, title?: string | null, text?: string | null, icon?: string | null, size?: string | null, style?: string | null, link?: { internalLinkToggle?: boolean | null, internalLink?: string | null, internalLinkHash?: string | null, externalUrlToggle?: boolean | null, externalUrl?: string | null, overlayToggle?: boolean | null, linkText?: string | null, overlayLink?: { id: string, title?: string | null, body?: any | null } | null } | null } | null> | null }> }, allSanityEvent: { nodes: Array<{ id: string, title?: string | null, eventSlug?: string | null, externalUrl?: string | null, startDate?: any | null, endDate?: any | null, startTime?: string | null, endTime?: string | null, alt?: string | null, description?: any | null, image?: { asset?: { id: string, gatsbyImageData: any } | null } | null, game?: { name?: string | null, dynamoId?: string | null, slug?: string | null } | null }> }, sanityHomepage?: { id: string, privacyPolicy?: { id: string, body?: any | null } | null, termsAndConditions?: { id: string } | null, cookies?: { id: string } | null, accessibility?: { id: string } | null, newsletter?: { id: string } | null, childPrivacyPolicy?: { id: string } | null, resourcesForSchools?: { id: string } | null, aboutUs?: { id: string } | null } | null };

export type FLocalesFragment = { edges: Array<{ node: { ns?: string | null, data?: string | null, language?: string | null } }> };

export type FPlayerPointContextFragment = { all: number, gems: number };

export type FPlayerPointFragment = { points?: { all: number, gems: number } | null };

export type FPlayerProfileContextFragment = { firstName?: string | null, lastName?: string | null, fullName?: string | null, email: string, birthDate?: string | null, gender?: string | null, allowMarketingEmails?: boolean | null, isRegistered?: boolean | null, isVerified?: boolean | null, postCode?: string | null, lsoaCode?: string | null, ageGroup?: string | null };

export type FPlayerProfileFragment = { profile: { firstName?: string | null, lastName?: string | null, fullName?: string | null, email: string, birthDate?: string | null, gender?: string | null, allowMarketingEmails?: boolean | null, isRegistered?: boolean | null, isVerified?: boolean | null, postCode?: string | null, lsoaCode?: string | null, ageGroup?: string | null } };

export type FPlayerInfoContextFragment = { gameId?: string | null, teamId?: string | null, publicName?: string | null };

export type FPlayerInfoFragment = { info: { gameId?: string | null, teamId?: string | null, publicName?: string | null } };

export type FPlayerRoleContextFragment = { isChild?: boolean | null, parentId?: string | null, authID?: string | null };

export type FPlayerRoleFragment = { role: { isChild?: boolean | null, parentId?: string | null, authID?: string | null } };

export type GameDetailsFragment = { name?: string | null, slug?: string | null, dynamoId?: string | null, status?: string | null, numberOfPartnersInFooter?: number | null, facebookUsername?: string | null, emailAddress?: string | null, twitterUsername?: string | null, introductionHeading?: string | null, hideLeaderboards?: boolean | null, showMessage?: boolean | null, maintenanceTitle?: string | null, i18n_lang?: string | null, awards?: boolean | null, endOfGameShowWinners?: boolean | null, maintenanceDescription?: any | null, introductionContent?: any | null, endOfGameWinnersText?: any | null, faqs?: { id: string } | { id: string } | null, howToPlay?: { id: string } | null, partners?: Array<{ id: string, name?: string | null, websiteUrl?: string | null, logo?: { asset?: { gatsbyImageData: any } | null } | null } | null> | null, footerPartners?: Array<{ id: string, name?: string | null, websiteUrl?: string | null, logo?: { asset?: { gatsbyImageData: any } | null } | null } | null> | null, partnersPage?: { id: string, title?: string | null, _rawIntroduction?: any | null } | null, leaderboardSettings?: { pointsHelpText?: string | null, howItWorksContent?: any | null } | null, introductionVideoCta?: { text?: string | null, videoUrl?: string | null, placeholderImage?: { asset?: { gatsbyImageData: any } | null } | null } | null, ctaListForLoggedInUsers?: Array<{ id: string, title?: string | null, text?: string | null, icon?: string | null, size?: string | null, style?: string | null, link?: { internalLinkToggle?: boolean | null, internalLink?: string | null, internalLinkHash?: string | null, externalUrlToggle?: boolean | null, externalUrl?: string | null, overlayToggle?: boolean | null, linkText?: string | null, overlayLink?: { id: string, title?: string | null, body?: any | null } | null } | null } | null> | null, ctaListForLoggedOutUsers?: Array<{ id: string, title?: string | null, text?: string | null, icon?: string | null, size?: string | null, style?: string | null, link?: { internalLinkToggle?: boolean | null, internalLink?: string | null, internalLinkHash?: string | null, externalUrlToggle?: boolean | null, externalUrl?: string | null, overlayToggle?: boolean | null, linkText?: string | null, overlayLink?: { id: string, title?: string | null, body?: any | null } | null } | null } | null> | null };

export type HomepageDetailsFragment = { privacyPolicy?: { id: string } | null, childPrivacyPolicy?: { id: string } | null, resourcesForSchools?: { id: string } | null, termsAndConditions?: { id: string } | null, partners?: Array<{ id: string, name?: string | null, websiteUrl?: string | null, logo?: { asset?: { gatsbyImageData: any } | null } | null } | null> | null };

export type CtaFragment = { id: string, title?: string | null, text?: string | null, icon?: string | null, size?: string | null, style?: string | null, link?: { internalLinkToggle?: boolean | null, internalLink?: string | null, internalLinkHash?: string | null, externalUrlToggle?: boolean | null, externalUrl?: string | null, overlayToggle?: boolean | null, linkText?: string | null, overlayLink?: { id: string, title?: string | null, body?: any | null } | null } | null };

export type WeeklyThemesFragment = { weeklyThemes?: Array<{ id: string, name?: string | null, title?: string | null, subtitle?: string | null, themeColours?: string | null, logo?: { asset?: { url?: string | null } | null } | null } | null> | null };

export type GetChildQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetChildQuery = { getPlayer: { id: string, role: { authID?: string | null, isInstaller?: boolean | null, isChild?: boolean | null, parentId?: string | null, policies?: Array<{ name: string, options?: any | null }> | null }, tags: Array<{ tagType: TagTypes, tagNumber: number, deviceID?: string | null }>, team?: { name: string, leaderboardId?: string | null, all: number, gems: number, totalMembers: number, type: TeamTypes, details: { leaders?: Array<string> | null, leadersEmails?: Array<string> | null, description?: string | null, rejectionReason?: string | null } } | null, info: { gameId?: string | null, teamId?: string | null, publicName?: string | null }, profile: { firstName?: string | null, lastName?: string | null, fullName?: string | null, email: string, birthDate?: string | null, gender?: string | null, allowMarketingEmails?: boolean | null, isRegistered?: boolean | null, isVerified?: boolean | null, postCode?: string | null, lsoaCode?: string | null, ageGroup?: string | null }, points?: { all: number, gems: number } | null } };

export type GetRoutesQueryVariables = Exact<{
  playerId?: InputMaybe<Scalars['String']>;
}>;


export type GetRoutesQuery = { getPlayer: { routes?: Array<{ id: string, locationSlug?: string | null, swipeTimestamp: string, points: number }> | null } };

export type JoinGameMutationVariables = Exact<{
  input: JoinGameInput;
}>;


export type JoinGameMutation = { joinGame: boolean };

export type FindPlayerSurveysQueryVariables = Exact<{
  playerId: Scalars['String'];
  gameId: Scalars['String'];
}>;


export type FindPlayerSurveysQuery = { findPlayerSurveys: Array<{ id: string, surveyType: SurveyTypes, isConfirmed: boolean, createdAt: string, status: SurveyStatus }> };

export type GetGameWithSurveysQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetGameWithSurveysQuery = { getGame: { id: string, info: { surveys?: { tellUsAboutYou?: { link: string } | null, closing?: { link: string, shownFromDate: string } | null } | null } } };

export type FindAllPlayerSurveysQueryVariables = Exact<{
  playerId?: InputMaybe<Scalars['String']>;
  gameId?: InputMaybe<Scalars['String']>;
}>;


export type FindAllPlayerSurveysQuery = { findPlayerSurveys: Array<{ id: string, surveyType: SurveyTypes }> };

export type CreateSurveyMutationVariables = Exact<{
  input: SurveySharedInput;
}>;


export type CreateSurveyMutation = { createSurvey: { id: string } };

export type ConfirmEmailMutationVariables = Exact<{
  input: ConfirmEmailInput;
}>;


export type ConfirmEmailMutation = { confirmEmail: boolean };

export type PlayerRoutesQueryVariables = Exact<{
  playerId: Scalars['String'];
}>;


export type PlayerRoutesQuery = { playerRoutes: { routes?: Array<{ id: string, tagNumber: number, locationId: string, locationSlug?: string | null, swipeTimestamp: string, points: number }> | null } };

export type GetLeaderboardPlayersQueryVariables = Exact<{
  input: GetPlayerLeaderboardsInput;
}>;


export type GetLeaderboardPlayersQuery = { getPlayerLeaderboards: { rank: string, data: Array<{ id: string, name: string, amount: number, avatar?: string | null, position: number, marked: boolean }> } };

export type GetLeaderboardTeamsQueryVariables = Exact<{
  input: GetTeamLeaderboardsInput;
  gameId?: InputMaybe<Scalars['String']>;
}>;


export type GetLeaderboardTeamsQuery = { getTeamLeaderboards: { data: Array<{ id: string, name: string, amount: number, avatar?: string | null, position: number, marked: boolean, totalMembers: number }> }, findLeaderboards: Array<{ id: string, name: string }> };

export type GetLeaderboardFollowQueryVariables = Exact<{
  input: GetFollowLeaderboardsInput;
}>;


export type GetLeaderboardFollowQuery = { getFollowLeaderboards: { rank: string, data: Array<{ id: string, name: string, amount: number, avatar?: string | null, position: number, marked: boolean }> } };

export type CreateFollowMutationVariables = Exact<{
  input: PlayerFollowInput;
}>;


export type CreateFollowMutation = { createFollow: boolean };

export type DeleteFollowMutationVariables = Exact<{
  input: PlayerFollowInput;
}>;


export type DeleteFollowMutation = { deleteFollow: boolean };

export type FindFollowedQueryVariables = Exact<{
  input: FindPlayerFollowInput;
}>;


export type FindFollowedQuery = { findFollowed: Array<string> };

export type FindLocationsQueryVariables = Exact<{
  gameId?: InputMaybe<Scalars['String']>;
}>;


export type FindLocationsQuery = { findLocations: Array<{ id: string, slug: string, lat: number, lng: number, type: LocationTypes, gemType?: GemType | null, beatBoxNumber?: number | null, details: { name?: string | null, description?: string | null, accessible?: boolean | null } }> };

export type GetTeamsV2QueryVariables = Exact<{
  gameId: Scalars['String'];
  parentTeamId?: InputMaybe<Scalars['String']>;
}>;


export type GetTeamsV2Query = { getTeamsV2: Array<{ teamId: string, name: string, parentTeamId?: string | null }> };

export type GetPlayerTeamsV2QueryVariables = Exact<{
  gameId: Scalars['String'];
  playerId: Scalars['String'];
}>;


export type GetPlayerTeamsV2Query = { getPlayerTeamsV2: Array<{ teamId: string, name: string, parentTeamId?: string | null }> };

export type GetPlayerLeaderboardQueryVariables = Exact<{
  teamId: Scalars['String'];
  gems?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetPlayerLeaderboardQuery = { getPlayerLeaderboardV2: { board: Array<{ id: string, name: string, avatar?: string | null, points: number }> } };

export type GetTeamLeaderboardQueryVariables = Exact<{
  gameId: Scalars['String'];
  teamId: Scalars['String'];
}>;


export type GetTeamLeaderboardQuery = { getTeamLeaderboardV2: { averageBoard: Array<{ id: string, name: string, points: number }>, board: Array<{ id: string, name: string, points: number }> } };

export type FindTeamsQueryVariables = Exact<{
  input: FindTeamsInput;
}>;


export type FindTeamsQuery = { findTeams: Array<{ id: string, name: string, status: TeamStatus, details: { leaders?: Array<string> | null } }> };

export type LeaveGameMutationVariables = Exact<{ [key: string]: never; }>;


export type LeaveGameMutation = { leaveGame: boolean };

export type RemoveFromFamilyMutationVariables = Exact<{
  input: RemoveFromFamilyInput;
}>;


export type RemoveFromFamilyMutation = { removeFromFamily: boolean };

export type DeleteChildMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
}>;


export type DeleteChildMutation = { deleteChild: boolean };

export type DeletePlayerMutationVariables = Exact<{ [key: string]: never; }>;


export type DeletePlayerMutation = { deletePlayer: boolean };

export type ReadMessageMutationVariables = Exact<{
  messageId: Scalars['String'];
}>;


export type ReadMessageMutation = { readMessage: boolean };

export type LikeMessageMutationVariables = Exact<{
  campaignId: Scalars['String'];
}>;


export type LikeMessageMutation = { likeMessage: boolean };

export type UnlikeMessageMutationVariables = Exact<{
  campaignId: Scalars['String'];
}>;


export type UnlikeMessageMutation = { unlikeMessage: boolean };

export type PostTeamMessageMutationVariables = Exact<{
  content: TeamMessageContent;
}>;


export type PostTeamMessageMutation = { postTeamMessage: boolean };

export type MsgFragment = { messageId: string, campaignId: string, teamName?: string | null, content: string, category: string, createdAt: string, readAt?: string | null, isLiked: boolean, likesCount: number };

export type GetMessagesQueryVariables = Exact<{
  category?: InputMaybe<Scalars['String']>;
}>;


export type GetMessagesQuery = { getMessages: Array<{ messageId: string, campaignId: string, teamName?: string | null, content: string, category: string, createdAt: string, readAt?: string | null, isLiked: boolean, likesCount: number }> };

export type GetMessageQueryVariables = Exact<{
  messageId: Scalars['String'];
}>;


export type GetMessageQuery = { getMessage: { messageId: string, campaignId: string, teamName?: string | null, content: string, category: string, createdAt: string, readAt?: string | null, isLiked: boolean, likesCount: number } };

export type HasUnreadMessageQueryVariables = Exact<{ [key: string]: never; }>;


export type HasUnreadMessageQuery = { hasUnreadMessage: boolean };

export type NewsletterSignupMutationVariables = Exact<{
  input: NewsletterSignUpInput;
}>;


export type NewsletterSignupMutation = { newsletterSignUp: boolean };

export type UpdatePlayerMutationVariables = Exact<{
  input: UpdatePlayerInput;
}>;


export type UpdatePlayerMutation = { updatePlayer: { id: string } };

export type JoinFamilyMutationVariables = Exact<{
  input: JoinFamilyInput;
}>;


export type JoinFamilyMutation = { joinFamily: boolean };

export type AssignTagMutationVariables = Exact<{
  input: PlayerTagCreateInput;
}>;


export type AssignTagMutation = { assignTag: { tagNumber: number } };

export type JoinTeamMutationVariables = Exact<{
  input: JoinTeamInput;
}>;


export type JoinTeamMutation = { joinTeam: boolean };

export type LeaveTeamMutationVariables = Exact<{
  playerId: Scalars['String'];
}>;


export type LeaveTeamMutation = { leaveTeam: boolean };

export type CreateTeamMutationVariables = Exact<{
  input: TeamCreateInput;
}>;


export type CreateTeamMutation = { createTeam: { id: string } };

export type FindTeamNamesQueryVariables = Exact<{
  input: FindTeamsInput;
}>;


export type FindTeamNamesQuery = { findTeamNames: { teamNames: Array<string> } };

export type CreateChildMutationVariables = Exact<{
  input: CreateChildPlayerInput;
}>;


export type CreateChildMutation = { createChild: { id: string } };

export type CheckPublicNameQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type CheckPublicNameQuery = { checkPublicName: boolean };

export type FindAllTeamsQueryVariables = Exact<{
  input: FindTeamsInput;
}>;


export type FindAllTeamsQuery = { findTeams: Array<{ id: string, name: string, status: TeamStatus }> };

export type GetUserTeamQueryVariables = Exact<{
  input: GetTeamInput;
}>;


export type GetUserTeamQuery = { getTeam: { id: string, name: string } };

export type CreatePostCodeRecordMutationVariables = Exact<{
  input: PostCodeInput;
}>;


export type CreatePostCodeRecordMutation = { checkPostCode: { id: string } };

export const FPlayerRoleContextFragmentDoc = `
    fragment FPlayerRoleContext on PlayerRole {
  isChild
  parentId
  authID
}
    `;
export const FPlayerInfoContextFragmentDoc = `
    fragment FPlayerInfoContext on PlayerInfo {
  gameId
  teamId
  publicName
}
    `;
export const FPlayerInfoFragmentDoc = `
    fragment FPlayerInfo on Player {
  info {
    ...FPlayerInfoContext
  }
}
    ${FPlayerInfoContextFragmentDoc}`;
export const FPlayerProfileContextFragmentDoc = `
    fragment FPlayerProfileContext on PlayerProfile {
  firstName
  lastName
  fullName
  email
  birthDate
  gender
  allowMarketingEmails
  isRegistered
  isVerified
  postCode
  lsoaCode
  ageGroup
}
    `;
export const FPlayerProfileFragmentDoc = `
    fragment FPlayerProfile on Player {
  profile {
    ...FPlayerProfileContext
  }
}
    ${FPlayerProfileContextFragmentDoc}`;
export const FPlayerPointContextFragmentDoc = `
    fragment FPlayerPointContext on PlayerPoint {
  all
  gems
}
    `;
export const FPlayerPointFragmentDoc = `
    fragment FPlayerPoint on Player {
  points {
    ...FPlayerPointContext
  }
}
    ${FPlayerPointContextFragmentDoc}`;
export const UserFragmentDoc = `
    fragment User on Player {
  id
  role {
    ...FPlayerRoleContext
    authID
    isInstaller
    policies {
      name
      options
    }
  }
  ...FPlayerInfo
  ...FPlayerProfile
  ...FPlayerPoint
  tags {
    tagType
    tagNumber
    deviceID
  }
  team {
    name
    leaderboardId
    all
    gems
    totalMembers
    type
    details {
      leaders
      leadersEmails
      description
      rejectionReason
    }
  }
}
    ${FPlayerRoleContextFragmentDoc}
${FPlayerInfoFragmentDoc}
${FPlayerProfileFragmentDoc}
${FPlayerPointFragmentDoc}`;
export const FGameInfoSurveysFragmentDoc = `
    fragment FGameInfoSurveys on GameInfo {
  surveys {
    tellUsAboutYou {
      link
    }
    closing {
      link
      shownFromDate
    }
  }
}
    `;
export const FGameInfoBasicFragmentDoc = `
    fragment FGameInfoBasic on GameInfo {
  slug
  name
  status
}
    `;
export const FGameInfoDatesFragmentDoc = `
    fragment FGameInfoDates on GameInfo {
  anticipationStartsAt
  teamsStartsAt
  startsAt
  endsAt
  sustainEndsAt
}
    `;
export const FGameInfoRestFragmentDoc = `
    fragment FGameInfoRest on GameInfo {
  hideOnLanding
  originalSlug
  boundingBox
  helpWidget
  isMobileGame
  restrictAtDays
}
    `;
export const FGameSettingsFragmentDoc = `
    fragment FGameSettings on GameInfo {
  settings {
    locationDistanceMeters
    locationDistance
    POIName
  }
}
    `;
export const FGameInfoFragmentDoc = `
    fragment FGameInfo on Game {
  info {
    region
    ...FGameInfoBasic
    ...FGameInfoDates
    ...FGameInfoRest
    ...FGameSettings
  }
}
    ${FGameInfoBasicFragmentDoc}
${FGameInfoDatesFragmentDoc}
${FGameInfoRestFragmentDoc}
${FGameSettingsFragmentDoc}`;
export const FGameCounterFragmentDoc = `
    fragment FGameCounter on Game {
  counter {
    totalMiles
    totalPlayers
  }
}
    `;
export const FLocalesFragmentDoc = `
    fragment FLocales on LocaleConnection {
  edges {
    node {
      ns
      data
      language
    }
  }
}
    `;
export const FPlayerRoleFragmentDoc = `
    fragment FPlayerRole on Player {
  role {
    ...FPlayerRoleContext
  }
}
    ${FPlayerRoleContextFragmentDoc}`;
export const CtaFragmentDoc = `
    fragment cta on SanityCta {
  id
  title
  text
  icon
  size
  style
  link {
    internalLinkToggle
    internalLink
    internalLinkHash
    externalUrlToggle
    externalUrl
    overlayToggle
    overlayLink {
      id
      title
      body: _rawBody
    }
    linkText
  }
}
    `;
export const GameDetailsFragmentDoc = `
    fragment gameDetails on SanityGame {
  name
  slug
  dynamoId
  status
  numberOfPartnersInFooter
  facebookUsername
  emailAddress
  twitterUsername
  introductionHeading
  hideLeaderboards
  showMessage
  maintenanceTitle
  i18n_lang
  faqs {
    ... on Node {
      id
    }
  }
  howToPlay {
    id
  }
  awards
  maintenanceDescription: _rawMaintenanceDescription
  partners {
    id
    name
    websiteUrl
    logo {
      asset {
        gatsbyImageData(fit: FILLMAX, placeholder: BLURRED)
      }
    }
  }
  footerPartners {
    id
    name
    websiteUrl
    logo {
      asset {
        gatsbyImageData(fit: FILLMAX, placeholder: BLURRED)
      }
    }
  }
  partnersPage {
    id
    title
    _rawIntroduction(resolveReferences: {maxDepth: 15})
  }
  leaderboardSettings {
    howItWorksContent: _rawHowItWorksContent
    pointsHelpText
  }
  introductionContent: _rawIntroductionContent
  introductionVideoCta {
    placeholderImage {
      asset {
        gatsbyImageData(fit: FILLMAX, placeholder: BLURRED)
      }
    }
    text
    videoUrl
  }
  ctaListForLoggedInUsers {
    ...cta
  }
  ctaListForLoggedOutUsers {
    ...cta
  }
  endOfGameShowWinners
  endOfGameWinnersText: _rawEndOfGameWinnersText
}
    ${CtaFragmentDoc}`;
export const HomepageDetailsFragmentDoc = `
    fragment homepageDetails on SanityHomepage {
  privacyPolicy {
    id
  }
  childPrivacyPolicy {
    id
  }
  resourcesForSchools {
    id
  }
  termsAndConditions {
    id
  }
  partners {
    id
    name
    websiteUrl
    logo {
      asset {
        gatsbyImageData(fit: FILLMAX, placeholder: BLURRED)
      }
    }
  }
}
    `;
export const WeeklyThemesFragmentDoc = `
    fragment weeklyThemes on SanityGame {
  weeklyThemes {
    id
    name
    title
    subtitle
    themeColours
    logo {
      asset {
        url
      }
    }
  }
}
    `;
export const MsgFragmentDoc = `
    fragment Msg on Message {
  messageId
  campaignId
  teamName
  content
  category
  createdAt
  readAt
  isLiked
  likesCount
}
    `;
export const PlayerSurveysDocument = `
    query PlayerSurveys($gameId: String!, $playerId: String!) {
  findPlayerSurveys(playerId: $playerId, gameId: $gameId) {
    surveyType
  }
}
    `;
export const usePlayerSurveysQuery = <
      TData = PlayerSurveysQuery,
      TError = unknown
    >(
      variables: PlayerSurveysQueryVariables,
      options?: UseQueryOptions<PlayerSurveysQuery, TError, TData>
    ) =>
    useQuery<PlayerSurveysQuery, TError, TData>(
      ['PlayerSurveys', variables],
      fetchGenerated<PlayerSurveysQuery, PlayerSurveysQueryVariables>(PlayerSurveysDocument, variables),
      options
    );
export const GetGameSurveyInfoDocument = `
    query GetGameSurveyInfo($id: String = "") {
  getGame(id: $id) {
    id
    info {
      ...FGameInfoSurveys
    }
  }
}
    ${FGameInfoSurveysFragmentDoc}`;
export const useGetGameSurveyInfoQuery = <
      TData = GetGameSurveyInfoQuery,
      TError = unknown
    >(
      variables?: GetGameSurveyInfoQueryVariables,
      options?: UseQueryOptions<GetGameSurveyInfoQuery, TError, TData>
    ) =>
    useQuery<GetGameSurveyInfoQuery, TError, TData>(
      variables === undefined ? ['GetGameSurveyInfo'] : ['GetGameSurveyInfo', variables],
      fetchGenerated<GetGameSurveyInfoQuery, GetGameSurveyInfoQueryVariables>(GetGameSurveyInfoDocument, variables),
      options
    );
export const SignupPlayerDocument = `
    mutation SignupPlayer($input: SignupPlayerInput!) {
  signup(input: $input) {
    id
  }
}
    `;
export const useSignupPlayerMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SignupPlayerMutation, TError, SignupPlayerMutationVariables, TContext>) =>
    useMutation<SignupPlayerMutation, TError, SignupPlayerMutationVariables, TContext>(
      ['SignupPlayer'],
      (variables?: SignupPlayerMutationVariables) => fetchGenerated<SignupPlayerMutation, SignupPlayerMutationVariables>(SignupPlayerDocument, variables)(),
      options
    );
export const AuthPlayerDocument = `
    query AuthPlayer($authID: String!) {
  getPlayerByAuth(authID: $authID) {
    ...User
  }
}
    ${UserFragmentDoc}`;
export const useAuthPlayerQuery = <
      TData = AuthPlayerQuery,
      TError = unknown
    >(
      variables: AuthPlayerQueryVariables,
      options?: UseQueryOptions<AuthPlayerQuery, TError, TData>
    ) =>
    useQuery<AuthPlayerQuery, TError, TData>(
      ['AuthPlayer', variables],
      fetchGenerated<AuthPlayerQuery, AuthPlayerQueryVariables>(AuthPlayerDocument, variables),
      options
    );
export const GetPlayerByIdDocument = `
    query GetPlayerById($id: String!) {
  getPlayer(id: $id) {
    ...User
  }
}
    ${UserFragmentDoc}`;
export const useGetPlayerByIdQuery = <
      TData = GetPlayerByIdQuery,
      TError = unknown
    >(
      variables: GetPlayerByIdQueryVariables,
      options?: UseQueryOptions<GetPlayerByIdQuery, TError, TData>
    ) =>
    useQuery<GetPlayerByIdQuery, TError, TData>(
      ['GetPlayerById', variables],
      fetchGenerated<GetPlayerByIdQuery, GetPlayerByIdQueryVariables>(GetPlayerByIdDocument, variables),
      options
    );
export const LocalPlayerDocument = `
    query LocalPlayer($email: String!) {
  getPlayerByEmail(email: $email) {
    ...User
  }
}
    ${UserFragmentDoc}`;
export const useLocalPlayerQuery = <
      TData = LocalPlayerQuery,
      TError = unknown
    >(
      variables: LocalPlayerQueryVariables,
      options?: UseQueryOptions<LocalPlayerQuery, TError, TData>
    ) =>
    useQuery<LocalPlayerQuery, TError, TData>(
      ['LocalPlayer', variables],
      fetchGenerated<LocalPlayerQuery, LocalPlayerQueryVariables>(LocalPlayerDocument, variables),
      options
    );
export const FindFamilyPlayersDocument = `
    query FindFamilyPlayers($input: FindFamilyPlayersInput!) {
  findFamilyPlayers(input: $input) {
    ...User
  }
}
    ${UserFragmentDoc}`;
export const useFindFamilyPlayersQuery = <
      TData = FindFamilyPlayersQuery,
      TError = unknown
    >(
      variables: FindFamilyPlayersQueryVariables,
      options?: UseQueryOptions<FindFamilyPlayersQuery, TError, TData>
    ) =>
    useQuery<FindFamilyPlayersQuery, TError, TData>(
      ['FindFamilyPlayers', variables],
      fetchGenerated<FindFamilyPlayersQuery, FindFamilyPlayersQueryVariables>(FindFamilyPlayersDocument, variables),
      options
    );
export const GetActiveGameDocument = `
    query GetActiveGame($id: String = "") {
  getGame(id: $id) {
    id
    ...FGameInfo
    ...FGameCounter
    leaderboards {
      id
      name
    }
    teams {
      name
      leaderboardId
      totalMembers
      gems
      all
    }
  }
}
    ${FGameInfoFragmentDoc}
${FGameCounterFragmentDoc}`;
export const useGetActiveGameQuery = <
      TData = GetActiveGameQuery,
      TError = unknown
    >(
      variables?: GetActiveGameQueryVariables,
      options?: UseQueryOptions<GetActiveGameQuery, TError, TData>
    ) =>
    useQuery<GetActiveGameQuery, TError, TData>(
      variables === undefined ? ['GetActiveGame'] : ['GetActiveGame', variables],
      fetchGenerated<GetActiveGameQuery, GetActiveGameQueryVariables>(GetActiveGameDocument, variables),
      options
    );
export const GetAllGamesDocument = `
    query getAllGames {
  findGames {
    id
    ...FGameInfo
  }
}
    ${FGameInfoFragmentDoc}`;
export const useGetAllGamesQuery = <
      TData = GetAllGamesQuery,
      TError = unknown
    >(
      variables?: GetAllGamesQueryVariables,
      options?: UseQueryOptions<GetAllGamesQuery, TError, TData>
    ) =>
    useQuery<GetAllGamesQuery, TError, TData>(
      variables === undefined ? ['getAllGames'] : ['getAllGames', variables],
      fetchGenerated<GetAllGamesQuery, GetAllGamesQueryVariables>(GetAllGamesDocument, variables),
      options
    );
export const GetAllInitialGamesDocument = `
    query getAllInitialGames {
  allSanityGame {
    nodes {
      ...gameDetails
    }
  }
  allSanityEvent {
    nodes {
      id
      title
      eventSlug
      description: _rawDescription
      externalUrl
      startDate
      endDate
      startTime
      endTime
      alt
      image {
        asset {
          id
          gatsbyImageData(width: 700, placeholder: BLURRED, formats: [AUTO, WEBP])
        }
      }
      game {
        name
        dynamoId
        slug
      }
    }
  }
  sanityHomepage(_id: {regex: "/(drafts.|)homepage/"}, i18n_lang: {eq: "en-GB"}) {
    id
    privacyPolicy {
      id
      body: _rawBody
    }
    termsAndConditions {
      id
    }
    cookies {
      id
    }
    accessibility {
      id
    }
    newsletter {
      id
    }
    childPrivacyPolicy {
      id
    }
    resourcesForSchools {
      id
    }
    aboutUs {
      id
    }
  }
}
    ${GameDetailsFragmentDoc}`;
export const useGetAllInitialGamesQuery = <
      TData = GetAllInitialGamesQuery,
      TError = unknown
    >(
      variables?: GetAllInitialGamesQueryVariables,
      options?: UseQueryOptions<GetAllInitialGamesQuery, TError, TData>
    ) =>
    useQuery<GetAllInitialGamesQuery, TError, TData>(
      variables === undefined ? ['getAllInitialGames'] : ['getAllInitialGames', variables],
      fetchGenerated<GetAllInitialGamesQuery, GetAllInitialGamesQueryVariables>(GetAllInitialGamesDocument, variables),
      options
    );
export const GetChildDocument = `
    query GetChild($id: String!) {
  getPlayer(id: $id) {
    ...User
  }
}
    ${UserFragmentDoc}`;
export const useGetChildQuery = <
      TData = GetChildQuery,
      TError = unknown
    >(
      variables: GetChildQueryVariables,
      options?: UseQueryOptions<GetChildQuery, TError, TData>
    ) =>
    useQuery<GetChildQuery, TError, TData>(
      ['GetChild', variables],
      fetchGenerated<GetChildQuery, GetChildQueryVariables>(GetChildDocument, variables),
      options
    );
export const GetRoutesDocument = `
    query GetRoutes($playerId: String = "") {
  getPlayer(id: $playerId) {
    routes {
      id
      locationSlug
      swipeTimestamp
      points
    }
  }
}
    `;
export const useGetRoutesQuery = <
      TData = GetRoutesQuery,
      TError = unknown
    >(
      variables?: GetRoutesQueryVariables,
      options?: UseQueryOptions<GetRoutesQuery, TError, TData>
    ) =>
    useQuery<GetRoutesQuery, TError, TData>(
      variables === undefined ? ['GetRoutes'] : ['GetRoutes', variables],
      fetchGenerated<GetRoutesQuery, GetRoutesQueryVariables>(GetRoutesDocument, variables),
      options
    );
export const JoinGameDocument = `
    mutation JoinGame($input: JoinGameInput!) {
  joinGame(input: $input)
}
    `;
export const useJoinGameMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<JoinGameMutation, TError, JoinGameMutationVariables, TContext>) =>
    useMutation<JoinGameMutation, TError, JoinGameMutationVariables, TContext>(
      ['JoinGame'],
      (variables?: JoinGameMutationVariables) => fetchGenerated<JoinGameMutation, JoinGameMutationVariables>(JoinGameDocument, variables)(),
      options
    );
export const FindPlayerSurveysDocument = `
    query FindPlayerSurveys($playerId: String!, $gameId: String!) {
  findPlayerSurveys(playerId: $playerId, gameId: $gameId) {
    id
    surveyType
    isConfirmed
    createdAt
    status
  }
}
    `;
export const useFindPlayerSurveysQuery = <
      TData = FindPlayerSurveysQuery,
      TError = unknown
    >(
      variables: FindPlayerSurveysQueryVariables,
      options?: UseQueryOptions<FindPlayerSurveysQuery, TError, TData>
    ) =>
    useQuery<FindPlayerSurveysQuery, TError, TData>(
      ['FindPlayerSurveys', variables],
      fetchGenerated<FindPlayerSurveysQuery, FindPlayerSurveysQueryVariables>(FindPlayerSurveysDocument, variables),
      options
    );
export const GetGameWithSurveysDocument = `
    query GetGameWithSurveys($id: String!) {
  getGame(id: $id) {
    id
    info {
      ...FGameInfoSurveys
    }
  }
}
    ${FGameInfoSurveysFragmentDoc}`;
export const useGetGameWithSurveysQuery = <
      TData = GetGameWithSurveysQuery,
      TError = unknown
    >(
      variables: GetGameWithSurveysQueryVariables,
      options?: UseQueryOptions<GetGameWithSurveysQuery, TError, TData>
    ) =>
    useQuery<GetGameWithSurveysQuery, TError, TData>(
      ['GetGameWithSurveys', variables],
      fetchGenerated<GetGameWithSurveysQuery, GetGameWithSurveysQueryVariables>(GetGameWithSurveysDocument, variables),
      options
    );
export const FindAllPlayerSurveysDocument = `
    query FindAllPlayerSurveys($playerId: String = "", $gameId: String = "") {
  findPlayerSurveys(playerId: $playerId, gameId: $gameId) {
    id
    surveyType
  }
}
    `;
export const useFindAllPlayerSurveysQuery = <
      TData = FindAllPlayerSurveysQuery,
      TError = unknown
    >(
      variables?: FindAllPlayerSurveysQueryVariables,
      options?: UseQueryOptions<FindAllPlayerSurveysQuery, TError, TData>
    ) =>
    useQuery<FindAllPlayerSurveysQuery, TError, TData>(
      variables === undefined ? ['FindAllPlayerSurveys'] : ['FindAllPlayerSurveys', variables],
      fetchGenerated<FindAllPlayerSurveysQuery, FindAllPlayerSurveysQueryVariables>(FindAllPlayerSurveysDocument, variables),
      options
    );
export const CreateSurveyDocument = `
    mutation CreateSurvey($input: SurveySharedInput!) {
  createSurvey(input: $input) {
    id
  }
}
    `;
export const useCreateSurveyMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateSurveyMutation, TError, CreateSurveyMutationVariables, TContext>) =>
    useMutation<CreateSurveyMutation, TError, CreateSurveyMutationVariables, TContext>(
      ['CreateSurvey'],
      (variables?: CreateSurveyMutationVariables) => fetchGenerated<CreateSurveyMutation, CreateSurveyMutationVariables>(CreateSurveyDocument, variables)(),
      options
    );
export const ConfirmEmailDocument = `
    mutation ConfirmEmail($input: ConfirmEmailInput!) {
  confirmEmail(input: $input)
}
    `;
export const useConfirmEmailMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ConfirmEmailMutation, TError, ConfirmEmailMutationVariables, TContext>) =>
    useMutation<ConfirmEmailMutation, TError, ConfirmEmailMutationVariables, TContext>(
      ['ConfirmEmail'],
      (variables?: ConfirmEmailMutationVariables) => fetchGenerated<ConfirmEmailMutation, ConfirmEmailMutationVariables>(ConfirmEmailDocument, variables)(),
      options
    );
export const PlayerRoutesDocument = `
    query PlayerRoutes($playerId: String!) {
  playerRoutes: getPlayer(id: $playerId) {
    routes {
      id
      tagNumber
      locationId
      locationSlug
      swipeTimestamp
      points
    }
  }
}
    `;
export const usePlayerRoutesQuery = <
      TData = PlayerRoutesQuery,
      TError = unknown
    >(
      variables: PlayerRoutesQueryVariables,
      options?: UseQueryOptions<PlayerRoutesQuery, TError, TData>
    ) =>
    useQuery<PlayerRoutesQuery, TError, TData>(
      ['PlayerRoutes', variables],
      fetchGenerated<PlayerRoutesQuery, PlayerRoutesQueryVariables>(PlayerRoutesDocument, variables),
      options
    );
export const GetLeaderboardPlayersDocument = `
    query GetLeaderboardPlayers($input: GetPlayerLeaderboardsInput!) {
  getPlayerLeaderboards(input: $input) {
    rank
    data {
      id
      name
      amount
      avatar
      position
      marked
    }
  }
}
    `;
export const useGetLeaderboardPlayersQuery = <
      TData = GetLeaderboardPlayersQuery,
      TError = unknown
    >(
      variables: GetLeaderboardPlayersQueryVariables,
      options?: UseQueryOptions<GetLeaderboardPlayersQuery, TError, TData>
    ) =>
    useQuery<GetLeaderboardPlayersQuery, TError, TData>(
      ['GetLeaderboardPlayers', variables],
      fetchGenerated<GetLeaderboardPlayersQuery, GetLeaderboardPlayersQueryVariables>(GetLeaderboardPlayersDocument, variables),
      options
    );
export const GetLeaderboardTeamsDocument = `
    query GetLeaderboardTeams($input: GetTeamLeaderboardsInput!, $gameId: String = "") {
  getTeamLeaderboards(input: $input) {
    data {
      id
      name
      amount
      avatar
      position
      marked
      totalMembers
    }
  }
  findLeaderboards(gameId: $gameId) {
    id
    name
  }
}
    `;
export const useGetLeaderboardTeamsQuery = <
      TData = GetLeaderboardTeamsQuery,
      TError = unknown
    >(
      variables: GetLeaderboardTeamsQueryVariables,
      options?: UseQueryOptions<GetLeaderboardTeamsQuery, TError, TData>
    ) =>
    useQuery<GetLeaderboardTeamsQuery, TError, TData>(
      ['GetLeaderboardTeams', variables],
      fetchGenerated<GetLeaderboardTeamsQuery, GetLeaderboardTeamsQueryVariables>(GetLeaderboardTeamsDocument, variables),
      options
    );
export const GetLeaderboardFollowDocument = `
    query GetLeaderboardFollow($input: GetFollowLeaderboardsInput!) {
  getFollowLeaderboards(input: $input) {
    rank
    data {
      id
      name
      amount
      avatar
      position
      marked
    }
  }
}
    `;
export const useGetLeaderboardFollowQuery = <
      TData = GetLeaderboardFollowQuery,
      TError = unknown
    >(
      variables: GetLeaderboardFollowQueryVariables,
      options?: UseQueryOptions<GetLeaderboardFollowQuery, TError, TData>
    ) =>
    useQuery<GetLeaderboardFollowQuery, TError, TData>(
      ['GetLeaderboardFollow', variables],
      fetchGenerated<GetLeaderboardFollowQuery, GetLeaderboardFollowQueryVariables>(GetLeaderboardFollowDocument, variables),
      options
    );
export const CreateFollowDocument = `
    mutation CreateFollow($input: PlayerFollowInput!) {
  createFollow(input: $input)
}
    `;
export const useCreateFollowMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateFollowMutation, TError, CreateFollowMutationVariables, TContext>) =>
    useMutation<CreateFollowMutation, TError, CreateFollowMutationVariables, TContext>(
      ['CreateFollow'],
      (variables?: CreateFollowMutationVariables) => fetchGenerated<CreateFollowMutation, CreateFollowMutationVariables>(CreateFollowDocument, variables)(),
      options
    );
export const DeleteFollowDocument = `
    mutation DeleteFollow($input: PlayerFollowInput!) {
  deleteFollow(input: $input)
}
    `;
export const useDeleteFollowMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteFollowMutation, TError, DeleteFollowMutationVariables, TContext>) =>
    useMutation<DeleteFollowMutation, TError, DeleteFollowMutationVariables, TContext>(
      ['DeleteFollow'],
      (variables?: DeleteFollowMutationVariables) => fetchGenerated<DeleteFollowMutation, DeleteFollowMutationVariables>(DeleteFollowDocument, variables)(),
      options
    );
export const FindFollowedDocument = `
    query FindFollowed($input: FindPlayerFollowInput!) {
  findFollowed(input: $input)
}
    `;
export const useFindFollowedQuery = <
      TData = FindFollowedQuery,
      TError = unknown
    >(
      variables: FindFollowedQueryVariables,
      options?: UseQueryOptions<FindFollowedQuery, TError, TData>
    ) =>
    useQuery<FindFollowedQuery, TError, TData>(
      ['FindFollowed', variables],
      fetchGenerated<FindFollowedQuery, FindFollowedQueryVariables>(FindFollowedDocument, variables),
      options
    );
export const FindLocationsDocument = `
    query FindLocations($gameId: String = "") {
  findLocations(gameId: $gameId) {
    id
    slug
    lat
    lng
    type
    gemType
    beatBoxNumber
    details {
      name
      description
      accessible
    }
  }
}
    `;
export const useFindLocationsQuery = <
      TData = FindLocationsQuery,
      TError = unknown
    >(
      variables?: FindLocationsQueryVariables,
      options?: UseQueryOptions<FindLocationsQuery, TError, TData>
    ) =>
    useQuery<FindLocationsQuery, TError, TData>(
      variables === undefined ? ['FindLocations'] : ['FindLocations', variables],
      fetchGenerated<FindLocationsQuery, FindLocationsQueryVariables>(FindLocationsDocument, variables),
      options
    );
export const GetTeamsV2Document = `
    query getTeamsV2($gameId: String!, $parentTeamId: String) {
  getTeamsV2(gameId: $gameId, parentTeamId: $parentTeamId) {
    teamId
    name
    parentTeamId
  }
}
    `;
export const useGetTeamsV2Query = <
      TData = GetTeamsV2Query,
      TError = unknown
    >(
      variables: GetTeamsV2QueryVariables,
      options?: UseQueryOptions<GetTeamsV2Query, TError, TData>
    ) =>
    useQuery<GetTeamsV2Query, TError, TData>(
      ['getTeamsV2', variables],
      fetchGenerated<GetTeamsV2Query, GetTeamsV2QueryVariables>(GetTeamsV2Document, variables),
      options
    );
export const GetPlayerTeamsV2Document = `
    query getPlayerTeamsV2($gameId: String!, $playerId: String!) {
  getPlayerTeamsV2(gameId: $gameId, playerId: $playerId) {
    teamId
    name
    parentTeamId
  }
}
    `;
export const useGetPlayerTeamsV2Query = <
      TData = GetPlayerTeamsV2Query,
      TError = unknown
    >(
      variables: GetPlayerTeamsV2QueryVariables,
      options?: UseQueryOptions<GetPlayerTeamsV2Query, TError, TData>
    ) =>
    useQuery<GetPlayerTeamsV2Query, TError, TData>(
      ['getPlayerTeamsV2', variables],
      fetchGenerated<GetPlayerTeamsV2Query, GetPlayerTeamsV2QueryVariables>(GetPlayerTeamsV2Document, variables),
      options
    );
export const GetPlayerLeaderboardDocument = `
    query getPlayerLeaderboard($teamId: String!, $gems: Boolean) {
  getPlayerLeaderboardV2(teamId: $teamId, gems: $gems) {
    board {
      id
      name
      avatar
      points
    }
  }
}
    `;
export const useGetPlayerLeaderboardQuery = <
      TData = GetPlayerLeaderboardQuery,
      TError = unknown
    >(
      variables: GetPlayerLeaderboardQueryVariables,
      options?: UseQueryOptions<GetPlayerLeaderboardQuery, TError, TData>
    ) =>
    useQuery<GetPlayerLeaderboardQuery, TError, TData>(
      ['getPlayerLeaderboard', variables],
      fetchGenerated<GetPlayerLeaderboardQuery, GetPlayerLeaderboardQueryVariables>(GetPlayerLeaderboardDocument, variables),
      options
    );
export const GetTeamLeaderboardDocument = `
    query getTeamLeaderboard($gameId: String!, $teamId: String!) {
  getTeamLeaderboardV2(gameId: $gameId, teamId: $teamId) {
    averageBoard {
      id
      name
      points
    }
    board {
      id
      name
      points
    }
  }
}
    `;
export const useGetTeamLeaderboardQuery = <
      TData = GetTeamLeaderboardQuery,
      TError = unknown
    >(
      variables: GetTeamLeaderboardQueryVariables,
      options?: UseQueryOptions<GetTeamLeaderboardQuery, TError, TData>
    ) =>
    useQuery<GetTeamLeaderboardQuery, TError, TData>(
      ['getTeamLeaderboard', variables],
      fetchGenerated<GetTeamLeaderboardQuery, GetTeamLeaderboardQueryVariables>(GetTeamLeaderboardDocument, variables),
      options
    );
export const FindTeamsDocument = `
    query FindTeams($input: FindTeamsInput!) {
  findTeams(input: $input) {
    id
    name
    status
    details {
      leaders
    }
  }
}
    `;
export const useFindTeamsQuery = <
      TData = FindTeamsQuery,
      TError = unknown
    >(
      variables: FindTeamsQueryVariables,
      options?: UseQueryOptions<FindTeamsQuery, TError, TData>
    ) =>
    useQuery<FindTeamsQuery, TError, TData>(
      ['FindTeams', variables],
      fetchGenerated<FindTeamsQuery, FindTeamsQueryVariables>(FindTeamsDocument, variables),
      options
    );
export const LeaveGameDocument = `
    mutation LeaveGame {
  leaveGame
}
    `;
export const useLeaveGameMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<LeaveGameMutation, TError, LeaveGameMutationVariables, TContext>) =>
    useMutation<LeaveGameMutation, TError, LeaveGameMutationVariables, TContext>(
      ['LeaveGame'],
      (variables?: LeaveGameMutationVariables) => fetchGenerated<LeaveGameMutation, LeaveGameMutationVariables>(LeaveGameDocument, variables)(),
      options
    );
export const RemoveFromFamilyDocument = `
    mutation RemoveFromFamily($input: RemoveFromFamilyInput!) {
  removeFromFamily(input: $input)
}
    `;
export const useRemoveFromFamilyMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveFromFamilyMutation, TError, RemoveFromFamilyMutationVariables, TContext>) =>
    useMutation<RemoveFromFamilyMutation, TError, RemoveFromFamilyMutationVariables, TContext>(
      ['RemoveFromFamily'],
      (variables?: RemoveFromFamilyMutationVariables) => fetchGenerated<RemoveFromFamilyMutation, RemoveFromFamilyMutationVariables>(RemoveFromFamilyDocument, variables)(),
      options
    );
export const DeleteChildDocument = `
    mutation DeleteChild($id: String = "") {
  deleteChild(childId: $id)
}
    `;
export const useDeleteChildMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteChildMutation, TError, DeleteChildMutationVariables, TContext>) =>
    useMutation<DeleteChildMutation, TError, DeleteChildMutationVariables, TContext>(
      ['DeleteChild'],
      (variables?: DeleteChildMutationVariables) => fetchGenerated<DeleteChildMutation, DeleteChildMutationVariables>(DeleteChildDocument, variables)(),
      options
    );
export const DeletePlayerDocument = `
    mutation DeletePlayer {
  deletePlayer
}
    `;
export const useDeletePlayerMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeletePlayerMutation, TError, DeletePlayerMutationVariables, TContext>) =>
    useMutation<DeletePlayerMutation, TError, DeletePlayerMutationVariables, TContext>(
      ['DeletePlayer'],
      (variables?: DeletePlayerMutationVariables) => fetchGenerated<DeletePlayerMutation, DeletePlayerMutationVariables>(DeletePlayerDocument, variables)(),
      options
    );
export const ReadMessageDocument = `
    mutation readMessage($messageId: String!) {
  readMessage(messageId: $messageId)
}
    `;
export const useReadMessageMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ReadMessageMutation, TError, ReadMessageMutationVariables, TContext>) =>
    useMutation<ReadMessageMutation, TError, ReadMessageMutationVariables, TContext>(
      ['readMessage'],
      (variables?: ReadMessageMutationVariables) => fetchGenerated<ReadMessageMutation, ReadMessageMutationVariables>(ReadMessageDocument, variables)(),
      options
    );
export const LikeMessageDocument = `
    mutation likeMessage($campaignId: String!) {
  likeMessage(campaignId: $campaignId)
}
    `;
export const useLikeMessageMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<LikeMessageMutation, TError, LikeMessageMutationVariables, TContext>) =>
    useMutation<LikeMessageMutation, TError, LikeMessageMutationVariables, TContext>(
      ['likeMessage'],
      (variables?: LikeMessageMutationVariables) => fetchGenerated<LikeMessageMutation, LikeMessageMutationVariables>(LikeMessageDocument, variables)(),
      options
    );
export const UnlikeMessageDocument = `
    mutation unlikeMessage($campaignId: String!) {
  unlikeMessage(campaignId: $campaignId)
}
    `;
export const useUnlikeMessageMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UnlikeMessageMutation, TError, UnlikeMessageMutationVariables, TContext>) =>
    useMutation<UnlikeMessageMutation, TError, UnlikeMessageMutationVariables, TContext>(
      ['unlikeMessage'],
      (variables?: UnlikeMessageMutationVariables) => fetchGenerated<UnlikeMessageMutation, UnlikeMessageMutationVariables>(UnlikeMessageDocument, variables)(),
      options
    );
export const PostTeamMessageDocument = `
    mutation postTeamMessage($content: TeamMessageContent!) {
  postTeamMessage(content: $content)
}
    `;
export const usePostTeamMessageMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<PostTeamMessageMutation, TError, PostTeamMessageMutationVariables, TContext>) =>
    useMutation<PostTeamMessageMutation, TError, PostTeamMessageMutationVariables, TContext>(
      ['postTeamMessage'],
      (variables?: PostTeamMessageMutationVariables) => fetchGenerated<PostTeamMessageMutation, PostTeamMessageMutationVariables>(PostTeamMessageDocument, variables)(),
      options
    );
export const GetMessagesDocument = `
    query getMessages($category: String) {
  getMessages(category: $category) {
    ...Msg
  }
}
    ${MsgFragmentDoc}`;
export const useGetMessagesQuery = <
      TData = GetMessagesQuery,
      TError = unknown
    >(
      variables?: GetMessagesQueryVariables,
      options?: UseQueryOptions<GetMessagesQuery, TError, TData>
    ) =>
    useQuery<GetMessagesQuery, TError, TData>(
      variables === undefined ? ['getMessages'] : ['getMessages', variables],
      fetchGenerated<GetMessagesQuery, GetMessagesQueryVariables>(GetMessagesDocument, variables),
      options
    );
export const GetMessageDocument = `
    query getMessage($messageId: String!) {
  getMessage(messageId: $messageId) {
    ...Msg
  }
}
    ${MsgFragmentDoc}`;
export const useGetMessageQuery = <
      TData = GetMessageQuery,
      TError = unknown
    >(
      variables: GetMessageQueryVariables,
      options?: UseQueryOptions<GetMessageQuery, TError, TData>
    ) =>
    useQuery<GetMessageQuery, TError, TData>(
      ['getMessage', variables],
      fetchGenerated<GetMessageQuery, GetMessageQueryVariables>(GetMessageDocument, variables),
      options
    );
export const HasUnreadMessageDocument = `
    query hasUnreadMessage {
  hasUnreadMessage
}
    `;
export const useHasUnreadMessageQuery = <
      TData = HasUnreadMessageQuery,
      TError = unknown
    >(
      variables?: HasUnreadMessageQueryVariables,
      options?: UseQueryOptions<HasUnreadMessageQuery, TError, TData>
    ) =>
    useQuery<HasUnreadMessageQuery, TError, TData>(
      variables === undefined ? ['hasUnreadMessage'] : ['hasUnreadMessage', variables],
      fetchGenerated<HasUnreadMessageQuery, HasUnreadMessageQueryVariables>(HasUnreadMessageDocument, variables),
      options
    );
export const NewsletterSignupDocument = `
    mutation NewsletterSignup($input: NewsletterSignUpInput!) {
  newsletterSignUp(input: $input)
}
    `;
export const useNewsletterSignupMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<NewsletterSignupMutation, TError, NewsletterSignupMutationVariables, TContext>) =>
    useMutation<NewsletterSignupMutation, TError, NewsletterSignupMutationVariables, TContext>(
      ['NewsletterSignup'],
      (variables?: NewsletterSignupMutationVariables) => fetchGenerated<NewsletterSignupMutation, NewsletterSignupMutationVariables>(NewsletterSignupDocument, variables)(),
      options
    );
export const UpdatePlayerDocument = `
    mutation UpdatePlayer($input: UpdatePlayerInput!) {
  updatePlayer(input: $input) {
    id
  }
}
    `;
export const useUpdatePlayerMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdatePlayerMutation, TError, UpdatePlayerMutationVariables, TContext>) =>
    useMutation<UpdatePlayerMutation, TError, UpdatePlayerMutationVariables, TContext>(
      ['UpdatePlayer'],
      (variables?: UpdatePlayerMutationVariables) => fetchGenerated<UpdatePlayerMutation, UpdatePlayerMutationVariables>(UpdatePlayerDocument, variables)(),
      options
    );
export const JoinFamilyDocument = `
    mutation JoinFamily($input: JoinFamilyInput!) {
  joinFamily(input: $input)
}
    `;
export const useJoinFamilyMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<JoinFamilyMutation, TError, JoinFamilyMutationVariables, TContext>) =>
    useMutation<JoinFamilyMutation, TError, JoinFamilyMutationVariables, TContext>(
      ['JoinFamily'],
      (variables?: JoinFamilyMutationVariables) => fetchGenerated<JoinFamilyMutation, JoinFamilyMutationVariables>(JoinFamilyDocument, variables)(),
      options
    );
export const AssignTagDocument = `
    mutation AssignTag($input: PlayerTagCreateInput!) {
  assignTag(input: $input) {
    tagNumber
  }
}
    `;
export const useAssignTagMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AssignTagMutation, TError, AssignTagMutationVariables, TContext>) =>
    useMutation<AssignTagMutation, TError, AssignTagMutationVariables, TContext>(
      ['AssignTag'],
      (variables?: AssignTagMutationVariables) => fetchGenerated<AssignTagMutation, AssignTagMutationVariables>(AssignTagDocument, variables)(),
      options
    );
export const JoinTeamDocument = `
    mutation JoinTeam($input: JoinTeamInput!) {
  joinTeam(input: $input)
}
    `;
export const useJoinTeamMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<JoinTeamMutation, TError, JoinTeamMutationVariables, TContext>) =>
    useMutation<JoinTeamMutation, TError, JoinTeamMutationVariables, TContext>(
      ['JoinTeam'],
      (variables?: JoinTeamMutationVariables) => fetchGenerated<JoinTeamMutation, JoinTeamMutationVariables>(JoinTeamDocument, variables)(),
      options
    );
export const LeaveTeamDocument = `
    mutation LeaveTeam($playerId: String!) {
  leaveTeam(playerId: $playerId)
}
    `;
export const useLeaveTeamMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<LeaveTeamMutation, TError, LeaveTeamMutationVariables, TContext>) =>
    useMutation<LeaveTeamMutation, TError, LeaveTeamMutationVariables, TContext>(
      ['LeaveTeam'],
      (variables?: LeaveTeamMutationVariables) => fetchGenerated<LeaveTeamMutation, LeaveTeamMutationVariables>(LeaveTeamDocument, variables)(),
      options
    );
export const CreateTeamDocument = `
    mutation CreateTeam($input: TeamCreateInput!) {
  createTeam(input: $input) {
    id
  }
}
    `;
export const useCreateTeamMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateTeamMutation, TError, CreateTeamMutationVariables, TContext>) =>
    useMutation<CreateTeamMutation, TError, CreateTeamMutationVariables, TContext>(
      ['CreateTeam'],
      (variables?: CreateTeamMutationVariables) => fetchGenerated<CreateTeamMutation, CreateTeamMutationVariables>(CreateTeamDocument, variables)(),
      options
    );
export const FindTeamNamesDocument = `
    query FindTeamNames($input: FindTeamsInput!) {
  findTeamNames(input: $input) {
    teamNames
  }
}
    `;
export const useFindTeamNamesQuery = <
      TData = FindTeamNamesQuery,
      TError = unknown
    >(
      variables: FindTeamNamesQueryVariables,
      options?: UseQueryOptions<FindTeamNamesQuery, TError, TData>
    ) =>
    useQuery<FindTeamNamesQuery, TError, TData>(
      ['FindTeamNames', variables],
      fetchGenerated<FindTeamNamesQuery, FindTeamNamesQueryVariables>(FindTeamNamesDocument, variables),
      options
    );
export const CreateChildDocument = `
    mutation CreateChild($input: CreateChildPlayerInput!) {
  createChild(input: $input) {
    id
  }
}
    `;
export const useCreateChildMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateChildMutation, TError, CreateChildMutationVariables, TContext>) =>
    useMutation<CreateChildMutation, TError, CreateChildMutationVariables, TContext>(
      ['CreateChild'],
      (variables?: CreateChildMutationVariables) => fetchGenerated<CreateChildMutation, CreateChildMutationVariables>(CreateChildDocument, variables)(),
      options
    );
export const CheckPublicNameDocument = `
    query CheckPublicName($name: String!) {
  checkPublicName(name: $name)
}
    `;
export const useCheckPublicNameQuery = <
      TData = CheckPublicNameQuery,
      TError = unknown
    >(
      variables: CheckPublicNameQueryVariables,
      options?: UseQueryOptions<CheckPublicNameQuery, TError, TData>
    ) =>
    useQuery<CheckPublicNameQuery, TError, TData>(
      ['CheckPublicName', variables],
      fetchGenerated<CheckPublicNameQuery, CheckPublicNameQueryVariables>(CheckPublicNameDocument, variables),
      options
    );
export const FindAllTeamsDocument = `
    query FindAllTeams($input: FindTeamsInput!) {
  findTeams(input: $input) {
    id
    name
    status
  }
}
    `;
export const useFindAllTeamsQuery = <
      TData = FindAllTeamsQuery,
      TError = unknown
    >(
      variables: FindAllTeamsQueryVariables,
      options?: UseQueryOptions<FindAllTeamsQuery, TError, TData>
    ) =>
    useQuery<FindAllTeamsQuery, TError, TData>(
      ['FindAllTeams', variables],
      fetchGenerated<FindAllTeamsQuery, FindAllTeamsQueryVariables>(FindAllTeamsDocument, variables),
      options
    );
export const GetUserTeamDocument = `
    query GetUserTeam($input: GetTeamInput!) {
  getTeam(input: $input) {
    id
    name
  }
}
    `;
export const useGetUserTeamQuery = <
      TData = GetUserTeamQuery,
      TError = unknown
    >(
      variables: GetUserTeamQueryVariables,
      options?: UseQueryOptions<GetUserTeamQuery, TError, TData>
    ) =>
    useQuery<GetUserTeamQuery, TError, TData>(
      ['GetUserTeam', variables],
      fetchGenerated<GetUserTeamQuery, GetUserTeamQueryVariables>(GetUserTeamDocument, variables),
      options
    );
export const CreatePostCodeRecordDocument = `
    mutation CreatePostCodeRecord($input: PostCodeInput!) {
  checkPostCode(input: $input) {
    id
  }
}
    `;
export const useCreatePostCodeRecordMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreatePostCodeRecordMutation, TError, CreatePostCodeRecordMutationVariables, TContext>) =>
    useMutation<CreatePostCodeRecordMutation, TError, CreatePostCodeRecordMutationVariables, TContext>(
      ['CreatePostCodeRecord'],
      (variables?: CreatePostCodeRecordMutationVariables) => fetchGenerated<CreatePostCodeRecordMutation, CreatePostCodeRecordMutationVariables>(CreatePostCodeRecordDocument, variables)(),
      options
    );